var hu = Object.defineProperty;
var du = (e, t, n) => t in e ? hu(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var qa = (e, t, n) => (du(e, typeof t != "symbol" ? t + "" : t, n), n);
import { useRef as yo, useCallback as Mn, useEffect as ba, useLayoutEffect as yu, useState as go } from "react";
import { c as vo, a as gu } from "./lodash-3345fe65.js";
import "./myasurion-shared.mixpanel.es.js";
import { g as vu, a as mu } from "./domains-6461a203.js";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const mo = function(e) {
  const t = [];
  let n = 0;
  for (let r = 0; r < e.length; r++) {
    let a = e.charCodeAt(r);
    a < 128 ? t[n++] = a : a < 2048 ? (t[n++] = a >> 6 | 192, t[n++] = a & 63 | 128) : (a & 64512) === 55296 && r + 1 < e.length && (e.charCodeAt(r + 1) & 64512) === 56320 ? (a = 65536 + ((a & 1023) << 10) + (e.charCodeAt(++r) & 1023), t[n++] = a >> 18 | 240, t[n++] = a >> 12 & 63 | 128, t[n++] = a >> 6 & 63 | 128, t[n++] = a & 63 | 128) : (t[n++] = a >> 12 | 224, t[n++] = a >> 6 & 63 | 128, t[n++] = a & 63 | 128);
  }
  return t;
}, Eu = function(e) {
  const t = [];
  let n = 0, r = 0;
  for (; n < e.length; ) {
    const a = e[n++];
    if (a < 128)
      t[r++] = String.fromCharCode(a);
    else if (a > 191 && a < 224) {
      const s = e[n++];
      t[r++] = String.fromCharCode((a & 31) << 6 | s & 63);
    } else if (a > 239 && a < 365) {
      const s = e[n++], i = e[n++], o = e[n++], u = ((a & 7) << 18 | (s & 63) << 12 | (i & 63) << 6 | o & 63) - 65536;
      t[r++] = String.fromCharCode(55296 + (u >> 10)), t[r++] = String.fromCharCode(56320 + (u & 1023));
    } else {
      const s = e[n++], i = e[n++];
      t[r++] = String.fromCharCode((a & 15) << 12 | (s & 63) << 6 | i & 63);
    }
  }
  return t.join("");
}, Eo = {
  /**
   * Maps bytes to characters.
   */
  byteToCharMap_: null,
  /**
   * Maps characters to bytes.
   */
  charToByteMap_: null,
  /**
   * Maps bytes to websafe characters.
   * @private
   */
  byteToCharMapWebSafe_: null,
  /**
   * Maps websafe characters to bytes.
   * @private
   */
  charToByteMapWebSafe_: null,
  /**
   * Our default alphabet, shared between
   * ENCODED_VALS and ENCODED_VALS_WEBSAFE
   */
  ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
  /**
   * Our default alphabet. Value 64 (=) is special; it means "nothing."
   */
  get ENCODED_VALS() {
    return this.ENCODED_VALS_BASE + "+/=";
  },
  /**
   * Our websafe alphabet.
   */
  get ENCODED_VALS_WEBSAFE() {
    return this.ENCODED_VALS_BASE + "-_.";
  },
  /**
   * Whether this browser supports the atob and btoa functions. This extension
   * started at Mozilla but is now implemented by many browsers. We use the
   * ASSUME_* variables to avoid pulling in the full useragent detection library
   * but still allowing the standard per-browser compilations.
   *
   */
  HAS_NATIVE_SUPPORT: typeof atob == "function",
  /**
   * Base64-encode an array of bytes.
   *
   * @param input An array of bytes (numbers with
   *     value in [0, 255]) to encode.
   * @param webSafe Boolean indicating we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeByteArray(e, t) {
    if (!Array.isArray(e))
      throw Error("encodeByteArray takes an array as a parameter");
    this.init_();
    const n = t ? this.byteToCharMapWebSafe_ : this.byteToCharMap_, r = [];
    for (let a = 0; a < e.length; a += 3) {
      const s = e[a], i = a + 1 < e.length, o = i ? e[a + 1] : 0, u = a + 2 < e.length, c = u ? e[a + 2] : 0, l = s >> 2, p = (s & 3) << 4 | o >> 4;
      let g = (o & 15) << 2 | c >> 6, C = c & 63;
      u || (C = 64, i || (g = 64)), r.push(n[l], n[p], n[g], n[C]);
    }
    return r.join("");
  },
  /**
   * Base64-encode a string.
   *
   * @param input A string to encode.
   * @param webSafe If true, we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeString(e, t) {
    return this.HAS_NATIVE_SUPPORT && !t ? btoa(e) : this.encodeByteArray(mo(e), t);
  },
  /**
   * Base64-decode a string.
   *
   * @param input to decode.
   * @param webSafe True if we should use the
   *     alternative alphabet.
   * @return string representing the decoded value.
   */
  decodeString(e, t) {
    return this.HAS_NATIVE_SUPPORT && !t ? atob(e) : Eu(this.decodeStringToByteArray(e, t));
  },
  /**
   * Base64-decode a string.
   *
   * In base-64 decoding, groups of four characters are converted into three
   * bytes.  If the encoder did not apply padding, the input length may not
   * be a multiple of 4.
   *
   * In this case, the last group will have fewer than 4 characters, and
   * padding will be inferred.  If the group has one or two characters, it decodes
   * to one byte.  If the group has three characters, it decodes to two bytes.
   *
   * @param input Input to decode.
   * @param webSafe True if we should use the web-safe alphabet.
   * @return bytes representing the decoded value.
   */
  decodeStringToByteArray(e, t) {
    this.init_();
    const n = t ? this.charToByteMapWebSafe_ : this.charToByteMap_, r = [];
    for (let a = 0; a < e.length; ) {
      const s = n[e.charAt(a++)], o = a < e.length ? n[e.charAt(a)] : 0;
      ++a;
      const c = a < e.length ? n[e.charAt(a)] : 64;
      ++a;
      const p = a < e.length ? n[e.charAt(a)] : 64;
      if (++a, s == null || o == null || c == null || p == null)
        throw new Cu();
      const g = s << 2 | o >> 4;
      if (r.push(g), c !== 64) {
        const C = o << 4 & 240 | c >> 2;
        if (r.push(C), p !== 64) {
          const d = c << 6 & 192 | p;
          r.push(d);
        }
      }
    }
    return r;
  },
  /**
   * Lazy static initialization function. Called before
   * accessing any of the static map variables.
   * @private
   */
  init_() {
    if (!this.byteToCharMap_) {
      this.byteToCharMap_ = {}, this.charToByteMap_ = {}, this.byteToCharMapWebSafe_ = {}, this.charToByteMapWebSafe_ = {};
      for (let e = 0; e < this.ENCODED_VALS.length; e++)
        this.byteToCharMap_[e] = this.ENCODED_VALS.charAt(e), this.charToByteMap_[this.byteToCharMap_[e]] = e, this.byteToCharMapWebSafe_[e] = this.ENCODED_VALS_WEBSAFE.charAt(e), this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[e]] = e, e >= this.ENCODED_VALS_BASE.length && (this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(e)] = e, this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(e)] = e);
    }
  }
};
class Cu extends Error {
  constructor() {
    super(...arguments), this.name = "DecodeBase64StringError";
  }
}
const Su = function(e) {
  const t = mo(e);
  return Eo.encodeByteArray(t, !0);
}, Co = function(e) {
  return Su(e).replace(/\./g, "");
}, bu = function(e) {
  try {
    return Eo.decodeString(e, !0);
  } catch (t) {
    console.error("base64Decode failed: ", t);
  }
  return null;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function xu() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Tu = () => xu().__FIREBASE_DEFAULTS__, Au = () => {
  if (typeof process > "u" || typeof process.env > "u")
    return;
  const e = process.env.__FIREBASE_DEFAULTS__;
  if (e)
    return JSON.parse(e);
}, Iu = () => {
  if (typeof document > "u")
    return;
  let e;
  try {
    e = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
  } catch {
    return;
  }
  const t = e && bu(e[1]);
  return t && JSON.parse(t);
}, wu = () => {
  try {
    return Tu() || Au() || Iu();
  } catch (e) {
    console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
    return;
  }
}, So = () => {
  var e;
  return (e = wu()) === null || e === void 0 ? void 0 : e.config;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Bu {
  constructor() {
    this.reject = () => {
    }, this.resolve = () => {
    }, this.promise = new Promise((t, n) => {
      this.resolve = t, this.reject = n;
    });
  }
  /**
   * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
   * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
   * and returns a node-style callback which will resolve or reject the Deferred's promise.
   */
  wrapCallback(t) {
    return (n, r) => {
      n ? this.reject(n) : this.resolve(r), typeof t == "function" && (this.promise.catch(() => {
      }), t.length === 1 ? t(n) : t(n, r));
    };
  }
}
function bo() {
  try {
    return typeof indexedDB == "object";
  } catch {
    return !1;
  }
}
function _u() {
  return new Promise((e, t) => {
    try {
      let n = !0;
      const r = "validate-browser-context-for-indexeddb-analytics-module", a = self.indexedDB.open(r);
      a.onsuccess = () => {
        a.result.close(), n || self.indexedDB.deleteDatabase(r), e(!0);
      }, a.onupgradeneeded = () => {
        n = !1;
      }, a.onerror = () => {
        var s;
        t(((s = a.error) === null || s === void 0 ? void 0 : s.message) || "");
      };
    } catch (n) {
      t(n);
    }
  });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Nu = "FirebaseError";
class Lr extends Error {
  constructor(t, n, r) {
    super(n), this.code = t, this.customData = r, this.name = Nu, Object.setPrototypeOf(this, Lr.prototype), Error.captureStackTrace && Error.captureStackTrace(this, xa.prototype.create);
  }
}
class xa {
  constructor(t, n, r) {
    this.service = t, this.serviceName = n, this.errors = r;
  }
  create(t, ...n) {
    const r = n[0] || {}, a = `${this.service}/${t}`, s = this.errors[t], i = s ? Ru(s, r) : "Error", o = `${this.serviceName}: ${i} (${a}).`;
    return new Lr(a, o, r);
  }
}
function Ru(e, t) {
  return e.replace(Lu, (n, r) => {
    const a = t[r];
    return a != null ? String(a) : `<${r}?>`;
  });
}
const Lu = /\{\$([^}]+)}/g;
function ci(e, t) {
  if (e === t)
    return !0;
  const n = Object.keys(e), r = Object.keys(t);
  for (const a of n) {
    if (!r.includes(a))
      return !1;
    const s = e[a], i = t[a];
    if (xs(s) && xs(i)) {
      if (!ci(s, i))
        return !1;
    } else if (s !== i)
      return !1;
  }
  for (const a of r)
    if (!n.includes(a))
      return !1;
  return !0;
}
function xs(e) {
  return e !== null && typeof e == "object";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Du = 1e3, ku = 2, Ou = 4 * 60 * 60 * 1e3, Pu = 0.5;
function Uu(e, t = Du, n = ku) {
  const r = t * Math.pow(n, e), a = Math.round(
    // A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    Pu * r * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2
  );
  return Math.min(Ou, r + a);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Zr(e) {
  return e && e._delegate ? e._delegate : e;
}
class Qr {
  /**
   *
   * @param name The public service name, e.g. app, auth, firestore, database
   * @param instanceFactory Service factory responsible for creating the public interface
   * @param type whether the service provided by the component is public or private
   */
  constructor(t, n, r) {
    this.name = t, this.instanceFactory = n, this.type = r, this.multipleInstances = !1, this.serviceProps = {}, this.instantiationMode = "LAZY", this.onInstanceCreated = null;
  }
  setInstantiationMode(t) {
    return this.instantiationMode = t, this;
  }
  setMultipleInstances(t) {
    return this.multipleInstances = t, this;
  }
  setServiceProps(t) {
    return this.serviceProps = t, this;
  }
  setInstanceCreatedCallback(t) {
    return this.onInstanceCreated = t, this;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Kr = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Fu {
  constructor(t, n) {
    this.name = t, this.container = n, this.component = null, this.instances = /* @__PURE__ */ new Map(), this.instancesDeferred = /* @__PURE__ */ new Map(), this.instancesOptions = /* @__PURE__ */ new Map(), this.onInitCallbacks = /* @__PURE__ */ new Map();
  }
  /**
   * @param identifier A provider can provide mulitple instances of a service
   * if this.component.multipleInstances is true.
   */
  get(t) {
    const n = this.normalizeInstanceIdentifier(t);
    if (!this.instancesDeferred.has(n)) {
      const r = new Bu();
      if (this.instancesDeferred.set(n, r), this.isInitialized(n) || this.shouldAutoInitialize())
        try {
          const a = this.getOrInitializeService({
            instanceIdentifier: n
          });
          a && r.resolve(a);
        } catch {
        }
    }
    return this.instancesDeferred.get(n).promise;
  }
  getImmediate(t) {
    var n;
    const r = this.normalizeInstanceIdentifier(t == null ? void 0 : t.identifier), a = (n = t == null ? void 0 : t.optional) !== null && n !== void 0 ? n : !1;
    if (this.isInitialized(r) || this.shouldAutoInitialize())
      try {
        return this.getOrInitializeService({
          instanceIdentifier: r
        });
      } catch (s) {
        if (a)
          return null;
        throw s;
      }
    else {
      if (a)
        return null;
      throw Error(`Service ${this.name} is not available`);
    }
  }
  getComponent() {
    return this.component;
  }
  setComponent(t) {
    if (t.name !== this.name)
      throw Error(`Mismatching Component ${t.name} for Provider ${this.name}.`);
    if (this.component)
      throw Error(`Component for ${this.name} has already been provided`);
    if (this.component = t, !!this.shouldAutoInitialize()) {
      if (Mu(t))
        try {
          this.getOrInitializeService({ instanceIdentifier: Kr });
        } catch {
        }
      for (const [n, r] of this.instancesDeferred.entries()) {
        const a = this.normalizeInstanceIdentifier(n);
        try {
          const s = this.getOrInitializeService({
            instanceIdentifier: a
          });
          r.resolve(s);
        } catch {
        }
      }
    }
  }
  clearInstance(t = Kr) {
    this.instancesDeferred.delete(t), this.instancesOptions.delete(t), this.instances.delete(t);
  }
  // app.delete() will call this method on every provider to delete the services
  // TODO: should we mark the provider as deleted?
  async delete() {
    const t = Array.from(this.instances.values());
    await Promise.all([
      ...t.filter((n) => "INTERNAL" in n).map((n) => n.INTERNAL.delete()),
      ...t.filter((n) => "_delete" in n).map((n) => n._delete())
    ]);
  }
  isComponentSet() {
    return this.component != null;
  }
  isInitialized(t = Kr) {
    return this.instances.has(t);
  }
  getOptions(t = Kr) {
    return this.instancesOptions.get(t) || {};
  }
  initialize(t = {}) {
    const { options: n = {} } = t, r = this.normalizeInstanceIdentifier(t.instanceIdentifier);
    if (this.isInitialized(r))
      throw Error(`${this.name}(${r}) has already been initialized`);
    if (!this.isComponentSet())
      throw Error(`Component ${this.name} has not been registered yet`);
    const a = this.getOrInitializeService({
      instanceIdentifier: r,
      options: n
    });
    for (const [s, i] of this.instancesDeferred.entries()) {
      const o = this.normalizeInstanceIdentifier(s);
      r === o && i.resolve(a);
    }
    return a;
  }
  /**
   *
   * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
   * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
   *
   * @param identifier An optional instance identifier
   * @returns a function to unregister the callback
   */
  onInit(t, n) {
    var r;
    const a = this.normalizeInstanceIdentifier(n), s = (r = this.onInitCallbacks.get(a)) !== null && r !== void 0 ? r : /* @__PURE__ */ new Set();
    s.add(t), this.onInitCallbacks.set(a, s);
    const i = this.instances.get(a);
    return i && t(i, a), () => {
      s.delete(t);
    };
  }
  /**
   * Invoke onInit callbacks synchronously
   * @param instance the service instance`
   */
  invokeOnInitCallbacks(t, n) {
    const r = this.onInitCallbacks.get(n);
    if (r)
      for (const a of r)
        try {
          a(t, n);
        } catch {
        }
  }
  getOrInitializeService({ instanceIdentifier: t, options: n = {} }) {
    let r = this.instances.get(t);
    if (!r && this.component && (r = this.component.instanceFactory(this.container, {
      instanceIdentifier: Vu(t),
      options: n
    }), this.instances.set(t, r), this.instancesOptions.set(t, n), this.invokeOnInitCallbacks(r, t), this.component.onInstanceCreated))
      try {
        this.component.onInstanceCreated(this.container, t, r);
      } catch {
      }
    return r || null;
  }
  normalizeInstanceIdentifier(t = Kr) {
    return this.component ? this.component.multipleInstances ? t : Kr : t;
  }
  shouldAutoInitialize() {
    return !!this.component && this.component.instantiationMode !== "EXPLICIT";
  }
}
function Vu(e) {
  return e === Kr ? void 0 : e;
}
function Mu(e) {
  return e.instantiationMode === "EAGER";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ku {
  constructor(t) {
    this.name = t, this.providers = /* @__PURE__ */ new Map();
  }
  /**
   *
   * @param component Component being added
   * @param overwrite When a component with the same name has already been registered,
   * if overwrite is true: overwrite the existing component with the new component and create a new
   * provider with the new component. It can be useful in tests where you want to use different mocks
   * for different tests.
   * if overwrite is false: throw an exception
   */
  addComponent(t) {
    const n = this.getProvider(t.name);
    if (n.isComponentSet())
      throw new Error(`Component ${t.name} has already been registered with ${this.name}`);
    n.setComponent(t);
  }
  addOrOverwriteComponent(t) {
    this.getProvider(t.name).isComponentSet() && this.providers.delete(t.name), this.addComponent(t);
  }
  /**
   * getProvider provides a type safe interface where it can only be called with a field name
   * present in NameServiceMapping interface.
   *
   * Firebase SDKs providing services should extend NameServiceMapping interface to register
   * themselves.
   */
  getProvider(t) {
    if (this.providers.has(t))
      return this.providers.get(t);
    const n = new Fu(t, this);
    return this.providers.set(t, n), n;
  }
  getProviders() {
    return Array.from(this.providers.values());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Ze;
(function(e) {
  e[e.DEBUG = 0] = "DEBUG", e[e.VERBOSE = 1] = "VERBOSE", e[e.INFO = 2] = "INFO", e[e.WARN = 3] = "WARN", e[e.ERROR = 4] = "ERROR", e[e.SILENT = 5] = "SILENT";
})(Ze || (Ze = {}));
const ju = {
  debug: Ze.DEBUG,
  verbose: Ze.VERBOSE,
  info: Ze.INFO,
  warn: Ze.WARN,
  error: Ze.ERROR,
  silent: Ze.SILENT
}, Hu = Ze.INFO, qu = {
  [Ze.DEBUG]: "log",
  [Ze.VERBOSE]: "log",
  [Ze.INFO]: "info",
  [Ze.WARN]: "warn",
  [Ze.ERROR]: "error"
}, Gu = (e, t, ...n) => {
  if (t < e.logLevel)
    return;
  const r = (/* @__PURE__ */ new Date()).toISOString(), a = qu[t];
  if (a)
    console[a](`[${r}]  ${e.name}:`, ...n);
  else
    throw new Error(`Attempted to log a message with an invalid logType (value: ${t})`);
};
class xo {
  /**
   * Gives you an instance of a Logger to capture messages according to
   * Firebase's logging scheme.
   *
   * @param name The name that the logs will be associated with
   */
  constructor(t) {
    this.name = t, this._logLevel = Hu, this._logHandler = Gu, this._userLogHandler = null;
  }
  get logLevel() {
    return this._logLevel;
  }
  set logLevel(t) {
    if (!(t in Ze))
      throw new TypeError(`Invalid value "${t}" assigned to \`logLevel\``);
    this._logLevel = t;
  }
  // Workaround for setter/getter having to be the same type.
  setLogLevel(t) {
    this._logLevel = typeof t == "string" ? ju[t] : t;
  }
  get logHandler() {
    return this._logHandler;
  }
  set logHandler(t) {
    if (typeof t != "function")
      throw new TypeError("Value assigned to `logHandler` must be a function");
    this._logHandler = t;
  }
  get userLogHandler() {
    return this._userLogHandler;
  }
  set userLogHandler(t) {
    this._userLogHandler = t;
  }
  /**
   * The functions below are all based on the `console` interface
   */
  debug(...t) {
    this._userLogHandler && this._userLogHandler(this, Ze.DEBUG, ...t), this._logHandler(this, Ze.DEBUG, ...t);
  }
  log(...t) {
    this._userLogHandler && this._userLogHandler(this, Ze.VERBOSE, ...t), this._logHandler(this, Ze.VERBOSE, ...t);
  }
  info(...t) {
    this._userLogHandler && this._userLogHandler(this, Ze.INFO, ...t), this._logHandler(this, Ze.INFO, ...t);
  }
  warn(...t) {
    this._userLogHandler && this._userLogHandler(this, Ze.WARN, ...t), this._logHandler(this, Ze.WARN, ...t);
  }
  error(...t) {
    this._userLogHandler && this._userLogHandler(this, Ze.ERROR, ...t), this._logHandler(this, Ze.ERROR, ...t);
  }
}
const $u = (e, t) => t.some((n) => e instanceof n);
let Ts, As;
function zu() {
  return Ts || (Ts = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function Wu() {
  return As || (As = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const To = /* @__PURE__ */ new WeakMap(), ui = /* @__PURE__ */ new WeakMap(), Ao = /* @__PURE__ */ new WeakMap(), Ga = /* @__PURE__ */ new WeakMap(), Oi = /* @__PURE__ */ new WeakMap();
function Qu(e) {
  const t = new Promise((n, r) => {
    const a = () => {
      e.removeEventListener("success", s), e.removeEventListener("error", i);
    }, s = () => {
      n(Ar(e.result)), a();
    }, i = () => {
      r(e.error), a();
    };
    e.addEventListener("success", s), e.addEventListener("error", i);
  });
  return t.then((n) => {
    n instanceof IDBCursor && To.set(n, e);
  }).catch(() => {
  }), Oi.set(t, e), t;
}
function Yu(e) {
  if (ui.has(e))
    return;
  const t = new Promise((n, r) => {
    const a = () => {
      e.removeEventListener("complete", s), e.removeEventListener("error", i), e.removeEventListener("abort", i);
    }, s = () => {
      n(), a();
    }, i = () => {
      r(e.error || new DOMException("AbortError", "AbortError")), a();
    };
    e.addEventListener("complete", s), e.addEventListener("error", i), e.addEventListener("abort", i);
  });
  ui.set(e, t);
}
let li = {
  get(e, t, n) {
    if (e instanceof IDBTransaction) {
      if (t === "done")
        return ui.get(e);
      if (t === "objectStoreNames")
        return e.objectStoreNames || Ao.get(e);
      if (t === "store")
        return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
    }
    return Ar(e[t]);
  },
  set(e, t, n) {
    return e[t] = n, !0;
  },
  has(e, t) {
    return e instanceof IDBTransaction && (t === "done" || t === "store") ? !0 : t in e;
  }
};
function Xu(e) {
  li = e(li);
}
function Ju(e) {
  return e === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(t, ...n) {
    const r = e.call($a(this), t, ...n);
    return Ao.set(r, t.sort ? t.sort() : [t]), Ar(r);
  } : Wu().includes(e) ? function(...t) {
    return e.apply($a(this), t), Ar(To.get(this));
  } : function(...t) {
    return Ar(e.apply($a(this), t));
  };
}
function Zu(e) {
  return typeof e == "function" ? Ju(e) : (e instanceof IDBTransaction && Yu(e), $u(e, zu()) ? new Proxy(e, li) : e);
}
function Ar(e) {
  if (e instanceof IDBRequest)
    return Qu(e);
  if (Ga.has(e))
    return Ga.get(e);
  const t = Zu(e);
  return t !== e && (Ga.set(e, t), Oi.set(t, e)), t;
}
const $a = (e) => Oi.get(e);
function el(e, t, { blocked: n, upgrade: r, blocking: a, terminated: s } = {}) {
  const i = indexedDB.open(e, t), o = Ar(i);
  return r && i.addEventListener("upgradeneeded", (u) => {
    r(Ar(i.result), u.oldVersion, u.newVersion, Ar(i.transaction), u);
  }), n && i.addEventListener("blocked", (u) => n(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    u.oldVersion,
    u.newVersion,
    u
  )), o.then((u) => {
    s && u.addEventListener("close", () => s()), a && u.addEventListener("versionchange", (c) => a(c.oldVersion, c.newVersion, c));
  }).catch(() => {
  }), o;
}
const tl = ["get", "getKey", "getAll", "getAllKeys", "count"], rl = ["put", "add", "delete", "clear"], za = /* @__PURE__ */ new Map();
function Is(e, t) {
  if (!(e instanceof IDBDatabase && !(t in e) && typeof t == "string"))
    return;
  if (za.get(t))
    return za.get(t);
  const n = t.replace(/FromIndex$/, ""), r = t !== n, a = rl.includes(n);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(n in (r ? IDBIndex : IDBObjectStore).prototype) || !(a || tl.includes(n))
  )
    return;
  const s = async function(i, ...o) {
    const u = this.transaction(i, a ? "readwrite" : "readonly");
    let c = u.store;
    return r && (c = c.index(o.shift())), (await Promise.all([
      c[n](...o),
      a && u.done
    ]))[0];
  };
  return za.set(t, s), s;
}
Xu((e) => ({
  ...e,
  get: (t, n, r) => Is(t, n) || e.get(t, n, r),
  has: (t, n) => !!Is(t, n) || e.has(t, n)
}));
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class nl {
  constructor(t) {
    this.container = t;
  }
  // In initial implementation, this will be called by installations on
  // auth token refresh, and installations will send this string.
  getPlatformInfoString() {
    return this.container.getProviders().map((n) => {
      if (al(n)) {
        const r = n.getImmediate();
        return `${r.library}/${r.version}`;
      } else
        return null;
    }).filter((n) => n).join(" ");
  }
}
function al(e) {
  const t = e.getComponent();
  return (t == null ? void 0 : t.type) === "VERSION";
}
const fi = "@firebase/app", ws = "0.9.24";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Yr = new xo("@firebase/app"), il = "@firebase/app-compat", sl = "@firebase/analytics-compat", ol = "@firebase/analytics", cl = "@firebase/app-check-compat", ul = "@firebase/app-check", ll = "@firebase/auth", fl = "@firebase/auth-compat", pl = "@firebase/database", hl = "@firebase/database-compat", dl = "@firebase/functions", yl = "@firebase/functions-compat", gl = "@firebase/installations", vl = "@firebase/installations-compat", ml = "@firebase/messaging", El = "@firebase/messaging-compat", Cl = "@firebase/performance", Sl = "@firebase/performance-compat", bl = "@firebase/remote-config", xl = "@firebase/remote-config-compat", Tl = "@firebase/storage", Al = "@firebase/storage-compat", Il = "@firebase/firestore", wl = "@firebase/firestore-compat", Bl = "firebase", _l = "10.7.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const pi = "[DEFAULT]", Nl = {
  [fi]: "fire-core",
  [il]: "fire-core-compat",
  [ol]: "fire-analytics",
  [sl]: "fire-analytics-compat",
  [ul]: "fire-app-check",
  [cl]: "fire-app-check-compat",
  [ll]: "fire-auth",
  [fl]: "fire-auth-compat",
  [pl]: "fire-rtdb",
  [hl]: "fire-rtdb-compat",
  [dl]: "fire-fn",
  [yl]: "fire-fn-compat",
  [gl]: "fire-iid",
  [vl]: "fire-iid-compat",
  [ml]: "fire-fcm",
  [El]: "fire-fcm-compat",
  [Cl]: "fire-perf",
  [Sl]: "fire-perf-compat",
  [bl]: "fire-rc",
  [xl]: "fire-rc-compat",
  [Tl]: "fire-gcs",
  [Al]: "fire-gcs-compat",
  [Il]: "fire-fst",
  [wl]: "fire-fst-compat",
  "fire-js": "fire-js",
  [Bl]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Kn = /* @__PURE__ */ new Map(), hi = /* @__PURE__ */ new Map();
function Rl(e, t) {
  try {
    e.container.addComponent(t);
  } catch (n) {
    Yr.debug(`Component ${t.name} failed to register with FirebaseApp ${e.name}`, n);
  }
}
function gn(e) {
  const t = e.name;
  if (hi.has(t))
    return Yr.debug(`There were multiple attempts to register component ${t}.`), !1;
  hi.set(t, e);
  for (const n of Kn.values())
    Rl(n, e);
  return !0;
}
function Pi(e, t) {
  const n = e.container.getProvider("heartbeat").getImmediate({ optional: !0 });
  return n && n.triggerHeartbeat(), e.container.getProvider(t);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Ll = {
  [
    "no-app"
    /* AppError.NO_APP */
  ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
  [
    "bad-app-name"
    /* AppError.BAD_APP_NAME */
  ]: "Illegal App name: '{$appName}",
  [
    "duplicate-app"
    /* AppError.DUPLICATE_APP */
  ]: "Firebase App named '{$appName}' already exists with different options or config",
  [
    "app-deleted"
    /* AppError.APP_DELETED */
  ]: "Firebase App named '{$appName}' already deleted",
  [
    "no-options"
    /* AppError.NO_OPTIONS */
  ]: "Need to provide options, when not being deployed to hosting via source.",
  [
    "invalid-app-argument"
    /* AppError.INVALID_APP_ARGUMENT */
  ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
  [
    "invalid-log-argument"
    /* AppError.INVALID_LOG_ARGUMENT */
  ]: "First argument to `onLog` must be null or a function.",
  [
    "idb-open"
    /* AppError.IDB_OPEN */
  ]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
  [
    "idb-get"
    /* AppError.IDB_GET */
  ]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
  [
    "idb-set"
    /* AppError.IDB_WRITE */
  ]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
  [
    "idb-delete"
    /* AppError.IDB_DELETE */
  ]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."
}, Ir = new xa("app", "Firebase", Ll);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Dl {
  constructor(t, n, r) {
    this._isDeleted = !1, this._options = Object.assign({}, t), this._config = Object.assign({}, n), this._name = n.name, this._automaticDataCollectionEnabled = n.automaticDataCollectionEnabled, this._container = r, this.container.addComponent(new Qr(
      "app",
      () => this,
      "PUBLIC"
      /* ComponentType.PUBLIC */
    ));
  }
  get automaticDataCollectionEnabled() {
    return this.checkDestroyed(), this._automaticDataCollectionEnabled;
  }
  set automaticDataCollectionEnabled(t) {
    this.checkDestroyed(), this._automaticDataCollectionEnabled = t;
  }
  get name() {
    return this.checkDestroyed(), this._name;
  }
  get options() {
    return this.checkDestroyed(), this._options;
  }
  get config() {
    return this.checkDestroyed(), this._config;
  }
  get container() {
    return this._container;
  }
  get isDeleted() {
    return this._isDeleted;
  }
  set isDeleted(t) {
    this._isDeleted = t;
  }
  /**
   * This function will throw an Error if the App has already been deleted -
   * use before performing API actions on the App.
   */
  checkDestroyed() {
    if (this.isDeleted)
      throw Ir.create("app-deleted", { appName: this._name });
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const kl = _l;
function Io(e, t = {}) {
  let n = e;
  typeof t != "object" && (t = { name: t });
  const r = Object.assign({ name: pi, automaticDataCollectionEnabled: !1 }, t), a = r.name;
  if (typeof a != "string" || !a)
    throw Ir.create("bad-app-name", {
      appName: String(a)
    });
  if (n || (n = So()), !n)
    throw Ir.create(
      "no-options"
      /* AppError.NO_OPTIONS */
    );
  const s = Kn.get(a);
  if (s) {
    if (ci(n, s.options) && ci(r, s.config))
      return s;
    throw Ir.create("duplicate-app", { appName: a });
  }
  const i = new Ku(a);
  for (const u of hi.values())
    i.addComponent(u);
  const o = new Dl(n, r, i);
  return Kn.set(a, o), o;
}
function Ol(e = pi) {
  const t = Kn.get(e);
  if (!t && e === pi && So())
    return Io();
  if (!t)
    throw Ir.create("no-app", { appName: e });
  return t;
}
function Bs() {
  return Array.from(Kn.values());
}
function wr(e, t, n) {
  var r;
  let a = (r = Nl[e]) !== null && r !== void 0 ? r : e;
  n && (a += `-${n}`);
  const s = a.match(/\s|\//), i = t.match(/\s|\//);
  if (s || i) {
    const o = [
      `Unable to register library "${a}" with version "${t}":`
    ];
    s && o.push(`library name "${a}" contains illegal characters (whitespace or "/")`), s && i && o.push("and"), i && o.push(`version name "${t}" contains illegal characters (whitespace or "/")`), Yr.warn(o.join(" "));
    return;
  }
  gn(new Qr(
    `${a}-version`,
    () => ({ library: a, version: t }),
    "VERSION"
    /* ComponentType.VERSION */
  ));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Pl = "firebase-heartbeat-database", Ul = 1, jn = "firebase-heartbeat-store";
let Wa = null;
function wo() {
  return Wa || (Wa = el(Pl, Ul, {
    upgrade: (e, t) => {
      switch (t) {
        case 0:
          e.createObjectStore(jn);
      }
    }
  }).catch((e) => {
    throw Ir.create("idb-open", {
      originalErrorMessage: e.message
    });
  })), Wa;
}
async function Fl(e) {
  try {
    return await (await wo()).transaction(jn).objectStore(jn).get(Bo(e));
  } catch (t) {
    if (t instanceof Lr)
      Yr.warn(t.message);
    else {
      const n = Ir.create("idb-get", {
        originalErrorMessage: t == null ? void 0 : t.message
      });
      Yr.warn(n.message);
    }
  }
}
async function _s(e, t) {
  try {
    const r = (await wo()).transaction(jn, "readwrite");
    await r.objectStore(jn).put(t, Bo(e)), await r.done;
  } catch (n) {
    if (n instanceof Lr)
      Yr.warn(n.message);
    else {
      const r = Ir.create("idb-set", {
        originalErrorMessage: n == null ? void 0 : n.message
      });
      Yr.warn(r.message);
    }
  }
}
function Bo(e) {
  return `${e.name}!${e.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Vl = 1024, Ml = 30 * 24 * 60 * 60 * 1e3;
class Kl {
  constructor(t) {
    this.container = t, this._heartbeatsCache = null;
    const n = this.container.getProvider("app").getImmediate();
    this._storage = new Hl(n), this._heartbeatsCachePromise = this._storage.read().then((r) => (this._heartbeatsCache = r, r));
  }
  /**
   * Called to report a heartbeat. The function will generate
   * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
   * to IndexedDB.
   * Note that we only store one heartbeat per day. So if a heartbeat for today is
   * already logged, subsequent calls to this function in the same day will be ignored.
   */
  async triggerHeartbeat() {
    var t, n;
    const a = this.container.getProvider("platform-logger").getImmediate().getPlatformInfoString(), s = Ns();
    if (!(((t = this._heartbeatsCache) === null || t === void 0 ? void 0 : t.heartbeats) == null && (this._heartbeatsCache = await this._heartbeatsCachePromise, ((n = this._heartbeatsCache) === null || n === void 0 ? void 0 : n.heartbeats) == null)) && !(this._heartbeatsCache.lastSentHeartbeatDate === s || this._heartbeatsCache.heartbeats.some((i) => i.date === s)))
      return this._heartbeatsCache.heartbeats.push({ date: s, agent: a }), this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((i) => {
        const o = new Date(i.date).valueOf();
        return Date.now() - o <= Ml;
      }), this._storage.overwrite(this._heartbeatsCache);
  }
  /**
   * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
   * It also clears all heartbeats from memory as well as in IndexedDB.
   *
   * NOTE: Consuming product SDKs should not send the header if this method
   * returns an empty string.
   */
  async getHeartbeatsHeader() {
    var t;
    if (this._heartbeatsCache === null && await this._heartbeatsCachePromise, ((t = this._heartbeatsCache) === null || t === void 0 ? void 0 : t.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0)
      return "";
    const n = Ns(), { heartbeatsToSend: r, unsentEntries: a } = jl(this._heartbeatsCache.heartbeats), s = Co(JSON.stringify({ version: 2, heartbeats: r }));
    return this._heartbeatsCache.lastSentHeartbeatDate = n, a.length > 0 ? (this._heartbeatsCache.heartbeats = a, await this._storage.overwrite(this._heartbeatsCache)) : (this._heartbeatsCache.heartbeats = [], this._storage.overwrite(this._heartbeatsCache)), s;
  }
}
function Ns() {
  return (/* @__PURE__ */ new Date()).toISOString().substring(0, 10);
}
function jl(e, t = Vl) {
  const n = [];
  let r = e.slice();
  for (const a of e) {
    const s = n.find((i) => i.agent === a.agent);
    if (s) {
      if (s.dates.push(a.date), Rs(n) > t) {
        s.dates.pop();
        break;
      }
    } else if (n.push({
      agent: a.agent,
      dates: [a.date]
    }), Rs(n) > t) {
      n.pop();
      break;
    }
    r = r.slice(1);
  }
  return {
    heartbeatsToSend: n,
    unsentEntries: r
  };
}
class Hl {
  constructor(t) {
    this.app = t, this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
  }
  async runIndexedDBEnvironmentCheck() {
    return bo() ? _u().then(() => !0).catch(() => !1) : !1;
  }
  /**
   * Read all heartbeats.
   */
  async read() {
    if (await this._canUseIndexedDBPromise) {
      const n = await Fl(this.app);
      return n != null && n.heartbeats ? n : { heartbeats: [] };
    } else
      return { heartbeats: [] };
  }
  // overwrite the storage with the provided heartbeats
  async overwrite(t) {
    var n;
    if (await this._canUseIndexedDBPromise) {
      const a = await this.read();
      return _s(this.app, {
        lastSentHeartbeatDate: (n = t.lastSentHeartbeatDate) !== null && n !== void 0 ? n : a.lastSentHeartbeatDate,
        heartbeats: t.heartbeats
      });
    } else
      return;
  }
  // add heartbeats
  async add(t) {
    var n;
    if (await this._canUseIndexedDBPromise) {
      const a = await this.read();
      return _s(this.app, {
        lastSentHeartbeatDate: (n = t.lastSentHeartbeatDate) !== null && n !== void 0 ? n : a.lastSentHeartbeatDate,
        heartbeats: [
          ...a.heartbeats,
          ...t.heartbeats
        ]
      });
    } else
      return;
  }
}
function Rs(e) {
  return Co(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: e })
  ).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ql(e) {
  gn(new Qr(
    "platform-logger",
    (t) => new nl(t),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), gn(new Qr(
    "heartbeat",
    (t) => new Kl(t),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), wr(fi, ws, e), wr(fi, ws, "esm2017"), wr("fire-js", "");
}
ql("");
var Gl = "firebase", $l = "10.7.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
wr(Gl, $l, "app");
const zl = (e, t) => t.some((n) => e instanceof n);
let Ls, Ds;
function Wl() {
  return Ls || (Ls = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function Ql() {
  return Ds || (Ds = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const _o = /* @__PURE__ */ new WeakMap(), di = /* @__PURE__ */ new WeakMap(), No = /* @__PURE__ */ new WeakMap(), Qa = /* @__PURE__ */ new WeakMap(), Ui = /* @__PURE__ */ new WeakMap();
function Yl(e) {
  const t = new Promise((n, r) => {
    const a = () => {
      e.removeEventListener("success", s), e.removeEventListener("error", i);
    }, s = () => {
      n(Br(e.result)), a();
    }, i = () => {
      r(e.error), a();
    };
    e.addEventListener("success", s), e.addEventListener("error", i);
  });
  return t.then((n) => {
    n instanceof IDBCursor && _o.set(n, e);
  }).catch(() => {
  }), Ui.set(t, e), t;
}
function Xl(e) {
  if (di.has(e))
    return;
  const t = new Promise((n, r) => {
    const a = () => {
      e.removeEventListener("complete", s), e.removeEventListener("error", i), e.removeEventListener("abort", i);
    }, s = () => {
      n(), a();
    }, i = () => {
      r(e.error || new DOMException("AbortError", "AbortError")), a();
    };
    e.addEventListener("complete", s), e.addEventListener("error", i), e.addEventListener("abort", i);
  });
  di.set(e, t);
}
let yi = {
  get(e, t, n) {
    if (e instanceof IDBTransaction) {
      if (t === "done")
        return di.get(e);
      if (t === "objectStoreNames")
        return e.objectStoreNames || No.get(e);
      if (t === "store")
        return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
    }
    return Br(e[t]);
  },
  set(e, t, n) {
    return e[t] = n, !0;
  },
  has(e, t) {
    return e instanceof IDBTransaction && (t === "done" || t === "store") ? !0 : t in e;
  }
};
function Jl(e) {
  yi = e(yi);
}
function Zl(e) {
  return e === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(t, ...n) {
    const r = e.call(Ya(this), t, ...n);
    return No.set(r, t.sort ? t.sort() : [t]), Br(r);
  } : Ql().includes(e) ? function(...t) {
    return e.apply(Ya(this), t), Br(_o.get(this));
  } : function(...t) {
    return Br(e.apply(Ya(this), t));
  };
}
function ef(e) {
  return typeof e == "function" ? Zl(e) : (e instanceof IDBTransaction && Xl(e), zl(e, Wl()) ? new Proxy(e, yi) : e);
}
function Br(e) {
  if (e instanceof IDBRequest)
    return Yl(e);
  if (Qa.has(e))
    return Qa.get(e);
  const t = ef(e);
  return t !== e && (Qa.set(e, t), Ui.set(t, e)), t;
}
const Ya = (e) => Ui.get(e);
function tf(e, t, { blocked: n, upgrade: r, blocking: a, terminated: s } = {}) {
  const i = indexedDB.open(e, t), o = Br(i);
  return r && i.addEventListener("upgradeneeded", (u) => {
    r(Br(i.result), u.oldVersion, u.newVersion, Br(i.transaction));
  }), n && i.addEventListener("blocked", () => n()), o.then((u) => {
    s && u.addEventListener("close", () => s()), a && u.addEventListener("versionchange", () => a());
  }).catch(() => {
  }), o;
}
const rf = ["get", "getKey", "getAll", "getAllKeys", "count"], nf = ["put", "add", "delete", "clear"], Xa = /* @__PURE__ */ new Map();
function ks(e, t) {
  if (!(e instanceof IDBDatabase && !(t in e) && typeof t == "string"))
    return;
  if (Xa.get(t))
    return Xa.get(t);
  const n = t.replace(/FromIndex$/, ""), r = t !== n, a = nf.includes(n);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(n in (r ? IDBIndex : IDBObjectStore).prototype) || !(a || rf.includes(n))
  )
    return;
  const s = async function(i, ...o) {
    const u = this.transaction(i, a ? "readwrite" : "readonly");
    let c = u.store;
    return r && (c = c.index(o.shift())), (await Promise.all([
      c[n](...o),
      a && u.done
    ]))[0];
  };
  return Xa.set(t, s), s;
}
Jl((e) => ({
  ...e,
  get: (t, n, r) => ks(t, n) || e.get(t, n, r),
  has: (t, n) => !!ks(t, n) || e.has(t, n)
}));
const Ro = "@firebase/installations", Fi = "0.6.4";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Lo = 1e4, Do = `w:${Fi}`, ko = "FIS_v2", af = "https://firebaseinstallations.googleapis.com/v1", sf = 60 * 60 * 1e3, of = "installations", cf = "Installations";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const uf = {
  [
    "missing-app-config-values"
    /* ErrorCode.MISSING_APP_CONFIG_VALUES */
  ]: 'Missing App configuration value: "{$valueName}"',
  [
    "not-registered"
    /* ErrorCode.NOT_REGISTERED */
  ]: "Firebase Installation is not registered.",
  [
    "installation-not-found"
    /* ErrorCode.INSTALLATION_NOT_FOUND */
  ]: "Firebase Installation not found.",
  [
    "request-failed"
    /* ErrorCode.REQUEST_FAILED */
  ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
  [
    "app-offline"
    /* ErrorCode.APP_OFFLINE */
  ]: "Could not process request. Application offline.",
  [
    "delete-pending-registration"
    /* ErrorCode.DELETE_PENDING_REGISTRATION */
  ]: "Can't delete installation while there is a pending registration request."
}, Xr = new xa(of, cf, uf);
function Oo(e) {
  return e instanceof Lr && e.code.includes(
    "request-failed"
    /* ErrorCode.REQUEST_FAILED */
  );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Po({ projectId: e }) {
  return `${af}/projects/${e}/installations`;
}
function Uo(e) {
  return {
    token: e.token,
    requestStatus: 2,
    expiresIn: ff(e.expiresIn),
    creationTime: Date.now()
  };
}
async function Fo(e, t) {
  const r = (await t.json()).error;
  return Xr.create("request-failed", {
    requestName: e,
    serverCode: r.code,
    serverMessage: r.message,
    serverStatus: r.status
  });
}
function Vo({ apiKey: e }) {
  return new Headers({
    "Content-Type": "application/json",
    Accept: "application/json",
    "x-goog-api-key": e
  });
}
function lf(e, { refreshToken: t }) {
  const n = Vo(e);
  return n.append("Authorization", pf(t)), n;
}
async function Mo(e) {
  const t = await e();
  return t.status >= 500 && t.status < 600 ? e() : t;
}
function ff(e) {
  return Number(e.replace("s", "000"));
}
function pf(e) {
  return `${ko} ${e}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function hf({ appConfig: e, heartbeatServiceProvider: t }, { fid: n }) {
  const r = Po(e), a = Vo(e), s = t.getImmediate({
    optional: !0
  });
  if (s) {
    const c = await s.getHeartbeatsHeader();
    c && a.append("x-firebase-client", c);
  }
  const i = {
    fid: n,
    authVersion: ko,
    appId: e.appId,
    sdkVersion: Do
  }, o = {
    method: "POST",
    headers: a,
    body: JSON.stringify(i)
  }, u = await Mo(() => fetch(r, o));
  if (u.ok) {
    const c = await u.json();
    return {
      fid: c.fid || n,
      registrationStatus: 2,
      refreshToken: c.refreshToken,
      authToken: Uo(c.authToken)
    };
  } else
    throw await Fo("Create Installation", u);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ko(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function df(e) {
  return btoa(String.fromCharCode(...e)).replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const yf = /^[cdef][\w-]{21}$/, gi = "";
function gf() {
  try {
    const e = new Uint8Array(17);
    (self.crypto || self.msCrypto).getRandomValues(e), e[0] = 112 + e[0] % 16;
    const n = vf(e);
    return yf.test(n) ? n : gi;
  } catch {
    return gi;
  }
}
function vf(e) {
  return df(e).substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ta(e) {
  return `${e.appName}!${e.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const jo = /* @__PURE__ */ new Map();
function Ho(e, t) {
  const n = Ta(e);
  qo(n, t), mf(n, t);
}
function qo(e, t) {
  const n = jo.get(e);
  if (n)
    for (const r of n)
      r(t);
}
function mf(e, t) {
  const n = Ef();
  n && n.postMessage({ key: e, fid: t }), Cf();
}
let $r = null;
function Ef() {
  return !$r && "BroadcastChannel" in self && ($r = new BroadcastChannel("[Firebase] FID Change"), $r.onmessage = (e) => {
    qo(e.data.key, e.data.fid);
  }), $r;
}
function Cf() {
  jo.size === 0 && $r && ($r.close(), $r = null);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Sf = "firebase-installations-database", bf = 1, Jr = "firebase-installations-store";
let Ja = null;
function Vi() {
  return Ja || (Ja = tf(Sf, bf, {
    upgrade: (e, t) => {
      switch (t) {
        case 0:
          e.createObjectStore(Jr);
      }
    }
  })), Ja;
}
async function la(e, t) {
  const n = Ta(e), a = (await Vi()).transaction(Jr, "readwrite"), s = a.objectStore(Jr), i = await s.get(n);
  return await s.put(t, n), await a.done, (!i || i.fid !== t.fid) && Ho(e, t.fid), t;
}
async function Go(e) {
  const t = Ta(e), r = (await Vi()).transaction(Jr, "readwrite");
  await r.objectStore(Jr).delete(t), await r.done;
}
async function Aa(e, t) {
  const n = Ta(e), a = (await Vi()).transaction(Jr, "readwrite"), s = a.objectStore(Jr), i = await s.get(n), o = t(i);
  return o === void 0 ? await s.delete(n) : await s.put(o, n), await a.done, o && (!i || i.fid !== o.fid) && Ho(e, o.fid), o;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Mi(e) {
  let t;
  const n = await Aa(e.appConfig, (r) => {
    const a = xf(r), s = Tf(e, a);
    return t = s.registrationPromise, s.installationEntry;
  });
  return n.fid === gi ? { installationEntry: await t } : {
    installationEntry: n,
    registrationPromise: t
  };
}
function xf(e) {
  const t = e || {
    fid: gf(),
    registrationStatus: 0
    /* RequestStatus.NOT_STARTED */
  };
  return $o(t);
}
function Tf(e, t) {
  if (t.registrationStatus === 0) {
    if (!navigator.onLine) {
      const a = Promise.reject(Xr.create(
        "app-offline"
        /* ErrorCode.APP_OFFLINE */
      ));
      return {
        installationEntry: t,
        registrationPromise: a
      };
    }
    const n = {
      fid: t.fid,
      registrationStatus: 1,
      registrationTime: Date.now()
    }, r = Af(e, n);
    return { installationEntry: n, registrationPromise: r };
  } else
    return t.registrationStatus === 1 ? {
      installationEntry: t,
      registrationPromise: If(e)
    } : { installationEntry: t };
}
async function Af(e, t) {
  try {
    const n = await hf(e, t);
    return la(e.appConfig, n);
  } catch (n) {
    throw Oo(n) && n.customData.serverCode === 409 ? await Go(e.appConfig) : await la(e.appConfig, {
      fid: t.fid,
      registrationStatus: 0
      /* RequestStatus.NOT_STARTED */
    }), n;
  }
}
async function If(e) {
  let t = await Os(e.appConfig);
  for (; t.registrationStatus === 1; )
    await Ko(100), t = await Os(e.appConfig);
  if (t.registrationStatus === 0) {
    const { installationEntry: n, registrationPromise: r } = await Mi(e);
    return r || n;
  }
  return t;
}
function Os(e) {
  return Aa(e, (t) => {
    if (!t)
      throw Xr.create(
        "installation-not-found"
        /* ErrorCode.INSTALLATION_NOT_FOUND */
      );
    return $o(t);
  });
}
function $o(e) {
  return wf(e) ? {
    fid: e.fid,
    registrationStatus: 0
    /* RequestStatus.NOT_STARTED */
  } : e;
}
function wf(e) {
  return e.registrationStatus === 1 && e.registrationTime + Lo < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Bf({ appConfig: e, heartbeatServiceProvider: t }, n) {
  const r = _f(e, n), a = lf(e, n), s = t.getImmediate({
    optional: !0
  });
  if (s) {
    const c = await s.getHeartbeatsHeader();
    c && a.append("x-firebase-client", c);
  }
  const i = {
    installation: {
      sdkVersion: Do,
      appId: e.appId
    }
  }, o = {
    method: "POST",
    headers: a,
    body: JSON.stringify(i)
  }, u = await Mo(() => fetch(r, o));
  if (u.ok) {
    const c = await u.json();
    return Uo(c);
  } else
    throw await Fo("Generate Auth Token", u);
}
function _f(e, { fid: t }) {
  return `${Po(e)}/${t}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Ki(e, t = !1) {
  let n;
  const r = await Aa(e.appConfig, (s) => {
    if (!zo(s))
      throw Xr.create(
        "not-registered"
        /* ErrorCode.NOT_REGISTERED */
      );
    const i = s.authToken;
    if (!t && Lf(i))
      return s;
    if (i.requestStatus === 1)
      return n = Nf(e, t), s;
    {
      if (!navigator.onLine)
        throw Xr.create(
          "app-offline"
          /* ErrorCode.APP_OFFLINE */
        );
      const o = kf(s);
      return n = Rf(e, o), o;
    }
  });
  return n ? await n : r.authToken;
}
async function Nf(e, t) {
  let n = await Ps(e.appConfig);
  for (; n.authToken.requestStatus === 1; )
    await Ko(100), n = await Ps(e.appConfig);
  const r = n.authToken;
  return r.requestStatus === 0 ? Ki(e, t) : r;
}
function Ps(e) {
  return Aa(e, (t) => {
    if (!zo(t))
      throw Xr.create(
        "not-registered"
        /* ErrorCode.NOT_REGISTERED */
      );
    const n = t.authToken;
    return Of(n) ? Object.assign(Object.assign({}, t), { authToken: {
      requestStatus: 0
      /* RequestStatus.NOT_STARTED */
    } }) : t;
  });
}
async function Rf(e, t) {
  try {
    const n = await Bf(e, t), r = Object.assign(Object.assign({}, t), { authToken: n });
    return await la(e.appConfig, r), n;
  } catch (n) {
    if (Oo(n) && (n.customData.serverCode === 401 || n.customData.serverCode === 404))
      await Go(e.appConfig);
    else {
      const r = Object.assign(Object.assign({}, t), { authToken: {
        requestStatus: 0
        /* RequestStatus.NOT_STARTED */
      } });
      await la(e.appConfig, r);
    }
    throw n;
  }
}
function zo(e) {
  return e !== void 0 && e.registrationStatus === 2;
}
function Lf(e) {
  return e.requestStatus === 2 && !Df(e);
}
function Df(e) {
  const t = Date.now();
  return t < e.creationTime || e.creationTime + e.expiresIn < t + sf;
}
function kf(e) {
  const t = {
    requestStatus: 1,
    requestTime: Date.now()
  };
  return Object.assign(Object.assign({}, e), { authToken: t });
}
function Of(e) {
  return e.requestStatus === 1 && e.requestTime + Lo < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Pf(e) {
  const t = e, { installationEntry: n, registrationPromise: r } = await Mi(t);
  return r ? r.catch(console.error) : Ki(t).catch(console.error), n.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Uf(e, t = !1) {
  const n = e;
  return await Ff(n), (await Ki(n, t)).token;
}
async function Ff(e) {
  const { registrationPromise: t } = await Mi(e);
  t && await t;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Vf(e) {
  if (!e || !e.options)
    throw Za("App Configuration");
  if (!e.name)
    throw Za("App Name");
  const t = [
    "projectId",
    "apiKey",
    "appId"
  ];
  for (const n of t)
    if (!e.options[n])
      throw Za(n);
  return {
    appName: e.name,
    projectId: e.options.projectId,
    apiKey: e.options.apiKey,
    appId: e.options.appId
  };
}
function Za(e) {
  return Xr.create("missing-app-config-values", {
    valueName: e
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Wo = "installations", Mf = "installations-internal", Kf = (e) => {
  const t = e.getProvider("app").getImmediate(), n = Vf(t), r = Pi(t, "heartbeat");
  return {
    app: t,
    appConfig: n,
    heartbeatServiceProvider: r,
    _delete: () => Promise.resolve()
  };
}, jf = (e) => {
  const t = e.getProvider("app").getImmediate(), n = Pi(t, Wo).getImmediate();
  return {
    getId: () => Pf(n),
    getToken: (a) => Uf(n, a)
  };
};
function Hf() {
  gn(new Qr(
    Wo,
    Kf,
    "PUBLIC"
    /* ComponentType.PUBLIC */
  )), gn(new Qr(
    Mf,
    jf,
    "PRIVATE"
    /* ComponentType.PRIVATE */
  ));
}
Hf();
wr(Ro, Fi);
wr(Ro, Fi, "esm2017");
const ei = "@firebase/remote-config", Us = "0.4.4";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class qf {
  constructor() {
    this.listeners = [];
  }
  addEventListener(t) {
    this.listeners.push(t);
  }
  abort() {
    this.listeners.forEach((t) => t());
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Qo = "remote-config";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Gf = {
  [
    "registration-window"
    /* ErrorCode.REGISTRATION_WINDOW */
  ]: "Undefined window object. This SDK only supports usage in a browser environment.",
  [
    "registration-project-id"
    /* ErrorCode.REGISTRATION_PROJECT_ID */
  ]: "Undefined project identifier. Check Firebase app initialization.",
  [
    "registration-api-key"
    /* ErrorCode.REGISTRATION_API_KEY */
  ]: "Undefined API key. Check Firebase app initialization.",
  [
    "registration-app-id"
    /* ErrorCode.REGISTRATION_APP_ID */
  ]: "Undefined app identifier. Check Firebase app initialization.",
  [
    "storage-open"
    /* ErrorCode.STORAGE_OPEN */
  ]: "Error thrown when opening storage. Original error: {$originalErrorMessage}.",
  [
    "storage-get"
    /* ErrorCode.STORAGE_GET */
  ]: "Error thrown when reading from storage. Original error: {$originalErrorMessage}.",
  [
    "storage-set"
    /* ErrorCode.STORAGE_SET */
  ]: "Error thrown when writing to storage. Original error: {$originalErrorMessage}.",
  [
    "storage-delete"
    /* ErrorCode.STORAGE_DELETE */
  ]: "Error thrown when deleting from storage. Original error: {$originalErrorMessage}.",
  [
    "fetch-client-network"
    /* ErrorCode.FETCH_NETWORK */
  ]: "Fetch client failed to connect to a network. Check Internet connection. Original error: {$originalErrorMessage}.",
  [
    "fetch-timeout"
    /* ErrorCode.FETCH_TIMEOUT */
  ]: 'The config fetch request timed out.  Configure timeout using "fetchTimeoutMillis" SDK setting.',
  [
    "fetch-throttle"
    /* ErrorCode.FETCH_THROTTLE */
  ]: 'The config fetch request timed out while in an exponential backoff state. Configure timeout using "fetchTimeoutMillis" SDK setting. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.',
  [
    "fetch-client-parse"
    /* ErrorCode.FETCH_PARSE */
  ]: "Fetch client could not parse response. Original error: {$originalErrorMessage}.",
  [
    "fetch-status"
    /* ErrorCode.FETCH_STATUS */
  ]: "Fetch server returned an HTTP error status. HTTP status: {$httpStatus}.",
  [
    "indexed-db-unavailable"
    /* ErrorCode.INDEXED_DB_UNAVAILABLE */
  ]: "Indexed DB is not supported by current browser"
}, It = new xa("remoteconfig", "Remote Config", Gf);
function $f(e, t) {
  return e instanceof Lr && e.code.indexOf(t) !== -1;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const zf = !1, Wf = "", Fs = 0, Qf = ["1", "true", "t", "yes", "y", "on"];
class ti {
  constructor(t, n = Wf) {
    this._source = t, this._value = n;
  }
  asString() {
    return this._value;
  }
  asBoolean() {
    return this._source === "static" ? zf : Qf.indexOf(this._value.toLowerCase()) >= 0;
  }
  asNumber() {
    if (this._source === "static")
      return Fs;
    let t = Number(this._value);
    return isNaN(t) && (t = Fs), t;
  }
  getSource() {
    return this._source;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Yf(e = Ol()) {
  return e = Zr(e), Pi(e, Qo).getImmediate();
}
async function Xf(e) {
  const t = Zr(e), [n, r] = await Promise.all([
    t._storage.getLastSuccessfulFetchResponse(),
    t._storage.getActiveConfigEtag()
  ]);
  return !n || !n.config || !n.eTag || n.eTag === r ? !1 : (await Promise.all([
    t._storageCache.setActiveConfig(n.config),
    t._storage.setActiveConfigEtag(n.eTag)
  ]), !0);
}
function Jf(e) {
  const t = Zr(e);
  return t._initializePromise || (t._initializePromise = t._storageCache.loadFromStorage().then(() => {
    t._isInitializationComplete = !0;
  })), t._initializePromise;
}
async function Zf(e) {
  const t = Zr(e), n = new qf();
  setTimeout(async () => {
    n.abort();
  }, t.settings.fetchTimeoutMillis);
  try {
    await t._client.fetch({
      cacheMaxAgeMillis: t.settings.minimumFetchIntervalMillis,
      signal: n
    }), await t._storageCache.setLastFetchStatus("success");
  } catch (r) {
    const a = $f(
      r,
      "fetch-throttle"
      /* ErrorCode.FETCH_THROTTLE */
    ) ? "throttle" : "failure";
    throw await t._storageCache.setLastFetchStatus(a), r;
  }
}
function fy(e) {
  const t = Zr(e);
  return e0(t._storageCache.getActiveConfig(), t.defaultConfig).reduce((n, r) => (n[r] = Yo(e, r), n), {});
}
function Yo(e, t) {
  const n = Zr(e);
  n._isInitializationComplete || n._logger.debug(`A value was requested for key "${t}" before SDK initialization completed. Await on ensureInitialized if the intent was to get a previously activated value.`);
  const r = n._storageCache.getActiveConfig();
  return r && r[t] !== void 0 ? new ti("remote", r[t]) : n.defaultConfig && n.defaultConfig[t] !== void 0 ? new ti("default", String(n.defaultConfig[t])) : (n._logger.debug(`Returning static value for key "${t}". Define a default or remote value if this is unintentional.`), new ti("static"));
}
function e0(e = {}, t = {}) {
  return Object.keys(Object.assign(Object.assign({}, e), t));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class t0 {
  constructor(t, n, r, a) {
    this.client = t, this.storage = n, this.storageCache = r, this.logger = a;
  }
  /**
   * Returns true if the age of the cached fetched configs is less than or equal to
   * {@link Settings#minimumFetchIntervalInSeconds}.
   *
   * <p>This is comparable to passing `headers = { 'Cache-Control': max-age <maxAge> }` to the
   * native Fetch API.
   *
   * <p>Visible for testing.
   */
  isCachedDataFresh(t, n) {
    if (!n)
      return this.logger.debug("Config fetch cache check. Cache unpopulated."), !1;
    const r = Date.now() - n, a = r <= t;
    return this.logger.debug(`Config fetch cache check. Cache age millis: ${r}. Cache max age millis (minimumFetchIntervalMillis setting): ${t}. Is cache hit: ${a}.`), a;
  }
  async fetch(t) {
    const [n, r] = await Promise.all([
      this.storage.getLastSuccessfulFetchTimestampMillis(),
      this.storage.getLastSuccessfulFetchResponse()
    ]);
    if (r && this.isCachedDataFresh(t.cacheMaxAgeMillis, n))
      return r;
    t.eTag = r && r.eTag;
    const a = await this.client.fetch(t), s = [
      // Uses write-through cache for consistency with synchronous public API.
      this.storageCache.setLastSuccessfulFetchTimestampMillis(Date.now())
    ];
    return a.status === 200 && s.push(this.storage.setLastSuccessfulFetchResponse(a)), await Promise.all(s), a;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function r0(e = navigator) {
  return (
    // Most reliable, but only supported in Chrome/Firefox.
    e.languages && e.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    e.language
  );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class n0 {
  constructor(t, n, r, a, s, i) {
    this.firebaseInstallations = t, this.sdkVersion = n, this.namespace = r, this.projectId = a, this.apiKey = s, this.appId = i;
  }
  /**
   * Fetches from the Remote Config REST API.
   *
   * @throws a {@link ErrorCode.FETCH_NETWORK} error if {@link GlobalFetch#fetch} can't
   * connect to the network.
   * @throws a {@link ErrorCode.FETCH_PARSE} error if {@link Response#json} can't parse the
   * fetch response.
   * @throws a {@link ErrorCode.FETCH_STATUS} error if the service returns an HTTP error status.
   */
  async fetch(t) {
    const [n, r] = await Promise.all([
      this.firebaseInstallations.getId(),
      this.firebaseInstallations.getToken()
    ]), s = `${window.FIREBASE_REMOTE_CONFIG_URL_BASE || "https://firebaseremoteconfig.googleapis.com"}/v1/projects/${this.projectId}/namespaces/${this.namespace}:fetch?key=${this.apiKey}`, i = {
      "Content-Type": "application/json",
      "Content-Encoding": "gzip",
      // Deviates from pure decorator by not passing max-age header since we don't currently have
      // service behavior using that header.
      "If-None-Match": t.eTag || "*"
    }, o = {
      /* eslint-disable camelcase */
      sdk_version: this.sdkVersion,
      app_instance_id: n,
      app_instance_id_token: r,
      app_id: this.appId,
      language_code: r0()
      /* eslint-enable camelcase */
    }, u = {
      method: "POST",
      headers: i,
      body: JSON.stringify(o)
    }, c = fetch(s, u), l = new Promise((S, A) => {
      t.signal.addEventListener(() => {
        const D = new Error("The operation was aborted.");
        D.name = "AbortError", A(D);
      });
    });
    let p;
    try {
      await Promise.race([c, l]), p = await c;
    } catch (S) {
      let A = "fetch-client-network";
      throw (S == null ? void 0 : S.name) === "AbortError" && (A = "fetch-timeout"), It.create(A, {
        originalErrorMessage: S == null ? void 0 : S.message
      });
    }
    let g = p.status;
    const C = p.headers.get("ETag") || void 0;
    let d, b;
    if (p.status === 200) {
      let S;
      try {
        S = await p.json();
      } catch (A) {
        throw It.create("fetch-client-parse", {
          originalErrorMessage: A == null ? void 0 : A.message
        });
      }
      d = S.entries, b = S.state;
    }
    if (b === "INSTANCE_STATE_UNSPECIFIED" ? g = 500 : b === "NO_CHANGE" ? g = 304 : (b === "NO_TEMPLATE" || b === "EMPTY_CONFIG") && (d = {}), g !== 304 && g !== 200)
      throw It.create("fetch-status", {
        httpStatus: g
      });
    return { status: g, eTag: C, config: d };
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function a0(e, t) {
  return new Promise((n, r) => {
    const a = Math.max(t - Date.now(), 0), s = setTimeout(n, a);
    e.addEventListener(() => {
      clearTimeout(s), r(It.create("fetch-throttle", {
        throttleEndTimeMillis: t
      }));
    });
  });
}
function i0(e) {
  if (!(e instanceof Lr) || !e.customData)
    return !1;
  const t = Number(e.customData.httpStatus);
  return t === 429 || t === 500 || t === 503 || t === 504;
}
class s0 {
  constructor(t, n) {
    this.client = t, this.storage = n;
  }
  async fetch(t) {
    const n = await this.storage.getThrottleMetadata() || {
      backoffCount: 0,
      throttleEndTimeMillis: Date.now()
    };
    return this.attemptFetch(t, n);
  }
  /**
   * A recursive helper for attempting a fetch request repeatedly.
   *
   * @throws any non-retriable errors.
   */
  async attemptFetch(t, { throttleEndTimeMillis: n, backoffCount: r }) {
    await a0(t.signal, n);
    try {
      const a = await this.client.fetch(t);
      return await this.storage.deleteThrottleMetadata(), a;
    } catch (a) {
      if (!i0(a))
        throw a;
      const s = {
        throttleEndTimeMillis: Date.now() + Uu(r),
        backoffCount: r + 1
      };
      return await this.storage.setThrottleMetadata(s), this.attemptFetch(t, s);
    }
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const o0 = 60 * 1e3, c0 = 12 * 60 * 60 * 1e3;
class u0 {
  constructor(t, n, r, a, s) {
    this.app = t, this._client = n, this._storageCache = r, this._storage = a, this._logger = s, this._isInitializationComplete = !1, this.settings = {
      fetchTimeoutMillis: o0,
      minimumFetchIntervalMillis: c0
    }, this.defaultConfig = {};
  }
  get fetchTimeMillis() {
    return this._storageCache.getLastSuccessfulFetchTimestampMillis() || -1;
  }
  get lastFetchStatus() {
    return this._storageCache.getLastFetchStatus() || "no-fetch-yet";
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function sa(e, t) {
  const n = e.target.error || void 0;
  return It.create(t, {
    originalErrorMessage: n && (n == null ? void 0 : n.message)
  });
}
const jr = "app_namespace_store", l0 = "firebase_remote_config", f0 = 1;
function p0() {
  return new Promise((e, t) => {
    try {
      const n = indexedDB.open(l0, f0);
      n.onerror = (r) => {
        t(sa(
          r,
          "storage-open"
          /* ErrorCode.STORAGE_OPEN */
        ));
      }, n.onsuccess = (r) => {
        e(r.target.result);
      }, n.onupgradeneeded = (r) => {
        const a = r.target.result;
        switch (r.oldVersion) {
          case 0:
            a.createObjectStore(jr, {
              keyPath: "compositeKey"
            });
        }
      };
    } catch (n) {
      t(It.create("storage-open", {
        originalErrorMessage: n == null ? void 0 : n.message
      }));
    }
  });
}
class h0 {
  /**
   * @param appId enables storage segmentation by app (ID + name).
   * @param appName enables storage segmentation by app (ID + name).
   * @param namespace enables storage segmentation by namespace.
   */
  constructor(t, n, r, a = p0()) {
    this.appId = t, this.appName = n, this.namespace = r, this.openDbPromise = a;
  }
  getLastFetchStatus() {
    return this.get("last_fetch_status");
  }
  setLastFetchStatus(t) {
    return this.set("last_fetch_status", t);
  }
  // This is comparable to a cache entry timestamp. If we need to expire other data, we could
  // consider adding timestamp to all storage records and an optional max age arg to getters.
  getLastSuccessfulFetchTimestampMillis() {
    return this.get("last_successful_fetch_timestamp_millis");
  }
  setLastSuccessfulFetchTimestampMillis(t) {
    return this.set("last_successful_fetch_timestamp_millis", t);
  }
  getLastSuccessfulFetchResponse() {
    return this.get("last_successful_fetch_response");
  }
  setLastSuccessfulFetchResponse(t) {
    return this.set("last_successful_fetch_response", t);
  }
  getActiveConfig() {
    return this.get("active_config");
  }
  setActiveConfig(t) {
    return this.set("active_config", t);
  }
  getActiveConfigEtag() {
    return this.get("active_config_etag");
  }
  setActiveConfigEtag(t) {
    return this.set("active_config_etag", t);
  }
  getThrottleMetadata() {
    return this.get("throttle_metadata");
  }
  setThrottleMetadata(t) {
    return this.set("throttle_metadata", t);
  }
  deleteThrottleMetadata() {
    return this.delete("throttle_metadata");
  }
  async get(t) {
    const n = await this.openDbPromise;
    return new Promise((r, a) => {
      const i = n.transaction([jr], "readonly").objectStore(jr), o = this.createCompositeKey(t);
      try {
        const u = i.get(o);
        u.onerror = (c) => {
          a(sa(
            c,
            "storage-get"
            /* ErrorCode.STORAGE_GET */
          ));
        }, u.onsuccess = (c) => {
          const l = c.target.result;
          r(l ? l.value : void 0);
        };
      } catch (u) {
        a(It.create("storage-get", {
          originalErrorMessage: u == null ? void 0 : u.message
        }));
      }
    });
  }
  async set(t, n) {
    const r = await this.openDbPromise;
    return new Promise((a, s) => {
      const o = r.transaction([jr], "readwrite").objectStore(jr), u = this.createCompositeKey(t);
      try {
        const c = o.put({
          compositeKey: u,
          value: n
        });
        c.onerror = (l) => {
          s(sa(
            l,
            "storage-set"
            /* ErrorCode.STORAGE_SET */
          ));
        }, c.onsuccess = () => {
          a();
        };
      } catch (c) {
        s(It.create("storage-set", {
          originalErrorMessage: c == null ? void 0 : c.message
        }));
      }
    });
  }
  async delete(t) {
    const n = await this.openDbPromise;
    return new Promise((r, a) => {
      const i = n.transaction([jr], "readwrite").objectStore(jr), o = this.createCompositeKey(t);
      try {
        const u = i.delete(o);
        u.onerror = (c) => {
          a(sa(
            c,
            "storage-delete"
            /* ErrorCode.STORAGE_DELETE */
          ));
        }, u.onsuccess = () => {
          r();
        };
      } catch (u) {
        a(It.create("storage-delete", {
          originalErrorMessage: u == null ? void 0 : u.message
        }));
      }
    });
  }
  // Facilitates composite key functionality (which is unsupported in IE).
  createCompositeKey(t) {
    return [this.appId, this.appName, this.namespace, t].join();
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class d0 {
  constructor(t) {
    this.storage = t;
  }
  /**
   * Memory-only getters
   */
  getLastFetchStatus() {
    return this.lastFetchStatus;
  }
  getLastSuccessfulFetchTimestampMillis() {
    return this.lastSuccessfulFetchTimestampMillis;
  }
  getActiveConfig() {
    return this.activeConfig;
  }
  /**
   * Read-ahead getter
   */
  async loadFromStorage() {
    const t = this.storage.getLastFetchStatus(), n = this.storage.getLastSuccessfulFetchTimestampMillis(), r = this.storage.getActiveConfig(), a = await t;
    a && (this.lastFetchStatus = a);
    const s = await n;
    s && (this.lastSuccessfulFetchTimestampMillis = s);
    const i = await r;
    i && (this.activeConfig = i);
  }
  /**
   * Write-through setters
   */
  setLastFetchStatus(t) {
    return this.lastFetchStatus = t, this.storage.setLastFetchStatus(t);
  }
  setLastSuccessfulFetchTimestampMillis(t) {
    return this.lastSuccessfulFetchTimestampMillis = t, this.storage.setLastSuccessfulFetchTimestampMillis(t);
  }
  setActiveConfig(t) {
    return this.activeConfig = t, this.storage.setActiveConfig(t);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function y0() {
  gn(new Qr(
    Qo,
    e,
    "PUBLIC"
    /* ComponentType.PUBLIC */
  ).setMultipleInstances(!0)), wr(ei, Us), wr(ei, Us, "esm2017");
  function e(t, { instanceIdentifier: n }) {
    const r = t.getProvider("app").getImmediate(), a = t.getProvider("installations-internal").getImmediate();
    if (typeof window > "u")
      throw It.create(
        "registration-window"
        /* ErrorCode.REGISTRATION_WINDOW */
      );
    if (!bo())
      throw It.create(
        "indexed-db-unavailable"
        /* ErrorCode.INDEXED_DB_UNAVAILABLE */
      );
    const { projectId: s, apiKey: i, appId: o } = r.options;
    if (!s)
      throw It.create(
        "registration-project-id"
        /* ErrorCode.REGISTRATION_PROJECT_ID */
      );
    if (!i)
      throw It.create(
        "registration-api-key"
        /* ErrorCode.REGISTRATION_API_KEY */
      );
    if (!o)
      throw It.create(
        "registration-app-id"
        /* ErrorCode.REGISTRATION_APP_ID */
      );
    n = n || "firebase";
    const u = new h0(o, r.name, n), c = new d0(u), l = new xo(ei);
    l.logLevel = Ze.ERROR;
    const p = new n0(
      a,
      // Uses the JS SDK version, by which the RC package version can be deduced, if necessary.
      kl,
      n,
      s,
      i,
      o
    ), g = new s0(p, u), C = new t0(g, u, c, l), d = new u0(r, C, c, u, l);
    return Jf(d), d;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function g0(e) {
  return e = Zr(e), await Zf(e), Xf(e);
}
y0();
var De = {
  // default options
  options: {
    usePureJavaScript: !1
  }
}, ji = {}, v0 = ji, Vs = {};
ji.encode = function(e, t, n) {
  if (typeof t != "string")
    throw new TypeError('"alphabet" must be a string.');
  if (n !== void 0 && typeof n != "number")
    throw new TypeError('"maxline" must be a number.');
  var r = "";
  if (!(e instanceof Uint8Array))
    r = m0(e, t);
  else {
    var a = 0, s = t.length, i = t.charAt(0), o = [0];
    for (a = 0; a < e.length; ++a) {
      for (var u = 0, c = e[a]; u < o.length; ++u)
        c += o[u] << 8, o[u] = c % s, c = c / s | 0;
      for (; c > 0; )
        o.push(c % s), c = c / s | 0;
    }
    for (a = 0; e[a] === 0 && a < e.length - 1; ++a)
      r += i;
    for (a = o.length - 1; a >= 0; --a)
      r += t[o[a]];
  }
  if (n) {
    var l = new RegExp(".{1," + n + "}", "g");
    r = r.match(l).join(`\r
`);
  }
  return r;
};
ji.decode = function(e, t) {
  if (typeof e != "string")
    throw new TypeError('"input" must be a string.');
  if (typeof t != "string")
    throw new TypeError('"alphabet" must be a string.');
  var n = Vs[t];
  if (!n) {
    n = Vs[t] = [];
    for (var r = 0; r < t.length; ++r)
      n[t.charCodeAt(r)] = r;
  }
  e = e.replace(/\s/g, "");
  for (var a = t.length, s = t.charAt(0), i = [0], r = 0; r < e.length; r++) {
    var o = n[e.charCodeAt(r)];
    if (o === void 0)
      return;
    for (var u = 0, c = o; u < i.length; ++u)
      c += i[u] * a, i[u] = c & 255, c >>= 8;
    for (; c > 0; )
      i.push(c & 255), c >>= 8;
  }
  for (var l = 0; e[l] === s && l < e.length - 1; ++l)
    i.push(0);
  return typeof Buffer < "u" ? Buffer.from(i.reverse()) : new Uint8Array(i.reverse());
};
function m0(e, t) {
  var n = 0, r = t.length, a = t.charAt(0), s = [0];
  for (n = 0; n < e.length(); ++n) {
    for (var i = 0, o = e.at(n); i < s.length; ++i)
      o += s[i] << 8, s[i] = o % r, o = o / r | 0;
    for (; o > 0; )
      s.push(o % r), o = o / r | 0;
  }
  var u = "";
  for (n = 0; e.at(n) === 0 && n < e.length() - 1; ++n)
    u += a;
  for (n = s.length - 1; n >= 0; --n)
    u += t[s[n]];
  return u;
}
var Ms = De, Ks = v0, L = Ms.util = Ms.util || {};
(function() {
  if (typeof process < "u" && process.nextTick && !process.browser) {
    L.nextTick = process.nextTick, typeof setImmediate == "function" ? L.setImmediate = setImmediate : L.setImmediate = L.nextTick;
    return;
  }
  if (typeof setImmediate == "function") {
    L.setImmediate = function() {
      return setImmediate.apply(void 0, arguments);
    }, L.nextTick = function(i) {
      return setImmediate(i);
    };
    return;
  }
  if (L.setImmediate = function(i) {
    setTimeout(i, 0);
  }, typeof window < "u" && typeof window.postMessage == "function") {
    let i = function(o) {
      if (o.source === window && o.data === e) {
        o.stopPropagation();
        var u = t.slice();
        t.length = 0, u.forEach(function(c) {
          c();
        });
      }
    };
    var e = "forge.setImmediate", t = [];
    L.setImmediate = function(o) {
      t.push(o), t.length === 1 && window.postMessage(e, "*");
    }, window.addEventListener("message", i, !0);
  }
  if (typeof MutationObserver < "u") {
    var n = Date.now(), r = !0, a = document.createElement("div"), t = [];
    new MutationObserver(function() {
      var o = t.slice();
      t.length = 0, o.forEach(function(u) {
        u();
      });
    }).observe(a, { attributes: !0 });
    var s = L.setImmediate;
    L.setImmediate = function(o) {
      Date.now() - n > 15 ? (n = Date.now(), s(o)) : (t.push(o), t.length === 1 && a.setAttribute("a", r = !r));
    };
  }
  L.nextTick = L.setImmediate;
})();
L.isNodejs = typeof process < "u" && process.versions && process.versions.node;
L.globalScope = function() {
  return L.isNodejs ? vo : typeof self > "u" ? window : self;
}();
L.isArray = Array.isArray || function(e) {
  return Object.prototype.toString.call(e) === "[object Array]";
};
L.isArrayBuffer = function(e) {
  return typeof ArrayBuffer < "u" && e instanceof ArrayBuffer;
};
L.isArrayBufferView = function(e) {
  return e && L.isArrayBuffer(e.buffer) && e.byteLength !== void 0;
};
function qn(e) {
  if (!(e === 8 || e === 16 || e === 24 || e === 32))
    throw new Error("Only 8, 16, 24, or 32 bits supported: " + e);
}
L.ByteBuffer = Hi;
function Hi(e) {
  if (this.data = "", this.read = 0, typeof e == "string")
    this.data = e;
  else if (L.isArrayBuffer(e) || L.isArrayBufferView(e))
    if (typeof Buffer < "u" && e instanceof Buffer)
      this.data = e.toString("binary");
    else {
      var t = new Uint8Array(e);
      try {
        this.data = String.fromCharCode.apply(null, t);
      } catch {
        for (var n = 0; n < t.length; ++n)
          this.putByte(t[n]);
      }
    }
  else
    (e instanceof Hi || typeof e == "object" && typeof e.data == "string" && typeof e.read == "number") && (this.data = e.data, this.read = e.read);
  this._constructedStringLength = 0;
}
L.ByteStringBuffer = Hi;
var E0 = 4096;
L.ByteStringBuffer.prototype._optimizeConstructedString = function(e) {
  this._constructedStringLength += e, this._constructedStringLength > E0 && (this.data.substr(0, 1), this._constructedStringLength = 0);
};
L.ByteStringBuffer.prototype.length = function() {
  return this.data.length - this.read;
};
L.ByteStringBuffer.prototype.isEmpty = function() {
  return this.length() <= 0;
};
L.ByteStringBuffer.prototype.putByte = function(e) {
  return this.putBytes(String.fromCharCode(e));
};
L.ByteStringBuffer.prototype.fillWithByte = function(e, t) {
  e = String.fromCharCode(e);
  for (var n = this.data; t > 0; )
    t & 1 && (n += e), t >>>= 1, t > 0 && (e += e);
  return this.data = n, this._optimizeConstructedString(t), this;
};
L.ByteStringBuffer.prototype.putBytes = function(e) {
  return this.data += e, this._optimizeConstructedString(e.length), this;
};
L.ByteStringBuffer.prototype.putString = function(e) {
  return this.putBytes(L.encodeUtf8(e));
};
L.ByteStringBuffer.prototype.putInt16 = function(e) {
  return this.putBytes(
    String.fromCharCode(e >> 8 & 255) + String.fromCharCode(e & 255)
  );
};
L.ByteStringBuffer.prototype.putInt24 = function(e) {
  return this.putBytes(
    String.fromCharCode(e >> 16 & 255) + String.fromCharCode(e >> 8 & 255) + String.fromCharCode(e & 255)
  );
};
L.ByteStringBuffer.prototype.putInt32 = function(e) {
  return this.putBytes(
    String.fromCharCode(e >> 24 & 255) + String.fromCharCode(e >> 16 & 255) + String.fromCharCode(e >> 8 & 255) + String.fromCharCode(e & 255)
  );
};
L.ByteStringBuffer.prototype.putInt16Le = function(e) {
  return this.putBytes(
    String.fromCharCode(e & 255) + String.fromCharCode(e >> 8 & 255)
  );
};
L.ByteStringBuffer.prototype.putInt24Le = function(e) {
  return this.putBytes(
    String.fromCharCode(e & 255) + String.fromCharCode(e >> 8 & 255) + String.fromCharCode(e >> 16 & 255)
  );
};
L.ByteStringBuffer.prototype.putInt32Le = function(e) {
  return this.putBytes(
    String.fromCharCode(e & 255) + String.fromCharCode(e >> 8 & 255) + String.fromCharCode(e >> 16 & 255) + String.fromCharCode(e >> 24 & 255)
  );
};
L.ByteStringBuffer.prototype.putInt = function(e, t) {
  qn(t);
  var n = "";
  do
    t -= 8, n += String.fromCharCode(e >> t & 255);
  while (t > 0);
  return this.putBytes(n);
};
L.ByteStringBuffer.prototype.putSignedInt = function(e, t) {
  return e < 0 && (e += 2 << t - 1), this.putInt(e, t);
};
L.ByteStringBuffer.prototype.putBuffer = function(e) {
  return this.putBytes(e.getBytes());
};
L.ByteStringBuffer.prototype.getByte = function() {
  return this.data.charCodeAt(this.read++);
};
L.ByteStringBuffer.prototype.getInt16 = function() {
  var e = this.data.charCodeAt(this.read) << 8 ^ this.data.charCodeAt(this.read + 1);
  return this.read += 2, e;
};
L.ByteStringBuffer.prototype.getInt24 = function() {
  var e = this.data.charCodeAt(this.read) << 16 ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2);
  return this.read += 3, e;
};
L.ByteStringBuffer.prototype.getInt32 = function() {
  var e = this.data.charCodeAt(this.read) << 24 ^ this.data.charCodeAt(this.read + 1) << 16 ^ this.data.charCodeAt(this.read + 2) << 8 ^ this.data.charCodeAt(this.read + 3);
  return this.read += 4, e;
};
L.ByteStringBuffer.prototype.getInt16Le = function() {
  var e = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8;
  return this.read += 2, e;
};
L.ByteStringBuffer.prototype.getInt24Le = function() {
  var e = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16;
  return this.read += 3, e;
};
L.ByteStringBuffer.prototype.getInt32Le = function() {
  var e = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16 ^ this.data.charCodeAt(this.read + 3) << 24;
  return this.read += 4, e;
};
L.ByteStringBuffer.prototype.getInt = function(e) {
  qn(e);
  var t = 0;
  do
    t = (t << 8) + this.data.charCodeAt(this.read++), e -= 8;
  while (e > 0);
  return t;
};
L.ByteStringBuffer.prototype.getSignedInt = function(e) {
  var t = this.getInt(e), n = 2 << e - 2;
  return t >= n && (t -= n << 1), t;
};
L.ByteStringBuffer.prototype.getBytes = function(e) {
  var t;
  return e ? (e = Math.min(this.length(), e), t = this.data.slice(this.read, this.read + e), this.read += e) : e === 0 ? t = "" : (t = this.read === 0 ? this.data : this.data.slice(this.read), this.clear()), t;
};
L.ByteStringBuffer.prototype.bytes = function(e) {
  return typeof e > "u" ? this.data.slice(this.read) : this.data.slice(this.read, this.read + e);
};
L.ByteStringBuffer.prototype.at = function(e) {
  return this.data.charCodeAt(this.read + e);
};
L.ByteStringBuffer.prototype.setAt = function(e, t) {
  return this.data = this.data.substr(0, this.read + e) + String.fromCharCode(t) + this.data.substr(this.read + e + 1), this;
};
L.ByteStringBuffer.prototype.last = function() {
  return this.data.charCodeAt(this.data.length - 1);
};
L.ByteStringBuffer.prototype.copy = function() {
  var e = L.createBuffer(this.data);
  return e.read = this.read, e;
};
L.ByteStringBuffer.prototype.compact = function() {
  return this.read > 0 && (this.data = this.data.slice(this.read), this.read = 0), this;
};
L.ByteStringBuffer.prototype.clear = function() {
  return this.data = "", this.read = 0, this;
};
L.ByteStringBuffer.prototype.truncate = function(e) {
  var t = Math.max(0, this.length() - e);
  return this.data = this.data.substr(this.read, t), this.read = 0, this;
};
L.ByteStringBuffer.prototype.toHex = function() {
  for (var e = "", t = this.read; t < this.data.length; ++t) {
    var n = this.data.charCodeAt(t);
    n < 16 && (e += "0"), e += n.toString(16);
  }
  return e;
};
L.ByteStringBuffer.prototype.toString = function() {
  return L.decodeUtf8(this.bytes());
};
function C0(e, t) {
  t = t || {}, this.read = t.readOffset || 0, this.growSize = t.growSize || 1024;
  var n = L.isArrayBuffer(e), r = L.isArrayBufferView(e);
  if (n || r) {
    n ? this.data = new DataView(e) : this.data = new DataView(e.buffer, e.byteOffset, e.byteLength), this.write = "writeOffset" in t ? t.writeOffset : this.data.byteLength;
    return;
  }
  this.data = new DataView(new ArrayBuffer(0)), this.write = 0, e != null && this.putBytes(e), "writeOffset" in t && (this.write = t.writeOffset);
}
L.DataBuffer = C0;
L.DataBuffer.prototype.length = function() {
  return this.write - this.read;
};
L.DataBuffer.prototype.isEmpty = function() {
  return this.length() <= 0;
};
L.DataBuffer.prototype.accommodate = function(e, t) {
  if (this.length() >= e)
    return this;
  t = Math.max(t || this.growSize, e);
  var n = new Uint8Array(
    this.data.buffer,
    this.data.byteOffset,
    this.data.byteLength
  ), r = new Uint8Array(this.length() + t);
  return r.set(n), this.data = new DataView(r.buffer), this;
};
L.DataBuffer.prototype.putByte = function(e) {
  return this.accommodate(1), this.data.setUint8(this.write++, e), this;
};
L.DataBuffer.prototype.fillWithByte = function(e, t) {
  this.accommodate(t);
  for (var n = 0; n < t; ++n)
    this.data.setUint8(e);
  return this;
};
L.DataBuffer.prototype.putBytes = function(e, t) {
  if (L.isArrayBufferView(e)) {
    var n = new Uint8Array(e.buffer, e.byteOffset, e.byteLength), r = n.byteLength - n.byteOffset;
    this.accommodate(r);
    var a = new Uint8Array(this.data.buffer, this.write);
    return a.set(n), this.write += r, this;
  }
  if (L.isArrayBuffer(e)) {
    var n = new Uint8Array(e);
    this.accommodate(n.byteLength);
    var a = new Uint8Array(this.data.buffer);
    return a.set(n, this.write), this.write += n.byteLength, this;
  }
  if (e instanceof L.DataBuffer || typeof e == "object" && typeof e.read == "number" && typeof e.write == "number" && L.isArrayBufferView(e.data)) {
    var n = new Uint8Array(e.data.byteLength, e.read, e.length());
    this.accommodate(n.byteLength);
    var a = new Uint8Array(e.data.byteLength, this.write);
    return a.set(n), this.write += n.byteLength, this;
  }
  if (e instanceof L.ByteStringBuffer && (e = e.data, t = "binary"), t = t || "binary", typeof e == "string") {
    var s;
    if (t === "hex")
      return this.accommodate(Math.ceil(e.length / 2)), s = new Uint8Array(this.data.buffer, this.write), this.write += L.binary.hex.decode(e, s, this.write), this;
    if (t === "base64")
      return this.accommodate(Math.ceil(e.length / 4) * 3), s = new Uint8Array(this.data.buffer, this.write), this.write += L.binary.base64.decode(e, s, this.write), this;
    if (t === "utf8" && (e = L.encodeUtf8(e), t = "binary"), t === "binary" || t === "raw")
      return this.accommodate(e.length), s = new Uint8Array(this.data.buffer, this.write), this.write += L.binary.raw.decode(s), this;
    if (t === "utf16")
      return this.accommodate(e.length * 2), s = new Uint16Array(this.data.buffer, this.write), this.write += L.text.utf16.encode(s), this;
    throw new Error("Invalid encoding: " + t);
  }
  throw Error("Invalid parameter: " + e);
};
L.DataBuffer.prototype.putBuffer = function(e) {
  return this.putBytes(e), e.clear(), this;
};
L.DataBuffer.prototype.putString = function(e) {
  return this.putBytes(e, "utf16");
};
L.DataBuffer.prototype.putInt16 = function(e) {
  return this.accommodate(2), this.data.setInt16(this.write, e), this.write += 2, this;
};
L.DataBuffer.prototype.putInt24 = function(e) {
  return this.accommodate(3), this.data.setInt16(this.write, e >> 8 & 65535), this.data.setInt8(this.write, e >> 16 & 255), this.write += 3, this;
};
L.DataBuffer.prototype.putInt32 = function(e) {
  return this.accommodate(4), this.data.setInt32(this.write, e), this.write += 4, this;
};
L.DataBuffer.prototype.putInt16Le = function(e) {
  return this.accommodate(2), this.data.setInt16(this.write, e, !0), this.write += 2, this;
};
L.DataBuffer.prototype.putInt24Le = function(e) {
  return this.accommodate(3), this.data.setInt8(this.write, e >> 16 & 255), this.data.setInt16(this.write, e >> 8 & 65535, !0), this.write += 3, this;
};
L.DataBuffer.prototype.putInt32Le = function(e) {
  return this.accommodate(4), this.data.setInt32(this.write, e, !0), this.write += 4, this;
};
L.DataBuffer.prototype.putInt = function(e, t) {
  qn(t), this.accommodate(t / 8);
  do
    t -= 8, this.data.setInt8(this.write++, e >> t & 255);
  while (t > 0);
  return this;
};
L.DataBuffer.prototype.putSignedInt = function(e, t) {
  return qn(t), this.accommodate(t / 8), e < 0 && (e += 2 << t - 1), this.putInt(e, t);
};
L.DataBuffer.prototype.getByte = function() {
  return this.data.getInt8(this.read++);
};
L.DataBuffer.prototype.getInt16 = function() {
  var e = this.data.getInt16(this.read);
  return this.read += 2, e;
};
L.DataBuffer.prototype.getInt24 = function() {
  var e = this.data.getInt16(this.read) << 8 ^ this.data.getInt8(this.read + 2);
  return this.read += 3, e;
};
L.DataBuffer.prototype.getInt32 = function() {
  var e = this.data.getInt32(this.read);
  return this.read += 4, e;
};
L.DataBuffer.prototype.getInt16Le = function() {
  var e = this.data.getInt16(this.read, !0);
  return this.read += 2, e;
};
L.DataBuffer.prototype.getInt24Le = function() {
  var e = this.data.getInt8(this.read) ^ this.data.getInt16(this.read + 1, !0) << 8;
  return this.read += 3, e;
};
L.DataBuffer.prototype.getInt32Le = function() {
  var e = this.data.getInt32(this.read, !0);
  return this.read += 4, e;
};
L.DataBuffer.prototype.getInt = function(e) {
  qn(e);
  var t = 0;
  do
    t = (t << 8) + this.data.getInt8(this.read++), e -= 8;
  while (e > 0);
  return t;
};
L.DataBuffer.prototype.getSignedInt = function(e) {
  var t = this.getInt(e), n = 2 << e - 2;
  return t >= n && (t -= n << 1), t;
};
L.DataBuffer.prototype.getBytes = function(e) {
  var t;
  return e ? (e = Math.min(this.length(), e), t = this.data.slice(this.read, this.read + e), this.read += e) : e === 0 ? t = "" : (t = this.read === 0 ? this.data : this.data.slice(this.read), this.clear()), t;
};
L.DataBuffer.prototype.bytes = function(e) {
  return typeof e > "u" ? this.data.slice(this.read) : this.data.slice(this.read, this.read + e);
};
L.DataBuffer.prototype.at = function(e) {
  return this.data.getUint8(this.read + e);
};
L.DataBuffer.prototype.setAt = function(e, t) {
  return this.data.setUint8(e, t), this;
};
L.DataBuffer.prototype.last = function() {
  return this.data.getUint8(this.write - 1);
};
L.DataBuffer.prototype.copy = function() {
  return new L.DataBuffer(this);
};
L.DataBuffer.prototype.compact = function() {
  if (this.read > 0) {
    var e = new Uint8Array(this.data.buffer, this.read), t = new Uint8Array(e.byteLength);
    t.set(e), this.data = new DataView(t), this.write -= this.read, this.read = 0;
  }
  return this;
};
L.DataBuffer.prototype.clear = function() {
  return this.data = new DataView(new ArrayBuffer(0)), this.read = this.write = 0, this;
};
L.DataBuffer.prototype.truncate = function(e) {
  return this.write = Math.max(0, this.length() - e), this.read = Math.min(this.read, this.write), this;
};
L.DataBuffer.prototype.toHex = function() {
  for (var e = "", t = this.read; t < this.data.byteLength; ++t) {
    var n = this.data.getUint8(t);
    n < 16 && (e += "0"), e += n.toString(16);
  }
  return e;
};
L.DataBuffer.prototype.toString = function(e) {
  var t = new Uint8Array(this.data, this.read, this.length());
  if (e = e || "utf8", e === "binary" || e === "raw")
    return L.binary.raw.encode(t);
  if (e === "hex")
    return L.binary.hex.encode(t);
  if (e === "base64")
    return L.binary.base64.encode(t);
  if (e === "utf8")
    return L.text.utf8.decode(t);
  if (e === "utf16")
    return L.text.utf16.decode(t);
  throw new Error("Invalid encoding: " + e);
};
L.createBuffer = function(e, t) {
  return t = t || "raw", e !== void 0 && t === "utf8" && (e = L.encodeUtf8(e)), new L.ByteBuffer(e);
};
L.fillString = function(e, t) {
  for (var n = ""; t > 0; )
    t & 1 && (n += e), t >>>= 1, t > 0 && (e += e);
  return n;
};
L.xorBytes = function(e, t, n) {
  for (var r = "", a = "", s = "", i = 0, o = 0; n > 0; --n, ++i)
    a = e.charCodeAt(i) ^ t.charCodeAt(i), o >= 10 && (r += s, s = "", o = 0), s += String.fromCharCode(a), ++o;
  return r += s, r;
};
L.hexToBytes = function(e) {
  var t = "", n = 0;
  for (e.length & !0 && (n = 1, t += String.fromCharCode(parseInt(e[0], 16))); n < e.length; n += 2)
    t += String.fromCharCode(parseInt(e.substr(n, 2), 16));
  return t;
};
L.bytesToHex = function(e) {
  return L.createBuffer(e).toHex();
};
L.int32ToBytes = function(e) {
  return String.fromCharCode(e >> 24 & 255) + String.fromCharCode(e >> 16 & 255) + String.fromCharCode(e >> 8 & 255) + String.fromCharCode(e & 255);
};
var Cr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", Sr = [
  /*43 -43 = 0*/
  /*'+',  1,  2,  3,'/' */
  62,
  -1,
  -1,
  -1,
  63,
  /*'0','1','2','3','4','5','6','7','8','9' */
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  /*15, 16, 17,'=', 19, 20, 21 */
  -1,
  -1,
  -1,
  64,
  -1,
  -1,
  -1,
  /*65 - 43 = 22*/
  /*'A','B','C','D','E','F','G','H','I','J','K','L','M', */
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  /*'N','O','P','Q','R','S','T','U','V','W','X','Y','Z' */
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  /*91 - 43 = 48 */
  /*48, 49, 50, 51, 52, 53 */
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  /*97 - 43 = 54*/
  /*'a','b','c','d','e','f','g','h','i','j','k','l','m' */
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  /*'n','o','p','q','r','s','t','u','v','w','x','y','z' */
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51
], Xo = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
L.encode64 = function(e, t) {
  for (var n = "", r = "", a, s, i, o = 0; o < e.length; )
    a = e.charCodeAt(o++), s = e.charCodeAt(o++), i = e.charCodeAt(o++), n += Cr.charAt(a >> 2), n += Cr.charAt((a & 3) << 4 | s >> 4), isNaN(s) ? n += "==" : (n += Cr.charAt((s & 15) << 2 | i >> 6), n += isNaN(i) ? "=" : Cr.charAt(i & 63)), t && n.length > t && (r += n.substr(0, t) + `\r
`, n = n.substr(t));
  return r += n, r;
};
L.decode64 = function(e) {
  e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
  for (var t = "", n, r, a, s, i = 0; i < e.length; )
    n = Sr[e.charCodeAt(i++) - 43], r = Sr[e.charCodeAt(i++) - 43], a = Sr[e.charCodeAt(i++) - 43], s = Sr[e.charCodeAt(i++) - 43], t += String.fromCharCode(n << 2 | r >> 4), a !== 64 && (t += String.fromCharCode((r & 15) << 4 | a >> 2), s !== 64 && (t += String.fromCharCode((a & 3) << 6 | s)));
  return t;
};
L.encodeUtf8 = function(e) {
  return unescape(encodeURIComponent(e));
};
L.decodeUtf8 = function(e) {
  return decodeURIComponent(escape(e));
};
L.binary = {
  raw: {},
  hex: {},
  base64: {},
  base58: {},
  baseN: {
    encode: Ks.encode,
    decode: Ks.decode
  }
};
L.binary.raw.encode = function(e) {
  return String.fromCharCode.apply(null, e);
};
L.binary.raw.decode = function(e, t, n) {
  var r = t;
  r || (r = new Uint8Array(e.length)), n = n || 0;
  for (var a = n, s = 0; s < e.length; ++s)
    r[a++] = e.charCodeAt(s);
  return t ? a - n : r;
};
L.binary.hex.encode = L.bytesToHex;
L.binary.hex.decode = function(e, t, n) {
  var r = t;
  r || (r = new Uint8Array(Math.ceil(e.length / 2))), n = n || 0;
  var a = 0, s = n;
  for (e.length & 1 && (a = 1, r[s++] = parseInt(e[0], 16)); a < e.length; a += 2)
    r[s++] = parseInt(e.substr(a, 2), 16);
  return t ? s - n : r;
};
L.binary.base64.encode = function(e, t) {
  for (var n = "", r = "", a, s, i, o = 0; o < e.byteLength; )
    a = e[o++], s = e[o++], i = e[o++], n += Cr.charAt(a >> 2), n += Cr.charAt((a & 3) << 4 | s >> 4), isNaN(s) ? n += "==" : (n += Cr.charAt((s & 15) << 2 | i >> 6), n += isNaN(i) ? "=" : Cr.charAt(i & 63)), t && n.length > t && (r += n.substr(0, t) + `\r
`, n = n.substr(t));
  return r += n, r;
};
L.binary.base64.decode = function(e, t, n) {
  var r = t;
  r || (r = new Uint8Array(Math.ceil(e.length / 4) * 3)), e = e.replace(/[^A-Za-z0-9\+\/\=]/g, ""), n = n || 0;
  for (var a, s, i, o, u = 0, c = n; u < e.length; )
    a = Sr[e.charCodeAt(u++) - 43], s = Sr[e.charCodeAt(u++) - 43], i = Sr[e.charCodeAt(u++) - 43], o = Sr[e.charCodeAt(u++) - 43], r[c++] = a << 2 | s >> 4, i !== 64 && (r[c++] = (s & 15) << 4 | i >> 2, o !== 64 && (r[c++] = (i & 3) << 6 | o));
  return t ? c - n : r.subarray(0, c);
};
L.binary.base58.encode = function(e, t) {
  return L.binary.baseN.encode(e, Xo, t);
};
L.binary.base58.decode = function(e, t) {
  return L.binary.baseN.decode(e, Xo, t);
};
L.text = {
  utf8: {},
  utf16: {}
};
L.text.utf8.encode = function(e, t, n) {
  e = L.encodeUtf8(e);
  var r = t;
  r || (r = new Uint8Array(e.length)), n = n || 0;
  for (var a = n, s = 0; s < e.length; ++s)
    r[a++] = e.charCodeAt(s);
  return t ? a - n : r;
};
L.text.utf8.decode = function(e) {
  return L.decodeUtf8(String.fromCharCode.apply(null, e));
};
L.text.utf16.encode = function(e, t, n) {
  var r = t;
  r || (r = new Uint8Array(e.length * 2));
  var a = new Uint16Array(r.buffer);
  n = n || 0;
  for (var s = n, i = n, o = 0; o < e.length; ++o)
    a[i++] = e.charCodeAt(o), s += 2;
  return t ? s - n : r;
};
L.text.utf16.decode = function(e) {
  return String.fromCharCode.apply(null, new Uint16Array(e.buffer));
};
L.deflate = function(e, t, n) {
  if (t = L.decode64(e.deflate(L.encode64(t)).rval), n) {
    var r = 2, a = t.charCodeAt(1);
    a & 32 && (r = 6), t = t.substring(r, t.length - 4);
  }
  return t;
};
L.inflate = function(e, t, n) {
  var r = e.inflate(L.encode64(t)).rval;
  return r === null ? null : L.decode64(r);
};
var qi = function(e, t, n) {
  if (!e)
    throw new Error("WebStorage not available.");
  var r;
  if (n === null ? r = e.removeItem(t) : (n = L.encode64(JSON.stringify(n)), r = e.setItem(t, n)), typeof r < "u" && r.rval !== !0) {
    var a = new Error(r.error.message);
    throw a.id = r.error.id, a.name = r.error.name, a;
  }
}, Gi = function(e, t) {
  if (!e)
    throw new Error("WebStorage not available.");
  var n = e.getItem(t);
  if (e.init)
    if (n.rval === null) {
      if (n.error) {
        var r = new Error(n.error.message);
        throw r.id = n.error.id, r.name = n.error.name, r;
      }
      n = null;
    } else
      n = n.rval;
  return n !== null && (n = JSON.parse(L.decode64(n))), n;
}, S0 = function(e, t, n, r) {
  var a = Gi(e, t);
  a === null && (a = {}), a[n] = r, qi(e, t, a);
}, b0 = function(e, t, n) {
  var r = Gi(e, t);
  return r !== null && (r = n in r ? r[n] : null), r;
}, x0 = function(e, t, n) {
  var r = Gi(e, t);
  if (r !== null && n in r) {
    delete r[n];
    var a = !0;
    for (var s in r) {
      a = !1;
      break;
    }
    a && (r = null), qi(e, t, r);
  }
}, T0 = function(e, t) {
  qi(e, t, null);
}, Ia = function(e, t, n) {
  var r = null;
  typeof n > "u" && (n = ["web", "flash"]);
  var a, s = !1, i = null;
  for (var o in n) {
    a = n[o];
    try {
      if (a === "flash" || a === "both") {
        if (t[0] === null)
          throw new Error("Flash local storage not available.");
        r = e.apply(this, t), s = a === "flash";
      }
      (a === "web" || a === "both") && (t[0] = localStorage, r = e.apply(this, t), s = !0);
    } catch (u) {
      i = u;
    }
    if (s)
      break;
  }
  if (!s)
    throw i;
  return r;
};
L.setItem = function(e, t, n, r, a) {
  Ia(S0, arguments, a);
};
L.getItem = function(e, t, n, r) {
  return Ia(b0, arguments, r);
};
L.removeItem = function(e, t, n, r) {
  Ia(x0, arguments, r);
};
L.clearItems = function(e, t, n) {
  Ia(T0, arguments, n);
};
L.isEmpty = function(e) {
  for (var t in e)
    if (e.hasOwnProperty(t))
      return !1;
  return !0;
};
L.format = function(e) {
  for (var t = /%./g, n, r, a = 0, s = [], i = 0; n = t.exec(e); ) {
    r = e.substring(i, t.lastIndex - 2), r.length > 0 && s.push(r), i = t.lastIndex;
    var o = n[0][1];
    switch (o) {
      case "s":
      case "o":
        a < arguments.length ? s.push(arguments[a++ + 1]) : s.push("<?>");
        break;
      case "%":
        s.push("%");
        break;
      default:
        s.push("<%" + o + "?>");
    }
  }
  return s.push(e.substring(i)), s.join("");
};
L.formatNumber = function(e, t, n, r) {
  var a = e, s = isNaN(t = Math.abs(t)) ? 2 : t, i = n === void 0 ? "," : n, o = r === void 0 ? "." : r, u = a < 0 ? "-" : "", c = parseInt(a = Math.abs(+a || 0).toFixed(s), 10) + "", l = c.length > 3 ? c.length % 3 : 0;
  return u + (l ? c.substr(0, l) + o : "") + c.substr(l).replace(/(\d{3})(?=\d)/g, "$1" + o) + (s ? i + Math.abs(a - c).toFixed(s).slice(2) : "");
};
L.formatSize = function(e) {
  return e >= 1073741824 ? e = L.formatNumber(e / 1073741824, 2, ".", "") + " GiB" : e >= 1048576 ? e = L.formatNumber(e / 1048576, 2, ".", "") + " MiB" : e >= 1024 ? e = L.formatNumber(e / 1024, 0) + " KiB" : e = L.formatNumber(e, 0) + " bytes", e;
};
L.bytesFromIP = function(e) {
  return e.indexOf(".") !== -1 ? L.bytesFromIPv4(e) : e.indexOf(":") !== -1 ? L.bytesFromIPv6(e) : null;
};
L.bytesFromIPv4 = function(e) {
  if (e = e.split("."), e.length !== 4)
    return null;
  for (var t = L.createBuffer(), n = 0; n < e.length; ++n) {
    var r = parseInt(e[n], 10);
    if (isNaN(r))
      return null;
    t.putByte(r);
  }
  return t.getBytes();
};
L.bytesFromIPv6 = function(e) {
  var t = 0;
  e = e.split(":").filter(function(i) {
    return i.length === 0 && ++t, !0;
  });
  for (var n = (8 - e.length + t) * 2, r = L.createBuffer(), a = 0; a < 8; ++a) {
    if (!e[a] || e[a].length === 0) {
      r.fillWithByte(0, n), n = 0;
      continue;
    }
    var s = L.hexToBytes(e[a]);
    s.length < 2 && r.putByte(0), r.putBytes(s);
  }
  return r.getBytes();
};
L.bytesToIP = function(e) {
  return e.length === 4 ? L.bytesToIPv4(e) : e.length === 16 ? L.bytesToIPv6(e) : null;
};
L.bytesToIPv4 = function(e) {
  if (e.length !== 4)
    return null;
  for (var t = [], n = 0; n < e.length; ++n)
    t.push(e.charCodeAt(n));
  return t.join(".");
};
L.bytesToIPv6 = function(e) {
  if (e.length !== 16)
    return null;
  for (var t = [], n = [], r = 0, a = 0; a < e.length; a += 2) {
    for (var s = L.bytesToHex(e[a] + e[a + 1]); s[0] === "0" && s !== "0"; )
      s = s.substr(1);
    if (s === "0") {
      var i = n[n.length - 1], o = t.length;
      !i || o !== i.end + 1 ? n.push({ start: o, end: o }) : (i.end = o, i.end - i.start > n[r].end - n[r].start && (r = n.length - 1));
    }
    t.push(s);
  }
  if (n.length > 0) {
    var u = n[r];
    u.end - u.start > 0 && (t.splice(u.start, u.end - u.start + 1, ""), u.start === 0 && t.unshift(""), u.end === 7 && t.push(""));
  }
  return t.join(":");
};
L.estimateCores = function(e, t) {
  if (typeof e == "function" && (t = e, e = {}), e = e || {}, "cores" in L && !e.update)
    return t(null, L.cores);
  if (typeof navigator < "u" && "hardwareConcurrency" in navigator && navigator.hardwareConcurrency > 0)
    return L.cores = navigator.hardwareConcurrency, t(null, L.cores);
  if (typeof Worker > "u")
    return L.cores = 1, t(null, L.cores);
  if (typeof Blob > "u")
    return L.cores = 2, t(null, L.cores);
  var n = URL.createObjectURL(new Blob([
    "(",
    function() {
      self.addEventListener("message", function(i) {
        var o = Date.now(), u = o + 4;
        self.postMessage({ st: o, et: u });
      });
    }.toString(),
    ")()"
  ], { type: "application/javascript" }));
  r([], 5, 16);
  function r(i, o, u) {
    if (o === 0) {
      var c = Math.floor(i.reduce(function(l, p) {
        return l + p;
      }, 0) / i.length);
      return L.cores = Math.max(1, c), URL.revokeObjectURL(n), t(null, L.cores);
    }
    a(u, function(l, p) {
      i.push(s(u, p)), r(i, o - 1, u);
    });
  }
  function a(i, o) {
    for (var u = [], c = [], l = 0; l < i; ++l) {
      var p = new Worker(n);
      p.addEventListener("message", function(g) {
        if (c.push(g.data), c.length === i) {
          for (var C = 0; C < i; ++C)
            u[C].terminate();
          o(null, c);
        }
      }), u.push(p);
    }
    for (var l = 0; l < i; ++l)
      u[l].postMessage(l);
  }
  function s(i, o) {
    for (var u = [], c = 0; c < i; ++c)
      for (var l = o[c], p = u[c] = [], g = 0; g < i; ++g)
        if (c !== g) {
          var C = o[g];
          (l.st > C.st && l.st < C.et || C.st > l.st && C.st < l.et) && p.push(g);
        }
    return u.reduce(function(d, b) {
      return Math.max(d, b.length);
    }, 0);
  }
};
var yt = De;
yt.cipher = yt.cipher || {};
yt.cipher.algorithms = yt.cipher.algorithms || {};
yt.cipher.createCipher = function(e, t) {
  var n = e;
  if (typeof n == "string" && (n = yt.cipher.getAlgorithm(n), n && (n = n())), !n)
    throw new Error("Unsupported algorithm: " + e);
  return new yt.cipher.BlockCipher({
    algorithm: n,
    key: t,
    decrypt: !1
  });
};
yt.cipher.createDecipher = function(e, t) {
  var n = e;
  if (typeof n == "string" && (n = yt.cipher.getAlgorithm(n), n && (n = n())), !n)
    throw new Error("Unsupported algorithm: " + e);
  return new yt.cipher.BlockCipher({
    algorithm: n,
    key: t,
    decrypt: !0
  });
};
yt.cipher.registerAlgorithm = function(e, t) {
  e = e.toUpperCase(), yt.cipher.algorithms[e] = t;
};
yt.cipher.getAlgorithm = function(e) {
  return e = e.toUpperCase(), e in yt.cipher.algorithms ? yt.cipher.algorithms[e] : null;
};
var $i = yt.cipher.BlockCipher = function(e) {
  this.algorithm = e.algorithm, this.mode = this.algorithm.mode, this.blockSize = this.mode.blockSize, this._finish = !1, this._input = null, this.output = null, this._op = e.decrypt ? this.mode.decrypt : this.mode.encrypt, this._decrypt = e.decrypt, this.algorithm.initialize(e);
};
$i.prototype.start = function(e) {
  e = e || {};
  var t = {};
  for (var n in e)
    t[n] = e[n];
  t.decrypt = this._decrypt, this._finish = !1, this._input = yt.util.createBuffer(), this.output = e.output || yt.util.createBuffer(), this.mode.start(t);
};
$i.prototype.update = function(e) {
  for (e && this._input.putBuffer(e); !this._op.call(this.mode, this._input, this.output, this._finish) && !this._finish; )
    ;
  this._input.compact();
};
$i.prototype.finish = function(e) {
  e && (this.mode.name === "ECB" || this.mode.name === "CBC") && (this.mode.pad = function(n) {
    return e(this.blockSize, n, !1);
  }, this.mode.unpad = function(n) {
    return e(this.blockSize, n, !0);
  });
  var t = {};
  return t.decrypt = this._decrypt, t.overflow = this._input.length() % this.blockSize, !(!this._decrypt && this.mode.pad && !this.mode.pad(this._input, t) || (this._finish = !0, this.update(), this._decrypt && this.mode.unpad && !this.mode.unpad(this.output, t)) || this.mode.afterFinish && !this.mode.afterFinish(this.output, t));
};
var dt = De;
dt.cipher = dt.cipher || {};
var Pe = dt.cipher.modes = dt.cipher.modes || {};
Pe.ecb = function(e) {
  e = e || {}, this.name = "ECB", this.cipher = e.cipher, this.blockSize = e.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = new Array(this._ints), this._outBlock = new Array(this._ints);
};
Pe.ecb.prototype.start = function(e) {
};
Pe.ecb.prototype.encrypt = function(e, t, n) {
  if (e.length() < this.blockSize && !(n && e.length() > 0))
    return !0;
  for (var r = 0; r < this._ints; ++r)
    this._inBlock[r] = e.getInt32();
  this.cipher.encrypt(this._inBlock, this._outBlock);
  for (var r = 0; r < this._ints; ++r)
    t.putInt32(this._outBlock[r]);
};
Pe.ecb.prototype.decrypt = function(e, t, n) {
  if (e.length() < this.blockSize && !(n && e.length() > 0))
    return !0;
  for (var r = 0; r < this._ints; ++r)
    this._inBlock[r] = e.getInt32();
  this.cipher.decrypt(this._inBlock, this._outBlock);
  for (var r = 0; r < this._ints; ++r)
    t.putInt32(this._outBlock[r]);
};
Pe.ecb.prototype.pad = function(e, t) {
  var n = e.length() === this.blockSize ? this.blockSize : this.blockSize - e.length();
  return e.fillWithByte(n, n), !0;
};
Pe.ecb.prototype.unpad = function(e, t) {
  if (t.overflow > 0)
    return !1;
  var n = e.length(), r = e.at(n - 1);
  return r > this.blockSize << 2 ? !1 : (e.truncate(r), !0);
};
Pe.cbc = function(e) {
  e = e || {}, this.name = "CBC", this.cipher = e.cipher, this.blockSize = e.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = new Array(this._ints), this._outBlock = new Array(this._ints);
};
Pe.cbc.prototype.start = function(e) {
  if (e.iv === null) {
    if (!this._prev)
      throw new Error("Invalid IV parameter.");
    this._iv = this._prev.slice(0);
  } else if ("iv" in e)
    this._iv = wa(e.iv, this.blockSize), this._prev = this._iv.slice(0);
  else
    throw new Error("Invalid IV parameter.");
};
Pe.cbc.prototype.encrypt = function(e, t, n) {
  if (e.length() < this.blockSize && !(n && e.length() > 0))
    return !0;
  for (var r = 0; r < this._ints; ++r)
    this._inBlock[r] = this._prev[r] ^ e.getInt32();
  this.cipher.encrypt(this._inBlock, this._outBlock);
  for (var r = 0; r < this._ints; ++r)
    t.putInt32(this._outBlock[r]);
  this._prev = this._outBlock;
};
Pe.cbc.prototype.decrypt = function(e, t, n) {
  if (e.length() < this.blockSize && !(n && e.length() > 0))
    return !0;
  for (var r = 0; r < this._ints; ++r)
    this._inBlock[r] = e.getInt32();
  this.cipher.decrypt(this._inBlock, this._outBlock);
  for (var r = 0; r < this._ints; ++r)
    t.putInt32(this._prev[r] ^ this._outBlock[r]);
  this._prev = this._inBlock.slice(0);
};
Pe.cbc.prototype.pad = function(e, t) {
  var n = e.length() === this.blockSize ? this.blockSize : this.blockSize - e.length();
  return e.fillWithByte(n, n), !0;
};
Pe.cbc.prototype.unpad = function(e, t) {
  if (t.overflow > 0)
    return !1;
  var n = e.length(), r = e.at(n - 1);
  return r > this.blockSize << 2 ? !1 : (e.truncate(r), !0);
};
Pe.cfb = function(e) {
  e = e || {}, this.name = "CFB", this.cipher = e.cipher, this.blockSize = e.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = null, this._outBlock = new Array(this._ints), this._partialBlock = new Array(this._ints), this._partialOutput = dt.util.createBuffer(), this._partialBytes = 0;
};
Pe.cfb.prototype.start = function(e) {
  if (!("iv" in e))
    throw new Error("Invalid IV parameter.");
  this._iv = wa(e.iv, this.blockSize), this._inBlock = this._iv.slice(0), this._partialBytes = 0;
};
Pe.cfb.prototype.encrypt = function(e, t, n) {
  var r = e.length();
  if (r === 0)
    return !0;
  if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && r >= this.blockSize) {
    for (var a = 0; a < this._ints; ++a)
      this._inBlock[a] = e.getInt32() ^ this._outBlock[a], t.putInt32(this._inBlock[a]);
    return;
  }
  var s = (this.blockSize - r) % this.blockSize;
  s > 0 && (s = this.blockSize - s), this._partialOutput.clear();
  for (var a = 0; a < this._ints; ++a)
    this._partialBlock[a] = e.getInt32() ^ this._outBlock[a], this._partialOutput.putInt32(this._partialBlock[a]);
  if (s > 0)
    e.read -= this.blockSize;
  else
    for (var a = 0; a < this._ints; ++a)
      this._inBlock[a] = this._partialBlock[a];
  if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), s > 0 && !n)
    return t.putBytes(this._partialOutput.getBytes(
      s - this._partialBytes
    )), this._partialBytes = s, !0;
  t.putBytes(this._partialOutput.getBytes(
    r - this._partialBytes
  )), this._partialBytes = 0;
};
Pe.cfb.prototype.decrypt = function(e, t, n) {
  var r = e.length();
  if (r === 0)
    return !0;
  if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && r >= this.blockSize) {
    for (var a = 0; a < this._ints; ++a)
      this._inBlock[a] = e.getInt32(), t.putInt32(this._inBlock[a] ^ this._outBlock[a]);
    return;
  }
  var s = (this.blockSize - r) % this.blockSize;
  s > 0 && (s = this.blockSize - s), this._partialOutput.clear();
  for (var a = 0; a < this._ints; ++a)
    this._partialBlock[a] = e.getInt32(), this._partialOutput.putInt32(this._partialBlock[a] ^ this._outBlock[a]);
  if (s > 0)
    e.read -= this.blockSize;
  else
    for (var a = 0; a < this._ints; ++a)
      this._inBlock[a] = this._partialBlock[a];
  if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), s > 0 && !n)
    return t.putBytes(this._partialOutput.getBytes(
      s - this._partialBytes
    )), this._partialBytes = s, !0;
  t.putBytes(this._partialOutput.getBytes(
    r - this._partialBytes
  )), this._partialBytes = 0;
};
Pe.ofb = function(e) {
  e = e || {}, this.name = "OFB", this.cipher = e.cipher, this.blockSize = e.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = null, this._outBlock = new Array(this._ints), this._partialOutput = dt.util.createBuffer(), this._partialBytes = 0;
};
Pe.ofb.prototype.start = function(e) {
  if (!("iv" in e))
    throw new Error("Invalid IV parameter.");
  this._iv = wa(e.iv, this.blockSize), this._inBlock = this._iv.slice(0), this._partialBytes = 0;
};
Pe.ofb.prototype.encrypt = function(e, t, n) {
  var r = e.length();
  if (e.length() === 0)
    return !0;
  if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && r >= this.blockSize) {
    for (var a = 0; a < this._ints; ++a)
      t.putInt32(e.getInt32() ^ this._outBlock[a]), this._inBlock[a] = this._outBlock[a];
    return;
  }
  var s = (this.blockSize - r) % this.blockSize;
  s > 0 && (s = this.blockSize - s), this._partialOutput.clear();
  for (var a = 0; a < this._ints; ++a)
    this._partialOutput.putInt32(e.getInt32() ^ this._outBlock[a]);
  if (s > 0)
    e.read -= this.blockSize;
  else
    for (var a = 0; a < this._ints; ++a)
      this._inBlock[a] = this._outBlock[a];
  if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), s > 0 && !n)
    return t.putBytes(this._partialOutput.getBytes(
      s - this._partialBytes
    )), this._partialBytes = s, !0;
  t.putBytes(this._partialOutput.getBytes(
    r - this._partialBytes
  )), this._partialBytes = 0;
};
Pe.ofb.prototype.decrypt = Pe.ofb.prototype.encrypt;
Pe.ctr = function(e) {
  e = e || {}, this.name = "CTR", this.cipher = e.cipher, this.blockSize = e.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = null, this._outBlock = new Array(this._ints), this._partialOutput = dt.util.createBuffer(), this._partialBytes = 0;
};
Pe.ctr.prototype.start = function(e) {
  if (!("iv" in e))
    throw new Error("Invalid IV parameter.");
  this._iv = wa(e.iv, this.blockSize), this._inBlock = this._iv.slice(0), this._partialBytes = 0;
};
Pe.ctr.prototype.encrypt = function(e, t, n) {
  var r = e.length();
  if (r === 0)
    return !0;
  if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && r >= this.blockSize)
    for (var a = 0; a < this._ints; ++a)
      t.putInt32(e.getInt32() ^ this._outBlock[a]);
  else {
    var s = (this.blockSize - r) % this.blockSize;
    s > 0 && (s = this.blockSize - s), this._partialOutput.clear();
    for (var a = 0; a < this._ints; ++a)
      this._partialOutput.putInt32(e.getInt32() ^ this._outBlock[a]);
    if (s > 0 && (e.read -= this.blockSize), this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), s > 0 && !n)
      return t.putBytes(this._partialOutput.getBytes(
        s - this._partialBytes
      )), this._partialBytes = s, !0;
    t.putBytes(this._partialOutput.getBytes(
      r - this._partialBytes
    )), this._partialBytes = 0;
  }
  Ba(this._inBlock);
};
Pe.ctr.prototype.decrypt = Pe.ctr.prototype.encrypt;
Pe.gcm = function(e) {
  e = e || {}, this.name = "GCM", this.cipher = e.cipher, this.blockSize = e.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = new Array(this._ints), this._outBlock = new Array(this._ints), this._partialOutput = dt.util.createBuffer(), this._partialBytes = 0, this._R = 3774873600;
};
Pe.gcm.prototype.start = function(e) {
  if (!("iv" in e))
    throw new Error("Invalid IV parameter.");
  var t = dt.util.createBuffer(e.iv);
  this._cipherLength = 0;
  var n;
  if ("additionalData" in e ? n = dt.util.createBuffer(e.additionalData) : n = dt.util.createBuffer(), "tagLength" in e ? this._tagLength = e.tagLength : this._tagLength = 128, this._tag = null, e.decrypt && (this._tag = dt.util.createBuffer(e.tag).getBytes(), this._tag.length !== this._tagLength / 8))
    throw new Error("Authentication tag does not match tag length.");
  this._hashBlock = new Array(this._ints), this.tag = null, this._hashSubkey = new Array(this._ints), this.cipher.encrypt([0, 0, 0, 0], this._hashSubkey), this.componentBits = 4, this._m = this.generateHashTable(this._hashSubkey, this.componentBits);
  var r = t.length();
  if (r === 12)
    this._j0 = [t.getInt32(), t.getInt32(), t.getInt32(), 1];
  else {
    for (this._j0 = [0, 0, 0, 0]; t.length() > 0; )
      this._j0 = this.ghash(
        this._hashSubkey,
        this._j0,
        [t.getInt32(), t.getInt32(), t.getInt32(), t.getInt32()]
      );
    this._j0 = this.ghash(
      this._hashSubkey,
      this._j0,
      [0, 0].concat(vi(r * 8))
    );
  }
  this._inBlock = this._j0.slice(0), Ba(this._inBlock), this._partialBytes = 0, n = dt.util.createBuffer(n), this._aDataLength = vi(n.length() * 8);
  var a = n.length() % this.blockSize;
  for (a && n.fillWithByte(0, this.blockSize - a), this._s = [0, 0, 0, 0]; n.length() > 0; )
    this._s = this.ghash(this._hashSubkey, this._s, [
      n.getInt32(),
      n.getInt32(),
      n.getInt32(),
      n.getInt32()
    ]);
};
Pe.gcm.prototype.encrypt = function(e, t, n) {
  var r = e.length();
  if (r === 0)
    return !0;
  if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && r >= this.blockSize) {
    for (var a = 0; a < this._ints; ++a)
      t.putInt32(this._outBlock[a] ^= e.getInt32());
    this._cipherLength += this.blockSize;
  } else {
    var s = (this.blockSize - r) % this.blockSize;
    s > 0 && (s = this.blockSize - s), this._partialOutput.clear();
    for (var a = 0; a < this._ints; ++a)
      this._partialOutput.putInt32(e.getInt32() ^ this._outBlock[a]);
    if (s <= 0 || n) {
      if (n) {
        var i = r % this.blockSize;
        this._cipherLength += i, this._partialOutput.truncate(this.blockSize - i);
      } else
        this._cipherLength += this.blockSize;
      for (var a = 0; a < this._ints; ++a)
        this._outBlock[a] = this._partialOutput.getInt32();
      this._partialOutput.read -= this.blockSize;
    }
    if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), s > 0 && !n)
      return e.read -= this.blockSize, t.putBytes(this._partialOutput.getBytes(
        s - this._partialBytes
      )), this._partialBytes = s, !0;
    t.putBytes(this._partialOutput.getBytes(
      r - this._partialBytes
    )), this._partialBytes = 0;
  }
  this._s = this.ghash(this._hashSubkey, this._s, this._outBlock), Ba(this._inBlock);
};
Pe.gcm.prototype.decrypt = function(e, t, n) {
  var r = e.length();
  if (r < this.blockSize && !(n && r > 0))
    return !0;
  this.cipher.encrypt(this._inBlock, this._outBlock), Ba(this._inBlock), this._hashBlock[0] = e.getInt32(), this._hashBlock[1] = e.getInt32(), this._hashBlock[2] = e.getInt32(), this._hashBlock[3] = e.getInt32(), this._s = this.ghash(this._hashSubkey, this._s, this._hashBlock);
  for (var a = 0; a < this._ints; ++a)
    t.putInt32(this._outBlock[a] ^ this._hashBlock[a]);
  r < this.blockSize ? this._cipherLength += r % this.blockSize : this._cipherLength += this.blockSize;
};
Pe.gcm.prototype.afterFinish = function(e, t) {
  var n = !0;
  t.decrypt && t.overflow && e.truncate(this.blockSize - t.overflow), this.tag = dt.util.createBuffer();
  var r = this._aDataLength.concat(vi(this._cipherLength * 8));
  this._s = this.ghash(this._hashSubkey, this._s, r);
  var a = [];
  this.cipher.encrypt(this._j0, a);
  for (var s = 0; s < this._ints; ++s)
    this.tag.putInt32(this._s[s] ^ a[s]);
  return this.tag.truncate(this.tag.length() % (this._tagLength / 8)), t.decrypt && this.tag.bytes() !== this._tag && (n = !1), n;
};
Pe.gcm.prototype.multiply = function(e, t) {
  for (var n = [0, 0, 0, 0], r = t.slice(0), a = 0; a < 128; ++a) {
    var s = e[a / 32 | 0] & 1 << 31 - a % 32;
    s && (n[0] ^= r[0], n[1] ^= r[1], n[2] ^= r[2], n[3] ^= r[3]), this.pow(r, r);
  }
  return n;
};
Pe.gcm.prototype.pow = function(e, t) {
  for (var n = e[3] & 1, r = 3; r > 0; --r)
    t[r] = e[r] >>> 1 | (e[r - 1] & 1) << 31;
  t[0] = e[0] >>> 1, n && (t[0] ^= this._R);
};
Pe.gcm.prototype.tableMultiply = function(e) {
  for (var t = [0, 0, 0, 0], n = 0; n < 32; ++n) {
    var r = n / 8 | 0, a = e[r] >>> (7 - n % 8) * 4 & 15, s = this._m[n][a];
    t[0] ^= s[0], t[1] ^= s[1], t[2] ^= s[2], t[3] ^= s[3];
  }
  return t;
};
Pe.gcm.prototype.ghash = function(e, t, n) {
  return t[0] ^= n[0], t[1] ^= n[1], t[2] ^= n[2], t[3] ^= n[3], this.tableMultiply(t);
};
Pe.gcm.prototype.generateHashTable = function(e, t) {
  for (var n = 8 / t, r = 4 * n, a = 16 * n, s = new Array(a), i = 0; i < a; ++i) {
    var o = [0, 0, 0, 0], u = i / r | 0, c = (r - 1 - i % r) * t;
    o[u] = 1 << t - 1 << c, s[i] = this.generateSubHashTable(this.multiply(o, e), t);
  }
  return s;
};
Pe.gcm.prototype.generateSubHashTable = function(e, t) {
  var n = 1 << t, r = n >>> 1, a = new Array(n);
  a[r] = e.slice(0);
  for (var s = r >>> 1; s > 0; )
    this.pow(a[2 * s], a[s] = []), s >>= 1;
  for (s = 2; s < r; ) {
    for (var i = 1; i < s; ++i) {
      var o = a[s], u = a[i];
      a[s + i] = [
        o[0] ^ u[0],
        o[1] ^ u[1],
        o[2] ^ u[2],
        o[3] ^ u[3]
      ];
    }
    s *= 2;
  }
  for (a[0] = [0, 0, 0, 0], s = r + 1; s < n; ++s) {
    var c = a[s ^ r];
    a[s] = [e[0] ^ c[0], e[1] ^ c[1], e[2] ^ c[2], e[3] ^ c[3]];
  }
  return a;
};
function wa(e, t) {
  if (typeof e == "string" && (e = dt.util.createBuffer(e)), dt.util.isArray(e) && e.length > 4) {
    var n = e;
    e = dt.util.createBuffer();
    for (var r = 0; r < n.length; ++r)
      e.putByte(n[r]);
  }
  if (e.length() < t)
    throw new Error(
      "Invalid IV length; got " + e.length() + " bytes and expected " + t + " bytes."
    );
  if (!dt.util.isArray(e)) {
    for (var a = [], s = t / 4, r = 0; r < s; ++r)
      a.push(e.getInt32());
    e = a;
  }
  return e;
}
function Ba(e) {
  e[e.length - 1] = e[e.length - 1] + 1 & 4294967295;
}
function vi(e) {
  return [e / 4294967296 | 0, e & 4294967295];
}
var tt = De;
tt.aes = tt.aes || {};
tt.aes.startEncrypting = function(e, t, n, r) {
  var a = _a({
    key: e,
    output: n,
    decrypt: !1,
    mode: r
  });
  return a.start(t), a;
};
tt.aes.createEncryptionCipher = function(e, t) {
  return _a({
    key: e,
    output: null,
    decrypt: !1,
    mode: t
  });
};
tt.aes.startDecrypting = function(e, t, n, r) {
  var a = _a({
    key: e,
    output: n,
    decrypt: !0,
    mode: r
  });
  return a.start(t), a;
};
tt.aes.createDecryptionCipher = function(e, t) {
  return _a({
    key: e,
    output: null,
    decrypt: !0,
    mode: t
  });
};
tt.aes.Algorithm = function(e, t) {
  zi || Zo();
  var n = this;
  n.name = e, n.mode = new t({
    blockSize: 16,
    cipher: {
      encrypt: function(r, a) {
        return Ei(n._w, r, a, !1);
      },
      decrypt: function(r, a) {
        return Ei(n._w, r, a, !0);
      }
    }
  }), n._init = !1;
};
tt.aes.Algorithm.prototype.initialize = function(e) {
  if (!this._init) {
    var t = e.key, n;
    if (typeof t == "string" && (t.length === 16 || t.length === 24 || t.length === 32))
      t = tt.util.createBuffer(t);
    else if (tt.util.isArray(t) && (t.length === 16 || t.length === 24 || t.length === 32)) {
      n = t, t = tt.util.createBuffer();
      for (var r = 0; r < n.length; ++r)
        t.putByte(n[r]);
    }
    if (!tt.util.isArray(t)) {
      n = t, t = [];
      var a = n.length();
      if (a === 16 || a === 24 || a === 32) {
        a = a >>> 2;
        for (var r = 0; r < a; ++r)
          t.push(n.getInt32());
      }
    }
    if (!tt.util.isArray(t) || !(t.length === 4 || t.length === 6 || t.length === 8))
      throw new Error("Invalid key parameter.");
    var s = this.mode.name, i = ["CFB", "OFB", "CTR", "GCM"].indexOf(s) !== -1;
    this._w = ec(t, e.decrypt && !i), this._init = !0;
  }
};
tt.aes._expandKey = function(e, t) {
  return zi || Zo(), ec(e, t);
};
tt.aes._updateBlock = Ei;
Cn("AES-ECB", tt.cipher.modes.ecb);
Cn("AES-CBC", tt.cipher.modes.cbc);
Cn("AES-CFB", tt.cipher.modes.cfb);
Cn("AES-OFB", tt.cipher.modes.ofb);
Cn("AES-CTR", tt.cipher.modes.ctr);
Cn("AES-GCM", tt.cipher.modes.gcm);
function Cn(e, t) {
  var n = function() {
    return new tt.aes.Algorithm(e, t);
  };
  tt.cipher.registerAlgorithm(e, n);
}
var zi = !1, fn = 4, bt, mi, Jo, zr, $t;
function Zo() {
  zi = !0, Jo = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54];
  for (var e = new Array(256), t = 0; t < 128; ++t)
    e[t] = t << 1, e[t + 128] = t + 128 << 1 ^ 283;
  bt = new Array(256), mi = new Array(256), zr = new Array(4), $t = new Array(4);
  for (var t = 0; t < 4; ++t)
    zr[t] = new Array(256), $t[t] = new Array(256);
  for (var n = 0, r = 0, a, s, i, o, u, c, l, t = 0; t < 256; ++t) {
    o = r ^ r << 1 ^ r << 2 ^ r << 3 ^ r << 4, o = o >> 8 ^ o & 255 ^ 99, bt[n] = o, mi[o] = n, u = e[o], a = e[n], s = e[a], i = e[s], c = u << 24 ^ // 2
    o << 16 ^ // 1
    o << 8 ^ // 1
    (o ^ u), l = (a ^ s ^ i) << 24 ^ // E (14)
    (n ^ i) << 16 ^ // 9
    (n ^ s ^ i) << 8 ^ // D (13)
    (n ^ a ^ i);
    for (var p = 0; p < 4; ++p)
      zr[p][n] = c, $t[p][o] = l, c = c << 24 | c >>> 8, l = l << 24 | l >>> 8;
    n === 0 ? n = r = 1 : (n = a ^ e[e[e[a ^ i]]], r ^= e[e[r]]);
  }
}
function ec(e, t) {
  for (var n = e.slice(0), r, a = 1, s = n.length, i = s + 6 + 1, o = fn * i, u = s; u < o; ++u)
    r = n[u - 1], u % s === 0 ? (r = bt[r >>> 16 & 255] << 24 ^ bt[r >>> 8 & 255] << 16 ^ bt[r & 255] << 8 ^ bt[r >>> 24] ^ Jo[a] << 24, a++) : s > 6 && u % s === 4 && (r = bt[r >>> 24] << 24 ^ bt[r >>> 16 & 255] << 16 ^ bt[r >>> 8 & 255] << 8 ^ bt[r & 255]), n[u] = n[u - s] ^ r;
  if (t) {
    var c, l = $t[0], p = $t[1], g = $t[2], C = $t[3], d = n.slice(0);
    o = n.length;
    for (var u = 0, b = o - fn; u < o; u += fn, b -= fn)
      if (u === 0 || u === o - fn)
        d[u] = n[b], d[u + 1] = n[b + 3], d[u + 2] = n[b + 2], d[u + 3] = n[b + 1];
      else
        for (var S = 0; S < fn; ++S)
          c = n[b + S], d[u + (3 & -S)] = l[bt[c >>> 24]] ^ p[bt[c >>> 16 & 255]] ^ g[bt[c >>> 8 & 255]] ^ C[bt[c & 255]];
    n = d;
  }
  return n;
}
function Ei(e, t, n, r) {
  var a = e.length / 4 - 1, s, i, o, u, c;
  r ? (s = $t[0], i = $t[1], o = $t[2], u = $t[3], c = mi) : (s = zr[0], i = zr[1], o = zr[2], u = zr[3], c = bt);
  var l, p, g, C, d, b, S;
  l = t[0] ^ e[0], p = t[r ? 3 : 1] ^ e[1], g = t[2] ^ e[2], C = t[r ? 1 : 3] ^ e[3];
  for (var A = 3, D = 1; D < a; ++D)
    d = s[l >>> 24] ^ i[p >>> 16 & 255] ^ o[g >>> 8 & 255] ^ u[C & 255] ^ e[++A], b = s[p >>> 24] ^ i[g >>> 16 & 255] ^ o[C >>> 8 & 255] ^ u[l & 255] ^ e[++A], S = s[g >>> 24] ^ i[C >>> 16 & 255] ^ o[l >>> 8 & 255] ^ u[p & 255] ^ e[++A], C = s[C >>> 24] ^ i[l >>> 16 & 255] ^ o[p >>> 8 & 255] ^ u[g & 255] ^ e[++A], l = d, p = b, g = S;
  n[0] = c[l >>> 24] << 24 ^ c[p >>> 16 & 255] << 16 ^ c[g >>> 8 & 255] << 8 ^ c[C & 255] ^ e[++A], n[r ? 3 : 1] = c[p >>> 24] << 24 ^ c[g >>> 16 & 255] << 16 ^ c[C >>> 8 & 255] << 8 ^ c[l & 255] ^ e[++A], n[2] = c[g >>> 24] << 24 ^ c[C >>> 16 & 255] << 16 ^ c[l >>> 8 & 255] << 8 ^ c[p & 255] ^ e[++A], n[r ? 1 : 3] = c[C >>> 24] << 24 ^ c[l >>> 16 & 255] << 16 ^ c[p >>> 8 & 255] << 8 ^ c[g & 255] ^ e[++A];
}
function _a(e) {
  e = e || {};
  var t = (e.mode || "CBC").toUpperCase(), n = "AES-" + t, r;
  e.decrypt ? r = tt.cipher.createDecipher(n, e.key) : r = tt.cipher.createCipher(n, e.key);
  var a = r.start;
  return r.start = function(s, i) {
    var o = null;
    i instanceof tt.util.ByteBuffer && (o = i, i = {}), i = i || {}, i.output = o, i.iv = s, a.call(r, i);
  }, r;
}
var Pn = De;
Pn.pki = Pn.pki || {};
var Ci = Pn.pki.oids = Pn.oids = Pn.oids || {};
function ee(e, t) {
  Ci[e] = t, Ci[t] = e;
}
function Qe(e, t) {
  Ci[e] = t;
}
ee("1.2.840.113549.1.1.1", "rsaEncryption");
ee("1.2.840.113549.1.1.4", "md5WithRSAEncryption");
ee("1.2.840.113549.1.1.5", "sha1WithRSAEncryption");
ee("1.2.840.113549.1.1.7", "RSAES-OAEP");
ee("1.2.840.113549.1.1.8", "mgf1");
ee("1.2.840.113549.1.1.9", "pSpecified");
ee("1.2.840.113549.1.1.10", "RSASSA-PSS");
ee("1.2.840.113549.1.1.11", "sha256WithRSAEncryption");
ee("1.2.840.113549.1.1.12", "sha384WithRSAEncryption");
ee("1.2.840.113549.1.1.13", "sha512WithRSAEncryption");
ee("1.3.101.112", "EdDSA25519");
ee("1.2.840.10040.4.3", "dsa-with-sha1");
ee("1.3.14.3.2.7", "desCBC");
ee("1.3.14.3.2.26", "sha1");
ee("1.3.14.3.2.29", "sha1WithRSASignature");
ee("2.16.840.1.101.3.4.2.1", "sha256");
ee("2.16.840.1.101.3.4.2.2", "sha384");
ee("2.16.840.1.101.3.4.2.3", "sha512");
ee("2.16.840.1.101.3.4.2.4", "sha224");
ee("2.16.840.1.101.3.4.2.5", "sha512-224");
ee("2.16.840.1.101.3.4.2.6", "sha512-256");
ee("1.2.840.113549.2.2", "md2");
ee("1.2.840.113549.2.5", "md5");
ee("1.2.840.113549.1.7.1", "data");
ee("1.2.840.113549.1.7.2", "signedData");
ee("1.2.840.113549.1.7.3", "envelopedData");
ee("1.2.840.113549.1.7.4", "signedAndEnvelopedData");
ee("1.2.840.113549.1.7.5", "digestedData");
ee("1.2.840.113549.1.7.6", "encryptedData");
ee("1.2.840.113549.1.9.1", "emailAddress");
ee("1.2.840.113549.1.9.2", "unstructuredName");
ee("1.2.840.113549.1.9.3", "contentType");
ee("1.2.840.113549.1.9.4", "messageDigest");
ee("1.2.840.113549.1.9.5", "signingTime");
ee("1.2.840.113549.1.9.6", "counterSignature");
ee("1.2.840.113549.1.9.7", "challengePassword");
ee("1.2.840.113549.1.9.8", "unstructuredAddress");
ee("1.2.840.113549.1.9.14", "extensionRequest");
ee("1.2.840.113549.1.9.20", "friendlyName");
ee("1.2.840.113549.1.9.21", "localKeyId");
ee("1.2.840.113549.1.9.22.1", "x509Certificate");
ee("1.2.840.113549.1.12.10.1.1", "keyBag");
ee("1.2.840.113549.1.12.10.1.2", "pkcs8ShroudedKeyBag");
ee("1.2.840.113549.1.12.10.1.3", "certBag");
ee("1.2.840.113549.1.12.10.1.4", "crlBag");
ee("1.2.840.113549.1.12.10.1.5", "secretBag");
ee("1.2.840.113549.1.12.10.1.6", "safeContentsBag");
ee("1.2.840.113549.1.5.13", "pkcs5PBES2");
ee("1.2.840.113549.1.5.12", "pkcs5PBKDF2");
ee("1.2.840.113549.1.12.1.1", "pbeWithSHAAnd128BitRC4");
ee("1.2.840.113549.1.12.1.2", "pbeWithSHAAnd40BitRC4");
ee("1.2.840.113549.1.12.1.3", "pbeWithSHAAnd3-KeyTripleDES-CBC");
ee("1.2.840.113549.1.12.1.4", "pbeWithSHAAnd2-KeyTripleDES-CBC");
ee("1.2.840.113549.1.12.1.5", "pbeWithSHAAnd128BitRC2-CBC");
ee("1.2.840.113549.1.12.1.6", "pbewithSHAAnd40BitRC2-CBC");
ee("1.2.840.113549.2.7", "hmacWithSHA1");
ee("1.2.840.113549.2.8", "hmacWithSHA224");
ee("1.2.840.113549.2.9", "hmacWithSHA256");
ee("1.2.840.113549.2.10", "hmacWithSHA384");
ee("1.2.840.113549.2.11", "hmacWithSHA512");
ee("1.2.840.113549.3.7", "des-EDE3-CBC");
ee("2.16.840.1.101.3.4.1.2", "aes128-CBC");
ee("2.16.840.1.101.3.4.1.22", "aes192-CBC");
ee("2.16.840.1.101.3.4.1.42", "aes256-CBC");
ee("2.5.4.3", "commonName");
ee("2.5.4.4", "surname");
ee("2.5.4.5", "serialNumber");
ee("2.5.4.6", "countryName");
ee("2.5.4.7", "localityName");
ee("2.5.4.8", "stateOrProvinceName");
ee("2.5.4.9", "streetAddress");
ee("2.5.4.10", "organizationName");
ee("2.5.4.11", "organizationalUnitName");
ee("2.5.4.12", "title");
ee("2.5.4.13", "description");
ee("2.5.4.15", "businessCategory");
ee("2.5.4.17", "postalCode");
ee("2.5.4.42", "givenName");
ee("1.3.6.1.4.1.311.60.2.1.2", "jurisdictionOfIncorporationStateOrProvinceName");
ee("1.3.6.1.4.1.311.60.2.1.3", "jurisdictionOfIncorporationCountryName");
ee("2.16.840.1.113730.1.1", "nsCertType");
ee("2.16.840.1.113730.1.13", "nsComment");
Qe("2.5.29.1", "authorityKeyIdentifier");
Qe("2.5.29.2", "keyAttributes");
Qe("2.5.29.3", "certificatePolicies");
Qe("2.5.29.4", "keyUsageRestriction");
Qe("2.5.29.5", "policyMapping");
Qe("2.5.29.6", "subtreesConstraint");
Qe("2.5.29.7", "subjectAltName");
Qe("2.5.29.8", "issuerAltName");
Qe("2.5.29.9", "subjectDirectoryAttributes");
Qe("2.5.29.10", "basicConstraints");
Qe("2.5.29.11", "nameConstraints");
Qe("2.5.29.12", "policyConstraints");
Qe("2.5.29.13", "basicConstraints");
ee("2.5.29.14", "subjectKeyIdentifier");
ee("2.5.29.15", "keyUsage");
Qe("2.5.29.16", "privateKeyUsagePeriod");
ee("2.5.29.17", "subjectAltName");
ee("2.5.29.18", "issuerAltName");
ee("2.5.29.19", "basicConstraints");
Qe("2.5.29.20", "cRLNumber");
Qe("2.5.29.21", "cRLReason");
Qe("2.5.29.22", "expirationDate");
Qe("2.5.29.23", "instructionCode");
Qe("2.5.29.24", "invalidityDate");
Qe("2.5.29.25", "cRLDistributionPoints");
Qe("2.5.29.26", "issuingDistributionPoint");
Qe("2.5.29.27", "deltaCRLIndicator");
Qe("2.5.29.28", "issuingDistributionPoint");
Qe("2.5.29.29", "certificateIssuer");
Qe("2.5.29.30", "nameConstraints");
ee("2.5.29.31", "cRLDistributionPoints");
ee("2.5.29.32", "certificatePolicies");
Qe("2.5.29.33", "policyMappings");
Qe("2.5.29.34", "policyConstraints");
ee("2.5.29.35", "authorityKeyIdentifier");
Qe("2.5.29.36", "policyConstraints");
ee("2.5.29.37", "extKeyUsage");
Qe("2.5.29.46", "freshestCRL");
Qe("2.5.29.54", "inhibitAnyPolicy");
ee("1.3.6.1.4.1.11129.2.4.2", "timestampList");
ee("1.3.6.1.5.5.7.1.1", "authorityInfoAccess");
ee("1.3.6.1.5.5.7.3.1", "serverAuth");
ee("1.3.6.1.5.5.7.3.2", "clientAuth");
ee("1.3.6.1.5.5.7.3.3", "codeSigning");
ee("1.3.6.1.5.5.7.3.4", "emailProtection");
ee("1.3.6.1.5.5.7.3.8", "timeStamping");
var rt = De, fe = rt.asn1 = rt.asn1 || {};
fe.Class = {
  UNIVERSAL: 0,
  APPLICATION: 64,
  CONTEXT_SPECIFIC: 128,
  PRIVATE: 192
};
fe.Type = {
  NONE: 0,
  BOOLEAN: 1,
  INTEGER: 2,
  BITSTRING: 3,
  OCTETSTRING: 4,
  NULL: 5,
  OID: 6,
  ODESC: 7,
  EXTERNAL: 8,
  REAL: 9,
  ENUMERATED: 10,
  EMBEDDED: 11,
  UTF8: 12,
  ROID: 13,
  SEQUENCE: 16,
  SET: 17,
  PRINTABLESTRING: 19,
  IA5STRING: 22,
  UTCTIME: 23,
  GENERALIZEDTIME: 24,
  BMPSTRING: 30
};
fe.create = function(e, t, n, r, a) {
  if (rt.util.isArray(r)) {
    for (var s = [], i = 0; i < r.length; ++i)
      r[i] !== void 0 && s.push(r[i]);
    r = s;
  }
  var o = {
    tagClass: e,
    type: t,
    constructed: n,
    composed: n || rt.util.isArray(r),
    value: r
  };
  return a && "bitStringContents" in a && (o.bitStringContents = a.bitStringContents, o.original = fe.copy(o)), o;
};
fe.copy = function(e, t) {
  var n;
  if (rt.util.isArray(e)) {
    n = [];
    for (var r = 0; r < e.length; ++r)
      n.push(fe.copy(e[r], t));
    return n;
  }
  return typeof e == "string" ? e : (n = {
    tagClass: e.tagClass,
    type: e.type,
    constructed: e.constructed,
    composed: e.composed,
    value: fe.copy(e.value, t)
  }, t && !t.excludeBitStringContents && (n.bitStringContents = e.bitStringContents), n);
};
fe.equals = function(e, t, n) {
  if (rt.util.isArray(e)) {
    if (!rt.util.isArray(t) || e.length !== t.length)
      return !1;
    for (var r = 0; r < e.length; ++r)
      if (!fe.equals(e[r], t[r]))
        return !1;
    return !0;
  }
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "string")
    return e === t;
  var a = e.tagClass === t.tagClass && e.type === t.type && e.constructed === t.constructed && e.composed === t.composed && fe.equals(e.value, t.value);
  return n && n.includeBitStringContents && (a = a && e.bitStringContents === t.bitStringContents), a;
};
fe.getBerValueLength = function(e) {
  var t = e.getByte();
  if (t !== 128) {
    var n, r = t & 128;
    return r ? n = e.getInt((t & 127) << 3) : n = t, n;
  }
};
function kn(e, t, n) {
  if (n > t) {
    var r = new Error("Too few bytes to parse DER.");
    throw r.available = e.length(), r.remaining = t, r.requested = n, r;
  }
}
var A0 = function(e, t) {
  var n = e.getByte();
  if (t--, n !== 128) {
    var r, a = n & 128;
    if (!a)
      r = n;
    else {
      var s = n & 127;
      kn(e, t, s), r = e.getInt(s << 3);
    }
    if (r < 0)
      throw new Error("Negative length: " + r);
    return r;
  }
};
fe.fromDer = function(e, t) {
  t === void 0 && (t = {
    strict: !0,
    parseAllBytes: !0,
    decodeBitStrings: !0
  }), typeof t == "boolean" && (t = {
    strict: t,
    parseAllBytes: !0,
    decodeBitStrings: !0
  }), "strict" in t || (t.strict = !0), "parseAllBytes" in t || (t.parseAllBytes = !0), "decodeBitStrings" in t || (t.decodeBitStrings = !0), typeof e == "string" && (e = rt.util.createBuffer(e));
  var n = e.length(), r = oa(e, e.length(), 0, t);
  if (t.parseAllBytes && e.length() !== 0) {
    var a = new Error("Unparsed DER bytes remain after ASN.1 parsing.");
    throw a.byteCount = n, a.remaining = e.length(), a;
  }
  return r;
};
function oa(e, t, n, r) {
  var a;
  kn(e, t, 2);
  var s = e.getByte();
  t--;
  var i = s & 192, o = s & 31;
  a = e.length();
  var u = A0(e, t);
  if (t -= a - e.length(), u !== void 0 && u > t) {
    if (r.strict) {
      var c = new Error("Too few bytes to read ASN.1 value.");
      throw c.available = e.length(), c.remaining = t, c.requested = u, c;
    }
    u = t;
  }
  var l, p, g = (s & 32) === 32;
  if (g)
    if (l = [], u === void 0)
      for (; ; ) {
        if (kn(e, t, 2), e.bytes(2) === String.fromCharCode(0, 0)) {
          e.getBytes(2), t -= 2;
          break;
        }
        a = e.length(), l.push(oa(e, t, n + 1, r)), t -= a - e.length();
      }
    else
      for (; u > 0; )
        a = e.length(), l.push(oa(e, u, n + 1, r)), t -= a - e.length(), u -= a - e.length();
  if (l === void 0 && i === fe.Class.UNIVERSAL && o === fe.Type.BITSTRING && (p = e.bytes(u)), l === void 0 && r.decodeBitStrings && i === fe.Class.UNIVERSAL && // FIXME: OCTET STRINGs not yet supported here
  // .. other parts of forge expect to decode OCTET STRINGs manually
  o === fe.Type.BITSTRING && u > 1) {
    var C = e.read, d = t, b = 0;
    if (o === fe.Type.BITSTRING && (kn(e, t, 1), b = e.getByte(), t--), b === 0)
      try {
        a = e.length();
        var S = {
          // enforce strict mode to avoid parsing ASN.1 from plain data
          strict: !0,
          decodeBitStrings: !0
        }, A = oa(e, t, n + 1, S), D = a - e.length();
        t -= D, o == fe.Type.BITSTRING && D++;
        var _ = A.tagClass;
        D === u && (_ === fe.Class.UNIVERSAL || _ === fe.Class.CONTEXT_SPECIFIC) && (l = [A]);
      } catch {
      }
    l === void 0 && (e.read = C, t = d);
  }
  if (l === void 0) {
    if (u === void 0) {
      if (r.strict)
        throw new Error("Non-constructed ASN.1 object of indefinite length.");
      u = t;
    }
    if (o === fe.Type.BMPSTRING)
      for (l = ""; u > 0; u -= 2)
        kn(e, t, 2), l += String.fromCharCode(e.getInt16()), t -= 2;
    else
      l = e.getBytes(u), t -= u;
  }
  var M = p === void 0 ? null : {
    bitStringContents: p
  };
  return fe.create(i, o, g, l, M);
}
fe.toDer = function(e) {
  var t = rt.util.createBuffer(), n = e.tagClass | e.type, r = rt.util.createBuffer(), a = !1;
  if ("bitStringContents" in e && (a = !0, e.original && (a = fe.equals(e, e.original))), a)
    r.putBytes(e.bitStringContents);
  else if (e.composed) {
    e.constructed ? n |= 32 : r.putByte(0);
    for (var s = 0; s < e.value.length; ++s)
      e.value[s] !== void 0 && r.putBuffer(fe.toDer(e.value[s]));
  } else if (e.type === fe.Type.BMPSTRING)
    for (var s = 0; s < e.value.length; ++s)
      r.putInt16(e.value.charCodeAt(s));
  else
    e.type === fe.Type.INTEGER && e.value.length > 1 && // leading 0x00 for positive integer
    (e.value.charCodeAt(0) === 0 && !(e.value.charCodeAt(1) & 128) || // leading 0xFF for negative integer
    e.value.charCodeAt(0) === 255 && (e.value.charCodeAt(1) & 128) === 128) ? r.putBytes(e.value.substr(1)) : r.putBytes(e.value);
  if (t.putByte(n), r.length() <= 127)
    t.putByte(r.length() & 127);
  else {
    var i = r.length(), o = "";
    do
      o += String.fromCharCode(i & 255), i = i >>> 8;
    while (i > 0);
    t.putByte(o.length | 128);
    for (var s = o.length - 1; s >= 0; --s)
      t.putByte(o.charCodeAt(s));
  }
  return t.putBuffer(r), t;
};
fe.oidToDer = function(e) {
  var t = e.split("."), n = rt.util.createBuffer();
  n.putByte(40 * parseInt(t[0], 10) + parseInt(t[1], 10));
  for (var r, a, s, i, o = 2; o < t.length; ++o) {
    r = !0, a = [], s = parseInt(t[o], 10);
    do
      i = s & 127, s = s >>> 7, r || (i |= 128), a.push(i), r = !1;
    while (s > 0);
    for (var u = a.length - 1; u >= 0; --u)
      n.putByte(a[u]);
  }
  return n;
};
fe.derToOid = function(e) {
  var t;
  typeof e == "string" && (e = rt.util.createBuffer(e));
  var n = e.getByte();
  t = Math.floor(n / 40) + "." + n % 40;
  for (var r = 0; e.length() > 0; )
    n = e.getByte(), r = r << 7, n & 128 ? r += n & 127 : (t += "." + (r + n), r = 0);
  return t;
};
fe.utcTimeToDate = function(e) {
  var t = /* @__PURE__ */ new Date(), n = parseInt(e.substr(0, 2), 10);
  n = n >= 50 ? 1900 + n : 2e3 + n;
  var r = parseInt(e.substr(2, 2), 10) - 1, a = parseInt(e.substr(4, 2), 10), s = parseInt(e.substr(6, 2), 10), i = parseInt(e.substr(8, 2), 10), o = 0;
  if (e.length > 11) {
    var u = e.charAt(10), c = 10;
    u !== "+" && u !== "-" && (o = parseInt(e.substr(10, 2), 10), c += 2);
  }
  if (t.setUTCFullYear(n, r, a), t.setUTCHours(s, i, o, 0), c && (u = e.charAt(c), u === "+" || u === "-")) {
    var l = parseInt(e.substr(c + 1, 2), 10), p = parseInt(e.substr(c + 4, 2), 10), g = l * 60 + p;
    g *= 6e4, u === "+" ? t.setTime(+t - g) : t.setTime(+t + g);
  }
  return t;
};
fe.generalizedTimeToDate = function(e) {
  var t = /* @__PURE__ */ new Date(), n = parseInt(e.substr(0, 4), 10), r = parseInt(e.substr(4, 2), 10) - 1, a = parseInt(e.substr(6, 2), 10), s = parseInt(e.substr(8, 2), 10), i = parseInt(e.substr(10, 2), 10), o = parseInt(e.substr(12, 2), 10), u = 0, c = 0, l = !1;
  e.charAt(e.length - 1) === "Z" && (l = !0);
  var p = e.length - 5, g = e.charAt(p);
  if (g === "+" || g === "-") {
    var C = parseInt(e.substr(p + 1, 2), 10), d = parseInt(e.substr(p + 4, 2), 10);
    c = C * 60 + d, c *= 6e4, g === "+" && (c *= -1), l = !0;
  }
  return e.charAt(14) === "." && (u = parseFloat(e.substr(14), 10) * 1e3), l ? (t.setUTCFullYear(n, r, a), t.setUTCHours(s, i, o, u), t.setTime(+t + c)) : (t.setFullYear(n, r, a), t.setHours(s, i, o, u)), t;
};
fe.dateToUtcTime = function(e) {
  if (typeof e == "string")
    return e;
  var t = "", n = [];
  n.push(("" + e.getUTCFullYear()).substr(2)), n.push("" + (e.getUTCMonth() + 1)), n.push("" + e.getUTCDate()), n.push("" + e.getUTCHours()), n.push("" + e.getUTCMinutes()), n.push("" + e.getUTCSeconds());
  for (var r = 0; r < n.length; ++r)
    n[r].length < 2 && (t += "0"), t += n[r];
  return t += "Z", t;
};
fe.dateToGeneralizedTime = function(e) {
  if (typeof e == "string")
    return e;
  var t = "", n = [];
  n.push("" + e.getUTCFullYear()), n.push("" + (e.getUTCMonth() + 1)), n.push("" + e.getUTCDate()), n.push("" + e.getUTCHours()), n.push("" + e.getUTCMinutes()), n.push("" + e.getUTCSeconds());
  for (var r = 0; r < n.length; ++r)
    n[r].length < 2 && (t += "0"), t += n[r];
  return t += "Z", t;
};
fe.integerToDer = function(e) {
  var t = rt.util.createBuffer();
  if (e >= -128 && e < 128)
    return t.putSignedInt(e, 8);
  if (e >= -32768 && e < 32768)
    return t.putSignedInt(e, 16);
  if (e >= -8388608 && e < 8388608)
    return t.putSignedInt(e, 24);
  if (e >= -2147483648 && e < 2147483648)
    return t.putSignedInt(e, 32);
  var n = new Error("Integer too large; max is 32-bits.");
  throw n.integer = e, n;
};
fe.derToInteger = function(e) {
  typeof e == "string" && (e = rt.util.createBuffer(e));
  var t = e.length() * 8;
  if (t > 32)
    throw new Error("Integer too large; max is 32-bits.");
  return e.getSignedInt(t);
};
fe.validate = function(e, t, n, r) {
  var a = !1;
  if ((e.tagClass === t.tagClass || typeof t.tagClass > "u") && (e.type === t.type || typeof t.type > "u"))
    if (e.constructed === t.constructed || typeof t.constructed > "u") {
      if (a = !0, t.value && rt.util.isArray(t.value))
        for (var s = 0, i = 0; a && i < t.value.length; ++i)
          a = t.value[i].optional || !1, e.value[s] && (a = fe.validate(e.value[s], t.value[i], n, r), a ? ++s : t.value[i].optional && (a = !0)), !a && r && r.push(
            "[" + t.name + '] Tag class "' + t.tagClass + '", type "' + t.type + '" expected value length "' + t.value.length + '", got "' + e.value.length + '"'
          );
      if (a && n && (t.capture && (n[t.capture] = e.value), t.captureAsn1 && (n[t.captureAsn1] = e), t.captureBitStringContents && "bitStringContents" in e && (n[t.captureBitStringContents] = e.bitStringContents), t.captureBitStringValue && "bitStringContents" in e))
        if (e.bitStringContents.length < 2)
          n[t.captureBitStringValue] = "";
        else {
          var o = e.bitStringContents.charCodeAt(0);
          if (o !== 0)
            throw new Error(
              "captureBitStringValue only supported for zero unused bits"
            );
          n[t.captureBitStringValue] = e.bitStringContents.slice(1);
        }
    } else
      r && r.push(
        "[" + t.name + '] Expected constructed "' + t.constructed + '", got "' + e.constructed + '"'
      );
  else
    r && (e.tagClass !== t.tagClass && r.push(
      "[" + t.name + '] Expected tag class "' + t.tagClass + '", got "' + e.tagClass + '"'
    ), e.type !== t.type && r.push(
      "[" + t.name + '] Expected type "' + t.type + '", got "' + e.type + '"'
    ));
  return a;
};
var js = /[^\\u0000-\\u00ff]/;
fe.prettyPrint = function(e, t, n) {
  var r = "";
  t = t || 0, n = n || 2, t > 0 && (r += `
`);
  for (var a = "", s = 0; s < t * n; ++s)
    a += " ";
  switch (r += a + "Tag: ", e.tagClass) {
    case fe.Class.UNIVERSAL:
      r += "Universal:";
      break;
    case fe.Class.APPLICATION:
      r += "Application:";
      break;
    case fe.Class.CONTEXT_SPECIFIC:
      r += "Context-Specific:";
      break;
    case fe.Class.PRIVATE:
      r += "Private:";
      break;
  }
  if (e.tagClass === fe.Class.UNIVERSAL)
    switch (r += e.type, e.type) {
      case fe.Type.NONE:
        r += " (None)";
        break;
      case fe.Type.BOOLEAN:
        r += " (Boolean)";
        break;
      case fe.Type.INTEGER:
        r += " (Integer)";
        break;
      case fe.Type.BITSTRING:
        r += " (Bit string)";
        break;
      case fe.Type.OCTETSTRING:
        r += " (Octet string)";
        break;
      case fe.Type.NULL:
        r += " (Null)";
        break;
      case fe.Type.OID:
        r += " (Object Identifier)";
        break;
      case fe.Type.ODESC:
        r += " (Object Descriptor)";
        break;
      case fe.Type.EXTERNAL:
        r += " (External or Instance of)";
        break;
      case fe.Type.REAL:
        r += " (Real)";
        break;
      case fe.Type.ENUMERATED:
        r += " (Enumerated)";
        break;
      case fe.Type.EMBEDDED:
        r += " (Embedded PDV)";
        break;
      case fe.Type.UTF8:
        r += " (UTF8)";
        break;
      case fe.Type.ROID:
        r += " (Relative Object Identifier)";
        break;
      case fe.Type.SEQUENCE:
        r += " (Sequence)";
        break;
      case fe.Type.SET:
        r += " (Set)";
        break;
      case fe.Type.PRINTABLESTRING:
        r += " (Printable String)";
        break;
      case fe.Type.IA5String:
        r += " (IA5String (ASCII))";
        break;
      case fe.Type.UTCTIME:
        r += " (UTC time)";
        break;
      case fe.Type.GENERALIZEDTIME:
        r += " (Generalized time)";
        break;
      case fe.Type.BMPSTRING:
        r += " (BMP String)";
        break;
    }
  else
    r += e.type;
  if (r += `
`, r += a + "Constructed: " + e.constructed + `
`, e.composed) {
    for (var i = 0, o = "", s = 0; s < e.value.length; ++s)
      e.value[s] !== void 0 && (i += 1, o += fe.prettyPrint(e.value[s], t + 1, n), s + 1 < e.value.length && (o += ","));
    r += a + "Sub values: " + i + o;
  } else {
    if (r += a + "Value: ", e.type === fe.Type.OID) {
      var u = fe.derToOid(e.value);
      r += u, rt.pki && rt.pki.oids && u in rt.pki.oids && (r += " (" + rt.pki.oids[u] + ") ");
    }
    if (e.type === fe.Type.INTEGER)
      try {
        r += fe.derToInteger(e.value);
      } catch {
        r += "0x" + rt.util.bytesToHex(e.value);
      }
    else if (e.type === fe.Type.BITSTRING) {
      if (e.value.length > 1 ? r += "0x" + rt.util.bytesToHex(e.value.slice(1)) : r += "(none)", e.value.length > 0) {
        var c = e.value.charCodeAt(0);
        c == 1 ? r += " (1 unused bit shown)" : c > 1 && (r += " (" + c + " unused bits shown)");
      }
    } else if (e.type === fe.Type.OCTETSTRING)
      js.test(e.value) || (r += "(" + e.value + ") "), r += "0x" + rt.util.bytesToHex(e.value);
    else if (e.type === fe.Type.UTF8)
      try {
        r += rt.util.decodeUtf8(e.value);
      } catch (l) {
        if (l.message === "URI malformed")
          r += "0x" + rt.util.bytesToHex(e.value) + " (malformed UTF8)";
        else
          throw l;
      }
    else
      e.type === fe.Type.PRINTABLESTRING || e.type === fe.Type.IA5String ? r += e.value : js.test(e.value) ? r += "0x" + rt.util.bytesToHex(e.value) : e.value.length === 0 ? r += "[null]" : r += e.value;
  }
  return r;
};
var fa = De;
fa.md = fa.md || {};
fa.md.algorithms = fa.md.algorithms || {};
var fr = De, I0 = fr.hmac = fr.hmac || {};
I0.create = function() {
  var e = null, t = null, n = null, r = null, a = {};
  return a.start = function(s, i) {
    if (s !== null)
      if (typeof s == "string")
        if (s = s.toLowerCase(), s in fr.md.algorithms)
          t = fr.md.algorithms[s].create();
        else
          throw new Error('Unknown hash algorithm "' + s + '"');
      else
        t = s;
    if (i === null)
      i = e;
    else {
      if (typeof i == "string")
        i = fr.util.createBuffer(i);
      else if (fr.util.isArray(i)) {
        var o = i;
        i = fr.util.createBuffer();
        for (var u = 0; u < o.length; ++u)
          i.putByte(o[u]);
      }
      var c = i.length();
      c > t.blockLength && (t.start(), t.update(i.bytes()), i = t.digest()), n = fr.util.createBuffer(), r = fr.util.createBuffer(), c = i.length();
      for (var u = 0; u < c; ++u) {
        var o = i.at(u);
        n.putByte(54 ^ o), r.putByte(92 ^ o);
      }
      if (c < t.blockLength)
        for (var o = t.blockLength - c, u = 0; u < o; ++u)
          n.putByte(54), r.putByte(92);
      e = i, n = n.bytes(), r = r.bytes();
    }
    t.start(), t.update(n);
  }, a.update = function(s) {
    t.update(s);
  }, a.getMac = function() {
    var s = t.digest().bytes();
    return t.start(), t.update(r), t.update(s), t.digest();
  }, a.digest = a.getMac, a;
};
var tr = De, tc = tr.md5 = tr.md5 || {};
tr.md.md5 = tr.md.algorithms.md5 = tc;
tc.create = function() {
  rc || w0();
  var e = null, t = tr.util.createBuffer(), n = new Array(16), r = {
    algorithm: "md5",
    blockLength: 64,
    digestLength: 16,
    // 56-bit length of message so far (does not including padding)
    messageLength: 0,
    // true message length
    fullMessageLength: null,
    // size of message length in bytes
    messageLengthSize: 8
  };
  return r.start = function() {
    r.messageLength = 0, r.fullMessageLength = r.messageLength64 = [];
    for (var a = r.messageLengthSize / 4, s = 0; s < a; ++s)
      r.fullMessageLength.push(0);
    return t = tr.util.createBuffer(), e = {
      h0: 1732584193,
      h1: 4023233417,
      h2: 2562383102,
      h3: 271733878
    }, r;
  }, r.start(), r.update = function(a, s) {
    s === "utf8" && (a = tr.util.encodeUtf8(a));
    var i = a.length;
    r.messageLength += i, i = [i / 4294967296 >>> 0, i >>> 0];
    for (var o = r.fullMessageLength.length - 1; o >= 0; --o)
      r.fullMessageLength[o] += i[1], i[1] = i[0] + (r.fullMessageLength[o] / 4294967296 >>> 0), r.fullMessageLength[o] = r.fullMessageLength[o] >>> 0, i[0] = i[1] / 4294967296 >>> 0;
    return t.putBytes(a), Hs(e, n, t), (t.read > 2048 || t.length() === 0) && t.compact(), r;
  }, r.digest = function() {
    var a = tr.util.createBuffer();
    a.putBytes(t.bytes());
    var s = r.fullMessageLength[r.fullMessageLength.length - 1] + r.messageLengthSize, i = s & r.blockLength - 1;
    a.putBytes(Si.substr(0, r.blockLength - i));
    for (var o, u = 0, c = r.fullMessageLength.length - 1; c >= 0; --c)
      o = r.fullMessageLength[c] * 8 + u, u = o / 4294967296 >>> 0, a.putInt32Le(o >>> 0);
    var l = {
      h0: e.h0,
      h1: e.h1,
      h2: e.h2,
      h3: e.h3
    };
    Hs(l, n, a);
    var p = tr.util.createBuffer();
    return p.putInt32Le(l.h0), p.putInt32Le(l.h1), p.putInt32Le(l.h2), p.putInt32Le(l.h3), p;
  }, r;
};
var Si = null, ca = null, On = null, hn = null, rc = !1;
function w0() {
  Si = String.fromCharCode(128), Si += tr.util.fillString(String.fromCharCode(0), 64), ca = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    1,
    6,
    11,
    0,
    5,
    10,
    15,
    4,
    9,
    14,
    3,
    8,
    13,
    2,
    7,
    12,
    5,
    8,
    11,
    14,
    1,
    4,
    7,
    10,
    13,
    0,
    3,
    6,
    9,
    12,
    15,
    2,
    0,
    7,
    14,
    5,
    12,
    3,
    10,
    1,
    8,
    15,
    6,
    13,
    4,
    11,
    2,
    9
  ], On = [
    7,
    12,
    17,
    22,
    7,
    12,
    17,
    22,
    7,
    12,
    17,
    22,
    7,
    12,
    17,
    22,
    5,
    9,
    14,
    20,
    5,
    9,
    14,
    20,
    5,
    9,
    14,
    20,
    5,
    9,
    14,
    20,
    4,
    11,
    16,
    23,
    4,
    11,
    16,
    23,
    4,
    11,
    16,
    23,
    4,
    11,
    16,
    23,
    6,
    10,
    15,
    21,
    6,
    10,
    15,
    21,
    6,
    10,
    15,
    21,
    6,
    10,
    15,
    21
  ], hn = new Array(64);
  for (var e = 0; e < 64; ++e)
    hn[e] = Math.floor(Math.abs(Math.sin(e + 1)) * 4294967296);
  rc = !0;
}
function Hs(e, t, n) {
  for (var r, a, s, i, o, u, c, l, p = n.length(); p >= 64; ) {
    for (a = e.h0, s = e.h1, i = e.h2, o = e.h3, l = 0; l < 16; ++l)
      t[l] = n.getInt32Le(), u = o ^ s & (i ^ o), r = a + u + hn[l] + t[l], c = On[l], a = o, o = i, i = s, s += r << c | r >>> 32 - c;
    for (; l < 32; ++l)
      u = i ^ o & (s ^ i), r = a + u + hn[l] + t[ca[l]], c = On[l], a = o, o = i, i = s, s += r << c | r >>> 32 - c;
    for (; l < 48; ++l)
      u = s ^ i ^ o, r = a + u + hn[l] + t[ca[l]], c = On[l], a = o, o = i, i = s, s += r << c | r >>> 32 - c;
    for (; l < 64; ++l)
      u = i ^ (s | ~o), r = a + u + hn[l] + t[ca[l]], c = On[l], a = o, o = i, i = s, s += r << c | r >>> 32 - c;
    e.h0 = e.h0 + a | 0, e.h1 = e.h1 + s | 0, e.h2 = e.h2 + i | 0, e.h3 = e.h3 + o | 0, p -= 64;
  }
}
var pa = De, nc = pa.pem = pa.pem || {};
nc.encode = function(e, t) {
  t = t || {};
  var n = "-----BEGIN " + e.type + `-----\r
`, r;
  if (e.procType && (r = {
    name: "Proc-Type",
    values: [String(e.procType.version), e.procType.type]
  }, n += ra(r)), e.contentDomain && (r = { name: "Content-Domain", values: [e.contentDomain] }, n += ra(r)), e.dekInfo && (r = { name: "DEK-Info", values: [e.dekInfo.algorithm] }, e.dekInfo.parameters && r.values.push(e.dekInfo.parameters), n += ra(r)), e.headers)
    for (var a = 0; a < e.headers.length; ++a)
      n += ra(e.headers[a]);
  return e.procType && (n += `\r
`), n += pa.util.encode64(e.body, t.maxline || 64) + `\r
`, n += "-----END " + e.type + `-----\r
`, n;
};
nc.decode = function(e) {
  for (var t = [], n = /\s*-----BEGIN ([A-Z0-9- ]+)-----\r?\n?([\x21-\x7e\s]+?(?:\r?\n\r?\n))?([:A-Za-z0-9+\/=\s]+?)-----END \1-----/g, r = /([\x21-\x7e]+):\s*([\x21-\x7e\s^:]+)/, a = /\r?\n/, s; s = n.exec(e), !!s; ) {
    var i = s[1];
    i === "NEW CERTIFICATE REQUEST" && (i = "CERTIFICATE REQUEST");
    var o = {
      type: i,
      procType: null,
      contentDomain: null,
      dekInfo: null,
      headers: [],
      body: pa.util.decode64(s[3])
    };
    if (t.push(o), !!s[2]) {
      for (var u = s[2].split(a), c = 0; s && c < u.length; ) {
        for (var l = u[c].replace(/\s+$/, ""), p = c + 1; p < u.length; ++p) {
          var g = u[p];
          if (!/\s/.test(g[0]))
            break;
          l += g, c = p;
        }
        if (s = l.match(r), s) {
          for (var C = { name: s[1], values: [] }, d = s[2].split(","), b = 0; b < d.length; ++b)
            C.values.push(B0(d[b]));
          if (o.procType)
            if (!o.contentDomain && C.name === "Content-Domain")
              o.contentDomain = d[0] || "";
            else if (!o.dekInfo && C.name === "DEK-Info") {
              if (C.values.length === 0)
                throw new Error('Invalid PEM formatted message. The "DEK-Info" header must have at least one subfield.');
              o.dekInfo = { algorithm: d[0], parameters: d[1] || null };
            } else
              o.headers.push(C);
          else {
            if (C.name !== "Proc-Type")
              throw new Error('Invalid PEM formatted message. The first encapsulated header must be "Proc-Type".');
            if (C.values.length !== 2)
              throw new Error('Invalid PEM formatted message. The "Proc-Type" header must have two subfields.');
            o.procType = { version: d[0], type: d[1] };
          }
        }
        ++c;
      }
      if (o.procType === "ENCRYPTED" && !o.dekInfo)
        throw new Error('Invalid PEM formatted message. The "DEK-Info" header must be present if "Proc-Type" is "ENCRYPTED".');
    }
  }
  if (t.length === 0)
    throw new Error("Invalid PEM formatted message.");
  return t;
};
function ra(e) {
  for (var t = e.name + ": ", n = [], r = function(u, c) {
    return " " + c;
  }, a = 0; a < e.values.length; ++a)
    n.push(e.values[a].replace(/^(\S+\r\n)/, r));
  t += n.join(",") + `\r
`;
  for (var s = 0, i = -1, a = 0; a < t.length; ++a, ++s)
    if (s > 65 && i !== -1) {
      var o = t[i];
      o === "," ? (++i, t = t.substr(0, i) + `\r
 ` + t.substr(i)) : t = t.substr(0, i) + `\r
` + o + t.substr(i + 1), s = a - i - 1, i = -1, ++a;
    } else
      (t[a] === " " || t[a] === "	" || t[a] === ",") && (i = a);
  return t;
}
function B0(e) {
  return e.replace(/^\s+/, "");
}
var it = De;
it.des = it.des || {};
it.des.startEncrypting = function(e, t, n, r) {
  var a = Na({
    key: e,
    output: n,
    decrypt: !1,
    mode: r || (t === null ? "ECB" : "CBC")
  });
  return a.start(t), a;
};
it.des.createEncryptionCipher = function(e, t) {
  return Na({
    key: e,
    output: null,
    decrypt: !1,
    mode: t
  });
};
it.des.startDecrypting = function(e, t, n, r) {
  var a = Na({
    key: e,
    output: n,
    decrypt: !0,
    mode: r || (t === null ? "ECB" : "CBC")
  });
  return a.start(t), a;
};
it.des.createDecryptionCipher = function(e, t) {
  return Na({
    key: e,
    output: null,
    decrypt: !0,
    mode: t
  });
};
it.des.Algorithm = function(e, t) {
  var n = this;
  n.name = e, n.mode = new t({
    blockSize: 8,
    cipher: {
      encrypt: function(r, a) {
        return qs(n._keys, r, a, !1);
      },
      decrypt: function(r, a) {
        return qs(n._keys, r, a, !0);
      }
    }
  }), n._init = !1;
};
it.des.Algorithm.prototype.initialize = function(e) {
  if (!this._init) {
    var t = it.util.createBuffer(e.key);
    if (this.name.indexOf("3DES") === 0 && t.length() !== 24)
      throw new Error("Invalid Triple-DES key size: " + t.length() * 8);
    this._keys = U0(t), this._init = !0;
  }
};
ir("DES-ECB", it.cipher.modes.ecb);
ir("DES-CBC", it.cipher.modes.cbc);
ir("DES-CFB", it.cipher.modes.cfb);
ir("DES-OFB", it.cipher.modes.ofb);
ir("DES-CTR", it.cipher.modes.ctr);
ir("3DES-ECB", it.cipher.modes.ecb);
ir("3DES-CBC", it.cipher.modes.cbc);
ir("3DES-CFB", it.cipher.modes.cfb);
ir("3DES-OFB", it.cipher.modes.ofb);
ir("3DES-CTR", it.cipher.modes.ctr);
function ir(e, t) {
  var n = function() {
    return new it.des.Algorithm(e, t);
  };
  it.cipher.registerAlgorithm(e, n);
}
var _0 = [16843776, 0, 65536, 16843780, 16842756, 66564, 4, 65536, 1024, 16843776, 16843780, 1024, 16778244, 16842756, 16777216, 4, 1028, 16778240, 16778240, 66560, 66560, 16842752, 16842752, 16778244, 65540, 16777220, 16777220, 65540, 0, 1028, 66564, 16777216, 65536, 16843780, 4, 16842752, 16843776, 16777216, 16777216, 1024, 16842756, 65536, 66560, 16777220, 1024, 4, 16778244, 66564, 16843780, 65540, 16842752, 16778244, 16777220, 1028, 66564, 16843776, 1028, 16778240, 16778240, 0, 65540, 66560, 0, 16842756], N0 = [-2146402272, -2147450880, 32768, 1081376, 1048576, 32, -2146435040, -2147450848, -2147483616, -2146402272, -2146402304, -2147483648, -2147450880, 1048576, 32, -2146435040, 1081344, 1048608, -2147450848, 0, -2147483648, 32768, 1081376, -2146435072, 1048608, -2147483616, 0, 1081344, 32800, -2146402304, -2146435072, 32800, 0, 1081376, -2146435040, 1048576, -2147450848, -2146435072, -2146402304, 32768, -2146435072, -2147450880, 32, -2146402272, 1081376, 32, 32768, -2147483648, 32800, -2146402304, 1048576, -2147483616, 1048608, -2147450848, -2147483616, 1048608, 1081344, 0, -2147450880, 32800, -2147483648, -2146435040, -2146402272, 1081344], R0 = [520, 134349312, 0, 134348808, 134218240, 0, 131592, 134218240, 131080, 134217736, 134217736, 131072, 134349320, 131080, 134348800, 520, 134217728, 8, 134349312, 512, 131584, 134348800, 134348808, 131592, 134218248, 131584, 131072, 134218248, 8, 134349320, 512, 134217728, 134349312, 134217728, 131080, 520, 131072, 134349312, 134218240, 0, 512, 131080, 134349320, 134218240, 134217736, 512, 0, 134348808, 134218248, 131072, 134217728, 134349320, 8, 131592, 131584, 134217736, 134348800, 134218248, 520, 134348800, 131592, 8, 134348808, 131584], L0 = [8396801, 8321, 8321, 128, 8396928, 8388737, 8388609, 8193, 0, 8396800, 8396800, 8396929, 129, 0, 8388736, 8388609, 1, 8192, 8388608, 8396801, 128, 8388608, 8193, 8320, 8388737, 1, 8320, 8388736, 8192, 8396928, 8396929, 129, 8388736, 8388609, 8396800, 8396929, 129, 0, 0, 8396800, 8320, 8388736, 8388737, 1, 8396801, 8321, 8321, 128, 8396929, 129, 1, 8192, 8388609, 8193, 8396928, 8388737, 8193, 8320, 8388608, 8396801, 128, 8388608, 8192, 8396928], D0 = [256, 34078976, 34078720, 1107296512, 524288, 256, 1073741824, 34078720, 1074266368, 524288, 33554688, 1074266368, 1107296512, 1107820544, 524544, 1073741824, 33554432, 1074266112, 1074266112, 0, 1073742080, 1107820800, 1107820800, 33554688, 1107820544, 1073742080, 0, 1107296256, 34078976, 33554432, 1107296256, 524544, 524288, 1107296512, 256, 33554432, 1073741824, 34078720, 1107296512, 1074266368, 33554688, 1073741824, 1107820544, 34078976, 1074266368, 256, 33554432, 1107820544, 1107820800, 524544, 1107296256, 1107820800, 34078720, 0, 1074266112, 1107296256, 524544, 33554688, 1073742080, 524288, 0, 1074266112, 34078976, 1073742080], k0 = [536870928, 541065216, 16384, 541081616, 541065216, 16, 541081616, 4194304, 536887296, 4210704, 4194304, 536870928, 4194320, 536887296, 536870912, 16400, 0, 4194320, 536887312, 16384, 4210688, 536887312, 16, 541065232, 541065232, 0, 4210704, 541081600, 16400, 4210688, 541081600, 536870912, 536887296, 16, 541065232, 4210688, 541081616, 4194304, 16400, 536870928, 4194304, 536887296, 536870912, 16400, 536870928, 541081616, 4210688, 541065216, 4210704, 541081600, 0, 541065232, 16, 16384, 541065216, 4210704, 16384, 4194320, 536887312, 0, 541081600, 536870912, 4194320, 536887312], O0 = [2097152, 69206018, 67110914, 0, 2048, 67110914, 2099202, 69208064, 69208066, 2097152, 0, 67108866, 2, 67108864, 69206018, 2050, 67110912, 2099202, 2097154, 67110912, 67108866, 69206016, 69208064, 2097154, 69206016, 2048, 2050, 69208066, 2099200, 2, 67108864, 2099200, 67108864, 2099200, 2097152, 67110914, 67110914, 69206018, 69206018, 2, 2097154, 67108864, 67110912, 2097152, 69208064, 2050, 2099202, 69208064, 2050, 67108866, 69208066, 69206016, 2099200, 0, 2, 69208066, 0, 2099202, 69206016, 2048, 67108866, 67110912, 2048, 2097154], P0 = [268439616, 4096, 262144, 268701760, 268435456, 268439616, 64, 268435456, 262208, 268697600, 268701760, 266240, 268701696, 266304, 4096, 64, 268697600, 268435520, 268439552, 4160, 266240, 262208, 268697664, 268701696, 4160, 0, 0, 268697664, 268435520, 268439552, 266304, 262144, 266304, 262144, 268701696, 4096, 64, 268697664, 4096, 266304, 268439552, 64, 268435520, 268697600, 268697664, 268435456, 262144, 268439616, 0, 268701760, 262208, 268435520, 268697600, 268439552, 268439616, 0, 268701760, 266240, 266240, 4160, 4160, 262208, 268435456, 268701696];
function U0(e) {
  for (var t = [0, 4, 536870912, 536870916, 65536, 65540, 536936448, 536936452, 512, 516, 536871424, 536871428, 66048, 66052, 536936960, 536936964], n = [0, 1, 1048576, 1048577, 67108864, 67108865, 68157440, 68157441, 256, 257, 1048832, 1048833, 67109120, 67109121, 68157696, 68157697], r = [0, 8, 2048, 2056, 16777216, 16777224, 16779264, 16779272, 0, 8, 2048, 2056, 16777216, 16777224, 16779264, 16779272], a = [0, 2097152, 134217728, 136314880, 8192, 2105344, 134225920, 136323072, 131072, 2228224, 134348800, 136445952, 139264, 2236416, 134356992, 136454144], s = [0, 262144, 16, 262160, 0, 262144, 16, 262160, 4096, 266240, 4112, 266256, 4096, 266240, 4112, 266256], i = [0, 1024, 32, 1056, 0, 1024, 32, 1056, 33554432, 33555456, 33554464, 33555488, 33554432, 33555456, 33554464, 33555488], o = [0, 268435456, 524288, 268959744, 2, 268435458, 524290, 268959746, 0, 268435456, 524288, 268959744, 2, 268435458, 524290, 268959746], u = [0, 65536, 2048, 67584, 536870912, 536936448, 536872960, 536938496, 131072, 196608, 133120, 198656, 537001984, 537067520, 537004032, 537069568], c = [0, 262144, 0, 262144, 2, 262146, 2, 262146, 33554432, 33816576, 33554432, 33816576, 33554434, 33816578, 33554434, 33816578], l = [0, 268435456, 8, 268435464, 0, 268435456, 8, 268435464, 1024, 268436480, 1032, 268436488, 1024, 268436480, 1032, 268436488], p = [0, 32, 0, 32, 1048576, 1048608, 1048576, 1048608, 8192, 8224, 8192, 8224, 1056768, 1056800, 1056768, 1056800], g = [0, 16777216, 512, 16777728, 2097152, 18874368, 2097664, 18874880, 67108864, 83886080, 67109376, 83886592, 69206016, 85983232, 69206528, 85983744], C = [0, 4096, 134217728, 134221824, 524288, 528384, 134742016, 134746112, 16, 4112, 134217744, 134221840, 524304, 528400, 134742032, 134746128], d = [0, 4, 256, 260, 0, 4, 256, 260, 1, 5, 257, 261, 1, 5, 257, 261], b = e.length() > 8 ? 3 : 1, S = [], A = [0, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 0], D = 0, _, M = 0; M < b; M++) {
    var K = e.getInt32(), k = e.getInt32();
    _ = (K >>> 4 ^ k) & 252645135, k ^= _, K ^= _ << 4, _ = (k >>> -16 ^ K) & 65535, K ^= _, k ^= _ << -16, _ = (K >>> 2 ^ k) & 858993459, k ^= _, K ^= _ << 2, _ = (k >>> -16 ^ K) & 65535, K ^= _, k ^= _ << -16, _ = (K >>> 1 ^ k) & 1431655765, k ^= _, K ^= _ << 1, _ = (k >>> 8 ^ K) & 16711935, K ^= _, k ^= _ << 8, _ = (K >>> 1 ^ k) & 1431655765, k ^= _, K ^= _ << 1, _ = K << 8 | k >>> 20 & 240, K = k << 24 | k << 8 & 16711680 | k >>> 8 & 65280 | k >>> 24 & 240, k = _;
    for (var J = 0; J < A.length; ++J) {
      A[J] ? (K = K << 2 | K >>> 26, k = k << 2 | k >>> 26) : (K = K << 1 | K >>> 27, k = k << 1 | k >>> 27), K &= -15, k &= -15;
      var re = t[K >>> 28] | n[K >>> 24 & 15] | r[K >>> 20 & 15] | a[K >>> 16 & 15] | s[K >>> 12 & 15] | i[K >>> 8 & 15] | o[K >>> 4 & 15], G = u[k >>> 28] | c[k >>> 24 & 15] | l[k >>> 20 & 15] | p[k >>> 16 & 15] | g[k >>> 12 & 15] | C[k >>> 8 & 15] | d[k >>> 4 & 15];
      _ = (G >>> 16 ^ re) & 65535, S[D++] = re ^ _, S[D++] = G ^ _ << 16;
    }
  }
  return S;
}
function qs(e, t, n, r) {
  var a = e.length === 32 ? 3 : 9, s;
  a === 3 ? s = r ? [30, -2, -2] : [0, 32, 2] : s = r ? [94, 62, -2, 32, 64, 2, 30, -2, -2] : [0, 32, 2, 62, 30, -2, 64, 96, 2];
  var i, o = t[0], u = t[1];
  i = (o >>> 4 ^ u) & 252645135, u ^= i, o ^= i << 4, i = (o >>> 16 ^ u) & 65535, u ^= i, o ^= i << 16, i = (u >>> 2 ^ o) & 858993459, o ^= i, u ^= i << 2, i = (u >>> 8 ^ o) & 16711935, o ^= i, u ^= i << 8, i = (o >>> 1 ^ u) & 1431655765, u ^= i, o ^= i << 1, o = o << 1 | o >>> 31, u = u << 1 | u >>> 31;
  for (var c = 0; c < a; c += 3) {
    for (var l = s[c + 1], p = s[c + 2], g = s[c]; g != l; g += p) {
      var C = u ^ e[g], d = (u >>> 4 | u << 28) ^ e[g + 1];
      i = o, o = u, u = i ^ (N0[C >>> 24 & 63] | L0[C >>> 16 & 63] | k0[C >>> 8 & 63] | P0[C & 63] | _0[d >>> 24 & 63] | R0[d >>> 16 & 63] | D0[d >>> 8 & 63] | O0[d & 63]);
    }
    i = o, o = u, u = i;
  }
  o = o >>> 1 | o << 31, u = u >>> 1 | u << 31, i = (o >>> 1 ^ u) & 1431655765, u ^= i, o ^= i << 1, i = (u >>> 8 ^ o) & 16711935, o ^= i, u ^= i << 8, i = (u >>> 2 ^ o) & 858993459, o ^= i, u ^= i << 2, i = (o >>> 16 ^ u) & 65535, u ^= i, o ^= i << 16, i = (o >>> 4 ^ u) & 252645135, u ^= i, o ^= i << 4, n[0] = o, n[1] = u;
}
function Na(e) {
  e = e || {};
  var t = (e.mode || "CBC").toUpperCase(), n = "DES-" + t, r;
  e.decrypt ? r = it.cipher.createDecipher(n, e.key) : r = it.cipher.createCipher(n, e.key);
  var a = r.start;
  return r.start = function(s, i) {
    var o = null;
    i instanceof it.util.ByteBuffer && (o = i, i = {}), i = i || {}, i.output = o, i.iv = s, a.call(r, i);
  }, r;
}
const F0 = {}, V0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: F0
}, Symbol.toStringTag, { value: "Module" })), Wi = /* @__PURE__ */ gu(V0);
var xt = De, M0 = xt.pkcs5 = xt.pkcs5 || {}, cr;
xt.util.isNodejs && !xt.options.usePureJavaScript && (cr = Wi);
xt.pbkdf2 = M0.pbkdf2 = function(e, t, n, r, a, s) {
  if (typeof a == "function" && (s = a, a = null), xt.util.isNodejs && !xt.options.usePureJavaScript && cr.pbkdf2 && (a === null || typeof a != "object") && (cr.pbkdf2Sync.length > 4 || !a || a === "sha1"))
    return typeof a != "string" && (a = "sha1"), e = Buffer.from(e, "binary"), t = Buffer.from(t, "binary"), s ? cr.pbkdf2Sync.length === 4 ? cr.pbkdf2(e, t, n, r, function(_, M) {
      if (_)
        return s(_);
      s(null, M.toString("binary"));
    }) : cr.pbkdf2(e, t, n, r, a, function(_, M) {
      if (_)
        return s(_);
      s(null, M.toString("binary"));
    }) : cr.pbkdf2Sync.length === 4 ? cr.pbkdf2Sync(e, t, n, r).toString("binary") : cr.pbkdf2Sync(e, t, n, r, a).toString("binary");
  if ((typeof a > "u" || a === null) && (a = "sha1"), typeof a == "string") {
    if (!(a in xt.md.algorithms))
      throw new Error("Unknown hash algorithm: " + a);
    a = xt.md[a].create();
  }
  var i = a.digestLength;
  if (r > 4294967295 * i) {
    var o = new Error("Derived key is too long.");
    if (s)
      return s(o);
    throw o;
  }
  var u = Math.ceil(r / i), c = r - (u - 1) * i, l = xt.hmac.create();
  l.start(a, e);
  var p = "", g, C, d;
  if (!s) {
    for (var b = 1; b <= u; ++b) {
      l.start(null, null), l.update(t), l.update(xt.util.int32ToBytes(b)), g = d = l.digest().getBytes();
      for (var S = 2; S <= n; ++S)
        l.start(null, null), l.update(d), C = l.digest().getBytes(), g = xt.util.xorBytes(g, C, i), d = C;
      p += b < u ? g : g.substr(0, c);
    }
    return p;
  }
  var b = 1, S;
  function A() {
    if (b > u)
      return s(null, p);
    l.start(null, null), l.update(t), l.update(xt.util.int32ToBytes(b)), g = d = l.digest().getBytes(), S = 2, D();
  }
  function D() {
    if (S <= n)
      return l.start(null, null), l.update(d), C = l.digest().getBytes(), g = xt.util.xorBytes(g, C, i), d = C, ++S, xt.util.setImmediate(D);
    p += b < u ? g : g.substr(0, c), ++b, A();
  }
  A();
};
var rr = De, ac = rr.sha256 = rr.sha256 || {};
rr.md.sha256 = rr.md.algorithms.sha256 = ac;
ac.create = function() {
  ic || K0();
  var e = null, t = rr.util.createBuffer(), n = new Array(64), r = {
    algorithm: "sha256",
    blockLength: 64,
    digestLength: 32,
    // 56-bit length of message so far (does not including padding)
    messageLength: 0,
    // true message length
    fullMessageLength: null,
    // size of message length in bytes
    messageLengthSize: 8
  };
  return r.start = function() {
    r.messageLength = 0, r.fullMessageLength = r.messageLength64 = [];
    for (var a = r.messageLengthSize / 4, s = 0; s < a; ++s)
      r.fullMessageLength.push(0);
    return t = rr.util.createBuffer(), e = {
      h0: 1779033703,
      h1: 3144134277,
      h2: 1013904242,
      h3: 2773480762,
      h4: 1359893119,
      h5: 2600822924,
      h6: 528734635,
      h7: 1541459225
    }, r;
  }, r.start(), r.update = function(a, s) {
    s === "utf8" && (a = rr.util.encodeUtf8(a));
    var i = a.length;
    r.messageLength += i, i = [i / 4294967296 >>> 0, i >>> 0];
    for (var o = r.fullMessageLength.length - 1; o >= 0; --o)
      r.fullMessageLength[o] += i[1], i[1] = i[0] + (r.fullMessageLength[o] / 4294967296 >>> 0), r.fullMessageLength[o] = r.fullMessageLength[o] >>> 0, i[0] = i[1] / 4294967296 >>> 0;
    return t.putBytes(a), Gs(e, n, t), (t.read > 2048 || t.length() === 0) && t.compact(), r;
  }, r.digest = function() {
    var a = rr.util.createBuffer();
    a.putBytes(t.bytes());
    var s = r.fullMessageLength[r.fullMessageLength.length - 1] + r.messageLengthSize, i = s & r.blockLength - 1;
    a.putBytes(bi.substr(0, r.blockLength - i));
    for (var o, u, c = r.fullMessageLength[0] * 8, l = 0; l < r.fullMessageLength.length - 1; ++l)
      o = r.fullMessageLength[l + 1] * 8, u = o / 4294967296 >>> 0, c += u, a.putInt32(c >>> 0), c = o >>> 0;
    a.putInt32(c);
    var p = {
      h0: e.h0,
      h1: e.h1,
      h2: e.h2,
      h3: e.h3,
      h4: e.h4,
      h5: e.h5,
      h6: e.h6,
      h7: e.h7
    };
    Gs(p, n, a);
    var g = rr.util.createBuffer();
    return g.putInt32(p.h0), g.putInt32(p.h1), g.putInt32(p.h2), g.putInt32(p.h3), g.putInt32(p.h4), g.putInt32(p.h5), g.putInt32(p.h6), g.putInt32(p.h7), g;
  }, r;
};
var bi = null, ic = !1, sc = null;
function K0() {
  bi = String.fromCharCode(128), bi += rr.util.fillString(String.fromCharCode(0), 64), sc = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ], ic = !0;
}
function Gs(e, t, n) {
  for (var r, a, s, i, o, u, c, l, p, g, C, d, b, S, A, D = n.length(); D >= 64; ) {
    for (c = 0; c < 16; ++c)
      t[c] = n.getInt32();
    for (; c < 64; ++c)
      r = t[c - 2], r = (r >>> 17 | r << 15) ^ (r >>> 19 | r << 13) ^ r >>> 10, a = t[c - 15], a = (a >>> 7 | a << 25) ^ (a >>> 18 | a << 14) ^ a >>> 3, t[c] = r + t[c - 7] + a + t[c - 16] | 0;
    for (l = e.h0, p = e.h1, g = e.h2, C = e.h3, d = e.h4, b = e.h5, S = e.h6, A = e.h7, c = 0; c < 64; ++c)
      i = (d >>> 6 | d << 26) ^ (d >>> 11 | d << 21) ^ (d >>> 25 | d << 7), o = S ^ d & (b ^ S), s = (l >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10), u = l & p | g & (l ^ p), r = A + i + o + sc[c] + t[c], a = s + u, A = S, S = b, b = d, d = C + r >>> 0, C = g, g = p, p = l, l = r + a >>> 0;
    e.h0 = e.h0 + l | 0, e.h1 = e.h1 + p | 0, e.h2 = e.h2 + g | 0, e.h3 = e.h3 + C | 0, e.h4 = e.h4 + d | 0, e.h5 = e.h5 + b | 0, e.h6 = e.h6 + S | 0, e.h7 = e.h7 + A | 0, D -= 64;
  }
}
var Zt = De, ua = null;
Zt.util.isNodejs && !Zt.options.usePureJavaScript && !process.versions["node-webkit"] && (ua = Wi);
var j0 = Zt.prng = Zt.prng || {};
j0.create = function(e) {
  for (var t = {
    plugin: e,
    key: null,
    seed: null,
    time: null,
    // number of reseeds so far
    reseeds: 0,
    // amount of data generated so far
    generated: 0,
    // no initial key bytes
    keyBytes: ""
  }, n = e.md, r = new Array(32), a = 0; a < 32; ++a)
    r[a] = n.create();
  t.pools = r, t.pool = 0, t.generate = function(c, l) {
    if (!l)
      return t.generateSync(c);
    var p = t.plugin.cipher, g = t.plugin.increment, C = t.plugin.formatKey, d = t.plugin.formatSeed, b = Zt.util.createBuffer();
    t.key = null, S();
    function S(A) {
      if (A)
        return l(A);
      if (b.length() >= c)
        return l(null, b.getBytes(c));
      if (t.generated > 1048575 && (t.key = null), t.key === null)
        return Zt.util.nextTick(function() {
          s(S);
        });
      var D = p(t.key, t.seed);
      t.generated += D.length, b.putBytes(D), t.key = C(p(t.key, g(t.seed))), t.seed = d(p(t.key, t.seed)), Zt.util.setImmediate(S);
    }
  }, t.generateSync = function(c) {
    var l = t.plugin.cipher, p = t.plugin.increment, g = t.plugin.formatKey, C = t.plugin.formatSeed;
    t.key = null;
    for (var d = Zt.util.createBuffer(); d.length() < c; ) {
      t.generated > 1048575 && (t.key = null), t.key === null && i();
      var b = l(t.key, t.seed);
      t.generated += b.length, d.putBytes(b), t.key = g(l(t.key, p(t.seed))), t.seed = C(l(t.key, t.seed));
    }
    return d.getBytes(c);
  };
  function s(c) {
    if (t.pools[0].messageLength >= 32)
      return o(), c();
    var l = 32 - t.pools[0].messageLength << 5;
    t.seedFile(l, function(p, g) {
      if (p)
        return c(p);
      t.collect(g), o(), c();
    });
  }
  function i() {
    if (t.pools[0].messageLength >= 32)
      return o();
    var c = 32 - t.pools[0].messageLength << 5;
    t.collect(t.seedFileSync(c)), o();
  }
  function o() {
    t.reseeds = t.reseeds === 4294967295 ? 0 : t.reseeds + 1;
    var c = t.plugin.md.create();
    c.update(t.keyBytes);
    for (var l = 1, p = 0; p < 32; ++p)
      t.reseeds % l === 0 && (c.update(t.pools[p].digest().getBytes()), t.pools[p].start()), l = l << 1;
    t.keyBytes = c.digest().getBytes(), c.start(), c.update(t.keyBytes);
    var g = c.digest().getBytes();
    t.key = t.plugin.formatKey(t.keyBytes), t.seed = t.plugin.formatSeed(g), t.generated = 0;
  }
  function u(c) {
    var l = null, p = Zt.util.globalScope, g = p.crypto || p.msCrypto;
    g && g.getRandomValues && (l = function(K) {
      return g.getRandomValues(K);
    });
    var C = Zt.util.createBuffer();
    if (l)
      for (; C.length() < c; ) {
        var d = Math.max(1, Math.min(c - C.length(), 65536) / 4), b = new Uint32Array(Math.floor(d));
        try {
          l(b);
          for (var S = 0; S < b.length; ++S)
            C.putInt32(b[S]);
        } catch (K) {
          if (!(typeof QuotaExceededError < "u" && K instanceof QuotaExceededError))
            throw K;
        }
      }
    if (C.length() < c)
      for (var A, D, _, M = Math.floor(Math.random() * 65536); C.length() < c; ) {
        D = 16807 * (M & 65535), A = 16807 * (M >> 16), D += (A & 32767) << 16, D += A >> 15, D = (D & 2147483647) + (D >> 31), M = D & 4294967295;
        for (var S = 0; S < 3; ++S)
          _ = M >>> (S << 3), _ ^= Math.floor(Math.random() * 256), C.putByte(_ & 255);
      }
    return C.getBytes(c);
  }
  return ua ? (t.seedFile = function(c, l) {
    ua.randomBytes(c, function(p, g) {
      if (p)
        return l(p);
      l(null, g.toString());
    });
  }, t.seedFileSync = function(c) {
    return ua.randomBytes(c).toString();
  }) : (t.seedFile = function(c, l) {
    try {
      l(null, u(c));
    } catch (p) {
      l(p);
    }
  }, t.seedFileSync = u), t.collect = function(c) {
    for (var l = c.length, p = 0; p < l; ++p)
      t.pools[t.pool].update(c.substr(p, 1)), t.pool = t.pool === 31 ? 0 : t.pool + 1;
  }, t.collectInt = function(c, l) {
    for (var p = "", g = 0; g < l; g += 8)
      p += String.fromCharCode(c >> g & 255);
    t.collect(p);
  }, t.registerWorker = function(c) {
    if (c === self)
      t.seedFile = function(p, g) {
        function C(d) {
          var b = d.data;
          b.forge && b.forge.prng && (self.removeEventListener("message", C), g(b.forge.prng.err, b.forge.prng.bytes));
        }
        self.addEventListener("message", C), self.postMessage({ forge: { prng: { needed: p } } });
      };
    else {
      var l = function(p) {
        var g = p.data;
        g.forge && g.forge.prng && t.seedFile(g.forge.prng.needed, function(C, d) {
          c.postMessage({ forge: { prng: { err: C, bytes: d } } });
        });
      };
      c.addEventListener("message", l);
    }
  }, t;
};
var pt = De;
(function() {
  if (pt.random && pt.random.getBytes) {
    pt.random;
    return;
  }
  (function(e) {
    var t = {}, n = new Array(4), r = pt.util.createBuffer();
    t.formatKey = function(p) {
      var g = pt.util.createBuffer(p);
      return p = new Array(4), p[0] = g.getInt32(), p[1] = g.getInt32(), p[2] = g.getInt32(), p[3] = g.getInt32(), pt.aes._expandKey(p, !1);
    }, t.formatSeed = function(p) {
      var g = pt.util.createBuffer(p);
      return p = new Array(4), p[0] = g.getInt32(), p[1] = g.getInt32(), p[2] = g.getInt32(), p[3] = g.getInt32(), p;
    }, t.cipher = function(p, g) {
      return pt.aes._updateBlock(p, g, n, !1), r.putInt32(n[0]), r.putInt32(n[1]), r.putInt32(n[2]), r.putInt32(n[3]), r.getBytes();
    }, t.increment = function(p) {
      return ++p[3], p;
    }, t.md = pt.md.sha256;
    function a() {
      var p = pt.prng.create(t);
      return p.getBytes = function(g, C) {
        return p.generate(g, C);
      }, p.getBytesSync = function(g) {
        return p.generate(g);
      }, p;
    }
    var s = a(), i = null, o = pt.util.globalScope, u = o.crypto || o.msCrypto;
    if (u && u.getRandomValues && (i = function(p) {
      return u.getRandomValues(p);
    }), pt.options.usePureJavaScript || !pt.util.isNodejs && !i) {
      if (s.collectInt(+/* @__PURE__ */ new Date(), 32), typeof navigator < "u") {
        var c = "";
        for (var l in navigator)
          try {
            typeof navigator[l] == "string" && (c += navigator[l]);
          } catch {
          }
        s.collect(c), c = null;
      }
      e && (e().mousemove(function(p) {
        s.collectInt(p.clientX, 16), s.collectInt(p.clientY, 16);
      }), e().keypress(function(p) {
        s.collectInt(p.charCode, 8);
      }));
    }
    if (!pt.random)
      pt.random = s;
    else
      for (var l in s)
        pt.random[l] = s[l];
    pt.random.createInstance = a, pt.random;
  })(typeof jQuery < "u" ? jQuery : null);
})();
var wt = De, ri = [
  217,
  120,
  249,
  196,
  25,
  221,
  181,
  237,
  40,
  233,
  253,
  121,
  74,
  160,
  216,
  157,
  198,
  126,
  55,
  131,
  43,
  118,
  83,
  142,
  98,
  76,
  100,
  136,
  68,
  139,
  251,
  162,
  23,
  154,
  89,
  245,
  135,
  179,
  79,
  19,
  97,
  69,
  109,
  141,
  9,
  129,
  125,
  50,
  189,
  143,
  64,
  235,
  134,
  183,
  123,
  11,
  240,
  149,
  33,
  34,
  92,
  107,
  78,
  130,
  84,
  214,
  101,
  147,
  206,
  96,
  178,
  28,
  115,
  86,
  192,
  20,
  167,
  140,
  241,
  220,
  18,
  117,
  202,
  31,
  59,
  190,
  228,
  209,
  66,
  61,
  212,
  48,
  163,
  60,
  182,
  38,
  111,
  191,
  14,
  218,
  70,
  105,
  7,
  87,
  39,
  242,
  29,
  155,
  188,
  148,
  67,
  3,
  248,
  17,
  199,
  246,
  144,
  239,
  62,
  231,
  6,
  195,
  213,
  47,
  200,
  102,
  30,
  215,
  8,
  232,
  234,
  222,
  128,
  82,
  238,
  247,
  132,
  170,
  114,
  172,
  53,
  77,
  106,
  42,
  150,
  26,
  210,
  113,
  90,
  21,
  73,
  116,
  75,
  159,
  208,
  94,
  4,
  24,
  164,
  236,
  194,
  224,
  65,
  110,
  15,
  81,
  203,
  204,
  36,
  145,
  175,
  80,
  161,
  244,
  112,
  57,
  153,
  124,
  58,
  133,
  35,
  184,
  180,
  122,
  252,
  2,
  54,
  91,
  37,
  85,
  151,
  49,
  45,
  93,
  250,
  152,
  227,
  138,
  146,
  174,
  5,
  223,
  41,
  16,
  103,
  108,
  186,
  201,
  211,
  0,
  230,
  207,
  225,
  158,
  168,
  44,
  99,
  22,
  1,
  63,
  88,
  226,
  137,
  169,
  13,
  56,
  52,
  27,
  171,
  51,
  255,
  176,
  187,
  72,
  12,
  95,
  185,
  177,
  205,
  46,
  197,
  243,
  219,
  71,
  229,
  165,
  156,
  119,
  10,
  166,
  32,
  104,
  254,
  127,
  193,
  173
], $s = [1, 2, 3, 5], H0 = function(e, t) {
  return e << t & 65535 | (e & 65535) >> 16 - t;
}, q0 = function(e, t) {
  return (e & 65535) >> t | e << 16 - t & 65535;
};
wt.rc2 = wt.rc2 || {};
wt.rc2.expandKey = function(e, t) {
  typeof e == "string" && (e = wt.util.createBuffer(e)), t = t || 128;
  var n = e, r = e.length(), a = t, s = Math.ceil(a / 8), i = 255 >> (a & 7), o;
  for (o = r; o < 128; o++)
    n.putByte(ri[n.at(o - 1) + n.at(o - r) & 255]);
  for (n.setAt(128 - s, ri[n.at(128 - s) & i]), o = 127 - s; o >= 0; o--)
    n.setAt(o, ri[n.at(o + 1) ^ n.at(o + s)]);
  return n;
};
var oc = function(e, t, n) {
  var r = !1, a = null, s = null, i = null, o, u, c, l, p = [];
  for (e = wt.rc2.expandKey(e, t), c = 0; c < 64; c++)
    p.push(e.getInt16Le());
  n ? (o = function(d) {
    for (c = 0; c < 4; c++)
      d[c] += p[l] + (d[(c + 3) % 4] & d[(c + 2) % 4]) + (~d[(c + 3) % 4] & d[(c + 1) % 4]), d[c] = H0(d[c], $s[c]), l++;
  }, u = function(d) {
    for (c = 0; c < 4; c++)
      d[c] += p[d[(c + 3) % 4] & 63];
  }) : (o = function(d) {
    for (c = 3; c >= 0; c--)
      d[c] = q0(d[c], $s[c]), d[c] -= p[l] + (d[(c + 3) % 4] & d[(c + 2) % 4]) + (~d[(c + 3) % 4] & d[(c + 1) % 4]), l--;
  }, u = function(d) {
    for (c = 3; c >= 0; c--)
      d[c] -= p[d[(c + 3) % 4] & 63];
  });
  var g = function(d) {
    var b = [];
    for (c = 0; c < 4; c++) {
      var S = a.getInt16Le();
      i !== null && (n ? S ^= i.getInt16Le() : i.putInt16Le(S)), b.push(S & 65535);
    }
    l = n ? 0 : 63;
    for (var A = 0; A < d.length; A++)
      for (var D = 0; D < d[A][0]; D++)
        d[A][1](b);
    for (c = 0; c < 4; c++)
      i !== null && (n ? i.putInt16Le(b[c]) : b[c] ^= i.getInt16Le()), s.putInt16Le(b[c]);
  }, C = null;
  return C = {
    /**
     * Starts or restarts the encryption or decryption process, whichever
     * was previously configured.
     *
     * To use the cipher in CBC mode, iv may be given either as a string
     * of bytes, or as a byte buffer.  For ECB mode, give null as iv.
     *
     * @param iv the initialization vector to use, null for ECB mode.
     * @param output the output the buffer to write to, null to create one.
     */
    start: function(d, b) {
      d && typeof d == "string" && (d = wt.util.createBuffer(d)), r = !1, a = wt.util.createBuffer(), s = b || new wt.util.createBuffer(), i = d, C.output = s;
    },
    /**
     * Updates the next block.
     *
     * @param input the buffer to read from.
     */
    update: function(d) {
      for (r || a.putBuffer(d); a.length() >= 8; )
        g([
          [5, o],
          [1, u],
          [6, o],
          [1, u],
          [5, o]
        ]);
    },
    /**
     * Finishes encrypting or decrypting.
     *
     * @param pad a padding function to use, null for PKCS#7 padding,
     *           signature(blockSize, buffer, decrypt).
     *
     * @return true if successful, false on error.
     */
    finish: function(d) {
      var b = !0;
      if (n)
        if (d)
          b = d(8, a, !n);
        else {
          var S = a.length() === 8 ? 8 : 8 - a.length();
          a.fillWithByte(S, S);
        }
      if (b && (r = !0, C.update()), !n && (b = a.length() === 0, b))
        if (d)
          b = d(8, s, !n);
        else {
          var A = s.length(), D = s.at(A - 1);
          D > A ? b = !1 : s.truncate(D);
        }
      return b;
    }
  }, C;
};
wt.rc2.startEncrypting = function(e, t, n) {
  var r = wt.rc2.createEncryptionCipher(e, 128);
  return r.start(t, n), r;
};
wt.rc2.createEncryptionCipher = function(e, t) {
  return oc(e, t, !0);
};
wt.rc2.startDecrypting = function(e, t, n) {
  var r = wt.rc2.createDecryptionCipher(e, 128);
  return r.start(t, n), r;
};
wt.rc2.createDecryptionCipher = function(e, t) {
  return oc(e, t, !1);
};
var xi = De;
xi.jsbn = xi.jsbn || {};
var pr;
function W(e, t, n) {
  this.data = [], e != null && (typeof e == "number" ? this.fromNumber(e, t, n) : t == null && typeof e != "string" ? this.fromString(e, 256) : this.fromString(e, t));
}
xi.jsbn.BigInteger = W;
function He() {
  return new W(null);
}
function G0(e, t, n, r, a, s) {
  for (; --s >= 0; ) {
    var i = t * this.data[e++] + n.data[r] + a;
    a = Math.floor(i / 67108864), n.data[r++] = i & 67108863;
  }
  return a;
}
function $0(e, t, n, r, a, s) {
  for (var i = t & 32767, o = t >> 15; --s >= 0; ) {
    var u = this.data[e] & 32767, c = this.data[e++] >> 15, l = o * u + c * i;
    u = i * u + ((l & 32767) << 15) + n.data[r] + (a & 1073741823), a = (u >>> 30) + (l >>> 15) + o * c + (a >>> 30), n.data[r++] = u & 1073741823;
  }
  return a;
}
function zs(e, t, n, r, a, s) {
  for (var i = t & 16383, o = t >> 14; --s >= 0; ) {
    var u = this.data[e] & 16383, c = this.data[e++] >> 14, l = o * u + c * i;
    u = i * u + ((l & 16383) << 14) + n.data[r] + a, a = (u >> 28) + (l >> 14) + o * c, n.data[r++] = u & 268435455;
  }
  return a;
}
typeof navigator > "u" ? (W.prototype.am = zs, pr = 28) : navigator.appName == "Microsoft Internet Explorer" ? (W.prototype.am = $0, pr = 30) : navigator.appName != "Netscape" ? (W.prototype.am = G0, pr = 26) : (W.prototype.am = zs, pr = 28);
W.prototype.DB = pr;
W.prototype.DM = (1 << pr) - 1;
W.prototype.DV = 1 << pr;
var Qi = 52;
W.prototype.FV = Math.pow(2, Qi);
W.prototype.F1 = Qi - pr;
W.prototype.F2 = 2 * pr - Qi;
var z0 = "0123456789abcdefghijklmnopqrstuvwxyz", Ra = new Array(), Sn, Ut;
Sn = "0".charCodeAt(0);
for (Ut = 0; Ut <= 9; ++Ut)
  Ra[Sn++] = Ut;
Sn = "a".charCodeAt(0);
for (Ut = 10; Ut < 36; ++Ut)
  Ra[Sn++] = Ut;
Sn = "A".charCodeAt(0);
for (Ut = 10; Ut < 36; ++Ut)
  Ra[Sn++] = Ut;
function Ws(e) {
  return z0.charAt(e);
}
function cc(e, t) {
  var n = Ra[e.charCodeAt(t)];
  return n ?? -1;
}
function W0(e) {
  for (var t = this.t - 1; t >= 0; --t)
    e.data[t] = this.data[t];
  e.t = this.t, e.s = this.s;
}
function Q0(e) {
  this.t = 1, this.s = e < 0 ? -1 : 0, e > 0 ? this.data[0] = e : e < -1 ? this.data[0] = e + this.DV : this.t = 0;
}
function br(e) {
  var t = He();
  return t.fromInt(e), t;
}
function Y0(e, t) {
  var n;
  if (t == 16)
    n = 4;
  else if (t == 8)
    n = 3;
  else if (t == 256)
    n = 8;
  else if (t == 2)
    n = 1;
  else if (t == 32)
    n = 5;
  else if (t == 4)
    n = 2;
  else {
    this.fromRadix(e, t);
    return;
  }
  this.t = 0, this.s = 0;
  for (var r = e.length, a = !1, s = 0; --r >= 0; ) {
    var i = n == 8 ? e[r] & 255 : cc(e, r);
    if (i < 0) {
      e.charAt(r) == "-" && (a = !0);
      continue;
    }
    a = !1, s == 0 ? this.data[this.t++] = i : s + n > this.DB ? (this.data[this.t - 1] |= (i & (1 << this.DB - s) - 1) << s, this.data[this.t++] = i >> this.DB - s) : this.data[this.t - 1] |= i << s, s += n, s >= this.DB && (s -= this.DB);
  }
  n == 8 && e[0] & 128 && (this.s = -1, s > 0 && (this.data[this.t - 1] |= (1 << this.DB - s) - 1 << s)), this.clamp(), a && W.ZERO.subTo(this, this);
}
function X0() {
  for (var e = this.s & this.DM; this.t > 0 && this.data[this.t - 1] == e; )
    --this.t;
}
function J0(e) {
  if (this.s < 0)
    return "-" + this.negate().toString(e);
  var t;
  if (e == 16)
    t = 4;
  else if (e == 8)
    t = 3;
  else if (e == 2)
    t = 1;
  else if (e == 32)
    t = 5;
  else if (e == 4)
    t = 2;
  else
    return this.toRadix(e);
  var n = (1 << t) - 1, r, a = !1, s = "", i = this.t, o = this.DB - i * this.DB % t;
  if (i-- > 0)
    for (o < this.DB && (r = this.data[i] >> o) > 0 && (a = !0, s = Ws(r)); i >= 0; )
      o < t ? (r = (this.data[i] & (1 << o) - 1) << t - o, r |= this.data[--i] >> (o += this.DB - t)) : (r = this.data[i] >> (o -= t) & n, o <= 0 && (o += this.DB, --i)), r > 0 && (a = !0), a && (s += Ws(r));
  return a ? s : "0";
}
function Z0() {
  var e = He();
  return W.ZERO.subTo(this, e), e;
}
function ep() {
  return this.s < 0 ? this.negate() : this;
}
function tp(e) {
  var t = this.s - e.s;
  if (t != 0)
    return t;
  var n = this.t;
  if (t = n - e.t, t != 0)
    return this.s < 0 ? -t : t;
  for (; --n >= 0; )
    if ((t = this.data[n] - e.data[n]) != 0)
      return t;
  return 0;
}
function La(e) {
  var t = 1, n;
  return (n = e >>> 16) != 0 && (e = n, t += 16), (n = e >> 8) != 0 && (e = n, t += 8), (n = e >> 4) != 0 && (e = n, t += 4), (n = e >> 2) != 0 && (e = n, t += 2), (n = e >> 1) != 0 && (e = n, t += 1), t;
}
function rp() {
  return this.t <= 0 ? 0 : this.DB * (this.t - 1) + La(this.data[this.t - 1] ^ this.s & this.DM);
}
function np(e, t) {
  var n;
  for (n = this.t - 1; n >= 0; --n)
    t.data[n + e] = this.data[n];
  for (n = e - 1; n >= 0; --n)
    t.data[n] = 0;
  t.t = this.t + e, t.s = this.s;
}
function ap(e, t) {
  for (var n = e; n < this.t; ++n)
    t.data[n - e] = this.data[n];
  t.t = Math.max(this.t - e, 0), t.s = this.s;
}
function ip(e, t) {
  var n = e % this.DB, r = this.DB - n, a = (1 << r) - 1, s = Math.floor(e / this.DB), i = this.s << n & this.DM, o;
  for (o = this.t - 1; o >= 0; --o)
    t.data[o + s + 1] = this.data[o] >> r | i, i = (this.data[o] & a) << n;
  for (o = s - 1; o >= 0; --o)
    t.data[o] = 0;
  t.data[s] = i, t.t = this.t + s + 1, t.s = this.s, t.clamp();
}
function sp(e, t) {
  t.s = this.s;
  var n = Math.floor(e / this.DB);
  if (n >= this.t) {
    t.t = 0;
    return;
  }
  var r = e % this.DB, a = this.DB - r, s = (1 << r) - 1;
  t.data[0] = this.data[n] >> r;
  for (var i = n + 1; i < this.t; ++i)
    t.data[i - n - 1] |= (this.data[i] & s) << a, t.data[i - n] = this.data[i] >> r;
  r > 0 && (t.data[this.t - n - 1] |= (this.s & s) << a), t.t = this.t - n, t.clamp();
}
function op(e, t) {
  for (var n = 0, r = 0, a = Math.min(e.t, this.t); n < a; )
    r += this.data[n] - e.data[n], t.data[n++] = r & this.DM, r >>= this.DB;
  if (e.t < this.t) {
    for (r -= e.s; n < this.t; )
      r += this.data[n], t.data[n++] = r & this.DM, r >>= this.DB;
    r += this.s;
  } else {
    for (r += this.s; n < e.t; )
      r -= e.data[n], t.data[n++] = r & this.DM, r >>= this.DB;
    r -= e.s;
  }
  t.s = r < 0 ? -1 : 0, r < -1 ? t.data[n++] = this.DV + r : r > 0 && (t.data[n++] = r), t.t = n, t.clamp();
}
function cp(e, t) {
  var n = this.abs(), r = e.abs(), a = n.t;
  for (t.t = a + r.t; --a >= 0; )
    t.data[a] = 0;
  for (a = 0; a < r.t; ++a)
    t.data[a + n.t] = n.am(0, r.data[a], t, a, 0, n.t);
  t.s = 0, t.clamp(), this.s != e.s && W.ZERO.subTo(t, t);
}
function up(e) {
  for (var t = this.abs(), n = e.t = 2 * t.t; --n >= 0; )
    e.data[n] = 0;
  for (n = 0; n < t.t - 1; ++n) {
    var r = t.am(n, t.data[n], e, 2 * n, 0, 1);
    (e.data[n + t.t] += t.am(n + 1, 2 * t.data[n], e, 2 * n + 1, r, t.t - n - 1)) >= t.DV && (e.data[n + t.t] -= t.DV, e.data[n + t.t + 1] = 1);
  }
  e.t > 0 && (e.data[e.t - 1] += t.am(n, t.data[n], e, 2 * n, 0, 1)), e.s = 0, e.clamp();
}
function lp(e, t, n) {
  var r = e.abs();
  if (!(r.t <= 0)) {
    var a = this.abs();
    if (a.t < r.t) {
      t != null && t.fromInt(0), n != null && this.copyTo(n);
      return;
    }
    n == null && (n = He());
    var s = He(), i = this.s, o = e.s, u = this.DB - La(r.data[r.t - 1]);
    u > 0 ? (r.lShiftTo(u, s), a.lShiftTo(u, n)) : (r.copyTo(s), a.copyTo(n));
    var c = s.t, l = s.data[c - 1];
    if (l != 0) {
      var p = l * (1 << this.F1) + (c > 1 ? s.data[c - 2] >> this.F2 : 0), g = this.FV / p, C = (1 << this.F1) / p, d = 1 << this.F2, b = n.t, S = b - c, A = t ?? He();
      for (s.dlShiftTo(S, A), n.compareTo(A) >= 0 && (n.data[n.t++] = 1, n.subTo(A, n)), W.ONE.dlShiftTo(c, A), A.subTo(s, s); s.t < c; )
        s.data[s.t++] = 0;
      for (; --S >= 0; ) {
        var D = n.data[--b] == l ? this.DM : Math.floor(n.data[b] * g + (n.data[b - 1] + d) * C);
        if ((n.data[b] += s.am(0, D, n, S, 0, c)) < D)
          for (s.dlShiftTo(S, A), n.subTo(A, n); n.data[b] < --D; )
            n.subTo(A, n);
      }
      t != null && (n.drShiftTo(c, t), i != o && W.ZERO.subTo(t, t)), n.t = c, n.clamp(), u > 0 && n.rShiftTo(u, n), i < 0 && W.ZERO.subTo(n, n);
    }
  }
}
function fp(e) {
  var t = He();
  return this.abs().divRemTo(e, null, t), this.s < 0 && t.compareTo(W.ZERO) > 0 && e.subTo(t, t), t;
}
function en(e) {
  this.m = e;
}
function pp(e) {
  return e.s < 0 || e.compareTo(this.m) >= 0 ? e.mod(this.m) : e;
}
function hp(e) {
  return e;
}
function dp(e) {
  e.divRemTo(this.m, null, e);
}
function yp(e, t, n) {
  e.multiplyTo(t, n), this.reduce(n);
}
function gp(e, t) {
  e.squareTo(t), this.reduce(t);
}
en.prototype.convert = pp;
en.prototype.revert = hp;
en.prototype.reduce = dp;
en.prototype.mulTo = yp;
en.prototype.sqrTo = gp;
function vp() {
  if (this.t < 1)
    return 0;
  var e = this.data[0];
  if (!(e & 1))
    return 0;
  var t = e & 3;
  return t = t * (2 - (e & 15) * t) & 15, t = t * (2 - (e & 255) * t) & 255, t = t * (2 - ((e & 65535) * t & 65535)) & 65535, t = t * (2 - e * t % this.DV) % this.DV, t > 0 ? this.DV - t : -t;
}
function tn(e) {
  this.m = e, this.mp = e.invDigit(), this.mpl = this.mp & 32767, this.mph = this.mp >> 15, this.um = (1 << e.DB - 15) - 1, this.mt2 = 2 * e.t;
}
function mp(e) {
  var t = He();
  return e.abs().dlShiftTo(this.m.t, t), t.divRemTo(this.m, null, t), e.s < 0 && t.compareTo(W.ZERO) > 0 && this.m.subTo(t, t), t;
}
function Ep(e) {
  var t = He();
  return e.copyTo(t), this.reduce(t), t;
}
function Cp(e) {
  for (; e.t <= this.mt2; )
    e.data[e.t++] = 0;
  for (var t = 0; t < this.m.t; ++t) {
    var n = e.data[t] & 32767, r = n * this.mpl + ((n * this.mph + (e.data[t] >> 15) * this.mpl & this.um) << 15) & e.DM;
    for (n = t + this.m.t, e.data[n] += this.m.am(0, r, e, t, 0, this.m.t); e.data[n] >= e.DV; )
      e.data[n] -= e.DV, e.data[++n]++;
  }
  e.clamp(), e.drShiftTo(this.m.t, e), e.compareTo(this.m) >= 0 && e.subTo(this.m, e);
}
function Sp(e, t) {
  e.squareTo(t), this.reduce(t);
}
function bp(e, t, n) {
  e.multiplyTo(t, n), this.reduce(n);
}
tn.prototype.convert = mp;
tn.prototype.revert = Ep;
tn.prototype.reduce = Cp;
tn.prototype.mulTo = bp;
tn.prototype.sqrTo = Sp;
function xp() {
  return (this.t > 0 ? this.data[0] & 1 : this.s) == 0;
}
function Tp(e, t) {
  if (e > 4294967295 || e < 1)
    return W.ONE;
  var n = He(), r = He(), a = t.convert(this), s = La(e) - 1;
  for (a.copyTo(n); --s >= 0; )
    if (t.sqrTo(n, r), (e & 1 << s) > 0)
      t.mulTo(r, a, n);
    else {
      var i = n;
      n = r, r = i;
    }
  return t.revert(n);
}
function Ap(e, t) {
  var n;
  return e < 256 || t.isEven() ? n = new en(t) : n = new tn(t), this.exp(e, n);
}
W.prototype.copyTo = W0;
W.prototype.fromInt = Q0;
W.prototype.fromString = Y0;
W.prototype.clamp = X0;
W.prototype.dlShiftTo = np;
W.prototype.drShiftTo = ap;
W.prototype.lShiftTo = ip;
W.prototype.rShiftTo = sp;
W.prototype.subTo = op;
W.prototype.multiplyTo = cp;
W.prototype.squareTo = up;
W.prototype.divRemTo = lp;
W.prototype.invDigit = vp;
W.prototype.isEven = xp;
W.prototype.exp = Tp;
W.prototype.toString = J0;
W.prototype.negate = Z0;
W.prototype.abs = ep;
W.prototype.compareTo = tp;
W.prototype.bitLength = rp;
W.prototype.mod = fp;
W.prototype.modPowInt = Ap;
W.ZERO = br(0);
W.ONE = br(1);
function Ip() {
  var e = He();
  return this.copyTo(e), e;
}
function wp() {
  if (this.s < 0) {
    if (this.t == 1)
      return this.data[0] - this.DV;
    if (this.t == 0)
      return -1;
  } else {
    if (this.t == 1)
      return this.data[0];
    if (this.t == 0)
      return 0;
  }
  return (this.data[1] & (1 << 32 - this.DB) - 1) << this.DB | this.data[0];
}
function Bp() {
  return this.t == 0 ? this.s : this.data[0] << 24 >> 24;
}
function _p() {
  return this.t == 0 ? this.s : this.data[0] << 16 >> 16;
}
function Np(e) {
  return Math.floor(Math.LN2 * this.DB / Math.log(e));
}
function Rp() {
  return this.s < 0 ? -1 : this.t <= 0 || this.t == 1 && this.data[0] <= 0 ? 0 : 1;
}
function Lp(e) {
  if (e == null && (e = 10), this.signum() == 0 || e < 2 || e > 36)
    return "0";
  var t = this.chunkSize(e), n = Math.pow(e, t), r = br(n), a = He(), s = He(), i = "";
  for (this.divRemTo(r, a, s); a.signum() > 0; )
    i = (n + s.intValue()).toString(e).substr(1) + i, a.divRemTo(r, a, s);
  return s.intValue().toString(e) + i;
}
function Dp(e, t) {
  this.fromInt(0), t == null && (t = 10);
  for (var n = this.chunkSize(t), r = Math.pow(t, n), a = !1, s = 0, i = 0, o = 0; o < e.length; ++o) {
    var u = cc(e, o);
    if (u < 0) {
      e.charAt(o) == "-" && this.signum() == 0 && (a = !0);
      continue;
    }
    i = t * i + u, ++s >= n && (this.dMultiply(r), this.dAddOffset(i, 0), s = 0, i = 0);
  }
  s > 0 && (this.dMultiply(Math.pow(t, s)), this.dAddOffset(i, 0)), a && W.ZERO.subTo(this, this);
}
function kp(e, t, n) {
  if (typeof t == "number")
    if (e < 2)
      this.fromInt(1);
    else
      for (this.fromNumber(e, n), this.testBit(e - 1) || this.bitwiseTo(W.ONE.shiftLeft(e - 1), Yi, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(t); )
        this.dAddOffset(2, 0), this.bitLength() > e && this.subTo(W.ONE.shiftLeft(e - 1), this);
  else {
    var r = new Array(), a = e & 7;
    r.length = (e >> 3) + 1, t.nextBytes(r), a > 0 ? r[0] &= (1 << a) - 1 : r[0] = 0, this.fromString(r, 256);
  }
}
function Op() {
  var e = this.t, t = new Array();
  t[0] = this.s;
  var n = this.DB - e * this.DB % 8, r, a = 0;
  if (e-- > 0)
    for (n < this.DB && (r = this.data[e] >> n) != (this.s & this.DM) >> n && (t[a++] = r | this.s << this.DB - n); e >= 0; )
      n < 8 ? (r = (this.data[e] & (1 << n) - 1) << 8 - n, r |= this.data[--e] >> (n += this.DB - 8)) : (r = this.data[e] >> (n -= 8) & 255, n <= 0 && (n += this.DB, --e)), r & 128 && (r |= -256), a == 0 && (this.s & 128) != (r & 128) && ++a, (a > 0 || r != this.s) && (t[a++] = r);
  return t;
}
function Pp(e) {
  return this.compareTo(e) == 0;
}
function Up(e) {
  return this.compareTo(e) < 0 ? this : e;
}
function Fp(e) {
  return this.compareTo(e) > 0 ? this : e;
}
function Vp(e, t, n) {
  var r, a, s = Math.min(e.t, this.t);
  for (r = 0; r < s; ++r)
    n.data[r] = t(this.data[r], e.data[r]);
  if (e.t < this.t) {
    for (a = e.s & this.DM, r = s; r < this.t; ++r)
      n.data[r] = t(this.data[r], a);
    n.t = this.t;
  } else {
    for (a = this.s & this.DM, r = s; r < e.t; ++r)
      n.data[r] = t(a, e.data[r]);
    n.t = e.t;
  }
  n.s = t(this.s, e.s), n.clamp();
}
function Mp(e, t) {
  return e & t;
}
function Kp(e) {
  var t = He();
  return this.bitwiseTo(e, Mp, t), t;
}
function Yi(e, t) {
  return e | t;
}
function jp(e) {
  var t = He();
  return this.bitwiseTo(e, Yi, t), t;
}
function uc(e, t) {
  return e ^ t;
}
function Hp(e) {
  var t = He();
  return this.bitwiseTo(e, uc, t), t;
}
function lc(e, t) {
  return e & ~t;
}
function qp(e) {
  var t = He();
  return this.bitwiseTo(e, lc, t), t;
}
function Gp() {
  for (var e = He(), t = 0; t < this.t; ++t)
    e.data[t] = this.DM & ~this.data[t];
  return e.t = this.t, e.s = ~this.s, e;
}
function $p(e) {
  var t = He();
  return e < 0 ? this.rShiftTo(-e, t) : this.lShiftTo(e, t), t;
}
function zp(e) {
  var t = He();
  return e < 0 ? this.lShiftTo(-e, t) : this.rShiftTo(e, t), t;
}
function Wp(e) {
  if (e == 0)
    return -1;
  var t = 0;
  return e & 65535 || (e >>= 16, t += 16), e & 255 || (e >>= 8, t += 8), e & 15 || (e >>= 4, t += 4), e & 3 || (e >>= 2, t += 2), e & 1 || ++t, t;
}
function Qp() {
  for (var e = 0; e < this.t; ++e)
    if (this.data[e] != 0)
      return e * this.DB + Wp(this.data[e]);
  return this.s < 0 ? this.t * this.DB : -1;
}
function Yp(e) {
  for (var t = 0; e != 0; )
    e &= e - 1, ++t;
  return t;
}
function Xp() {
  for (var e = 0, t = this.s & this.DM, n = 0; n < this.t; ++n)
    e += Yp(this.data[n] ^ t);
  return e;
}
function Jp(e) {
  var t = Math.floor(e / this.DB);
  return t >= this.t ? this.s != 0 : (this.data[t] & 1 << e % this.DB) != 0;
}
function Zp(e, t) {
  var n = W.ONE.shiftLeft(e);
  return this.bitwiseTo(n, t, n), n;
}
function eh(e) {
  return this.changeBit(e, Yi);
}
function th(e) {
  return this.changeBit(e, lc);
}
function rh(e) {
  return this.changeBit(e, uc);
}
function nh(e, t) {
  for (var n = 0, r = 0, a = Math.min(e.t, this.t); n < a; )
    r += this.data[n] + e.data[n], t.data[n++] = r & this.DM, r >>= this.DB;
  if (e.t < this.t) {
    for (r += e.s; n < this.t; )
      r += this.data[n], t.data[n++] = r & this.DM, r >>= this.DB;
    r += this.s;
  } else {
    for (r += this.s; n < e.t; )
      r += e.data[n], t.data[n++] = r & this.DM, r >>= this.DB;
    r += e.s;
  }
  t.s = r < 0 ? -1 : 0, r > 0 ? t.data[n++] = r : r < -1 && (t.data[n++] = this.DV + r), t.t = n, t.clamp();
}
function ah(e) {
  var t = He();
  return this.addTo(e, t), t;
}
function ih(e) {
  var t = He();
  return this.subTo(e, t), t;
}
function sh(e) {
  var t = He();
  return this.multiplyTo(e, t), t;
}
function oh(e) {
  var t = He();
  return this.divRemTo(e, t, null), t;
}
function ch(e) {
  var t = He();
  return this.divRemTo(e, null, t), t;
}
function uh(e) {
  var t = He(), n = He();
  return this.divRemTo(e, t, n), new Array(t, n);
}
function lh(e) {
  this.data[this.t] = this.am(0, e - 1, this, 0, 0, this.t), ++this.t, this.clamp();
}
function fh(e, t) {
  if (e != 0) {
    for (; this.t <= t; )
      this.data[this.t++] = 0;
    for (this.data[t] += e; this.data[t] >= this.DV; )
      this.data[t] -= this.DV, ++t >= this.t && (this.data[this.t++] = 0), ++this.data[t];
  }
}
function Gn() {
}
function fc(e) {
  return e;
}
function ph(e, t, n) {
  e.multiplyTo(t, n);
}
function hh(e, t) {
  e.squareTo(t);
}
Gn.prototype.convert = fc;
Gn.prototype.revert = fc;
Gn.prototype.mulTo = ph;
Gn.prototype.sqrTo = hh;
function dh(e) {
  return this.exp(e, new Gn());
}
function yh(e, t, n) {
  var r = Math.min(this.t + e.t, t);
  for (n.s = 0, n.t = r; r > 0; )
    n.data[--r] = 0;
  var a;
  for (a = n.t - this.t; r < a; ++r)
    n.data[r + this.t] = this.am(0, e.data[r], n, r, 0, this.t);
  for (a = Math.min(e.t, t); r < a; ++r)
    this.am(0, e.data[r], n, r, 0, t - r);
  n.clamp();
}
function gh(e, t, n) {
  --t;
  var r = n.t = this.t + e.t - t;
  for (n.s = 0; --r >= 0; )
    n.data[r] = 0;
  for (r = Math.max(t - this.t, 0); r < e.t; ++r)
    n.data[this.t + r - t] = this.am(t - r, e.data[r], n, 0, 0, this.t + r - t);
  n.clamp(), n.drShiftTo(1, n);
}
function bn(e) {
  this.r2 = He(), this.q3 = He(), W.ONE.dlShiftTo(2 * e.t, this.r2), this.mu = this.r2.divide(e), this.m = e;
}
function vh(e) {
  if (e.s < 0 || e.t > 2 * this.m.t)
    return e.mod(this.m);
  if (e.compareTo(this.m) < 0)
    return e;
  var t = He();
  return e.copyTo(t), this.reduce(t), t;
}
function mh(e) {
  return e;
}
function Eh(e) {
  for (e.drShiftTo(this.m.t - 1, this.r2), e.t > this.m.t + 1 && (e.t = this.m.t + 1, e.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); e.compareTo(this.r2) < 0; )
    e.dAddOffset(1, this.m.t + 1);
  for (e.subTo(this.r2, e); e.compareTo(this.m) >= 0; )
    e.subTo(this.m, e);
}
function Ch(e, t) {
  e.squareTo(t), this.reduce(t);
}
function Sh(e, t, n) {
  e.multiplyTo(t, n), this.reduce(n);
}
bn.prototype.convert = vh;
bn.prototype.revert = mh;
bn.prototype.reduce = Eh;
bn.prototype.mulTo = Sh;
bn.prototype.sqrTo = Ch;
function bh(e, t) {
  var n = e.bitLength(), r, a = br(1), s;
  if (n <= 0)
    return a;
  n < 18 ? r = 1 : n < 48 ? r = 3 : n < 144 ? r = 4 : n < 768 ? r = 5 : r = 6, n < 8 ? s = new en(t) : t.isEven() ? s = new bn(t) : s = new tn(t);
  var i = new Array(), o = 3, u = r - 1, c = (1 << r) - 1;
  if (i[1] = s.convert(this), r > 1) {
    var l = He();
    for (s.sqrTo(i[1], l); o <= c; )
      i[o] = He(), s.mulTo(l, i[o - 2], i[o]), o += 2;
  }
  var p = e.t - 1, g, C = !0, d = He(), b;
  for (n = La(e.data[p]) - 1; p >= 0; ) {
    for (n >= u ? g = e.data[p] >> n - u & c : (g = (e.data[p] & (1 << n + 1) - 1) << u - n, p > 0 && (g |= e.data[p - 1] >> this.DB + n - u)), o = r; !(g & 1); )
      g >>= 1, --o;
    if ((n -= o) < 0 && (n += this.DB, --p), C)
      i[g].copyTo(a), C = !1;
    else {
      for (; o > 1; )
        s.sqrTo(a, d), s.sqrTo(d, a), o -= 2;
      o > 0 ? s.sqrTo(a, d) : (b = a, a = d, d = b), s.mulTo(d, i[g], a);
    }
    for (; p >= 0 && !(e.data[p] & 1 << n); )
      s.sqrTo(a, d), b = a, a = d, d = b, --n < 0 && (n = this.DB - 1, --p);
  }
  return s.revert(a);
}
function xh(e) {
  var t = this.s < 0 ? this.negate() : this.clone(), n = e.s < 0 ? e.negate() : e.clone();
  if (t.compareTo(n) < 0) {
    var r = t;
    t = n, n = r;
  }
  var a = t.getLowestSetBit(), s = n.getLowestSetBit();
  if (s < 0)
    return t;
  for (a < s && (s = a), s > 0 && (t.rShiftTo(s, t), n.rShiftTo(s, n)); t.signum() > 0; )
    (a = t.getLowestSetBit()) > 0 && t.rShiftTo(a, t), (a = n.getLowestSetBit()) > 0 && n.rShiftTo(a, n), t.compareTo(n) >= 0 ? (t.subTo(n, t), t.rShiftTo(1, t)) : (n.subTo(t, n), n.rShiftTo(1, n));
  return s > 0 && n.lShiftTo(s, n), n;
}
function Th(e) {
  if (e <= 0)
    return 0;
  var t = this.DV % e, n = this.s < 0 ? e - 1 : 0;
  if (this.t > 0)
    if (t == 0)
      n = this.data[0] % e;
    else
      for (var r = this.t - 1; r >= 0; --r)
        n = (t * n + this.data[r]) % e;
  return n;
}
function Ah(e) {
  var t = e.isEven();
  if (this.isEven() && t || e.signum() == 0)
    return W.ZERO;
  for (var n = e.clone(), r = this.clone(), a = br(1), s = br(0), i = br(0), o = br(1); n.signum() != 0; ) {
    for (; n.isEven(); )
      n.rShiftTo(1, n), t ? ((!a.isEven() || !s.isEven()) && (a.addTo(this, a), s.subTo(e, s)), a.rShiftTo(1, a)) : s.isEven() || s.subTo(e, s), s.rShiftTo(1, s);
    for (; r.isEven(); )
      r.rShiftTo(1, r), t ? ((!i.isEven() || !o.isEven()) && (i.addTo(this, i), o.subTo(e, o)), i.rShiftTo(1, i)) : o.isEven() || o.subTo(e, o), o.rShiftTo(1, o);
    n.compareTo(r) >= 0 ? (n.subTo(r, n), t && a.subTo(i, a), s.subTo(o, s)) : (r.subTo(n, r), t && i.subTo(a, i), o.subTo(s, o));
  }
  if (r.compareTo(W.ONE) != 0)
    return W.ZERO;
  if (o.compareTo(e) >= 0)
    return o.subtract(e);
  if (o.signum() < 0)
    o.addTo(e, o);
  else
    return o;
  return o.signum() < 0 ? o.add(e) : o;
}
var Gt = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509], Ih = (1 << 26) / Gt[Gt.length - 1];
function wh(e) {
  var t, n = this.abs();
  if (n.t == 1 && n.data[0] <= Gt[Gt.length - 1]) {
    for (t = 0; t < Gt.length; ++t)
      if (n.data[0] == Gt[t])
        return !0;
    return !1;
  }
  if (n.isEven())
    return !1;
  for (t = 1; t < Gt.length; ) {
    for (var r = Gt[t], a = t + 1; a < Gt.length && r < Ih; )
      r *= Gt[a++];
    for (r = n.modInt(r); t < a; )
      if (r % Gt[t++] == 0)
        return !1;
  }
  return n.millerRabin(e);
}
function Bh(e) {
  var t = this.subtract(W.ONE), n = t.getLowestSetBit();
  if (n <= 0)
    return !1;
  for (var r = t.shiftRight(n), a = _h(), s, i = 0; i < e; ++i) {
    do
      s = new W(this.bitLength(), a);
    while (s.compareTo(W.ONE) <= 0 || s.compareTo(t) >= 0);
    var o = s.modPow(r, this);
    if (o.compareTo(W.ONE) != 0 && o.compareTo(t) != 0) {
      for (var u = 1; u++ < n && o.compareTo(t) != 0; )
        if (o = o.modPowInt(2, this), o.compareTo(W.ONE) == 0)
          return !1;
      if (o.compareTo(t) != 0)
        return !1;
    }
  }
  return !0;
}
function _h() {
  return {
    // x is an array to fill with bytes
    nextBytes: function(e) {
      for (var t = 0; t < e.length; ++t)
        e[t] = Math.floor(Math.random() * 256);
    }
  };
}
W.prototype.chunkSize = Np;
W.prototype.toRadix = Lp;
W.prototype.fromRadix = Dp;
W.prototype.fromNumber = kp;
W.prototype.bitwiseTo = Vp;
W.prototype.changeBit = Zp;
W.prototype.addTo = nh;
W.prototype.dMultiply = lh;
W.prototype.dAddOffset = fh;
W.prototype.multiplyLowerTo = yh;
W.prototype.multiplyUpperTo = gh;
W.prototype.modInt = Th;
W.prototype.millerRabin = Bh;
W.prototype.clone = Ip;
W.prototype.intValue = wp;
W.prototype.byteValue = Bp;
W.prototype.shortValue = _p;
W.prototype.signum = Rp;
W.prototype.toByteArray = Op;
W.prototype.equals = Pp;
W.prototype.min = Up;
W.prototype.max = Fp;
W.prototype.and = Kp;
W.prototype.or = jp;
W.prototype.xor = Hp;
W.prototype.andNot = qp;
W.prototype.not = Gp;
W.prototype.shiftLeft = $p;
W.prototype.shiftRight = zp;
W.prototype.getLowestSetBit = Qp;
W.prototype.bitCount = Xp;
W.prototype.testBit = Jp;
W.prototype.setBit = eh;
W.prototype.clearBit = th;
W.prototype.flipBit = rh;
W.prototype.add = ah;
W.prototype.subtract = ih;
W.prototype.multiply = sh;
W.prototype.divide = oh;
W.prototype.remainder = ch;
W.prototype.divideAndRemainder = uh;
W.prototype.modPow = bh;
W.prototype.modInverse = Ah;
W.prototype.pow = dh;
W.prototype.gcd = xh;
W.prototype.isProbablePrime = wh;
var nr = De, pc = nr.sha1 = nr.sha1 || {};
nr.md.sha1 = nr.md.algorithms.sha1 = pc;
pc.create = function() {
  hc || Nh();
  var e = null, t = nr.util.createBuffer(), n = new Array(80), r = {
    algorithm: "sha1",
    blockLength: 64,
    digestLength: 20,
    // 56-bit length of message so far (does not including padding)
    messageLength: 0,
    // true message length
    fullMessageLength: null,
    // size of message length in bytes
    messageLengthSize: 8
  };
  return r.start = function() {
    r.messageLength = 0, r.fullMessageLength = r.messageLength64 = [];
    for (var a = r.messageLengthSize / 4, s = 0; s < a; ++s)
      r.fullMessageLength.push(0);
    return t = nr.util.createBuffer(), e = {
      h0: 1732584193,
      h1: 4023233417,
      h2: 2562383102,
      h3: 271733878,
      h4: 3285377520
    }, r;
  }, r.start(), r.update = function(a, s) {
    s === "utf8" && (a = nr.util.encodeUtf8(a));
    var i = a.length;
    r.messageLength += i, i = [i / 4294967296 >>> 0, i >>> 0];
    for (var o = r.fullMessageLength.length - 1; o >= 0; --o)
      r.fullMessageLength[o] += i[1], i[1] = i[0] + (r.fullMessageLength[o] / 4294967296 >>> 0), r.fullMessageLength[o] = r.fullMessageLength[o] >>> 0, i[0] = i[1] / 4294967296 >>> 0;
    return t.putBytes(a), Qs(e, n, t), (t.read > 2048 || t.length() === 0) && t.compact(), r;
  }, r.digest = function() {
    var a = nr.util.createBuffer();
    a.putBytes(t.bytes());
    var s = r.fullMessageLength[r.fullMessageLength.length - 1] + r.messageLengthSize, i = s & r.blockLength - 1;
    a.putBytes(Ti.substr(0, r.blockLength - i));
    for (var o, u, c = r.fullMessageLength[0] * 8, l = 0; l < r.fullMessageLength.length - 1; ++l)
      o = r.fullMessageLength[l + 1] * 8, u = o / 4294967296 >>> 0, c += u, a.putInt32(c >>> 0), c = o >>> 0;
    a.putInt32(c);
    var p = {
      h0: e.h0,
      h1: e.h1,
      h2: e.h2,
      h3: e.h3,
      h4: e.h4
    };
    Qs(p, n, a);
    var g = nr.util.createBuffer();
    return g.putInt32(p.h0), g.putInt32(p.h1), g.putInt32(p.h2), g.putInt32(p.h3), g.putInt32(p.h4), g;
  }, r;
};
var Ti = null, hc = !1;
function Nh() {
  Ti = String.fromCharCode(128), Ti += nr.util.fillString(String.fromCharCode(0), 64), hc = !0;
}
function Qs(e, t, n) {
  for (var r, a, s, i, o, u, c, l, p = n.length(); p >= 64; ) {
    for (a = e.h0, s = e.h1, i = e.h2, o = e.h3, u = e.h4, l = 0; l < 16; ++l)
      r = n.getInt32(), t[l] = r, c = o ^ s & (i ^ o), r = (a << 5 | a >>> 27) + c + u + 1518500249 + r, u = o, o = i, i = (s << 30 | s >>> 2) >>> 0, s = a, a = r;
    for (; l < 20; ++l)
      r = t[l - 3] ^ t[l - 8] ^ t[l - 14] ^ t[l - 16], r = r << 1 | r >>> 31, t[l] = r, c = o ^ s & (i ^ o), r = (a << 5 | a >>> 27) + c + u + 1518500249 + r, u = o, o = i, i = (s << 30 | s >>> 2) >>> 0, s = a, a = r;
    for (; l < 32; ++l)
      r = t[l - 3] ^ t[l - 8] ^ t[l - 14] ^ t[l - 16], r = r << 1 | r >>> 31, t[l] = r, c = s ^ i ^ o, r = (a << 5 | a >>> 27) + c + u + 1859775393 + r, u = o, o = i, i = (s << 30 | s >>> 2) >>> 0, s = a, a = r;
    for (; l < 40; ++l)
      r = t[l - 6] ^ t[l - 16] ^ t[l - 28] ^ t[l - 32], r = r << 2 | r >>> 30, t[l] = r, c = s ^ i ^ o, r = (a << 5 | a >>> 27) + c + u + 1859775393 + r, u = o, o = i, i = (s << 30 | s >>> 2) >>> 0, s = a, a = r;
    for (; l < 60; ++l)
      r = t[l - 6] ^ t[l - 16] ^ t[l - 28] ^ t[l - 32], r = r << 2 | r >>> 30, t[l] = r, c = s & i | o & (s ^ i), r = (a << 5 | a >>> 27) + c + u + 2400959708 + r, u = o, o = i, i = (s << 30 | s >>> 2) >>> 0, s = a, a = r;
    for (; l < 80; ++l)
      r = t[l - 6] ^ t[l - 16] ^ t[l - 28] ^ t[l - 32], r = r << 2 | r >>> 30, t[l] = r, c = s ^ i ^ o, r = (a << 5 | a >>> 27) + c + u + 3395469782 + r, u = o, o = i, i = (s << 30 | s >>> 2) >>> 0, s = a, a = r;
    e.h0 = e.h0 + a | 0, e.h1 = e.h1 + s | 0, e.h2 = e.h2 + i | 0, e.h3 = e.h3 + o | 0, e.h4 = e.h4 + u | 0, p -= 64;
  }
}
var ar = De, dc = ar.pkcs1 = ar.pkcs1 || {};
dc.encode_rsa_oaep = function(e, t, n) {
  var r, a, s, i;
  typeof n == "string" ? (r = n, a = arguments[3] || void 0, s = arguments[4] || void 0) : n && (r = n.label || void 0, a = n.seed || void 0, s = n.md || void 0, n.mgf1 && n.mgf1.md && (i = n.mgf1.md)), s ? s.start() : s = ar.md.sha1.create(), i || (i = s);
  var o = Math.ceil(e.n.bitLength() / 8), u = o - 2 * s.digestLength - 2;
  if (t.length > u) {
    var c = new Error("RSAES-OAEP input message length is too long.");
    throw c.length = t.length, c.maxLength = u, c;
  }
  r || (r = ""), s.update(r, "raw");
  for (var l = s.digest(), p = "", g = u - t.length, C = 0; C < g; C++)
    p += "\0";
  var d = l.getBytes() + p + "" + t;
  if (!a)
    a = ar.random.getBytes(s.digestLength);
  else if (a.length !== s.digestLength) {
    var c = new Error("Invalid RSAES-OAEP seed. The seed length must match the digest length.");
    throw c.seedLength = a.length, c.digestLength = s.digestLength, c;
  }
  var b = ha(a, o - s.digestLength - 1, i), S = ar.util.xorBytes(d, b, d.length), A = ha(S, s.digestLength, i), D = ar.util.xorBytes(a, A, a.length);
  return "\0" + D + S;
};
dc.decode_rsa_oaep = function(e, t, n) {
  var r, a, s;
  typeof n == "string" ? (r = n, a = arguments[3] || void 0) : n && (r = n.label || void 0, a = n.md || void 0, n.mgf1 && n.mgf1.md && (s = n.mgf1.md));
  var i = Math.ceil(e.n.bitLength() / 8);
  if (t.length !== i) {
    var S = new Error("RSAES-OAEP encoded message length is invalid.");
    throw S.length = t.length, S.expectedLength = i, S;
  }
  if (a === void 0 ? a = ar.md.sha1.create() : a.start(), s || (s = a), i < 2 * a.digestLength + 2)
    throw new Error("RSAES-OAEP key is too short for the hash function.");
  r || (r = ""), a.update(r, "raw");
  for (var o = a.digest().getBytes(), u = t.charAt(0), c = t.substring(1, a.digestLength + 1), l = t.substring(1 + a.digestLength), p = ha(l, a.digestLength, s), g = ar.util.xorBytes(c, p, c.length), C = ha(g, i - a.digestLength - 1, s), d = ar.util.xorBytes(l, C, l.length), b = d.substring(0, a.digestLength), S = u !== "\0", A = 0; A < a.digestLength; ++A)
    S |= o.charAt(A) !== b.charAt(A);
  for (var D = 1, _ = a.digestLength, M = a.digestLength; M < d.length; M++) {
    var K = d.charCodeAt(M), k = K & 1 ^ 1, J = D ? 65534 : 0;
    S |= K & J, D = D & k, _ += D;
  }
  if (S || d.charCodeAt(_) !== 1)
    throw new Error("Invalid RSAES-OAEP padding.");
  return d.substring(_ + 1);
};
function ha(e, t, n) {
  n || (n = ar.md.sha1.create());
  for (var r = "", a = Math.ceil(t / n.digestLength), s = 0; s < a; ++s) {
    var i = String.fromCharCode(
      s >> 24 & 255,
      s >> 16 & 255,
      s >> 8 & 255,
      s & 255
    );
    n.start(), n.update(e + i), r += n.digest().getBytes();
  }
  return r.substring(0, t);
}
var mr = De;
(function() {
  if (mr.prime) {
    mr.prime;
    return;
  }
  var e = mr.prime = mr.prime || {}, t = mr.jsbn.BigInteger, n = [6, 4, 2, 4, 2, 4, 6, 2], r = new t(null);
  r.fromInt(30);
  var a = function(p, g) {
    return p | g;
  };
  e.generateProbablePrime = function(p, g, C) {
    typeof g == "function" && (C = g, g = {}), g = g || {};
    var d = g.algorithm || "PRIMEINC";
    typeof d == "string" && (d = { name: d }), d.options = d.options || {};
    var b = g.prng || mr.random, S = {
      // x is an array to fill with bytes
      nextBytes: function(A) {
        for (var D = b.getBytesSync(A.length), _ = 0; _ < A.length; ++_)
          A[_] = D.charCodeAt(_);
      }
    };
    if (d.name === "PRIMEINC")
      return s(p, S, d.options, C);
    throw new Error("Invalid prime generation algorithm: " + d.name);
  };
  function s(p, g, C, d) {
    return "workers" in C ? u(p, g, C, d) : i(p, g, C, d);
  }
  function i(p, g, C, d) {
    var b = c(p, g), S = 0, A = l(b.bitLength());
    "millerRabinTests" in C && (A = C.millerRabinTests);
    var D = 10;
    "maxBlockTime" in C && (D = C.maxBlockTime), o(b, p, g, S, A, D, d);
  }
  function o(p, g, C, d, b, S, A) {
    var D = +/* @__PURE__ */ new Date();
    do {
      if (p.bitLength() > g && (p = c(g, C)), p.isProbablePrime(b))
        return A(null, p);
      p.dAddOffset(n[d++ % 8], 0);
    } while (S < 0 || +/* @__PURE__ */ new Date() - D < S);
    mr.util.setImmediate(function() {
      o(p, g, C, d, b, S, A);
    });
  }
  function u(p, g, C, d) {
    if (typeof Worker > "u")
      return i(p, g, C, d);
    var b = c(p, g), S = C.workers, A = C.workLoad || 100, D = A * 30 / 8, _ = C.workerScript || "forge/prime.worker.js";
    if (S === -1)
      return mr.util.estimateCores(function(K, k) {
        K && (k = 2), S = k - 1, M();
      });
    M();
    function M() {
      S = Math.max(1, S);
      for (var K = [], k = 0; k < S; ++k)
        K[k] = new Worker(_);
      for (var k = 0; k < S; ++k)
        K[k].addEventListener("message", re);
      var J = !1;
      function re(G) {
        if (!J) {
          var $ = G.data;
          if ($.found) {
            for (var ue = 0; ue < K.length; ++ue)
              K[ue].terminate();
            return J = !0, d(null, new t($.prime, 16));
          }
          b.bitLength() > p && (b = c(p, g));
          var ge = b.toString(16);
          G.target.postMessage({
            hex: ge,
            workLoad: A
          }), b.dAddOffset(D, 0);
        }
      }
    }
  }
  function c(p, g) {
    var C = new t(p, g), d = p - 1;
    return C.testBit(d) || C.bitwiseTo(t.ONE.shiftLeft(d), a, C), C.dAddOffset(31 - C.mod(r).byteValue(), 0), C;
  }
  function l(p) {
    return p <= 100 ? 27 : p <= 150 ? 18 : p <= 200 ? 15 : p <= 250 ? 12 : p <= 300 ? 9 : p <= 350 ? 8 : p <= 400 ? 7 : p <= 500 ? 6 : p <= 600 ? 5 : p <= 800 ? 4 : p <= 1250 ? 3 : 2;
  }
})();
var Se = De;
if (typeof je > "u")
  var je = Se.jsbn.BigInteger;
var Ai = Se.util.isNodejs ? Wi : null, P = Se.asn1, Ft = Se.util;
Se.pki = Se.pki || {};
Se.pki.rsa = Se.rsa = Se.rsa || {};
var _e = Se.pki, Rh = [6, 4, 2, 4, 2, 4, 6, 2], Lh = {
  // PrivateKeyInfo
  name: "PrivateKeyInfo",
  tagClass: P.Class.UNIVERSAL,
  type: P.Type.SEQUENCE,
  constructed: !0,
  value: [{
    // Version (INTEGER)
    name: "PrivateKeyInfo.version",
    tagClass: P.Class.UNIVERSAL,
    type: P.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyVersion"
  }, {
    // privateKeyAlgorithm
    name: "PrivateKeyInfo.privateKeyAlgorithm",
    tagClass: P.Class.UNIVERSAL,
    type: P.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "AlgorithmIdentifier.algorithm",
      tagClass: P.Class.UNIVERSAL,
      type: P.Type.OID,
      constructed: !1,
      capture: "privateKeyOid"
    }]
  }, {
    // PrivateKey
    name: "PrivateKeyInfo",
    tagClass: P.Class.UNIVERSAL,
    type: P.Type.OCTETSTRING,
    constructed: !1,
    capture: "privateKey"
  }]
}, Dh = {
  // RSAPrivateKey
  name: "RSAPrivateKey",
  tagClass: P.Class.UNIVERSAL,
  type: P.Type.SEQUENCE,
  constructed: !0,
  value: [{
    // Version (INTEGER)
    name: "RSAPrivateKey.version",
    tagClass: P.Class.UNIVERSAL,
    type: P.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyVersion"
  }, {
    // modulus (n)
    name: "RSAPrivateKey.modulus",
    tagClass: P.Class.UNIVERSAL,
    type: P.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyModulus"
  }, {
    // publicExponent (e)
    name: "RSAPrivateKey.publicExponent",
    tagClass: P.Class.UNIVERSAL,
    type: P.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyPublicExponent"
  }, {
    // privateExponent (d)
    name: "RSAPrivateKey.privateExponent",
    tagClass: P.Class.UNIVERSAL,
    type: P.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyPrivateExponent"
  }, {
    // prime1 (p)
    name: "RSAPrivateKey.prime1",
    tagClass: P.Class.UNIVERSAL,
    type: P.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyPrime1"
  }, {
    // prime2 (q)
    name: "RSAPrivateKey.prime2",
    tagClass: P.Class.UNIVERSAL,
    type: P.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyPrime2"
  }, {
    // exponent1 (d mod (p-1))
    name: "RSAPrivateKey.exponent1",
    tagClass: P.Class.UNIVERSAL,
    type: P.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyExponent1"
  }, {
    // exponent2 (d mod (q-1))
    name: "RSAPrivateKey.exponent2",
    tagClass: P.Class.UNIVERSAL,
    type: P.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyExponent2"
  }, {
    // coefficient ((inverse of q) mod p)
    name: "RSAPrivateKey.coefficient",
    tagClass: P.Class.UNIVERSAL,
    type: P.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyCoefficient"
  }]
}, kh = {
  // RSAPublicKey
  name: "RSAPublicKey",
  tagClass: P.Class.UNIVERSAL,
  type: P.Type.SEQUENCE,
  constructed: !0,
  value: [{
    // modulus (n)
    name: "RSAPublicKey.modulus",
    tagClass: P.Class.UNIVERSAL,
    type: P.Type.INTEGER,
    constructed: !1,
    capture: "publicKeyModulus"
  }, {
    // publicExponent (e)
    name: "RSAPublicKey.exponent",
    tagClass: P.Class.UNIVERSAL,
    type: P.Type.INTEGER,
    constructed: !1,
    capture: "publicKeyExponent"
  }]
}, Oh = Se.pki.rsa.publicKeyValidator = {
  name: "SubjectPublicKeyInfo",
  tagClass: P.Class.UNIVERSAL,
  type: P.Type.SEQUENCE,
  constructed: !0,
  captureAsn1: "subjectPublicKeyInfo",
  value: [{
    name: "SubjectPublicKeyInfo.AlgorithmIdentifier",
    tagClass: P.Class.UNIVERSAL,
    type: P.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "AlgorithmIdentifier.algorithm",
      tagClass: P.Class.UNIVERSAL,
      type: P.Type.OID,
      constructed: !1,
      capture: "publicKeyOid"
    }]
  }, {
    // subjectPublicKey
    name: "SubjectPublicKeyInfo.subjectPublicKey",
    tagClass: P.Class.UNIVERSAL,
    type: P.Type.BITSTRING,
    constructed: !1,
    value: [{
      // RSAPublicKey
      name: "SubjectPublicKeyInfo.subjectPublicKey.RSAPublicKey",
      tagClass: P.Class.UNIVERSAL,
      type: P.Type.SEQUENCE,
      constructed: !0,
      optional: !0,
      captureAsn1: "rsaPublicKey"
    }]
  }]
}, Ph = {
  name: "DigestInfo",
  tagClass: P.Class.UNIVERSAL,
  type: P.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "DigestInfo.DigestAlgorithm",
    tagClass: P.Class.UNIVERSAL,
    type: P.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "DigestInfo.DigestAlgorithm.algorithmIdentifier",
      tagClass: P.Class.UNIVERSAL,
      type: P.Type.OID,
      constructed: !1,
      capture: "algorithmIdentifier"
    }, {
      // NULL paramters
      name: "DigestInfo.DigestAlgorithm.parameters",
      tagClass: P.Class.UNIVERSAL,
      type: P.Type.NULL,
      // captured only to check existence for md2 and md5
      capture: "parameters",
      optional: !0,
      constructed: !1
    }]
  }, {
    // digest
    name: "DigestInfo.digest",
    tagClass: P.Class.UNIVERSAL,
    type: P.Type.OCTETSTRING,
    constructed: !1,
    capture: "digest"
  }]
}, Uh = function(e) {
  var t;
  if (e.algorithm in _e.oids)
    t = _e.oids[e.algorithm];
  else {
    var n = new Error("Unknown message digest algorithm.");
    throw n.algorithm = e.algorithm, n;
  }
  var r = P.oidToDer(t).getBytes(), a = P.create(
    P.Class.UNIVERSAL,
    P.Type.SEQUENCE,
    !0,
    []
  ), s = P.create(
    P.Class.UNIVERSAL,
    P.Type.SEQUENCE,
    !0,
    []
  );
  s.value.push(P.create(
    P.Class.UNIVERSAL,
    P.Type.OID,
    !1,
    r
  )), s.value.push(P.create(
    P.Class.UNIVERSAL,
    P.Type.NULL,
    !1,
    ""
  ));
  var i = P.create(
    P.Class.UNIVERSAL,
    P.Type.OCTETSTRING,
    !1,
    e.digest().getBytes()
  );
  return a.value.push(s), a.value.push(i), P.toDer(a).getBytes();
}, yc = function(e, t, n) {
  if (n)
    return e.modPow(t.e, t.n);
  if (!t.p || !t.q)
    return e.modPow(t.d, t.n);
  t.dP || (t.dP = t.d.mod(t.p.subtract(je.ONE))), t.dQ || (t.dQ = t.d.mod(t.q.subtract(je.ONE))), t.qInv || (t.qInv = t.q.modInverse(t.p));
  var r;
  do
    r = new je(
      Se.util.bytesToHex(Se.random.getBytes(t.n.bitLength() / 8)),
      16
    );
  while (r.compareTo(t.n) >= 0 || !r.gcd(t.n).equals(je.ONE));
  e = e.multiply(r.modPow(t.e, t.n)).mod(t.n);
  for (var a = e.mod(t.p).modPow(t.dP, t.p), s = e.mod(t.q).modPow(t.dQ, t.q); a.compareTo(s) < 0; )
    a = a.add(t.p);
  var i = a.subtract(s).multiply(t.qInv).mod(t.p).multiply(t.q).add(s);
  return i = i.multiply(r.modInverse(t.n)).mod(t.n), i;
};
_e.rsa.encrypt = function(e, t, n) {
  var r = n, a, s = Math.ceil(t.n.bitLength() / 8);
  n !== !1 && n !== !0 ? (r = n === 2, a = gc(e, t, n)) : (a = Se.util.createBuffer(), a.putBytes(e));
  for (var i = new je(a.toHex(), 16), o = yc(i, t, r), u = o.toString(16), c = Se.util.createBuffer(), l = s - Math.ceil(u.length / 2); l > 0; )
    c.putByte(0), --l;
  return c.putBytes(Se.util.hexToBytes(u)), c.getBytes();
};
_e.rsa.decrypt = function(e, t, n, r) {
  var a = Math.ceil(t.n.bitLength() / 8);
  if (e.length !== a) {
    var s = new Error("Encrypted message length is invalid.");
    throw s.length = e.length, s.expected = a, s;
  }
  var i = new je(Se.util.createBuffer(e).toHex(), 16);
  if (i.compareTo(t.n) >= 0)
    throw new Error("Encrypted message is invalid.");
  for (var o = yc(i, t, n), u = o.toString(16), c = Se.util.createBuffer(), l = a - Math.ceil(u.length / 2); l > 0; )
    c.putByte(0), --l;
  return c.putBytes(Se.util.hexToBytes(u)), r !== !1 ? da(c.getBytes(), t, n) : c.getBytes();
};
_e.rsa.createKeyPairGenerationState = function(e, t, n) {
  typeof e == "string" && (e = parseInt(e, 10)), e = e || 2048, n = n || {};
  var r = n.prng || Se.random, a = {
    // x is an array to fill with bytes
    nextBytes: function(o) {
      for (var u = r.getBytesSync(o.length), c = 0; c < o.length; ++c)
        o[c] = u.charCodeAt(c);
    }
  }, s = n.algorithm || "PRIMEINC", i;
  if (s === "PRIMEINC")
    i = {
      algorithm: s,
      state: 0,
      bits: e,
      rng: a,
      eInt: t || 65537,
      e: new je(null),
      p: null,
      q: null,
      qBits: e >> 1,
      pBits: e - (e >> 1),
      pqState: 0,
      num: null,
      keys: null
    }, i.e.fromInt(i.eInt);
  else
    throw new Error("Invalid key generation algorithm: " + s);
  return i;
};
_e.rsa.stepKeyPairGenerationState = function(e, t) {
  "algorithm" in e || (e.algorithm = "PRIMEINC");
  var n = new je(null);
  n.fromInt(30);
  for (var r = 0, a = function(p, g) {
    return p | g;
  }, s = +/* @__PURE__ */ new Date(), i, o = 0; e.keys === null && (t <= 0 || o < t); ) {
    if (e.state === 0) {
      var u = e.p === null ? e.pBits : e.qBits, c = u - 1;
      e.pqState === 0 ? (e.num = new je(u, e.rng), e.num.testBit(c) || e.num.bitwiseTo(
        je.ONE.shiftLeft(c),
        a,
        e.num
      ), e.num.dAddOffset(31 - e.num.mod(n).byteValue(), 0), r = 0, ++e.pqState) : e.pqState === 1 ? e.num.bitLength() > u ? e.pqState = 0 : e.num.isProbablePrime(
        Vh(e.num.bitLength())
      ) ? ++e.pqState : e.num.dAddOffset(Rh[r++ % 8], 0) : e.pqState === 2 ? e.pqState = e.num.subtract(je.ONE).gcd(e.e).compareTo(je.ONE) === 0 ? 3 : 0 : e.pqState === 3 && (e.pqState = 0, e.p === null ? e.p = e.num : e.q = e.num, e.p !== null && e.q !== null && ++e.state, e.num = null);
    } else if (e.state === 1)
      e.p.compareTo(e.q) < 0 && (e.num = e.p, e.p = e.q, e.q = e.num), ++e.state;
    else if (e.state === 2)
      e.p1 = e.p.subtract(je.ONE), e.q1 = e.q.subtract(je.ONE), e.phi = e.p1.multiply(e.q1), ++e.state;
    else if (e.state === 3)
      e.phi.gcd(e.e).compareTo(je.ONE) === 0 ? ++e.state : (e.p = null, e.q = null, e.state = 0);
    else if (e.state === 4)
      e.n = e.p.multiply(e.q), e.n.bitLength() === e.bits ? ++e.state : (e.q = null, e.state = 0);
    else if (e.state === 5) {
      var l = e.e.modInverse(e.phi);
      e.keys = {
        privateKey: _e.rsa.setPrivateKey(
          e.n,
          e.e,
          l,
          e.p,
          e.q,
          l.mod(e.p1),
          l.mod(e.q1),
          e.q.modInverse(e.p)
        ),
        publicKey: _e.rsa.setPublicKey(e.n, e.e)
      };
    }
    i = +/* @__PURE__ */ new Date(), o += i - s, s = i;
  }
  return e.keys !== null;
};
_e.rsa.generateKeyPair = function(e, t, n, r) {
  if (arguments.length === 1 ? typeof e == "object" ? (n = e, e = void 0) : typeof e == "function" && (r = e, e = void 0) : arguments.length === 2 ? typeof e == "number" ? typeof t == "function" ? (r = t, t = void 0) : typeof t != "number" && (n = t, t = void 0) : (n = e, r = t, e = void 0, t = void 0) : arguments.length === 3 && (typeof t == "number" ? typeof n == "function" && (r = n, n = void 0) : (r = n, n = t, t = void 0)), n = n || {}, e === void 0 && (e = n.bits || 2048), t === void 0 && (t = n.e || 65537), !Se.options.usePureJavaScript && !n.prng && e >= 256 && e <= 16384 && (t === 65537 || t === 3)) {
    if (r) {
      if (Ys("generateKeyPair"))
        return Ai.generateKeyPair("rsa", {
          modulusLength: e,
          publicExponent: t,
          publicKeyEncoding: {
            type: "spki",
            format: "pem"
          },
          privateKeyEncoding: {
            type: "pkcs8",
            format: "pem"
          }
        }, function(o, u, c) {
          if (o)
            return r(o);
          r(null, {
            privateKey: _e.privateKeyFromPem(c),
            publicKey: _e.publicKeyFromPem(u)
          });
        });
      if (Xs("generateKey") && Xs("exportKey"))
        return Ft.globalScope.crypto.subtle.generateKey({
          name: "RSASSA-PKCS1-v1_5",
          modulusLength: e,
          publicExponent: Zs(t),
          hash: { name: "SHA-256" }
        }, !0, ["sign", "verify"]).then(function(o) {
          return Ft.globalScope.crypto.subtle.exportKey(
            "pkcs8",
            o.privateKey
          );
        }).then(void 0, function(o) {
          r(o);
        }).then(function(o) {
          if (o) {
            var u = _e.privateKeyFromAsn1(
              P.fromDer(Se.util.createBuffer(o))
            );
            r(null, {
              privateKey: u,
              publicKey: _e.setRsaPublicKey(u.n, u.e)
            });
          }
        });
      if (Js("generateKey") && Js("exportKey")) {
        var a = Ft.globalScope.msCrypto.subtle.generateKey({
          name: "RSASSA-PKCS1-v1_5",
          modulusLength: e,
          publicExponent: Zs(t),
          hash: { name: "SHA-256" }
        }, !0, ["sign", "verify"]);
        a.oncomplete = function(o) {
          var u = o.target.result, c = Ft.globalScope.msCrypto.subtle.exportKey(
            "pkcs8",
            u.privateKey
          );
          c.oncomplete = function(l) {
            var p = l.target.result, g = _e.privateKeyFromAsn1(
              P.fromDer(Se.util.createBuffer(p))
            );
            r(null, {
              privateKey: g,
              publicKey: _e.setRsaPublicKey(g.n, g.e)
            });
          }, c.onerror = function(l) {
            r(l);
          };
        }, a.onerror = function(o) {
          r(o);
        };
        return;
      }
    } else if (Ys("generateKeyPairSync")) {
      var s = Ai.generateKeyPairSync("rsa", {
        modulusLength: e,
        publicExponent: t,
        publicKeyEncoding: {
          type: "spki",
          format: "pem"
        },
        privateKeyEncoding: {
          type: "pkcs8",
          format: "pem"
        }
      });
      return {
        privateKey: _e.privateKeyFromPem(s.privateKey),
        publicKey: _e.publicKeyFromPem(s.publicKey)
      };
    }
  }
  var i = _e.rsa.createKeyPairGenerationState(e, t, n);
  if (!r)
    return _e.rsa.stepKeyPairGenerationState(i, 0), i.keys;
  Fh(i, n, r);
};
_e.setRsaPublicKey = _e.rsa.setPublicKey = function(e, t) {
  var n = {
    n: e,
    e: t
  };
  return n.encrypt = function(r, a, s) {
    if (typeof a == "string" ? a = a.toUpperCase() : a === void 0 && (a = "RSAES-PKCS1-V1_5"), a === "RSAES-PKCS1-V1_5")
      a = {
        encode: function(o, u, c) {
          return gc(o, u, 2).getBytes();
        }
      };
    else if (a === "RSA-OAEP" || a === "RSAES-OAEP")
      a = {
        encode: function(o, u) {
          return Se.pkcs1.encode_rsa_oaep(u, o, s);
        }
      };
    else if (["RAW", "NONE", "NULL", null].indexOf(a) !== -1)
      a = { encode: function(o) {
        return o;
      } };
    else if (typeof a == "string")
      throw new Error('Unsupported encryption scheme: "' + a + '".');
    var i = a.encode(r, n, !0);
    return _e.rsa.encrypt(i, n, !0);
  }, n.verify = function(r, a, s, i) {
    typeof s == "string" ? s = s.toUpperCase() : s === void 0 && (s = "RSASSA-PKCS1-V1_5"), i === void 0 && (i = {
      _parseAllDigestBytes: !0
    }), "_parseAllDigestBytes" in i || (i._parseAllDigestBytes = !0), s === "RSASSA-PKCS1-V1_5" ? s = {
      verify: function(u, c) {
        c = da(c, n, !0);
        var l = P.fromDer(c, {
          parseAllBytes: i._parseAllDigestBytes
        }), p = {}, g = [];
        if (!P.validate(l, Ph, p, g)) {
          var C = new Error(
            "ASN.1 object does not contain a valid RSASSA-PKCS1-v1_5 DigestInfo value."
          );
          throw C.errors = g, C;
        }
        var d = P.derToOid(p.algorithmIdentifier);
        if (!(d === Se.oids.md2 || d === Se.oids.md5 || d === Se.oids.sha1 || d === Se.oids.sha224 || d === Se.oids.sha256 || d === Se.oids.sha384 || d === Se.oids.sha512 || d === Se.oids["sha512-224"] || d === Se.oids["sha512-256"])) {
          var C = new Error(
            "Unknown RSASSA-PKCS1-v1_5 DigestAlgorithm identifier."
          );
          throw C.oid = d, C;
        }
        if ((d === Se.oids.md2 || d === Se.oids.md5) && !("parameters" in p))
          throw new Error(
            "ASN.1 object does not contain a valid RSASSA-PKCS1-v1_5 DigestInfo value. Missing algorithm identifer NULL parameters."
          );
        return u === p.digest;
      }
    } : (s === "NONE" || s === "NULL" || s === null) && (s = {
      verify: function(u, c) {
        return c = da(c, n, !0), u === c;
      }
    });
    var o = _e.rsa.decrypt(a, n, !0, !1);
    return s.verify(r, o, n.n.bitLength());
  }, n;
};
_e.setRsaPrivateKey = _e.rsa.setPrivateKey = function(e, t, n, r, a, s, i, o) {
  var u = {
    n: e,
    e: t,
    d: n,
    p: r,
    q: a,
    dP: s,
    dQ: i,
    qInv: o
  };
  return u.decrypt = function(c, l, p) {
    typeof l == "string" ? l = l.toUpperCase() : l === void 0 && (l = "RSAES-PKCS1-V1_5");
    var g = _e.rsa.decrypt(c, u, !1, !1);
    if (l === "RSAES-PKCS1-V1_5")
      l = { decode: da };
    else if (l === "RSA-OAEP" || l === "RSAES-OAEP")
      l = {
        decode: function(C, d) {
          return Se.pkcs1.decode_rsa_oaep(d, C, p);
        }
      };
    else if (["RAW", "NONE", "NULL", null].indexOf(l) !== -1)
      l = { decode: function(C) {
        return C;
      } };
    else
      throw new Error('Unsupported encryption scheme: "' + l + '".');
    return l.decode(g, u, !1);
  }, u.sign = function(c, l) {
    var p = !1;
    typeof l == "string" && (l = l.toUpperCase()), l === void 0 || l === "RSASSA-PKCS1-V1_5" ? (l = { encode: Uh }, p = 1) : (l === "NONE" || l === "NULL" || l === null) && (l = { encode: function() {
      return c;
    } }, p = 1);
    var g = l.encode(c, u.n.bitLength());
    return _e.rsa.encrypt(g, u, p);
  }, u;
};
_e.wrapRsaPrivateKey = function(e) {
  return P.create(P.Class.UNIVERSAL, P.Type.SEQUENCE, !0, [
    // version (0)
    P.create(
      P.Class.UNIVERSAL,
      P.Type.INTEGER,
      !1,
      P.integerToDer(0).getBytes()
    ),
    // privateKeyAlgorithm
    P.create(P.Class.UNIVERSAL, P.Type.SEQUENCE, !0, [
      P.create(
        P.Class.UNIVERSAL,
        P.Type.OID,
        !1,
        P.oidToDer(_e.oids.rsaEncryption).getBytes()
      ),
      P.create(P.Class.UNIVERSAL, P.Type.NULL, !1, "")
    ]),
    // PrivateKey
    P.create(
      P.Class.UNIVERSAL,
      P.Type.OCTETSTRING,
      !1,
      P.toDer(e).getBytes()
    )
  ]);
};
_e.privateKeyFromAsn1 = function(e) {
  var t = {}, n = [];
  if (P.validate(e, Lh, t, n) && (e = P.fromDer(Se.util.createBuffer(t.privateKey))), t = {}, n = [], !P.validate(e, Dh, t, n)) {
    var r = new Error("Cannot read private key. ASN.1 object does not contain an RSAPrivateKey.");
    throw r.errors = n, r;
  }
  var a, s, i, o, u, c, l, p;
  return a = Se.util.createBuffer(t.privateKeyModulus).toHex(), s = Se.util.createBuffer(t.privateKeyPublicExponent).toHex(), i = Se.util.createBuffer(t.privateKeyPrivateExponent).toHex(), o = Se.util.createBuffer(t.privateKeyPrime1).toHex(), u = Se.util.createBuffer(t.privateKeyPrime2).toHex(), c = Se.util.createBuffer(t.privateKeyExponent1).toHex(), l = Se.util.createBuffer(t.privateKeyExponent2).toHex(), p = Se.util.createBuffer(t.privateKeyCoefficient).toHex(), _e.setRsaPrivateKey(
    new je(a, 16),
    new je(s, 16),
    new je(i, 16),
    new je(o, 16),
    new je(u, 16),
    new je(c, 16),
    new je(l, 16),
    new je(p, 16)
  );
};
_e.privateKeyToAsn1 = _e.privateKeyToRSAPrivateKey = function(e) {
  return P.create(P.Class.UNIVERSAL, P.Type.SEQUENCE, !0, [
    // version (0 = only 2 primes, 1 multiple primes)
    P.create(
      P.Class.UNIVERSAL,
      P.Type.INTEGER,
      !1,
      P.integerToDer(0).getBytes()
    ),
    // modulus (n)
    P.create(
      P.Class.UNIVERSAL,
      P.Type.INTEGER,
      !1,
      Jt(e.n)
    ),
    // publicExponent (e)
    P.create(
      P.Class.UNIVERSAL,
      P.Type.INTEGER,
      !1,
      Jt(e.e)
    ),
    // privateExponent (d)
    P.create(
      P.Class.UNIVERSAL,
      P.Type.INTEGER,
      !1,
      Jt(e.d)
    ),
    // privateKeyPrime1 (p)
    P.create(
      P.Class.UNIVERSAL,
      P.Type.INTEGER,
      !1,
      Jt(e.p)
    ),
    // privateKeyPrime2 (q)
    P.create(
      P.Class.UNIVERSAL,
      P.Type.INTEGER,
      !1,
      Jt(e.q)
    ),
    // privateKeyExponent1 (dP)
    P.create(
      P.Class.UNIVERSAL,
      P.Type.INTEGER,
      !1,
      Jt(e.dP)
    ),
    // privateKeyExponent2 (dQ)
    P.create(
      P.Class.UNIVERSAL,
      P.Type.INTEGER,
      !1,
      Jt(e.dQ)
    ),
    // coefficient (qInv)
    P.create(
      P.Class.UNIVERSAL,
      P.Type.INTEGER,
      !1,
      Jt(e.qInv)
    )
  ]);
};
_e.publicKeyFromAsn1 = function(e) {
  var t = {}, n = [];
  if (P.validate(e, Oh, t, n)) {
    var r = P.derToOid(t.publicKeyOid);
    if (r !== _e.oids.rsaEncryption) {
      var a = new Error("Cannot read public key. Unknown OID.");
      throw a.oid = r, a;
    }
    e = t.rsaPublicKey;
  }
  if (n = [], !P.validate(e, kh, t, n)) {
    var a = new Error("Cannot read public key. ASN.1 object does not contain an RSAPublicKey.");
    throw a.errors = n, a;
  }
  var s = Se.util.createBuffer(t.publicKeyModulus).toHex(), i = Se.util.createBuffer(t.publicKeyExponent).toHex();
  return _e.setRsaPublicKey(
    new je(s, 16),
    new je(i, 16)
  );
};
_e.publicKeyToAsn1 = _e.publicKeyToSubjectPublicKeyInfo = function(e) {
  return P.create(P.Class.UNIVERSAL, P.Type.SEQUENCE, !0, [
    // AlgorithmIdentifier
    P.create(P.Class.UNIVERSAL, P.Type.SEQUENCE, !0, [
      // algorithm
      P.create(
        P.Class.UNIVERSAL,
        P.Type.OID,
        !1,
        P.oidToDer(_e.oids.rsaEncryption).getBytes()
      ),
      // parameters (null)
      P.create(P.Class.UNIVERSAL, P.Type.NULL, !1, "")
    ]),
    // subjectPublicKey
    P.create(P.Class.UNIVERSAL, P.Type.BITSTRING, !1, [
      _e.publicKeyToRSAPublicKey(e)
    ])
  ]);
};
_e.publicKeyToRSAPublicKey = function(e) {
  return P.create(P.Class.UNIVERSAL, P.Type.SEQUENCE, !0, [
    // modulus (n)
    P.create(
      P.Class.UNIVERSAL,
      P.Type.INTEGER,
      !1,
      Jt(e.n)
    ),
    // publicExponent (e)
    P.create(
      P.Class.UNIVERSAL,
      P.Type.INTEGER,
      !1,
      Jt(e.e)
    )
  ]);
};
function gc(e, t, n) {
  var r = Se.util.createBuffer(), a = Math.ceil(t.n.bitLength() / 8);
  if (e.length > a - 11) {
    var s = new Error("Message is too long for PKCS#1 v1.5 padding.");
    throw s.length = e.length, s.max = a - 11, s;
  }
  r.putByte(0), r.putByte(n);
  var i = a - 3 - e.length, o;
  if (n === 0 || n === 1) {
    o = n === 0 ? 0 : 255;
    for (var u = 0; u < i; ++u)
      r.putByte(o);
  } else
    for (; i > 0; ) {
      for (var c = 0, l = Se.random.getBytes(i), u = 0; u < i; ++u)
        o = l.charCodeAt(u), o === 0 ? ++c : r.putByte(o);
      i = c;
    }
  return r.putByte(0), r.putBytes(e), r;
}
function da(e, t, n, r) {
  var a = Math.ceil(t.n.bitLength() / 8), s = Se.util.createBuffer(e), i = s.getByte(), o = s.getByte();
  if (i !== 0 || n && o !== 0 && o !== 1 || !n && o != 2 || n && o === 0 && typeof r > "u")
    throw new Error("Encryption block is invalid.");
  var u = 0;
  if (o === 0) {
    u = a - 3 - r;
    for (var c = 0; c < u; ++c)
      if (s.getByte() !== 0)
        throw new Error("Encryption block is invalid.");
  } else if (o === 1)
    for (u = 0; s.length() > 1; ) {
      if (s.getByte() !== 255) {
        --s.read;
        break;
      }
      ++u;
    }
  else if (o === 2)
    for (u = 0; s.length() > 1; ) {
      if (s.getByte() === 0) {
        --s.read;
        break;
      }
      ++u;
    }
  var l = s.getByte();
  if (l !== 0 || u !== a - 3 - s.length())
    throw new Error("Encryption block is invalid.");
  return s.getBytes();
}
function Fh(e, t, n) {
  typeof t == "function" && (n = t, t = {}), t = t || {};
  var r = {
    algorithm: {
      name: t.algorithm || "PRIMEINC",
      options: {
        workers: t.workers || 2,
        workLoad: t.workLoad || 100,
        workerScript: t.workerScript
      }
    }
  };
  "prng" in t && (r.prng = t.prng), a();
  function a() {
    s(e.pBits, function(o, u) {
      if (o)
        return n(o);
      if (e.p = u, e.q !== null)
        return i(o, e.q);
      s(e.qBits, i);
    });
  }
  function s(o, u) {
    Se.prime.generateProbablePrime(o, r, u);
  }
  function i(o, u) {
    if (o)
      return n(o);
    if (e.q = u, e.p.compareTo(e.q) < 0) {
      var c = e.p;
      e.p = e.q, e.q = c;
    }
    if (e.p.subtract(je.ONE).gcd(e.e).compareTo(je.ONE) !== 0) {
      e.p = null, a();
      return;
    }
    if (e.q.subtract(je.ONE).gcd(e.e).compareTo(je.ONE) !== 0) {
      e.q = null, s(e.qBits, i);
      return;
    }
    if (e.p1 = e.p.subtract(je.ONE), e.q1 = e.q.subtract(je.ONE), e.phi = e.p1.multiply(e.q1), e.phi.gcd(e.e).compareTo(je.ONE) !== 0) {
      e.p = e.q = null, a();
      return;
    }
    if (e.n = e.p.multiply(e.q), e.n.bitLength() !== e.bits) {
      e.q = null, s(e.qBits, i);
      return;
    }
    var l = e.e.modInverse(e.phi);
    e.keys = {
      privateKey: _e.rsa.setPrivateKey(
        e.n,
        e.e,
        l,
        e.p,
        e.q,
        l.mod(e.p1),
        l.mod(e.q1),
        e.q.modInverse(e.p)
      ),
      publicKey: _e.rsa.setPublicKey(e.n, e.e)
    }, n(null, e.keys);
  }
}
function Jt(e) {
  var t = e.toString(16);
  t[0] >= "8" && (t = "00" + t);
  var n = Se.util.hexToBytes(t);
  return n.length > 1 && // leading 0x00 for positive integer
  (n.charCodeAt(0) === 0 && !(n.charCodeAt(1) & 128) || // leading 0xFF for negative integer
  n.charCodeAt(0) === 255 && (n.charCodeAt(1) & 128) === 128) ? n.substr(1) : n;
}
function Vh(e) {
  return e <= 100 ? 27 : e <= 150 ? 18 : e <= 200 ? 15 : e <= 250 ? 12 : e <= 300 ? 9 : e <= 350 ? 8 : e <= 400 ? 7 : e <= 500 ? 6 : e <= 600 ? 5 : e <= 800 ? 4 : e <= 1250 ? 3 : 2;
}
function Ys(e) {
  return Se.util.isNodejs && typeof Ai[e] == "function";
}
function Xs(e) {
  return typeof Ft.globalScope < "u" && typeof Ft.globalScope.crypto == "object" && typeof Ft.globalScope.crypto.subtle == "object" && typeof Ft.globalScope.crypto.subtle[e] == "function";
}
function Js(e) {
  return typeof Ft.globalScope < "u" && typeof Ft.globalScope.msCrypto == "object" && typeof Ft.globalScope.msCrypto.subtle == "object" && typeof Ft.globalScope.msCrypto.subtle[e] == "function";
}
function Zs(e) {
  for (var t = Se.util.hexToBytes(e.toString(16)), n = new Uint8Array(t.length), r = 0; r < t.length; ++r)
    n[r] = t.charCodeAt(r);
  return n;
}
var ye = De;
if (typeof Mh > "u")
  var Mh = ye.jsbn.BigInteger;
var j = ye.asn1, Re = ye.pki = ye.pki || {};
Re.pbe = ye.pbe = ye.pbe || {};
var Mr = Re.oids, Kh = {
  name: "EncryptedPrivateKeyInfo",
  tagClass: j.Class.UNIVERSAL,
  type: j.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "EncryptedPrivateKeyInfo.encryptionAlgorithm",
    tagClass: j.Class.UNIVERSAL,
    type: j.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "AlgorithmIdentifier.algorithm",
      tagClass: j.Class.UNIVERSAL,
      type: j.Type.OID,
      constructed: !1,
      capture: "encryptionOid"
    }, {
      name: "AlgorithmIdentifier.parameters",
      tagClass: j.Class.UNIVERSAL,
      type: j.Type.SEQUENCE,
      constructed: !0,
      captureAsn1: "encryptionParams"
    }]
  }, {
    // encryptedData
    name: "EncryptedPrivateKeyInfo.encryptedData",
    tagClass: j.Class.UNIVERSAL,
    type: j.Type.OCTETSTRING,
    constructed: !1,
    capture: "encryptedData"
  }]
}, jh = {
  name: "PBES2Algorithms",
  tagClass: j.Class.UNIVERSAL,
  type: j.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "PBES2Algorithms.keyDerivationFunc",
    tagClass: j.Class.UNIVERSAL,
    type: j.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "PBES2Algorithms.keyDerivationFunc.oid",
      tagClass: j.Class.UNIVERSAL,
      type: j.Type.OID,
      constructed: !1,
      capture: "kdfOid"
    }, {
      name: "PBES2Algorithms.params",
      tagClass: j.Class.UNIVERSAL,
      type: j.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "PBES2Algorithms.params.salt",
        tagClass: j.Class.UNIVERSAL,
        type: j.Type.OCTETSTRING,
        constructed: !1,
        capture: "kdfSalt"
      }, {
        name: "PBES2Algorithms.params.iterationCount",
        tagClass: j.Class.UNIVERSAL,
        type: j.Type.INTEGER,
        constructed: !1,
        capture: "kdfIterationCount"
      }, {
        name: "PBES2Algorithms.params.keyLength",
        tagClass: j.Class.UNIVERSAL,
        type: j.Type.INTEGER,
        constructed: !1,
        optional: !0,
        capture: "keyLength"
      }, {
        // prf
        name: "PBES2Algorithms.params.prf",
        tagClass: j.Class.UNIVERSAL,
        type: j.Type.SEQUENCE,
        constructed: !0,
        optional: !0,
        value: [{
          name: "PBES2Algorithms.params.prf.algorithm",
          tagClass: j.Class.UNIVERSAL,
          type: j.Type.OID,
          constructed: !1,
          capture: "prfOid"
        }]
      }]
    }]
  }, {
    name: "PBES2Algorithms.encryptionScheme",
    tagClass: j.Class.UNIVERSAL,
    type: j.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "PBES2Algorithms.encryptionScheme.oid",
      tagClass: j.Class.UNIVERSAL,
      type: j.Type.OID,
      constructed: !1,
      capture: "encOid"
    }, {
      name: "PBES2Algorithms.encryptionScheme.iv",
      tagClass: j.Class.UNIVERSAL,
      type: j.Type.OCTETSTRING,
      constructed: !1,
      capture: "encIv"
    }]
  }]
}, Hh = {
  name: "pkcs-12PbeParams",
  tagClass: j.Class.UNIVERSAL,
  type: j.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "pkcs-12PbeParams.salt",
    tagClass: j.Class.UNIVERSAL,
    type: j.Type.OCTETSTRING,
    constructed: !1,
    capture: "salt"
  }, {
    name: "pkcs-12PbeParams.iterations",
    tagClass: j.Class.UNIVERSAL,
    type: j.Type.INTEGER,
    constructed: !1,
    capture: "iterations"
  }]
};
Re.encryptPrivateKeyInfo = function(e, t, n) {
  n = n || {}, n.saltSize = n.saltSize || 8, n.count = n.count || 2048, n.algorithm = n.algorithm || "aes128", n.prfAlgorithm = n.prfAlgorithm || "sha1";
  var r = ye.random.getBytesSync(n.saltSize), a = n.count, s = j.integerToDer(a), i, o, u;
  if (n.algorithm.indexOf("aes") === 0 || n.algorithm === "des") {
    var c, l, p;
    switch (n.algorithm) {
      case "aes128":
        i = 16, c = 16, l = Mr["aes128-CBC"], p = ye.aes.createEncryptionCipher;
        break;
      case "aes192":
        i = 24, c = 16, l = Mr["aes192-CBC"], p = ye.aes.createEncryptionCipher;
        break;
      case "aes256":
        i = 32, c = 16, l = Mr["aes256-CBC"], p = ye.aes.createEncryptionCipher;
        break;
      case "des":
        i = 8, c = 8, l = Mr.desCBC, p = ye.des.createEncryptionCipher;
        break;
      default:
        var g = new Error("Cannot encrypt private key. Unknown encryption algorithm.");
        throw g.algorithm = n.algorithm, g;
    }
    var C = "hmacWith" + n.prfAlgorithm.toUpperCase(), d = mc(C), b = ye.pkcs5.pbkdf2(t, r, a, i, d), S = ye.random.getBytesSync(c), A = p(b);
    A.start(S), A.update(j.toDer(e)), A.finish(), u = A.output.getBytes();
    var D = qh(r, s, i, C);
    o = j.create(
      j.Class.UNIVERSAL,
      j.Type.SEQUENCE,
      !0,
      [
        j.create(
          j.Class.UNIVERSAL,
          j.Type.OID,
          !1,
          j.oidToDer(Mr.pkcs5PBES2).getBytes()
        ),
        j.create(j.Class.UNIVERSAL, j.Type.SEQUENCE, !0, [
          // keyDerivationFunc
          j.create(j.Class.UNIVERSAL, j.Type.SEQUENCE, !0, [
            j.create(
              j.Class.UNIVERSAL,
              j.Type.OID,
              !1,
              j.oidToDer(Mr.pkcs5PBKDF2).getBytes()
            ),
            // PBKDF2-params
            D
          ]),
          // encryptionScheme
          j.create(j.Class.UNIVERSAL, j.Type.SEQUENCE, !0, [
            j.create(
              j.Class.UNIVERSAL,
              j.Type.OID,
              !1,
              j.oidToDer(l).getBytes()
            ),
            // iv
            j.create(
              j.Class.UNIVERSAL,
              j.Type.OCTETSTRING,
              !1,
              S
            )
          ])
        ])
      ]
    );
  } else if (n.algorithm === "3des") {
    i = 24;
    var _ = new ye.util.ByteBuffer(r), b = Re.pbe.generatePkcs12Key(t, _, 1, a, i), S = Re.pbe.generatePkcs12Key(t, _, 2, a, i), A = ye.des.createEncryptionCipher(b);
    A.start(S), A.update(j.toDer(e)), A.finish(), u = A.output.getBytes(), o = j.create(
      j.Class.UNIVERSAL,
      j.Type.SEQUENCE,
      !0,
      [
        j.create(
          j.Class.UNIVERSAL,
          j.Type.OID,
          !1,
          j.oidToDer(Mr["pbeWithSHAAnd3-KeyTripleDES-CBC"]).getBytes()
        ),
        // pkcs-12PbeParams
        j.create(j.Class.UNIVERSAL, j.Type.SEQUENCE, !0, [
          // salt
          j.create(j.Class.UNIVERSAL, j.Type.OCTETSTRING, !1, r),
          // iteration count
          j.create(
            j.Class.UNIVERSAL,
            j.Type.INTEGER,
            !1,
            s.getBytes()
          )
        ])
      ]
    );
  } else {
    var g = new Error("Cannot encrypt private key. Unknown encryption algorithm.");
    throw g.algorithm = n.algorithm, g;
  }
  var M = j.create(j.Class.UNIVERSAL, j.Type.SEQUENCE, !0, [
    // encryptionAlgorithm
    o,
    // encryptedData
    j.create(
      j.Class.UNIVERSAL,
      j.Type.OCTETSTRING,
      !1,
      u
    )
  ]);
  return M;
};
Re.decryptPrivateKeyInfo = function(e, t) {
  var n = null, r = {}, a = [];
  if (!j.validate(e, Kh, r, a)) {
    var s = new Error("Cannot read encrypted private key. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
    throw s.errors = a, s;
  }
  var i = j.derToOid(r.encryptionOid), o = Re.pbe.getCipher(i, r.encryptionParams, t), u = ye.util.createBuffer(r.encryptedData);
  return o.update(u), o.finish() && (n = j.fromDer(o.output)), n;
};
Re.encryptedPrivateKeyToPem = function(e, t) {
  var n = {
    type: "ENCRYPTED PRIVATE KEY",
    body: j.toDer(e).getBytes()
  };
  return ye.pem.encode(n, { maxline: t });
};
Re.encryptedPrivateKeyFromPem = function(e) {
  var t = ye.pem.decode(e)[0];
  if (t.type !== "ENCRYPTED PRIVATE KEY") {
    var n = new Error('Could not convert encrypted private key from PEM; PEM header type is "ENCRYPTED PRIVATE KEY".');
    throw n.headerType = t.type, n;
  }
  if (t.procType && t.procType.type === "ENCRYPTED")
    throw new Error("Could not convert encrypted private key from PEM; PEM is encrypted.");
  return j.fromDer(t.body);
};
Re.encryptRsaPrivateKey = function(e, t, n) {
  if (n = n || {}, !n.legacy) {
    var r = Re.wrapRsaPrivateKey(Re.privateKeyToAsn1(e));
    return r = Re.encryptPrivateKeyInfo(r, t, n), Re.encryptedPrivateKeyToPem(r);
  }
  var a, s, i, o;
  switch (n.algorithm) {
    case "aes128":
      a = "AES-128-CBC", i = 16, s = ye.random.getBytesSync(16), o = ye.aes.createEncryptionCipher;
      break;
    case "aes192":
      a = "AES-192-CBC", i = 24, s = ye.random.getBytesSync(16), o = ye.aes.createEncryptionCipher;
      break;
    case "aes256":
      a = "AES-256-CBC", i = 32, s = ye.random.getBytesSync(16), o = ye.aes.createEncryptionCipher;
      break;
    case "3des":
      a = "DES-EDE3-CBC", i = 24, s = ye.random.getBytesSync(8), o = ye.des.createEncryptionCipher;
      break;
    case "des":
      a = "DES-CBC", i = 8, s = ye.random.getBytesSync(8), o = ye.des.createEncryptionCipher;
      break;
    default:
      var u = new Error('Could not encrypt RSA private key; unsupported encryption algorithm "' + n.algorithm + '".');
      throw u.algorithm = n.algorithm, u;
  }
  var c = ye.pbe.opensslDeriveBytes(t, s.substr(0, 8), i), l = o(c);
  l.start(s), l.update(j.toDer(Re.privateKeyToAsn1(e))), l.finish();
  var p = {
    type: "RSA PRIVATE KEY",
    procType: {
      version: "4",
      type: "ENCRYPTED"
    },
    dekInfo: {
      algorithm: a,
      parameters: ye.util.bytesToHex(s).toUpperCase()
    },
    body: l.output.getBytes()
  };
  return ye.pem.encode(p);
};
Re.decryptRsaPrivateKey = function(e, t) {
  var n = null, r = ye.pem.decode(e)[0];
  if (r.type !== "ENCRYPTED PRIVATE KEY" && r.type !== "PRIVATE KEY" && r.type !== "RSA PRIVATE KEY") {
    var a = new Error('Could not convert private key from PEM; PEM header type is not "ENCRYPTED PRIVATE KEY", "PRIVATE KEY", or "RSA PRIVATE KEY".');
    throw a.headerType = a, a;
  }
  if (r.procType && r.procType.type === "ENCRYPTED") {
    var s, i;
    switch (r.dekInfo.algorithm) {
      case "DES-CBC":
        s = 8, i = ye.des.createDecryptionCipher;
        break;
      case "DES-EDE3-CBC":
        s = 24, i = ye.des.createDecryptionCipher;
        break;
      case "AES-128-CBC":
        s = 16, i = ye.aes.createDecryptionCipher;
        break;
      case "AES-192-CBC":
        s = 24, i = ye.aes.createDecryptionCipher;
        break;
      case "AES-256-CBC":
        s = 32, i = ye.aes.createDecryptionCipher;
        break;
      case "RC2-40-CBC":
        s = 5, i = function(p) {
          return ye.rc2.createDecryptionCipher(p, 40);
        };
        break;
      case "RC2-64-CBC":
        s = 8, i = function(p) {
          return ye.rc2.createDecryptionCipher(p, 64);
        };
        break;
      case "RC2-128-CBC":
        s = 16, i = function(p) {
          return ye.rc2.createDecryptionCipher(p, 128);
        };
        break;
      default:
        var a = new Error('Could not decrypt private key; unsupported encryption algorithm "' + r.dekInfo.algorithm + '".');
        throw a.algorithm = r.dekInfo.algorithm, a;
    }
    var o = ye.util.hexToBytes(r.dekInfo.parameters), u = ye.pbe.opensslDeriveBytes(t, o.substr(0, 8), s), c = i(u);
    if (c.start(o), c.update(ye.util.createBuffer(r.body)), c.finish())
      n = c.output.getBytes();
    else
      return n;
  } else
    n = r.body;
  return r.type === "ENCRYPTED PRIVATE KEY" ? n = Re.decryptPrivateKeyInfo(j.fromDer(n), t) : n = j.fromDer(n), n !== null && (n = Re.privateKeyFromAsn1(n)), n;
};
Re.pbe.generatePkcs12Key = function(e, t, n, r, a, s) {
  var i, o;
  if (typeof s > "u" || s === null) {
    if (!("sha1" in ye.md))
      throw new Error('"sha1" hash algorithm unavailable.');
    s = ye.md.sha1.create();
  }
  var u = s.digestLength, c = s.blockLength, l = new ye.util.ByteBuffer(), p = new ye.util.ByteBuffer();
  if (e != null) {
    for (o = 0; o < e.length; o++)
      p.putInt16(e.charCodeAt(o));
    p.putInt16(0);
  }
  var g = p.length(), C = t.length(), d = new ye.util.ByteBuffer();
  d.fillWithByte(n, c);
  var b = c * Math.ceil(C / c), S = new ye.util.ByteBuffer();
  for (o = 0; o < b; o++)
    S.putByte(t.at(o % C));
  var A = c * Math.ceil(g / c), D = new ye.util.ByteBuffer();
  for (o = 0; o < A; o++)
    D.putByte(p.at(o % g));
  var _ = S;
  _.putBuffer(D);
  for (var M = Math.ceil(a / u), K = 1; K <= M; K++) {
    var k = new ye.util.ByteBuffer();
    k.putBytes(d.bytes()), k.putBytes(_.bytes());
    for (var J = 0; J < r; J++)
      s.start(), s.update(k.getBytes()), k = s.digest();
    var re = new ye.util.ByteBuffer();
    for (o = 0; o < c; o++)
      re.putByte(k.at(o % u));
    var G = Math.ceil(C / c) + Math.ceil(g / c), $ = new ye.util.ByteBuffer();
    for (i = 0; i < G; i++) {
      var ue = new ye.util.ByteBuffer(_.getBytes(c)), ge = 511;
      for (o = re.length() - 1; o >= 0; o--)
        ge = ge >> 8, ge += re.at(o) + ue.at(o), ue.setAt(o, ge & 255);
      $.putBuffer(ue);
    }
    _ = $, l.putBuffer(k);
  }
  return l.truncate(l.length() - a), l;
};
Re.pbe.getCipher = function(e, t, n) {
  switch (e) {
    case Re.oids.pkcs5PBES2:
      return Re.pbe.getCipherForPBES2(e, t, n);
    case Re.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
    case Re.oids["pbewithSHAAnd40BitRC2-CBC"]:
      return Re.pbe.getCipherForPKCS12PBE(e, t, n);
    default:
      var r = new Error("Cannot read encrypted PBE data block. Unsupported OID.");
      throw r.oid = e, r.supportedOids = [
        "pkcs5PBES2",
        "pbeWithSHAAnd3-KeyTripleDES-CBC",
        "pbewithSHAAnd40BitRC2-CBC"
      ], r;
  }
};
Re.pbe.getCipherForPBES2 = function(e, t, n) {
  var r = {}, a = [];
  if (!j.validate(t, jh, r, a)) {
    var s = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
    throw s.errors = a, s;
  }
  if (e = j.derToOid(r.kdfOid), e !== Re.oids.pkcs5PBKDF2) {
    var s = new Error("Cannot read encrypted private key. Unsupported key derivation function OID.");
    throw s.oid = e, s.supportedOids = ["pkcs5PBKDF2"], s;
  }
  if (e = j.derToOid(r.encOid), e !== Re.oids["aes128-CBC"] && e !== Re.oids["aes192-CBC"] && e !== Re.oids["aes256-CBC"] && e !== Re.oids["des-EDE3-CBC"] && e !== Re.oids.desCBC) {
    var s = new Error("Cannot read encrypted private key. Unsupported encryption scheme OID.");
    throw s.oid = e, s.supportedOids = [
      "aes128-CBC",
      "aes192-CBC",
      "aes256-CBC",
      "des-EDE3-CBC",
      "desCBC"
    ], s;
  }
  var i = r.kdfSalt, o = ye.util.createBuffer(r.kdfIterationCount);
  o = o.getInt(o.length() << 3);
  var u, c;
  switch (Re.oids[e]) {
    case "aes128-CBC":
      u = 16, c = ye.aes.createDecryptionCipher;
      break;
    case "aes192-CBC":
      u = 24, c = ye.aes.createDecryptionCipher;
      break;
    case "aes256-CBC":
      u = 32, c = ye.aes.createDecryptionCipher;
      break;
    case "des-EDE3-CBC":
      u = 24, c = ye.des.createDecryptionCipher;
      break;
    case "desCBC":
      u = 8, c = ye.des.createDecryptionCipher;
      break;
  }
  var l = vc(r.prfOid), p = ye.pkcs5.pbkdf2(n, i, o, u, l), g = r.encIv, C = c(p);
  return C.start(g), C;
};
Re.pbe.getCipherForPKCS12PBE = function(e, t, n) {
  var r = {}, a = [];
  if (!j.validate(t, Hh, r, a)) {
    var s = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
    throw s.errors = a, s;
  }
  var i = ye.util.createBuffer(r.salt), o = ye.util.createBuffer(r.iterations);
  o = o.getInt(o.length() << 3);
  var u, c, l;
  switch (e) {
    case Re.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
      u = 24, c = 8, l = ye.des.startDecrypting;
      break;
    case Re.oids["pbewithSHAAnd40BitRC2-CBC"]:
      u = 5, c = 8, l = function(b, S) {
        var A = ye.rc2.createDecryptionCipher(b, 40);
        return A.start(S, null), A;
      };
      break;
    default:
      var s = new Error("Cannot read PKCS #12 PBE data block. Unsupported OID.");
      throw s.oid = e, s;
  }
  var p = vc(r.prfOid), g = Re.pbe.generatePkcs12Key(n, i, 1, o, u, p);
  p.start();
  var C = Re.pbe.generatePkcs12Key(n, i, 2, o, c, p);
  return l(g, C);
};
Re.pbe.opensslDeriveBytes = function(e, t, n, r) {
  if (typeof r > "u" || r === null) {
    if (!("md5" in ye.md))
      throw new Error('"md5" hash algorithm unavailable.');
    r = ye.md.md5.create();
  }
  t === null && (t = "");
  for (var a = [eo(r, e + t)], s = 16, i = 1; s < n; ++i, s += 16)
    a.push(eo(r, a[i - 1] + e + t));
  return a.join("").substr(0, n);
};
function eo(e, t) {
  return e.start().update(t).digest().getBytes();
}
function vc(e) {
  var t;
  if (!e)
    t = "hmacWithSHA1";
  else if (t = Re.oids[j.derToOid(e)], !t) {
    var n = new Error("Unsupported PRF OID.");
    throw n.oid = e, n.supported = [
      "hmacWithSHA1",
      "hmacWithSHA224",
      "hmacWithSHA256",
      "hmacWithSHA384",
      "hmacWithSHA512"
    ], n;
  }
  return mc(t);
}
function mc(e) {
  var t = ye.md;
  switch (e) {
    case "hmacWithSHA224":
      t = ye.md.sha512;
    case "hmacWithSHA1":
    case "hmacWithSHA256":
    case "hmacWithSHA384":
    case "hmacWithSHA512":
      e = e.substr(8).toLowerCase();
      break;
    default:
      var n = new Error("Unsupported PRF algorithm.");
      throw n.algorithm = e, n.supported = [
        "hmacWithSHA1",
        "hmacWithSHA224",
        "hmacWithSHA256",
        "hmacWithSHA384",
        "hmacWithSHA512"
      ], n;
  }
  if (!t || !(e in t))
    throw new Error("Unknown hash algorithm: " + e);
  return t[e].create();
}
function qh(e, t, n, r) {
  var a = j.create(j.Class.UNIVERSAL, j.Type.SEQUENCE, !0, [
    // salt
    j.create(
      j.Class.UNIVERSAL,
      j.Type.OCTETSTRING,
      !1,
      e
    ),
    // iteration count
    j.create(
      j.Class.UNIVERSAL,
      j.Type.INTEGER,
      !1,
      t.getBytes()
    )
  ]);
  return r !== "hmacWithSHA1" && a.value.push(
    // key length
    j.create(
      j.Class.UNIVERSAL,
      j.Type.INTEGER,
      !1,
      ye.util.hexToBytes(n.toString(16))
    ),
    // AlgorithmIdentifier
    j.create(j.Class.UNIVERSAL, j.Type.SEQUENCE, !0, [
      // algorithm
      j.create(
        j.Class.UNIVERSAL,
        j.Type.OID,
        !1,
        j.oidToDer(Re.oids[r]).getBytes()
      ),
      // parameters (null)
      j.create(j.Class.UNIVERSAL, j.Type.NULL, !1, "")
    ])
  ), a;
}
var vn = De, he = vn.asn1, xn = vn.pkcs7asn1 = vn.pkcs7asn1 || {};
vn.pkcs7 = vn.pkcs7 || {};
vn.pkcs7.asn1 = xn;
var Ec = {
  name: "ContentInfo",
  tagClass: he.Class.UNIVERSAL,
  type: he.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "ContentInfo.ContentType",
    tagClass: he.Class.UNIVERSAL,
    type: he.Type.OID,
    constructed: !1,
    capture: "contentType"
  }, {
    name: "ContentInfo.content",
    tagClass: he.Class.CONTEXT_SPECIFIC,
    type: 0,
    constructed: !0,
    optional: !0,
    captureAsn1: "content"
  }]
};
xn.contentInfoValidator = Ec;
var Cc = {
  name: "EncryptedContentInfo",
  tagClass: he.Class.UNIVERSAL,
  type: he.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "EncryptedContentInfo.contentType",
    tagClass: he.Class.UNIVERSAL,
    type: he.Type.OID,
    constructed: !1,
    capture: "contentType"
  }, {
    name: "EncryptedContentInfo.contentEncryptionAlgorithm",
    tagClass: he.Class.UNIVERSAL,
    type: he.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "EncryptedContentInfo.contentEncryptionAlgorithm.algorithm",
      tagClass: he.Class.UNIVERSAL,
      type: he.Type.OID,
      constructed: !1,
      capture: "encAlgorithm"
    }, {
      name: "EncryptedContentInfo.contentEncryptionAlgorithm.parameter",
      tagClass: he.Class.UNIVERSAL,
      captureAsn1: "encParameter"
    }]
  }, {
    name: "EncryptedContentInfo.encryptedContent",
    tagClass: he.Class.CONTEXT_SPECIFIC,
    type: 0,
    /* The PKCS#7 structure output by OpenSSL somewhat differs from what
     * other implementations do generate.
     *
     * OpenSSL generates a structure like this:
     * SEQUENCE {
     *    ...
     *    [0]
     *       26 DA 67 D2 17 9C 45 3C B1 2A A8 59 2F 29 33 38
     *       C3 C3 DF 86 71 74 7A 19 9F 40 D0 29 BE 85 90 45
     *       ...
     * }
     *
     * Whereas other implementations (and this PKCS#7 module) generate:
     * SEQUENCE {
     *    ...
     *    [0] {
     *       OCTET STRING
     *          26 DA 67 D2 17 9C 45 3C B1 2A A8 59 2F 29 33 38
     *          C3 C3 DF 86 71 74 7A 19 9F 40 D0 29 BE 85 90 45
     *          ...
     *    }
     * }
     *
     * In order to support both, we just capture the context specific
     * field here.  The OCTET STRING bit is removed below.
     */
    capture: "encryptedContent",
    captureAsn1: "encryptedContentAsn1"
  }]
};
xn.envelopedDataValidator = {
  name: "EnvelopedData",
  tagClass: he.Class.UNIVERSAL,
  type: he.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "EnvelopedData.Version",
    tagClass: he.Class.UNIVERSAL,
    type: he.Type.INTEGER,
    constructed: !1,
    capture: "version"
  }, {
    name: "EnvelopedData.RecipientInfos",
    tagClass: he.Class.UNIVERSAL,
    type: he.Type.SET,
    constructed: !0,
    captureAsn1: "recipientInfos"
  }].concat(Cc)
};
xn.encryptedDataValidator = {
  name: "EncryptedData",
  tagClass: he.Class.UNIVERSAL,
  type: he.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "EncryptedData.Version",
    tagClass: he.Class.UNIVERSAL,
    type: he.Type.INTEGER,
    constructed: !1,
    capture: "version"
  }].concat(Cc)
};
var Gh = {
  name: "SignerInfo",
  tagClass: he.Class.UNIVERSAL,
  type: he.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "SignerInfo.version",
    tagClass: he.Class.UNIVERSAL,
    type: he.Type.INTEGER,
    constructed: !1
  }, {
    name: "SignerInfo.issuerAndSerialNumber",
    tagClass: he.Class.UNIVERSAL,
    type: he.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "SignerInfo.issuerAndSerialNumber.issuer",
      tagClass: he.Class.UNIVERSAL,
      type: he.Type.SEQUENCE,
      constructed: !0,
      captureAsn1: "issuer"
    }, {
      name: "SignerInfo.issuerAndSerialNumber.serialNumber",
      tagClass: he.Class.UNIVERSAL,
      type: he.Type.INTEGER,
      constructed: !1,
      capture: "serial"
    }]
  }, {
    name: "SignerInfo.digestAlgorithm",
    tagClass: he.Class.UNIVERSAL,
    type: he.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "SignerInfo.digestAlgorithm.algorithm",
      tagClass: he.Class.UNIVERSAL,
      type: he.Type.OID,
      constructed: !1,
      capture: "digestAlgorithm"
    }, {
      name: "SignerInfo.digestAlgorithm.parameter",
      tagClass: he.Class.UNIVERSAL,
      constructed: !1,
      captureAsn1: "digestParameter",
      optional: !0
    }]
  }, {
    name: "SignerInfo.authenticatedAttributes",
    tagClass: he.Class.CONTEXT_SPECIFIC,
    type: 0,
    constructed: !0,
    optional: !0,
    capture: "authenticatedAttributes"
  }, {
    name: "SignerInfo.digestEncryptionAlgorithm",
    tagClass: he.Class.UNIVERSAL,
    type: he.Type.SEQUENCE,
    constructed: !0,
    capture: "signatureAlgorithm"
  }, {
    name: "SignerInfo.encryptedDigest",
    tagClass: he.Class.UNIVERSAL,
    type: he.Type.OCTETSTRING,
    constructed: !1,
    capture: "signature"
  }, {
    name: "SignerInfo.unauthenticatedAttributes",
    tagClass: he.Class.CONTEXT_SPECIFIC,
    type: 1,
    constructed: !0,
    optional: !0,
    capture: "unauthenticatedAttributes"
  }]
};
xn.signedDataValidator = {
  name: "SignedData",
  tagClass: he.Class.UNIVERSAL,
  type: he.Type.SEQUENCE,
  constructed: !0,
  value: [
    {
      name: "SignedData.Version",
      tagClass: he.Class.UNIVERSAL,
      type: he.Type.INTEGER,
      constructed: !1,
      capture: "version"
    },
    {
      name: "SignedData.DigestAlgorithms",
      tagClass: he.Class.UNIVERSAL,
      type: he.Type.SET,
      constructed: !0,
      captureAsn1: "digestAlgorithms"
    },
    Ec,
    {
      name: "SignedData.Certificates",
      tagClass: he.Class.CONTEXT_SPECIFIC,
      type: 0,
      optional: !0,
      captureAsn1: "certificates"
    },
    {
      name: "SignedData.CertificateRevocationLists",
      tagClass: he.Class.CONTEXT_SPECIFIC,
      type: 1,
      optional: !0,
      captureAsn1: "crls"
    },
    {
      name: "SignedData.SignerInfos",
      tagClass: he.Class.UNIVERSAL,
      type: he.Type.SET,
      capture: "signerInfos",
      optional: !0,
      value: [Gh]
    }
  ]
};
xn.recipientInfoValidator = {
  name: "RecipientInfo",
  tagClass: he.Class.UNIVERSAL,
  type: he.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "RecipientInfo.version",
    tagClass: he.Class.UNIVERSAL,
    type: he.Type.INTEGER,
    constructed: !1,
    capture: "version"
  }, {
    name: "RecipientInfo.issuerAndSerial",
    tagClass: he.Class.UNIVERSAL,
    type: he.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "RecipientInfo.issuerAndSerial.issuer",
      tagClass: he.Class.UNIVERSAL,
      type: he.Type.SEQUENCE,
      constructed: !0,
      captureAsn1: "issuer"
    }, {
      name: "RecipientInfo.issuerAndSerial.serialNumber",
      tagClass: he.Class.UNIVERSAL,
      type: he.Type.INTEGER,
      constructed: !1,
      capture: "serial"
    }]
  }, {
    name: "RecipientInfo.keyEncryptionAlgorithm",
    tagClass: he.Class.UNIVERSAL,
    type: he.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "RecipientInfo.keyEncryptionAlgorithm.algorithm",
      tagClass: he.Class.UNIVERSAL,
      type: he.Type.OID,
      constructed: !1,
      capture: "encAlgorithm"
    }, {
      name: "RecipientInfo.keyEncryptionAlgorithm.parameter",
      tagClass: he.Class.UNIVERSAL,
      constructed: !1,
      captureAsn1: "encParameter",
      optional: !0
    }]
  }, {
    name: "RecipientInfo.encryptedKey",
    tagClass: he.Class.UNIVERSAL,
    type: he.Type.OCTETSTRING,
    constructed: !1,
    capture: "encKey"
  }]
};
var Wr = De;
Wr.mgf = Wr.mgf || {};
var $h = Wr.mgf.mgf1 = Wr.mgf1 = Wr.mgf1 || {};
$h.create = function(e) {
  var t = {
    /**
     * Generate mask of specified length.
     *
     * @param {String} seed The seed for mask generation.
     * @param maskLen Number of bytes to generate.
     * @return {String} The generated mask.
     */
    generate: function(n, r) {
      for (var a = new Wr.util.ByteBuffer(), s = Math.ceil(r / e.digestLength), i = 0; i < s; i++) {
        var o = new Wr.util.ByteBuffer();
        o.putInt32(i), e.start(), e.update(n + o.getBytes()), a.putBuffer(e.digest());
      }
      return a.truncate(a.length() - r), a.getBytes();
    }
  };
  return t;
};
var ya = De;
ya.mgf = ya.mgf || {};
ya.mgf.mgf1 = ya.mgf1;
var Hr = De, zh = Hr.pss = Hr.pss || {};
zh.create = function(e) {
  arguments.length === 3 && (e = {
    md: arguments[0],
    mgf: arguments[1],
    saltLength: arguments[2]
  });
  var t = e.md, n = e.mgf, r = t.digestLength, a = e.salt || null;
  typeof a == "string" && (a = Hr.util.createBuffer(a));
  var s;
  if ("saltLength" in e)
    s = e.saltLength;
  else if (a !== null)
    s = a.length();
  else
    throw new Error("Salt length not specified or specific salt not given.");
  if (a !== null && a.length() !== s)
    throw new Error("Given salt length does not match length of given salt.");
  var i = e.prng || Hr.random, o = {};
  return o.encode = function(u, c) {
    var l, p = c - 1, g = Math.ceil(p / 8), C = u.digest().getBytes();
    if (g < r + s + 2)
      throw new Error("Message is too long to encrypt.");
    var d;
    a === null ? d = i.getBytesSync(s) : d = a.bytes();
    var b = new Hr.util.ByteBuffer();
    b.fillWithByte(0, 8), b.putBytes(C), b.putBytes(d), t.start(), t.update(b.getBytes());
    var S = t.digest().getBytes(), A = new Hr.util.ByteBuffer();
    A.fillWithByte(0, g - s - r - 2), A.putByte(1), A.putBytes(d);
    var D = A.getBytes(), _ = g - r - 1, M = n.generate(S, _), K = "";
    for (l = 0; l < _; l++)
      K += String.fromCharCode(D.charCodeAt(l) ^ M.charCodeAt(l));
    var k = 65280 >> 8 * g - p & 255;
    return K = String.fromCharCode(K.charCodeAt(0) & ~k) + K.substr(1), K + S + String.fromCharCode(188);
  }, o.verify = function(u, c, l) {
    var p, g = l - 1, C = Math.ceil(g / 8);
    if (c = c.substr(-C), C < r + s + 2)
      throw new Error("Inconsistent parameters to PSS signature verification.");
    if (c.charCodeAt(C - 1) !== 188)
      throw new Error("Encoded message does not end in 0xBC.");
    var d = C - r - 1, b = c.substr(0, d), S = c.substr(d, r), A = 65280 >> 8 * C - g & 255;
    if (b.charCodeAt(0) & A)
      throw new Error("Bits beyond keysize not zero as expected.");
    var D = n.generate(S, d), _ = "";
    for (p = 0; p < d; p++)
      _ += String.fromCharCode(b.charCodeAt(p) ^ D.charCodeAt(p));
    _ = String.fromCharCode(_.charCodeAt(0) & ~A) + _.substr(1);
    var M = C - r - s - 2;
    for (p = 0; p < M; p++)
      if (_.charCodeAt(p) !== 0)
        throw new Error("Leftmost octets not zero as expected");
    if (_.charCodeAt(M) !== 1)
      throw new Error("Inconsistent PSS signature, 0x01 marker not found");
    var K = _.substr(-s), k = new Hr.util.ByteBuffer();
    k.fillWithByte(0, 8), k.putBytes(u), k.putBytes(K), t.start(), t.update(k.getBytes());
    var J = t.digest().getBytes();
    return S === J;
  }, o;
};
var be = De, v = be.asn1, ae = be.pki = be.pki || {}, Ke = ae.oids, ut = {};
ut.CN = Ke.commonName;
ut.commonName = "CN";
ut.C = Ke.countryName;
ut.countryName = "C";
ut.L = Ke.localityName;
ut.localityName = "L";
ut.ST = Ke.stateOrProvinceName;
ut.stateOrProvinceName = "ST";
ut.O = Ke.organizationName;
ut.organizationName = "O";
ut.OU = Ke.organizationalUnitName;
ut.organizationalUnitName = "OU";
ut.E = Ke.emailAddress;
ut.emailAddress = "E";
var Sc = be.pki.rsa.publicKeyValidator, Wh = {
  name: "Certificate",
  tagClass: v.Class.UNIVERSAL,
  type: v.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "Certificate.TBSCertificate",
    tagClass: v.Class.UNIVERSAL,
    type: v.Type.SEQUENCE,
    constructed: !0,
    captureAsn1: "tbsCertificate",
    value: [
      {
        name: "Certificate.TBSCertificate.version",
        tagClass: v.Class.CONTEXT_SPECIFIC,
        type: 0,
        constructed: !0,
        optional: !0,
        value: [{
          name: "Certificate.TBSCertificate.version.integer",
          tagClass: v.Class.UNIVERSAL,
          type: v.Type.INTEGER,
          constructed: !1,
          capture: "certVersion"
        }]
      },
      {
        name: "Certificate.TBSCertificate.serialNumber",
        tagClass: v.Class.UNIVERSAL,
        type: v.Type.INTEGER,
        constructed: !1,
        capture: "certSerialNumber"
      },
      {
        name: "Certificate.TBSCertificate.signature",
        tagClass: v.Class.UNIVERSAL,
        type: v.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "Certificate.TBSCertificate.signature.algorithm",
          tagClass: v.Class.UNIVERSAL,
          type: v.Type.OID,
          constructed: !1,
          capture: "certinfoSignatureOid"
        }, {
          name: "Certificate.TBSCertificate.signature.parameters",
          tagClass: v.Class.UNIVERSAL,
          optional: !0,
          captureAsn1: "certinfoSignatureParams"
        }]
      },
      {
        name: "Certificate.TBSCertificate.issuer",
        tagClass: v.Class.UNIVERSAL,
        type: v.Type.SEQUENCE,
        constructed: !0,
        captureAsn1: "certIssuer"
      },
      {
        name: "Certificate.TBSCertificate.validity",
        tagClass: v.Class.UNIVERSAL,
        type: v.Type.SEQUENCE,
        constructed: !0,
        // Note: UTC and generalized times may both appear so the capture
        // names are based on their detected order, the names used below
        // are only for the common case, which validity time really means
        // "notBefore" and which means "notAfter" will be determined by order
        value: [{
          // notBefore (Time) (UTC time case)
          name: "Certificate.TBSCertificate.validity.notBefore (utc)",
          tagClass: v.Class.UNIVERSAL,
          type: v.Type.UTCTIME,
          constructed: !1,
          optional: !0,
          capture: "certValidity1UTCTime"
        }, {
          // notBefore (Time) (generalized time case)
          name: "Certificate.TBSCertificate.validity.notBefore (generalized)",
          tagClass: v.Class.UNIVERSAL,
          type: v.Type.GENERALIZEDTIME,
          constructed: !1,
          optional: !0,
          capture: "certValidity2GeneralizedTime"
        }, {
          // notAfter (Time) (only UTC time is supported)
          name: "Certificate.TBSCertificate.validity.notAfter (utc)",
          tagClass: v.Class.UNIVERSAL,
          type: v.Type.UTCTIME,
          constructed: !1,
          optional: !0,
          capture: "certValidity3UTCTime"
        }, {
          // notAfter (Time) (only UTC time is supported)
          name: "Certificate.TBSCertificate.validity.notAfter (generalized)",
          tagClass: v.Class.UNIVERSAL,
          type: v.Type.GENERALIZEDTIME,
          constructed: !1,
          optional: !0,
          capture: "certValidity4GeneralizedTime"
        }]
      },
      {
        // Name (subject) (RDNSequence)
        name: "Certificate.TBSCertificate.subject",
        tagClass: v.Class.UNIVERSAL,
        type: v.Type.SEQUENCE,
        constructed: !0,
        captureAsn1: "certSubject"
      },
      // SubjectPublicKeyInfo
      Sc,
      {
        // issuerUniqueID (optional)
        name: "Certificate.TBSCertificate.issuerUniqueID",
        tagClass: v.Class.CONTEXT_SPECIFIC,
        type: 1,
        constructed: !0,
        optional: !0,
        value: [{
          name: "Certificate.TBSCertificate.issuerUniqueID.id",
          tagClass: v.Class.UNIVERSAL,
          type: v.Type.BITSTRING,
          constructed: !1,
          // TODO: support arbitrary bit length ids
          captureBitStringValue: "certIssuerUniqueId"
        }]
      },
      {
        // subjectUniqueID (optional)
        name: "Certificate.TBSCertificate.subjectUniqueID",
        tagClass: v.Class.CONTEXT_SPECIFIC,
        type: 2,
        constructed: !0,
        optional: !0,
        value: [{
          name: "Certificate.TBSCertificate.subjectUniqueID.id",
          tagClass: v.Class.UNIVERSAL,
          type: v.Type.BITSTRING,
          constructed: !1,
          // TODO: support arbitrary bit length ids
          captureBitStringValue: "certSubjectUniqueId"
        }]
      },
      {
        // Extensions (optional)
        name: "Certificate.TBSCertificate.extensions",
        tagClass: v.Class.CONTEXT_SPECIFIC,
        type: 3,
        constructed: !0,
        captureAsn1: "certExtensions",
        optional: !0
      }
    ]
  }, {
    // AlgorithmIdentifier (signature algorithm)
    name: "Certificate.signatureAlgorithm",
    tagClass: v.Class.UNIVERSAL,
    type: v.Type.SEQUENCE,
    constructed: !0,
    value: [{
      // algorithm
      name: "Certificate.signatureAlgorithm.algorithm",
      tagClass: v.Class.UNIVERSAL,
      type: v.Type.OID,
      constructed: !1,
      capture: "certSignatureOid"
    }, {
      name: "Certificate.TBSCertificate.signature.parameters",
      tagClass: v.Class.UNIVERSAL,
      optional: !0,
      captureAsn1: "certSignatureParams"
    }]
  }, {
    // SignatureValue
    name: "Certificate.signatureValue",
    tagClass: v.Class.UNIVERSAL,
    type: v.Type.BITSTRING,
    constructed: !1,
    captureBitStringValue: "certSignature"
  }]
}, Qh = {
  name: "rsapss",
  tagClass: v.Class.UNIVERSAL,
  type: v.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "rsapss.hashAlgorithm",
    tagClass: v.Class.CONTEXT_SPECIFIC,
    type: 0,
    constructed: !0,
    value: [{
      name: "rsapss.hashAlgorithm.AlgorithmIdentifier",
      tagClass: v.Class.UNIVERSAL,
      type: v.Class.SEQUENCE,
      constructed: !0,
      optional: !0,
      value: [{
        name: "rsapss.hashAlgorithm.AlgorithmIdentifier.algorithm",
        tagClass: v.Class.UNIVERSAL,
        type: v.Type.OID,
        constructed: !1,
        capture: "hashOid"
        /* parameter block omitted, for SHA1 NULL anyhow. */
      }]
    }]
  }, {
    name: "rsapss.maskGenAlgorithm",
    tagClass: v.Class.CONTEXT_SPECIFIC,
    type: 1,
    constructed: !0,
    value: [{
      name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier",
      tagClass: v.Class.UNIVERSAL,
      type: v.Class.SEQUENCE,
      constructed: !0,
      optional: !0,
      value: [{
        name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.algorithm",
        tagClass: v.Class.UNIVERSAL,
        type: v.Type.OID,
        constructed: !1,
        capture: "maskGenOid"
      }, {
        name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params",
        tagClass: v.Class.UNIVERSAL,
        type: v.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params.algorithm",
          tagClass: v.Class.UNIVERSAL,
          type: v.Type.OID,
          constructed: !1,
          capture: "maskGenHashOid"
          /* parameter block omitted, for SHA1 NULL anyhow. */
        }]
      }]
    }]
  }, {
    name: "rsapss.saltLength",
    tagClass: v.Class.CONTEXT_SPECIFIC,
    type: 2,
    optional: !0,
    value: [{
      name: "rsapss.saltLength.saltLength",
      tagClass: v.Class.UNIVERSAL,
      type: v.Class.INTEGER,
      constructed: !1,
      capture: "saltLength"
    }]
  }, {
    name: "rsapss.trailerField",
    tagClass: v.Class.CONTEXT_SPECIFIC,
    type: 3,
    optional: !0,
    value: [{
      name: "rsapss.trailer.trailer",
      tagClass: v.Class.UNIVERSAL,
      type: v.Class.INTEGER,
      constructed: !1,
      capture: "trailer"
    }]
  }]
}, Yh = {
  name: "CertificationRequestInfo",
  tagClass: v.Class.UNIVERSAL,
  type: v.Type.SEQUENCE,
  constructed: !0,
  captureAsn1: "certificationRequestInfo",
  value: [
    {
      name: "CertificationRequestInfo.integer",
      tagClass: v.Class.UNIVERSAL,
      type: v.Type.INTEGER,
      constructed: !1,
      capture: "certificationRequestInfoVersion"
    },
    {
      // Name (subject) (RDNSequence)
      name: "CertificationRequestInfo.subject",
      tagClass: v.Class.UNIVERSAL,
      type: v.Type.SEQUENCE,
      constructed: !0,
      captureAsn1: "certificationRequestInfoSubject"
    },
    // SubjectPublicKeyInfo
    Sc,
    {
      name: "CertificationRequestInfo.attributes",
      tagClass: v.Class.CONTEXT_SPECIFIC,
      type: 0,
      constructed: !0,
      optional: !0,
      capture: "certificationRequestInfoAttributes",
      value: [{
        name: "CertificationRequestInfo.attributes",
        tagClass: v.Class.UNIVERSAL,
        type: v.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "CertificationRequestInfo.attributes.type",
          tagClass: v.Class.UNIVERSAL,
          type: v.Type.OID,
          constructed: !1
        }, {
          name: "CertificationRequestInfo.attributes.value",
          tagClass: v.Class.UNIVERSAL,
          type: v.Type.SET,
          constructed: !0
        }]
      }]
    }
  ]
}, Xh = {
  name: "CertificationRequest",
  tagClass: v.Class.UNIVERSAL,
  type: v.Type.SEQUENCE,
  constructed: !0,
  captureAsn1: "csr",
  value: [
    Yh,
    {
      // AlgorithmIdentifier (signature algorithm)
      name: "CertificationRequest.signatureAlgorithm",
      tagClass: v.Class.UNIVERSAL,
      type: v.Type.SEQUENCE,
      constructed: !0,
      value: [{
        // algorithm
        name: "CertificationRequest.signatureAlgorithm.algorithm",
        tagClass: v.Class.UNIVERSAL,
        type: v.Type.OID,
        constructed: !1,
        capture: "csrSignatureOid"
      }, {
        name: "CertificationRequest.signatureAlgorithm.parameters",
        tagClass: v.Class.UNIVERSAL,
        optional: !0,
        captureAsn1: "csrSignatureParams"
      }]
    },
    {
      // signature
      name: "CertificationRequest.signature",
      tagClass: v.Class.UNIVERSAL,
      type: v.Type.BITSTRING,
      constructed: !1,
      captureBitStringValue: "csrSignature"
    }
  ]
};
ae.RDNAttributesAsArray = function(e, t) {
  for (var n = [], r, a, s, i = 0; i < e.value.length; ++i) {
    r = e.value[i];
    for (var o = 0; o < r.value.length; ++o)
      s = {}, a = r.value[o], s.type = v.derToOid(a.value[0].value), s.value = a.value[1].value, s.valueTagClass = a.value[1].type, s.type in Ke && (s.name = Ke[s.type], s.name in ut && (s.shortName = ut[s.name])), t && (t.update(s.type), t.update(s.value)), n.push(s);
  }
  return n;
};
ae.CRIAttributesAsArray = function(e) {
  for (var t = [], n = 0; n < e.length; ++n)
    for (var r = e[n], a = v.derToOid(r.value[0].value), s = r.value[1].value, i = 0; i < s.length; ++i) {
      var o = {};
      if (o.type = a, o.value = s[i].value, o.valueTagClass = s[i].type, o.type in Ke && (o.name = Ke[o.type], o.name in ut && (o.shortName = ut[o.name])), o.type === Ke.extensionRequest) {
        o.extensions = [];
        for (var u = 0; u < o.value.length; ++u)
          o.extensions.push(ae.certificateExtensionFromAsn1(o.value[u]));
      }
      t.push(o);
    }
  return t;
};
function Nr(e, t) {
  typeof t == "string" && (t = { shortName: t });
  for (var n = null, r, a = 0; n === null && a < e.attributes.length; ++a)
    r = e.attributes[a], (t.type && t.type === r.type || t.name && t.name === r.name || t.shortName && t.shortName === r.shortName) && (n = r);
  return n;
}
var ga = function(e, t, n) {
  var r = {};
  if (e !== Ke["RSASSA-PSS"])
    return r;
  n && (r = {
    hash: {
      algorithmOid: Ke.sha1
    },
    mgf: {
      algorithmOid: Ke.mgf1,
      hash: {
        algorithmOid: Ke.sha1
      }
    },
    saltLength: 20
  });
  var a = {}, s = [];
  if (!v.validate(t, Qh, a, s)) {
    var i = new Error("Cannot read RSASSA-PSS parameter block.");
    throw i.errors = s, i;
  }
  return a.hashOid !== void 0 && (r.hash = r.hash || {}, r.hash.algorithmOid = v.derToOid(a.hashOid)), a.maskGenOid !== void 0 && (r.mgf = r.mgf || {}, r.mgf.algorithmOid = v.derToOid(a.maskGenOid), r.mgf.hash = r.mgf.hash || {}, r.mgf.hash.algorithmOid = v.derToOid(a.maskGenHashOid)), a.saltLength !== void 0 && (r.saltLength = a.saltLength.charCodeAt(0)), r;
}, Da = function(e) {
  switch (Ke[e.signatureOid]) {
    case "sha1WithRSAEncryption":
    case "sha1WithRSASignature":
      return be.md.sha1.create();
    case "md5WithRSAEncryption":
      return be.md.md5.create();
    case "sha256WithRSAEncryption":
      return be.md.sha256.create();
    case "sha384WithRSAEncryption":
      return be.md.sha384.create();
    case "sha512WithRSAEncryption":
      return be.md.sha512.create();
    case "RSASSA-PSS":
      return be.md.sha256.create();
    default:
      var t = new Error(
        "Could not compute " + e.type + " digest. Unknown signature OID."
      );
      throw t.signatureOid = e.signatureOid, t;
  }
}, bc = function(e) {
  var t = e.certificate, n;
  switch (t.signatureOid) {
    case Ke.sha1WithRSAEncryption:
    case Ke.sha1WithRSASignature:
      break;
    case Ke["RSASSA-PSS"]:
      var r, a;
      if (r = Ke[t.signatureParameters.mgf.hash.algorithmOid], r === void 0 || be.md[r] === void 0) {
        var s = new Error("Unsupported MGF hash function.");
        throw s.oid = t.signatureParameters.mgf.hash.algorithmOid, s.name = r, s;
      }
      if (a = Ke[t.signatureParameters.mgf.algorithmOid], a === void 0 || be.mgf[a] === void 0) {
        var s = new Error("Unsupported MGF function.");
        throw s.oid = t.signatureParameters.mgf.algorithmOid, s.name = a, s;
      }
      if (a = be.mgf[a].create(be.md[r].create()), r = Ke[t.signatureParameters.hash.algorithmOid], r === void 0 || be.md[r] === void 0) {
        var s = new Error("Unsupported RSASSA-PSS hash function.");
        throw s.oid = t.signatureParameters.hash.algorithmOid, s.name = r, s;
      }
      n = be.pss.create(
        be.md[r].create(),
        a,
        t.signatureParameters.saltLength
      );
      break;
  }
  return t.publicKey.verify(
    e.md.digest().getBytes(),
    e.signature,
    n
  );
};
ae.certificateFromPem = function(e, t, n) {
  var r = be.pem.decode(e)[0];
  if (r.type !== "CERTIFICATE" && r.type !== "X509 CERTIFICATE" && r.type !== "TRUSTED CERTIFICATE") {
    var a = new Error(
      'Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".'
    );
    throw a.headerType = r.type, a;
  }
  if (r.procType && r.procType.type === "ENCRYPTED")
    throw new Error(
      "Could not convert certificate from PEM; PEM is encrypted."
    );
  var s = v.fromDer(r.body, n);
  return ae.certificateFromAsn1(s, t);
};
ae.certificateToPem = function(e, t) {
  var n = {
    type: "CERTIFICATE",
    body: v.toDer(ae.certificateToAsn1(e)).getBytes()
  };
  return be.pem.encode(n, { maxline: t });
};
ae.publicKeyFromPem = function(e) {
  var t = be.pem.decode(e)[0];
  if (t.type !== "PUBLIC KEY" && t.type !== "RSA PUBLIC KEY") {
    var n = new Error('Could not convert public key from PEM; PEM header type is not "PUBLIC KEY" or "RSA PUBLIC KEY".');
    throw n.headerType = t.type, n;
  }
  if (t.procType && t.procType.type === "ENCRYPTED")
    throw new Error("Could not convert public key from PEM; PEM is encrypted.");
  var r = v.fromDer(t.body);
  return ae.publicKeyFromAsn1(r);
};
ae.publicKeyToPem = function(e, t) {
  var n = {
    type: "PUBLIC KEY",
    body: v.toDer(ae.publicKeyToAsn1(e)).getBytes()
  };
  return be.pem.encode(n, { maxline: t });
};
ae.publicKeyToRSAPublicKeyPem = function(e, t) {
  var n = {
    type: "RSA PUBLIC KEY",
    body: v.toDer(ae.publicKeyToRSAPublicKey(e)).getBytes()
  };
  return be.pem.encode(n, { maxline: t });
};
ae.getPublicKeyFingerprint = function(e, t) {
  t = t || {};
  var n = t.md || be.md.sha1.create(), r = t.type || "RSAPublicKey", a;
  switch (r) {
    case "RSAPublicKey":
      a = v.toDer(ae.publicKeyToRSAPublicKey(e)).getBytes();
      break;
    case "SubjectPublicKeyInfo":
      a = v.toDer(ae.publicKeyToAsn1(e)).getBytes();
      break;
    default:
      throw new Error('Unknown fingerprint type "' + t.type + '".');
  }
  n.start(), n.update(a);
  var s = n.digest();
  if (t.encoding === "hex") {
    var i = s.toHex();
    return t.delimiter ? i.match(/.{2}/g).join(t.delimiter) : i;
  } else {
    if (t.encoding === "binary")
      return s.getBytes();
    if (t.encoding)
      throw new Error('Unknown encoding "' + t.encoding + '".');
  }
  return s;
};
ae.certificationRequestFromPem = function(e, t, n) {
  var r = be.pem.decode(e)[0];
  if (r.type !== "CERTIFICATE REQUEST") {
    var a = new Error('Could not convert certification request from PEM; PEM header type is not "CERTIFICATE REQUEST".');
    throw a.headerType = r.type, a;
  }
  if (r.procType && r.procType.type === "ENCRYPTED")
    throw new Error("Could not convert certification request from PEM; PEM is encrypted.");
  var s = v.fromDer(r.body, n);
  return ae.certificationRequestFromAsn1(s, t);
};
ae.certificationRequestToPem = function(e, t) {
  var n = {
    type: "CERTIFICATE REQUEST",
    body: v.toDer(ae.certificationRequestToAsn1(e)).getBytes()
  };
  return be.pem.encode(n, { maxline: t });
};
ae.createCertificate = function() {
  var e = {};
  return e.version = 2, e.serialNumber = "00", e.signatureOid = null, e.signature = null, e.siginfo = {}, e.siginfo.algorithmOid = null, e.validity = {}, e.validity.notBefore = /* @__PURE__ */ new Date(), e.validity.notAfter = /* @__PURE__ */ new Date(), e.issuer = {}, e.issuer.getField = function(t) {
    return Nr(e.issuer, t);
  }, e.issuer.addField = function(t) {
    Vt([t]), e.issuer.attributes.push(t);
  }, e.issuer.attributes = [], e.issuer.hash = null, e.subject = {}, e.subject.getField = function(t) {
    return Nr(e.subject, t);
  }, e.subject.addField = function(t) {
    Vt([t]), e.subject.attributes.push(t);
  }, e.subject.attributes = [], e.subject.hash = null, e.extensions = [], e.publicKey = null, e.md = null, e.setSubject = function(t, n) {
    Vt(t), e.subject.attributes = t, delete e.subject.uniqueId, n && (e.subject.uniqueId = n), e.subject.hash = null;
  }, e.setIssuer = function(t, n) {
    Vt(t), e.issuer.attributes = t, delete e.issuer.uniqueId, n && (e.issuer.uniqueId = n), e.issuer.hash = null;
  }, e.setExtensions = function(t) {
    for (var n = 0; n < t.length; ++n)
      xc(t[n], { cert: e });
    e.extensions = t;
  }, e.getExtension = function(t) {
    typeof t == "string" && (t = { name: t });
    for (var n = null, r, a = 0; n === null && a < e.extensions.length; ++a)
      r = e.extensions[a], (t.id && r.id === t.id || t.name && r.name === t.name) && (n = r);
    return n;
  }, e.sign = function(t, n) {
    e.md = n || be.md.sha1.create();
    var r = Ke[e.md.algorithm + "WithRSAEncryption"];
    if (!r) {
      var a = new Error("Could not compute certificate digest. Unknown message digest algorithm OID.");
      throw a.algorithm = e.md.algorithm, a;
    }
    e.signatureOid = e.siginfo.algorithmOid = r, e.tbsCertificate = ae.getTBSCertificate(e);
    var s = v.toDer(e.tbsCertificate);
    e.md.update(s.getBytes()), e.signature = t.sign(e.md);
  }, e.verify = function(t) {
    var n = !1;
    if (!e.issued(t)) {
      var r = t.issuer, a = e.subject, s = new Error(
        "The parent certificate did not issue the given child certificate; the child certificate's issuer does not match the parent's subject."
      );
      throw s.expectedIssuer = a.attributes, s.actualIssuer = r.attributes, s;
    }
    var i = t.md;
    if (i === null) {
      i = Da({
        signatureOid: t.signatureOid,
        type: "certificate"
      });
      var o = t.tbsCertificate || ae.getTBSCertificate(t), u = v.toDer(o);
      i.update(u.getBytes());
    }
    return i !== null && (n = bc({
      certificate: e,
      md: i,
      signature: t.signature
    })), n;
  }, e.isIssuer = function(t) {
    var n = !1, r = e.issuer, a = t.subject;
    if (r.hash && a.hash)
      n = r.hash === a.hash;
    else if (r.attributes.length === a.attributes.length) {
      n = !0;
      for (var s, i, o = 0; n && o < r.attributes.length; ++o)
        s = r.attributes[o], i = a.attributes[o], (s.type !== i.type || s.value !== i.value) && (n = !1);
    }
    return n;
  }, e.issued = function(t) {
    return t.isIssuer(e);
  }, e.generateSubjectKeyIdentifier = function() {
    return ae.getPublicKeyFingerprint(e.publicKey, { type: "RSAPublicKey" });
  }, e.verifySubjectKeyIdentifier = function() {
    for (var t = Ke.subjectKeyIdentifier, n = 0; n < e.extensions.length; ++n) {
      var r = e.extensions[n];
      if (r.id === t) {
        var a = e.generateSubjectKeyIdentifier().getBytes();
        return be.util.hexToBytes(r.subjectKeyIdentifier) === a;
      }
    }
    return !1;
  }, e;
};
ae.certificateFromAsn1 = function(e, t) {
  var n = {}, r = [];
  if (!v.validate(e, Wh, n, r)) {
    var a = new Error("Cannot read X.509 certificate. ASN.1 object is not an X509v3 Certificate.");
    throw a.errors = r, a;
  }
  var s = v.derToOid(n.publicKeyOid);
  if (s !== ae.oids.rsaEncryption)
    throw new Error("Cannot read public key. OID is not RSA.");
  var i = ae.createCertificate();
  i.version = n.certVersion ? n.certVersion.charCodeAt(0) : 0;
  var o = be.util.createBuffer(n.certSerialNumber);
  i.serialNumber = o.toHex(), i.signatureOid = be.asn1.derToOid(n.certSignatureOid), i.signatureParameters = ga(
    i.signatureOid,
    n.certSignatureParams,
    !0
  ), i.siginfo.algorithmOid = be.asn1.derToOid(n.certinfoSignatureOid), i.siginfo.parameters = ga(
    i.siginfo.algorithmOid,
    n.certinfoSignatureParams,
    !1
  ), i.signature = n.certSignature;
  var u = [];
  if (n.certValidity1UTCTime !== void 0 && u.push(v.utcTimeToDate(n.certValidity1UTCTime)), n.certValidity2GeneralizedTime !== void 0 && u.push(v.generalizedTimeToDate(
    n.certValidity2GeneralizedTime
  )), n.certValidity3UTCTime !== void 0 && u.push(v.utcTimeToDate(n.certValidity3UTCTime)), n.certValidity4GeneralizedTime !== void 0 && u.push(v.generalizedTimeToDate(
    n.certValidity4GeneralizedTime
  )), u.length > 2)
    throw new Error("Cannot read notBefore/notAfter validity times; more than two times were provided in the certificate.");
  if (u.length < 2)
    throw new Error("Cannot read notBefore/notAfter validity times; they were not provided as either UTCTime or GeneralizedTime.");
  if (i.validity.notBefore = u[0], i.validity.notAfter = u[1], i.tbsCertificate = n.tbsCertificate, t) {
    i.md = Da({
      signatureOid: i.signatureOid,
      type: "certificate"
    });
    var c = v.toDer(i.tbsCertificate);
    i.md.update(c.getBytes());
  }
  var l = be.md.sha1.create(), p = v.toDer(n.certIssuer);
  l.update(p.getBytes()), i.issuer.getField = function(d) {
    return Nr(i.issuer, d);
  }, i.issuer.addField = function(d) {
    Vt([d]), i.issuer.attributes.push(d);
  }, i.issuer.attributes = ae.RDNAttributesAsArray(n.certIssuer), n.certIssuerUniqueId && (i.issuer.uniqueId = n.certIssuerUniqueId), i.issuer.hash = l.digest().toHex();
  var g = be.md.sha1.create(), C = v.toDer(n.certSubject);
  return g.update(C.getBytes()), i.subject.getField = function(d) {
    return Nr(i.subject, d);
  }, i.subject.addField = function(d) {
    Vt([d]), i.subject.attributes.push(d);
  }, i.subject.attributes = ae.RDNAttributesAsArray(n.certSubject), n.certSubjectUniqueId && (i.subject.uniqueId = n.certSubjectUniqueId), i.subject.hash = g.digest().toHex(), n.certExtensions ? i.extensions = ae.certificateExtensionsFromAsn1(n.certExtensions) : i.extensions = [], i.publicKey = ae.publicKeyFromAsn1(n.subjectPublicKeyInfo), i;
};
ae.certificateExtensionsFromAsn1 = function(e) {
  for (var t = [], n = 0; n < e.value.length; ++n)
    for (var r = e.value[n], a = 0; a < r.value.length; ++a)
      t.push(ae.certificateExtensionFromAsn1(r.value[a]));
  return t;
};
ae.certificateExtensionFromAsn1 = function(e) {
  var t = {};
  if (t.id = v.derToOid(e.value[0].value), t.critical = !1, e.value[1].type === v.Type.BOOLEAN ? (t.critical = e.value[1].value.charCodeAt(0) !== 0, t.value = e.value[2].value) : t.value = e.value[1].value, t.id in Ke) {
    if (t.name = Ke[t.id], t.name === "keyUsage") {
      var n = v.fromDer(t.value), r = 0, a = 0;
      n.value.length > 1 && (r = n.value.charCodeAt(1), a = n.value.length > 2 ? n.value.charCodeAt(2) : 0), t.digitalSignature = (r & 128) === 128, t.nonRepudiation = (r & 64) === 64, t.keyEncipherment = (r & 32) === 32, t.dataEncipherment = (r & 16) === 16, t.keyAgreement = (r & 8) === 8, t.keyCertSign = (r & 4) === 4, t.cRLSign = (r & 2) === 2, t.encipherOnly = (r & 1) === 1, t.decipherOnly = (a & 128) === 128;
    } else if (t.name === "basicConstraints") {
      var n = v.fromDer(t.value);
      n.value.length > 0 && n.value[0].type === v.Type.BOOLEAN ? t.cA = n.value[0].value.charCodeAt(0) !== 0 : t.cA = !1;
      var s = null;
      n.value.length > 0 && n.value[0].type === v.Type.INTEGER ? s = n.value[0].value : n.value.length > 1 && (s = n.value[1].value), s !== null && (t.pathLenConstraint = v.derToInteger(s));
    } else if (t.name === "extKeyUsage")
      for (var n = v.fromDer(t.value), i = 0; i < n.value.length; ++i) {
        var o = v.derToOid(n.value[i].value);
        o in Ke ? t[Ke[o]] = !0 : t[o] = !0;
      }
    else if (t.name === "nsCertType") {
      var n = v.fromDer(t.value), r = 0;
      n.value.length > 1 && (r = n.value.charCodeAt(1)), t.client = (r & 128) === 128, t.server = (r & 64) === 64, t.email = (r & 32) === 32, t.objsign = (r & 16) === 16, t.reserved = (r & 8) === 8, t.sslCA = (r & 4) === 4, t.emailCA = (r & 2) === 2, t.objCA = (r & 1) === 1;
    } else if (t.name === "subjectAltName" || t.name === "issuerAltName") {
      t.altNames = [];
      for (var u, n = v.fromDer(t.value), c = 0; c < n.value.length; ++c) {
        u = n.value[c];
        var l = {
          type: u.type,
          value: u.value
        };
        switch (t.altNames.push(l), u.type) {
          case 1:
          case 2:
          case 6:
            break;
          case 7:
            l.ip = be.util.bytesToIP(u.value);
            break;
          case 8:
            l.oid = v.derToOid(u.value);
            break;
        }
      }
    } else if (t.name === "subjectKeyIdentifier") {
      var n = v.fromDer(t.value);
      t.subjectKeyIdentifier = be.util.bytesToHex(n.value);
    }
  }
  return t;
};
ae.certificationRequestFromAsn1 = function(e, t) {
  var n = {}, r = [];
  if (!v.validate(e, Xh, n, r)) {
    var a = new Error("Cannot read PKCS#10 certificate request. ASN.1 object is not a PKCS#10 CertificationRequest.");
    throw a.errors = r, a;
  }
  var s = v.derToOid(n.publicKeyOid);
  if (s !== ae.oids.rsaEncryption)
    throw new Error("Cannot read public key. OID is not RSA.");
  var i = ae.createCertificationRequest();
  if (i.version = n.csrVersion ? n.csrVersion.charCodeAt(0) : 0, i.signatureOid = be.asn1.derToOid(n.csrSignatureOid), i.signatureParameters = ga(
    i.signatureOid,
    n.csrSignatureParams,
    !0
  ), i.siginfo.algorithmOid = be.asn1.derToOid(n.csrSignatureOid), i.siginfo.parameters = ga(
    i.siginfo.algorithmOid,
    n.csrSignatureParams,
    !1
  ), i.signature = n.csrSignature, i.certificationRequestInfo = n.certificationRequestInfo, t) {
    i.md = Da({
      signatureOid: i.signatureOid,
      type: "certification request"
    });
    var o = v.toDer(i.certificationRequestInfo);
    i.md.update(o.getBytes());
  }
  var u = be.md.sha1.create();
  return i.subject.getField = function(c) {
    return Nr(i.subject, c);
  }, i.subject.addField = function(c) {
    Vt([c]), i.subject.attributes.push(c);
  }, i.subject.attributes = ae.RDNAttributesAsArray(
    n.certificationRequestInfoSubject,
    u
  ), i.subject.hash = u.digest().toHex(), i.publicKey = ae.publicKeyFromAsn1(n.subjectPublicKeyInfo), i.getAttribute = function(c) {
    return Nr(i, c);
  }, i.addAttribute = function(c) {
    Vt([c]), i.attributes.push(c);
  }, i.attributes = ae.CRIAttributesAsArray(
    n.certificationRequestInfoAttributes || []
  ), i;
};
ae.createCertificationRequest = function() {
  var e = {};
  return e.version = 0, e.signatureOid = null, e.signature = null, e.siginfo = {}, e.siginfo.algorithmOid = null, e.subject = {}, e.subject.getField = function(t) {
    return Nr(e.subject, t);
  }, e.subject.addField = function(t) {
    Vt([t]), e.subject.attributes.push(t);
  }, e.subject.attributes = [], e.subject.hash = null, e.publicKey = null, e.attributes = [], e.getAttribute = function(t) {
    return Nr(e, t);
  }, e.addAttribute = function(t) {
    Vt([t]), e.attributes.push(t);
  }, e.md = null, e.setSubject = function(t) {
    Vt(t), e.subject.attributes = t, e.subject.hash = null;
  }, e.setAttributes = function(t) {
    Vt(t), e.attributes = t;
  }, e.sign = function(t, n) {
    e.md = n || be.md.sha1.create();
    var r = Ke[e.md.algorithm + "WithRSAEncryption"];
    if (!r) {
      var a = new Error("Could not compute certification request digest. Unknown message digest algorithm OID.");
      throw a.algorithm = e.md.algorithm, a;
    }
    e.signatureOid = e.siginfo.algorithmOid = r, e.certificationRequestInfo = ae.getCertificationRequestInfo(e);
    var s = v.toDer(e.certificationRequestInfo);
    e.md.update(s.getBytes()), e.signature = t.sign(e.md);
  }, e.verify = function() {
    var t = !1, n = e.md;
    if (n === null) {
      n = Da({
        signatureOid: e.signatureOid,
        type: "certification request"
      });
      var r = e.certificationRequestInfo || ae.getCertificationRequestInfo(e), a = v.toDer(r);
      n.update(a.getBytes());
    }
    return n !== null && (t = bc({
      certificate: e,
      md: n,
      signature: e.signature
    })), t;
  }, e;
};
function mn(e) {
  for (var t = v.create(
    v.Class.UNIVERSAL,
    v.Type.SEQUENCE,
    !0,
    []
  ), n, r, a = e.attributes, s = 0; s < a.length; ++s) {
    n = a[s];
    var i = n.value, o = v.Type.PRINTABLESTRING;
    "valueTagClass" in n && (o = n.valueTagClass, o === v.Type.UTF8 && (i = be.util.encodeUtf8(i))), r = v.create(v.Class.UNIVERSAL, v.Type.SET, !0, [
      v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, [
        // AttributeType
        v.create(
          v.Class.UNIVERSAL,
          v.Type.OID,
          !1,
          v.oidToDer(n.type).getBytes()
        ),
        // AttributeValue
        v.create(v.Class.UNIVERSAL, o, !1, i)
      ])
    ]), t.value.push(r);
  }
  return t;
}
function Vt(e) {
  for (var t, n = 0; n < e.length; ++n) {
    if (t = e[n], typeof t.name > "u" && (t.type && t.type in ae.oids ? t.name = ae.oids[t.type] : t.shortName && t.shortName in ut && (t.name = ae.oids[ut[t.shortName]])), typeof t.type > "u")
      if (t.name && t.name in ae.oids)
        t.type = ae.oids[t.name];
      else {
        var r = new Error("Attribute type not specified.");
        throw r.attribute = t, r;
      }
    if (typeof t.shortName > "u" && t.name && t.name in ut && (t.shortName = ut[t.name]), t.type === Ke.extensionRequest && (t.valueConstructed = !0, t.valueTagClass = v.Type.SEQUENCE, !t.value && t.extensions)) {
      t.value = [];
      for (var a = 0; a < t.extensions.length; ++a)
        t.value.push(ae.certificateExtensionToAsn1(
          xc(t.extensions[a])
        ));
    }
    if (typeof t.value > "u") {
      var r = new Error("Attribute value not specified.");
      throw r.attribute = t, r;
    }
  }
}
function xc(e, t) {
  if (t = t || {}, typeof e.name > "u" && e.id && e.id in ae.oids && (e.name = ae.oids[e.id]), typeof e.id > "u")
    if (e.name && e.name in ae.oids)
      e.id = ae.oids[e.name];
    else {
      var n = new Error("Extension ID not specified.");
      throw n.extension = e, n;
    }
  if (typeof e.value < "u")
    return e;
  if (e.name === "keyUsage") {
    var r = 0, a = 0, s = 0;
    e.digitalSignature && (a |= 128, r = 7), e.nonRepudiation && (a |= 64, r = 6), e.keyEncipherment && (a |= 32, r = 5), e.dataEncipherment && (a |= 16, r = 4), e.keyAgreement && (a |= 8, r = 3), e.keyCertSign && (a |= 4, r = 2), e.cRLSign && (a |= 2, r = 1), e.encipherOnly && (a |= 1, r = 0), e.decipherOnly && (s |= 128, r = 7);
    var i = String.fromCharCode(r);
    s !== 0 ? i += String.fromCharCode(a) + String.fromCharCode(s) : a !== 0 && (i += String.fromCharCode(a)), e.value = v.create(
      v.Class.UNIVERSAL,
      v.Type.BITSTRING,
      !1,
      i
    );
  } else if (e.name === "basicConstraints")
    e.value = v.create(
      v.Class.UNIVERSAL,
      v.Type.SEQUENCE,
      !0,
      []
    ), e.cA && e.value.value.push(v.create(
      v.Class.UNIVERSAL,
      v.Type.BOOLEAN,
      !1,
      String.fromCharCode(255)
    )), "pathLenConstraint" in e && e.value.value.push(v.create(
      v.Class.UNIVERSAL,
      v.Type.INTEGER,
      !1,
      v.integerToDer(e.pathLenConstraint).getBytes()
    ));
  else if (e.name === "extKeyUsage") {
    e.value = v.create(
      v.Class.UNIVERSAL,
      v.Type.SEQUENCE,
      !0,
      []
    );
    var o = e.value.value;
    for (var u in e)
      e[u] === !0 && (u in Ke ? o.push(v.create(
        v.Class.UNIVERSAL,
        v.Type.OID,
        !1,
        v.oidToDer(Ke[u]).getBytes()
      )) : u.indexOf(".") !== -1 && o.push(v.create(
        v.Class.UNIVERSAL,
        v.Type.OID,
        !1,
        v.oidToDer(u).getBytes()
      )));
  } else if (e.name === "nsCertType") {
    var r = 0, a = 0;
    e.client && (a |= 128, r = 7), e.server && (a |= 64, r = 6), e.email && (a |= 32, r = 5), e.objsign && (a |= 16, r = 4), e.reserved && (a |= 8, r = 3), e.sslCA && (a |= 4, r = 2), e.emailCA && (a |= 2, r = 1), e.objCA && (a |= 1, r = 0);
    var i = String.fromCharCode(r);
    a !== 0 && (i += String.fromCharCode(a)), e.value = v.create(
      v.Class.UNIVERSAL,
      v.Type.BITSTRING,
      !1,
      i
    );
  } else if (e.name === "subjectAltName" || e.name === "issuerAltName") {
    e.value = v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, []);
    for (var c, l = 0; l < e.altNames.length; ++l) {
      c = e.altNames[l];
      var i = c.value;
      if (c.type === 7 && c.ip) {
        if (i = be.util.bytesFromIP(c.ip), i === null) {
          var n = new Error(
            'Extension "ip" value is not a valid IPv4 or IPv6 address.'
          );
          throw n.extension = e, n;
        }
      } else
        c.type === 8 && (c.oid ? i = v.oidToDer(v.oidToDer(c.oid)) : i = v.oidToDer(i));
      e.value.value.push(v.create(
        v.Class.CONTEXT_SPECIFIC,
        c.type,
        !1,
        i
      ));
    }
  } else if (e.name === "nsComment" && t.cert) {
    if (!/^[\x00-\x7F]*$/.test(e.comment) || e.comment.length < 1 || e.comment.length > 128)
      throw new Error('Invalid "nsComment" content.');
    e.value = v.create(
      v.Class.UNIVERSAL,
      v.Type.IA5STRING,
      !1,
      e.comment
    );
  } else if (e.name === "subjectKeyIdentifier" && t.cert) {
    var p = t.cert.generateSubjectKeyIdentifier();
    e.subjectKeyIdentifier = p.toHex(), e.value = v.create(
      v.Class.UNIVERSAL,
      v.Type.OCTETSTRING,
      !1,
      p.getBytes()
    );
  } else if (e.name === "authorityKeyIdentifier" && t.cert) {
    e.value = v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, []);
    var o = e.value.value;
    if (e.keyIdentifier) {
      var g = e.keyIdentifier === !0 ? t.cert.generateSubjectKeyIdentifier().getBytes() : e.keyIdentifier;
      o.push(
        v.create(v.Class.CONTEXT_SPECIFIC, 0, !1, g)
      );
    }
    if (e.authorityCertIssuer) {
      var C = [
        v.create(v.Class.CONTEXT_SPECIFIC, 4, !0, [
          mn(e.authorityCertIssuer === !0 ? t.cert.issuer : e.authorityCertIssuer)
        ])
      ];
      o.push(
        v.create(v.Class.CONTEXT_SPECIFIC, 1, !0, C)
      );
    }
    if (e.serialNumber) {
      var d = be.util.hexToBytes(e.serialNumber === !0 ? t.cert.serialNumber : e.serialNumber);
      o.push(
        v.create(v.Class.CONTEXT_SPECIFIC, 2, !1, d)
      );
    }
  } else if (e.name === "cRLDistributionPoints") {
    e.value = v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, []);
    for (var o = e.value.value, b = v.create(
      v.Class.UNIVERSAL,
      v.Type.SEQUENCE,
      !0,
      []
    ), S = v.create(
      v.Class.CONTEXT_SPECIFIC,
      0,
      !0,
      []
    ), c, l = 0; l < e.altNames.length; ++l) {
      c = e.altNames[l];
      var i = c.value;
      if (c.type === 7 && c.ip) {
        if (i = be.util.bytesFromIP(c.ip), i === null) {
          var n = new Error(
            'Extension "ip" value is not a valid IPv4 or IPv6 address.'
          );
          throw n.extension = e, n;
        }
      } else
        c.type === 8 && (c.oid ? i = v.oidToDer(v.oidToDer(c.oid)) : i = v.oidToDer(i));
      S.value.push(v.create(
        v.Class.CONTEXT_SPECIFIC,
        c.type,
        !1,
        i
      ));
    }
    b.value.push(v.create(
      v.Class.CONTEXT_SPECIFIC,
      0,
      !0,
      [S]
    )), o.push(b);
  }
  if (typeof e.value > "u") {
    var n = new Error("Extension value not specified.");
    throw n.extension = e, n;
  }
  return e;
}
function Xi(e, t) {
  switch (e) {
    case Ke["RSASSA-PSS"]:
      var n = [];
      return t.hash.algorithmOid !== void 0 && n.push(v.create(v.Class.CONTEXT_SPECIFIC, 0, !0, [
        v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, [
          v.create(
            v.Class.UNIVERSAL,
            v.Type.OID,
            !1,
            v.oidToDer(t.hash.algorithmOid).getBytes()
          ),
          v.create(v.Class.UNIVERSAL, v.Type.NULL, !1, "")
        ])
      ])), t.mgf.algorithmOid !== void 0 && n.push(v.create(v.Class.CONTEXT_SPECIFIC, 1, !0, [
        v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, [
          v.create(
            v.Class.UNIVERSAL,
            v.Type.OID,
            !1,
            v.oidToDer(t.mgf.algorithmOid).getBytes()
          ),
          v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, [
            v.create(
              v.Class.UNIVERSAL,
              v.Type.OID,
              !1,
              v.oidToDer(t.mgf.hash.algorithmOid).getBytes()
            ),
            v.create(v.Class.UNIVERSAL, v.Type.NULL, !1, "")
          ])
        ])
      ])), t.saltLength !== void 0 && n.push(v.create(v.Class.CONTEXT_SPECIFIC, 2, !0, [
        v.create(
          v.Class.UNIVERSAL,
          v.Type.INTEGER,
          !1,
          v.integerToDer(t.saltLength).getBytes()
        )
      ])), v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, n);
    default:
      return v.create(v.Class.UNIVERSAL, v.Type.NULL, !1, "");
  }
}
function Jh(e) {
  var t = v.create(v.Class.CONTEXT_SPECIFIC, 0, !0, []);
  if (e.attributes.length === 0)
    return t;
  for (var n = e.attributes, r = 0; r < n.length; ++r) {
    var a = n[r], s = a.value, i = v.Type.UTF8;
    "valueTagClass" in a && (i = a.valueTagClass), i === v.Type.UTF8 && (s = be.util.encodeUtf8(s));
    var o = !1;
    "valueConstructed" in a && (o = a.valueConstructed);
    var u = v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, [
      // AttributeType
      v.create(
        v.Class.UNIVERSAL,
        v.Type.OID,
        !1,
        v.oidToDer(a.type).getBytes()
      ),
      v.create(v.Class.UNIVERSAL, v.Type.SET, !0, [
        // AttributeValue
        v.create(
          v.Class.UNIVERSAL,
          i,
          o,
          s
        )
      ])
    ]);
    t.value.push(u);
  }
  return t;
}
var Zh = /* @__PURE__ */ new Date("1950-01-01T00:00:00Z"), ed = /* @__PURE__ */ new Date("2050-01-01T00:00:00Z");
function to(e) {
  return e >= Zh && e < ed ? v.create(
    v.Class.UNIVERSAL,
    v.Type.UTCTIME,
    !1,
    v.dateToUtcTime(e)
  ) : v.create(
    v.Class.UNIVERSAL,
    v.Type.GENERALIZEDTIME,
    !1,
    v.dateToGeneralizedTime(e)
  );
}
ae.getTBSCertificate = function(e) {
  var t = to(e.validity.notBefore), n = to(e.validity.notAfter), r = v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, [
    // version
    v.create(v.Class.CONTEXT_SPECIFIC, 0, !0, [
      // integer
      v.create(
        v.Class.UNIVERSAL,
        v.Type.INTEGER,
        !1,
        v.integerToDer(e.version).getBytes()
      )
    ]),
    // serialNumber
    v.create(
      v.Class.UNIVERSAL,
      v.Type.INTEGER,
      !1,
      be.util.hexToBytes(e.serialNumber)
    ),
    // signature
    v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, [
      // algorithm
      v.create(
        v.Class.UNIVERSAL,
        v.Type.OID,
        !1,
        v.oidToDer(e.siginfo.algorithmOid).getBytes()
      ),
      // parameters
      Xi(
        e.siginfo.algorithmOid,
        e.siginfo.parameters
      )
    ]),
    // issuer
    mn(e.issuer),
    // validity
    v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, [
      t,
      n
    ]),
    // subject
    mn(e.subject),
    // SubjectPublicKeyInfo
    ae.publicKeyToAsn1(e.publicKey)
  ]);
  return e.issuer.uniqueId && r.value.push(
    v.create(v.Class.CONTEXT_SPECIFIC, 1, !0, [
      v.create(
        v.Class.UNIVERSAL,
        v.Type.BITSTRING,
        !1,
        // TODO: support arbitrary bit length ids
        String.fromCharCode(0) + e.issuer.uniqueId
      )
    ])
  ), e.subject.uniqueId && r.value.push(
    v.create(v.Class.CONTEXT_SPECIFIC, 2, !0, [
      v.create(
        v.Class.UNIVERSAL,
        v.Type.BITSTRING,
        !1,
        // TODO: support arbitrary bit length ids
        String.fromCharCode(0) + e.subject.uniqueId
      )
    ])
  ), e.extensions.length > 0 && r.value.push(ae.certificateExtensionsToAsn1(e.extensions)), r;
};
ae.getCertificationRequestInfo = function(e) {
  var t = v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, [
    // version
    v.create(
      v.Class.UNIVERSAL,
      v.Type.INTEGER,
      !1,
      v.integerToDer(e.version).getBytes()
    ),
    // subject
    mn(e.subject),
    // SubjectPublicKeyInfo
    ae.publicKeyToAsn1(e.publicKey),
    // attributes
    Jh(e)
  ]);
  return t;
};
ae.distinguishedNameToAsn1 = function(e) {
  return mn(e);
};
ae.certificateToAsn1 = function(e) {
  var t = e.tbsCertificate || ae.getTBSCertificate(e);
  return v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, [
    // TBSCertificate
    t,
    // AlgorithmIdentifier (signature algorithm)
    v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, [
      // algorithm
      v.create(
        v.Class.UNIVERSAL,
        v.Type.OID,
        !1,
        v.oidToDer(e.signatureOid).getBytes()
      ),
      // parameters
      Xi(e.signatureOid, e.signatureParameters)
    ]),
    // SignatureValue
    v.create(
      v.Class.UNIVERSAL,
      v.Type.BITSTRING,
      !1,
      String.fromCharCode(0) + e.signature
    )
  ]);
};
ae.certificateExtensionsToAsn1 = function(e) {
  var t = v.create(v.Class.CONTEXT_SPECIFIC, 3, !0, []), n = v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, []);
  t.value.push(n);
  for (var r = 0; r < e.length; ++r)
    n.value.push(ae.certificateExtensionToAsn1(e[r]));
  return t;
};
ae.certificateExtensionToAsn1 = function(e) {
  var t = v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, []);
  t.value.push(v.create(
    v.Class.UNIVERSAL,
    v.Type.OID,
    !1,
    v.oidToDer(e.id).getBytes()
  )), e.critical && t.value.push(v.create(
    v.Class.UNIVERSAL,
    v.Type.BOOLEAN,
    !1,
    String.fromCharCode(255)
  ));
  var n = e.value;
  return typeof e.value != "string" && (n = v.toDer(n).getBytes()), t.value.push(v.create(
    v.Class.UNIVERSAL,
    v.Type.OCTETSTRING,
    !1,
    n
  )), t;
};
ae.certificationRequestToAsn1 = function(e) {
  var t = e.certificationRequestInfo || ae.getCertificationRequestInfo(e);
  return v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, [
    // CertificationRequestInfo
    t,
    // AlgorithmIdentifier (signature algorithm)
    v.create(v.Class.UNIVERSAL, v.Type.SEQUENCE, !0, [
      // algorithm
      v.create(
        v.Class.UNIVERSAL,
        v.Type.OID,
        !1,
        v.oidToDer(e.signatureOid).getBytes()
      ),
      // parameters
      Xi(e.signatureOid, e.signatureParameters)
    ]),
    // signature
    v.create(
      v.Class.UNIVERSAL,
      v.Type.BITSTRING,
      !1,
      String.fromCharCode(0) + e.signature
    )
  ]);
};
ae.createCaStore = function(e) {
  var t = {
    // stored certificates
    certs: {}
  };
  t.getIssuer = function(i) {
    var o = n(i.issuer);
    return o;
  }, t.addCertificate = function(i) {
    if (typeof i == "string" && (i = be.pki.certificateFromPem(i)), r(i.subject), !t.hasCertificate(i))
      if (i.subject.hash in t.certs) {
        var o = t.certs[i.subject.hash];
        be.util.isArray(o) || (o = [o]), o.push(i), t.certs[i.subject.hash] = o;
      } else
        t.certs[i.subject.hash] = i;
  }, t.hasCertificate = function(i) {
    typeof i == "string" && (i = be.pki.certificateFromPem(i));
    var o = n(i.subject);
    if (!o)
      return !1;
    be.util.isArray(o) || (o = [o]);
    for (var u = v.toDer(ae.certificateToAsn1(i)).getBytes(), c = 0; c < o.length; ++c) {
      var l = v.toDer(ae.certificateToAsn1(o[c])).getBytes();
      if (u === l)
        return !0;
    }
    return !1;
  }, t.listAllCertificates = function() {
    var i = [];
    for (var o in t.certs)
      if (t.certs.hasOwnProperty(o)) {
        var u = t.certs[o];
        if (!be.util.isArray(u))
          i.push(u);
        else
          for (var c = 0; c < u.length; ++c)
            i.push(u[c]);
      }
    return i;
  }, t.removeCertificate = function(i) {
    var o;
    if (typeof i == "string" && (i = be.pki.certificateFromPem(i)), r(i.subject), !t.hasCertificate(i))
      return null;
    var u = n(i.subject);
    if (!be.util.isArray(u))
      return o = t.certs[i.subject.hash], delete t.certs[i.subject.hash], o;
    for (var c = v.toDer(ae.certificateToAsn1(i)).getBytes(), l = 0; l < u.length; ++l) {
      var p = v.toDer(ae.certificateToAsn1(u[l])).getBytes();
      c === p && (o = u[l], u.splice(l, 1));
    }
    return u.length === 0 && delete t.certs[i.subject.hash], o;
  };
  function n(i) {
    return r(i), t.certs[i.hash] || null;
  }
  function r(i) {
    if (!i.hash) {
      var o = be.md.sha1.create();
      i.attributes = ae.RDNAttributesAsArray(mn(i), o), i.hash = o.digest().toHex();
    }
  }
  if (e)
    for (var a = 0; a < e.length; ++a) {
      var s = e[a];
      t.addCertificate(s);
    }
  return t;
};
ae.certificateError = {
  bad_certificate: "forge.pki.BadCertificate",
  unsupported_certificate: "forge.pki.UnsupportedCertificate",
  certificate_revoked: "forge.pki.CertificateRevoked",
  certificate_expired: "forge.pki.CertificateExpired",
  certificate_unknown: "forge.pki.CertificateUnknown",
  unknown_ca: "forge.pki.UnknownCertificateAuthority"
};
ae.verifyCertificateChain = function(e, t, n) {
  typeof n == "function" && (n = { verify: n }), n = n || {}, t = t.slice(0);
  var r = t.slice(0), a = n.validityCheckDate;
  typeof a > "u" && (a = /* @__PURE__ */ new Date());
  var s = !0, i = null, o = 0;
  do {
    var u = t.shift(), c = null, l = !1;
    if (a && (a < u.validity.notBefore || a > u.validity.notAfter) && (i = {
      message: "Certificate is not valid yet or has expired.",
      error: ae.certificateError.certificate_expired,
      notBefore: u.validity.notBefore,
      notAfter: u.validity.notAfter,
      // TODO: we might want to reconsider renaming 'now' to
      // 'validityCheckDate' should this API be changed in the future.
      now: a
    }), i === null) {
      if (c = t[0] || e.getIssuer(u), c === null && u.isIssuer(u) && (l = !0, c = u), c) {
        var p = c;
        be.util.isArray(p) || (p = [p]);
        for (var g = !1; !g && p.length > 0; ) {
          c = p.shift();
          try {
            g = c.verify(u);
          } catch {
          }
        }
        g || (i = {
          message: "Certificate signature is invalid.",
          error: ae.certificateError.bad_certificate
        });
      }
      i === null && (!c || l) && !e.hasCertificate(u) && (i = {
        message: "Certificate is not trusted.",
        error: ae.certificateError.unknown_ca
      });
    }
    if (i === null && c && !u.isIssuer(c) && (i = {
      message: "Certificate issuer is invalid.",
      error: ae.certificateError.bad_certificate
    }), i === null)
      for (var C = {
        keyUsage: !0,
        basicConstraints: !0
      }, d = 0; i === null && d < u.extensions.length; ++d) {
        var b = u.extensions[d];
        b.critical && !(b.name in C) && (i = {
          message: "Certificate has an unsupported critical extension.",
          error: ae.certificateError.unsupported_certificate
        });
      }
    if (i === null && (!s || t.length === 0 && (!c || l))) {
      var S = u.getExtension("basicConstraints"), A = u.getExtension("keyUsage");
      if (A !== null && (!A.keyCertSign || S === null) && (i = {
        message: "Certificate keyUsage or basicConstraints conflict or indicate that the certificate is not a CA. If the certificate is the only one in the chain or isn't the first then the certificate must be a valid CA.",
        error: ae.certificateError.bad_certificate
      }), i === null && S !== null && !S.cA && (i = {
        message: "Certificate basicConstraints indicates the certificate is not a CA.",
        error: ae.certificateError.bad_certificate
      }), i === null && A !== null && "pathLenConstraint" in S) {
        var D = o - 1;
        D > S.pathLenConstraint && (i = {
          message: "Certificate basicConstraints pathLenConstraint violated.",
          error: ae.certificateError.bad_certificate
        });
      }
    }
    var _ = i === null ? !0 : i.error, M = n.verify ? n.verify(_, o, r) : _;
    if (M === !0)
      i = null;
    else
      throw _ === !0 && (i = {
        message: "The application rejected the certificate.",
        error: ae.certificateError.bad_certificate
      }), (M || M === 0) && (typeof M == "object" && !be.util.isArray(M) ? (M.message && (i.message = M.message), M.error && (i.error = M.error)) : typeof M == "string" && (i.error = M)), i;
    s = !1, ++o;
  } while (t.length > 0);
  return !0;
};
var et = De, B = et.asn1, ke = et.pki, Hn = et.pkcs12 = et.pkcs12 || {}, Tc = {
  name: "ContentInfo",
  tagClass: B.Class.UNIVERSAL,
  type: B.Type.SEQUENCE,
  // a ContentInfo
  constructed: !0,
  value: [{
    name: "ContentInfo.contentType",
    tagClass: B.Class.UNIVERSAL,
    type: B.Type.OID,
    constructed: !1,
    capture: "contentType"
  }, {
    name: "ContentInfo.content",
    tagClass: B.Class.CONTEXT_SPECIFIC,
    constructed: !0,
    captureAsn1: "content"
  }]
}, td = {
  name: "PFX",
  tagClass: B.Class.UNIVERSAL,
  type: B.Type.SEQUENCE,
  constructed: !0,
  value: [
    {
      name: "PFX.version",
      tagClass: B.Class.UNIVERSAL,
      type: B.Type.INTEGER,
      constructed: !1,
      capture: "version"
    },
    Tc,
    {
      name: "PFX.macData",
      tagClass: B.Class.UNIVERSAL,
      type: B.Type.SEQUENCE,
      constructed: !0,
      optional: !0,
      captureAsn1: "mac",
      value: [{
        name: "PFX.macData.mac",
        tagClass: B.Class.UNIVERSAL,
        type: B.Type.SEQUENCE,
        // DigestInfo
        constructed: !0,
        value: [{
          name: "PFX.macData.mac.digestAlgorithm",
          tagClass: B.Class.UNIVERSAL,
          type: B.Type.SEQUENCE,
          // DigestAlgorithmIdentifier
          constructed: !0,
          value: [{
            name: "PFX.macData.mac.digestAlgorithm.algorithm",
            tagClass: B.Class.UNIVERSAL,
            type: B.Type.OID,
            constructed: !1,
            capture: "macAlgorithm"
          }, {
            name: "PFX.macData.mac.digestAlgorithm.parameters",
            tagClass: B.Class.UNIVERSAL,
            captureAsn1: "macAlgorithmParameters"
          }]
        }, {
          name: "PFX.macData.mac.digest",
          tagClass: B.Class.UNIVERSAL,
          type: B.Type.OCTETSTRING,
          constructed: !1,
          capture: "macDigest"
        }]
      }, {
        name: "PFX.macData.macSalt",
        tagClass: B.Class.UNIVERSAL,
        type: B.Type.OCTETSTRING,
        constructed: !1,
        capture: "macSalt"
      }, {
        name: "PFX.macData.iterations",
        tagClass: B.Class.UNIVERSAL,
        type: B.Type.INTEGER,
        constructed: !1,
        optional: !0,
        capture: "macIterations"
      }]
    }
  ]
}, rd = {
  name: "SafeBag",
  tagClass: B.Class.UNIVERSAL,
  type: B.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "SafeBag.bagId",
    tagClass: B.Class.UNIVERSAL,
    type: B.Type.OID,
    constructed: !1,
    capture: "bagId"
  }, {
    name: "SafeBag.bagValue",
    tagClass: B.Class.CONTEXT_SPECIFIC,
    constructed: !0,
    captureAsn1: "bagValue"
  }, {
    name: "SafeBag.bagAttributes",
    tagClass: B.Class.UNIVERSAL,
    type: B.Type.SET,
    constructed: !0,
    optional: !0,
    capture: "bagAttributes"
  }]
}, nd = {
  name: "Attribute",
  tagClass: B.Class.UNIVERSAL,
  type: B.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "Attribute.attrId",
    tagClass: B.Class.UNIVERSAL,
    type: B.Type.OID,
    constructed: !1,
    capture: "oid"
  }, {
    name: "Attribute.attrValues",
    tagClass: B.Class.UNIVERSAL,
    type: B.Type.SET,
    constructed: !0,
    capture: "values"
  }]
}, ad = {
  name: "CertBag",
  tagClass: B.Class.UNIVERSAL,
  type: B.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "CertBag.certId",
    tagClass: B.Class.UNIVERSAL,
    type: B.Type.OID,
    constructed: !1,
    capture: "certId"
  }, {
    name: "CertBag.certValue",
    tagClass: B.Class.CONTEXT_SPECIFIC,
    constructed: !0,
    /* So far we only support X.509 certificates (which are wrapped in
       an OCTET STRING, hence hard code that here). */
    value: [{
      name: "CertBag.certValue[0]",
      tagClass: B.Class.UNIVERSAL,
      type: B.Class.OCTETSTRING,
      constructed: !1,
      capture: "cert"
    }]
  }]
};
function Ln(e, t, n, r) {
  for (var a = [], s = 0; s < e.length; s++)
    for (var i = 0; i < e[s].safeBags.length; i++) {
      var o = e[s].safeBags[i];
      if (!(r !== void 0 && o.type !== r)) {
        if (t === null) {
          a.push(o);
          continue;
        }
        o.attributes[t] !== void 0 && o.attributes[t].indexOf(n) >= 0 && a.push(o);
      }
    }
  return a;
}
Hn.pkcs12FromAsn1 = function(e, t, n) {
  typeof t == "string" ? (n = t, t = !0) : t === void 0 && (t = !0);
  var r = {}, a = [];
  if (!B.validate(e, td, r, a)) {
    var s = new Error("Cannot read PKCS#12 PFX. ASN.1 object is not an PKCS#12 PFX.");
    throw s.errors = s, s;
  }
  var i = {
    version: r.version.charCodeAt(0),
    safeContents: [],
    /**
     * Gets bags with matching attributes.
     *
     * @param filter the attributes to filter by:
     *          [localKeyId] the localKeyId to search for.
     *          [localKeyIdHex] the localKeyId in hex to search for.
     *          [friendlyName] the friendly name to search for.
     *          [bagType] bag type to narrow each attribute search by.
     *
     * @return a map of attribute type to an array of matching bags or, if no
     *           attribute was given but a bag type, the map key will be the
     *           bag type.
     */
    getBags: function(S) {
      var A = {}, D;
      return "localKeyId" in S ? D = S.localKeyId : "localKeyIdHex" in S && (D = et.util.hexToBytes(S.localKeyIdHex)), D === void 0 && !("friendlyName" in S) && "bagType" in S && (A[S.bagType] = Ln(
        i.safeContents,
        null,
        null,
        S.bagType
      )), D !== void 0 && (A.localKeyId = Ln(
        i.safeContents,
        "localKeyId",
        D,
        S.bagType
      )), "friendlyName" in S && (A.friendlyName = Ln(
        i.safeContents,
        "friendlyName",
        S.friendlyName,
        S.bagType
      )), A;
    },
    /**
     * DEPRECATED: use getBags() instead.
     *
     * Get bags with matching friendlyName attribute.
     *
     * @param friendlyName the friendly name to search for.
     * @param [bagType] bag type to narrow search by.
     *
     * @return an array of bags with matching friendlyName attribute.
     */
    getBagsByFriendlyName: function(S, A) {
      return Ln(
        i.safeContents,
        "friendlyName",
        S,
        A
      );
    },
    /**
     * DEPRECATED: use getBags() instead.
     *
     * Get bags with matching localKeyId attribute.
     *
     * @param localKeyId the localKeyId to search for.
     * @param [bagType] bag type to narrow search by.
     *
     * @return an array of bags with matching localKeyId attribute.
     */
    getBagsByLocalKeyId: function(S, A) {
      return Ln(
        i.safeContents,
        "localKeyId",
        S,
        A
      );
    }
  };
  if (r.version.charCodeAt(0) !== 3) {
    var s = new Error("PKCS#12 PFX of version other than 3 not supported.");
    throw s.version = r.version.charCodeAt(0), s;
  }
  if (B.derToOid(r.contentType) !== ke.oids.data) {
    var s = new Error("Only PKCS#12 PFX in password integrity mode supported.");
    throw s.oid = B.derToOid(r.contentType), s;
  }
  var o = r.content.value[0];
  if (o.tagClass !== B.Class.UNIVERSAL || o.type !== B.Type.OCTETSTRING)
    throw new Error("PKCS#12 authSafe content data is not an OCTET STRING.");
  if (o = Ji(o), r.mac) {
    var u = null, c = 0, l = B.derToOid(r.macAlgorithm);
    switch (l) {
      case ke.oids.sha1:
        u = et.md.sha1.create(), c = 20;
        break;
      case ke.oids.sha256:
        u = et.md.sha256.create(), c = 32;
        break;
      case ke.oids.sha384:
        u = et.md.sha384.create(), c = 48;
        break;
      case ke.oids.sha512:
        u = et.md.sha512.create(), c = 64;
        break;
      case ke.oids.md5:
        u = et.md.md5.create(), c = 16;
        break;
    }
    if (u === null)
      throw new Error("PKCS#12 uses unsupported MAC algorithm: " + l);
    var p = new et.util.ByteBuffer(r.macSalt), g = "macIterations" in r ? parseInt(et.util.bytesToHex(r.macIterations), 16) : 1, C = Hn.generateKey(
      n,
      p,
      3,
      g,
      c,
      u
    ), d = et.hmac.create();
    d.start(u, C), d.update(o.value);
    var b = d.getMac();
    if (b.getBytes() !== r.macDigest)
      throw new Error("PKCS#12 MAC could not be verified. Invalid password?");
  }
  return id(i, o.value, t, n), i;
};
function Ji(e) {
  if (e.composed || e.constructed) {
    for (var t = et.util.createBuffer(), n = 0; n < e.value.length; ++n)
      t.putBytes(e.value[n].value);
    e.composed = e.constructed = !1, e.value = t.getBytes();
  }
  return e;
}
function id(e, t, n, r) {
  if (t = B.fromDer(t, n), t.tagClass !== B.Class.UNIVERSAL || t.type !== B.Type.SEQUENCE || t.constructed !== !0)
    throw new Error("PKCS#12 AuthenticatedSafe expected to be a SEQUENCE OF ContentInfo");
  for (var a = 0; a < t.value.length; a++) {
    var s = t.value[a], i = {}, o = [];
    if (!B.validate(s, Tc, i, o)) {
      var u = new Error("Cannot read ContentInfo.");
      throw u.errors = o, u;
    }
    var c = {
      encrypted: !1
    }, l = null, p = i.content.value[0];
    switch (B.derToOid(i.contentType)) {
      case ke.oids.data:
        if (p.tagClass !== B.Class.UNIVERSAL || p.type !== B.Type.OCTETSTRING)
          throw new Error("PKCS#12 SafeContents Data is not an OCTET STRING.");
        l = Ji(p).value;
        break;
      case ke.oids.encryptedData:
        l = sd(p, r), c.encrypted = !0;
        break;
      default:
        var u = new Error("Unsupported PKCS#12 contentType.");
        throw u.contentType = B.derToOid(i.contentType), u;
    }
    c.safeBags = od(l, n, r), e.safeContents.push(c);
  }
}
function sd(e, t) {
  var n = {}, r = [];
  if (!B.validate(
    e,
    et.pkcs7.asn1.encryptedDataValidator,
    n,
    r
  )) {
    var a = new Error("Cannot read EncryptedContentInfo.");
    throw a.errors = r, a;
  }
  var s = B.derToOid(n.contentType);
  if (s !== ke.oids.data) {
    var a = new Error(
      "PKCS#12 EncryptedContentInfo ContentType is not Data."
    );
    throw a.oid = s, a;
  }
  s = B.derToOid(n.encAlgorithm);
  var i = ke.pbe.getCipher(s, n.encParameter, t), o = Ji(n.encryptedContentAsn1), u = et.util.createBuffer(o.value);
  if (i.update(u), !i.finish())
    throw new Error("Failed to decrypt PKCS#12 SafeContents.");
  return i.output.getBytes();
}
function od(e, t, n) {
  if (!t && e.length === 0)
    return [];
  if (e = B.fromDer(e, t), e.tagClass !== B.Class.UNIVERSAL || e.type !== B.Type.SEQUENCE || e.constructed !== !0)
    throw new Error(
      "PKCS#12 SafeContents expected to be a SEQUENCE OF SafeBag."
    );
  for (var r = [], a = 0; a < e.value.length; a++) {
    var s = e.value[a], i = {}, o = [];
    if (!B.validate(s, rd, i, o)) {
      var u = new Error("Cannot read SafeBag.");
      throw u.errors = o, u;
    }
    var c = {
      type: B.derToOid(i.bagId),
      attributes: cd(i.bagAttributes)
    };
    r.push(c);
    var l, p, g = i.bagValue.value[0];
    switch (c.type) {
      case ke.oids.pkcs8ShroudedKeyBag:
        if (g = ke.decryptPrivateKeyInfo(g, n), g === null)
          throw new Error(
            "Unable to decrypt PKCS#8 ShroudedKeyBag, wrong password?"
          );
      case ke.oids.keyBag:
        try {
          c.key = ke.privateKeyFromAsn1(g);
        } catch {
          c.key = null, c.asn1 = g;
        }
        continue;
      case ke.oids.certBag:
        l = ad, p = function() {
          if (B.derToOid(i.certId) !== ke.oids.x509Certificate) {
            var d = new Error(
              "Unsupported certificate type, only X.509 supported."
            );
            throw d.oid = B.derToOid(i.certId), d;
          }
          var b = B.fromDer(i.cert, t);
          try {
            c.cert = ke.certificateFromAsn1(b, !0);
          } catch {
            c.cert = null, c.asn1 = b;
          }
        };
        break;
      default:
        var u = new Error("Unsupported PKCS#12 SafeBag type.");
        throw u.oid = c.type, u;
    }
    if (l !== void 0 && !B.validate(g, l, i, o)) {
      var u = new Error("Cannot read PKCS#12 " + l.name);
      throw u.errors = o, u;
    }
    p();
  }
  return r;
}
function cd(e) {
  var t = {};
  if (e !== void 0)
    for (var n = 0; n < e.length; ++n) {
      var r = {}, a = [];
      if (!B.validate(e[n], nd, r, a)) {
        var s = new Error("Cannot read PKCS#12 BagAttribute.");
        throw s.errors = a, s;
      }
      var i = B.derToOid(r.oid);
      if (ke.oids[i] !== void 0) {
        t[ke.oids[i]] = [];
        for (var o = 0; o < r.values.length; ++o)
          t[ke.oids[i]].push(r.values[o].value);
      }
    }
  return t;
}
Hn.toPkcs12Asn1 = function(e, t, n, r) {
  r = r || {}, r.saltSize = r.saltSize || 8, r.count = r.count || 2048, r.algorithm = r.algorithm || r.encAlgorithm || "aes128", "useMac" in r || (r.useMac = !0), "localKeyId" in r || (r.localKeyId = null), "generateLocalKeyId" in r || (r.generateLocalKeyId = !0);
  var a = r.localKeyId, s;
  if (a !== null)
    a = et.util.hexToBytes(a);
  else if (r.generateLocalKeyId)
    if (t) {
      var i = et.util.isArray(t) ? t[0] : t;
      typeof i == "string" && (i = ke.certificateFromPem(i));
      var o = et.md.sha1.create();
      o.update(B.toDer(ke.certificateToAsn1(i)).getBytes()), a = o.digest().getBytes();
    } else
      a = et.random.getBytes(20);
  var u = [];
  a !== null && u.push(
    // localKeyID
    B.create(B.Class.UNIVERSAL, B.Type.SEQUENCE, !0, [
      // attrId
      B.create(
        B.Class.UNIVERSAL,
        B.Type.OID,
        !1,
        B.oidToDer(ke.oids.localKeyId).getBytes()
      ),
      // attrValues
      B.create(B.Class.UNIVERSAL, B.Type.SET, !0, [
        B.create(
          B.Class.UNIVERSAL,
          B.Type.OCTETSTRING,
          !1,
          a
        )
      ])
    ])
  ), "friendlyName" in r && u.push(
    // friendlyName
    B.create(B.Class.UNIVERSAL, B.Type.SEQUENCE, !0, [
      // attrId
      B.create(
        B.Class.UNIVERSAL,
        B.Type.OID,
        !1,
        B.oidToDer(ke.oids.friendlyName).getBytes()
      ),
      // attrValues
      B.create(B.Class.UNIVERSAL, B.Type.SET, !0, [
        B.create(
          B.Class.UNIVERSAL,
          B.Type.BMPSTRING,
          !1,
          r.friendlyName
        )
      ])
    ])
  ), u.length > 0 && (s = B.create(B.Class.UNIVERSAL, B.Type.SET, !0, u));
  var c = [], l = [];
  t !== null && (et.util.isArray(t) ? l = t : l = [t]);
  for (var p = [], g = 0; g < l.length; ++g) {
    t = l[g], typeof t == "string" && (t = ke.certificateFromPem(t));
    var C = g === 0 ? s : void 0, d = ke.certificateToAsn1(t), b = B.create(B.Class.UNIVERSAL, B.Type.SEQUENCE, !0, [
      // bagId
      B.create(
        B.Class.UNIVERSAL,
        B.Type.OID,
        !1,
        B.oidToDer(ke.oids.certBag).getBytes()
      ),
      // bagValue
      B.create(B.Class.CONTEXT_SPECIFIC, 0, !0, [
        // CertBag
        B.create(B.Class.UNIVERSAL, B.Type.SEQUENCE, !0, [
          // certId
          B.create(
            B.Class.UNIVERSAL,
            B.Type.OID,
            !1,
            B.oidToDer(ke.oids.x509Certificate).getBytes()
          ),
          // certValue (x509Certificate)
          B.create(B.Class.CONTEXT_SPECIFIC, 0, !0, [
            B.create(
              B.Class.UNIVERSAL,
              B.Type.OCTETSTRING,
              !1,
              B.toDer(d).getBytes()
            )
          ])
        ])
      ]),
      // bagAttributes (OPTIONAL)
      C
    ]);
    p.push(b);
  }
  if (p.length > 0) {
    var S = B.create(
      B.Class.UNIVERSAL,
      B.Type.SEQUENCE,
      !0,
      p
    ), A = (
      // PKCS#7 ContentInfo
      B.create(B.Class.UNIVERSAL, B.Type.SEQUENCE, !0, [
        // contentType
        B.create(
          B.Class.UNIVERSAL,
          B.Type.OID,
          !1,
          // OID for the content type is 'data'
          B.oidToDer(ke.oids.data).getBytes()
        ),
        // content
        B.create(B.Class.CONTEXT_SPECIFIC, 0, !0, [
          B.create(
            B.Class.UNIVERSAL,
            B.Type.OCTETSTRING,
            !1,
            B.toDer(S).getBytes()
          )
        ])
      ])
    );
    c.push(A);
  }
  var D = null;
  if (e !== null) {
    var _ = ke.wrapRsaPrivateKey(ke.privateKeyToAsn1(e));
    n === null ? D = B.create(B.Class.UNIVERSAL, B.Type.SEQUENCE, !0, [
      // bagId
      B.create(
        B.Class.UNIVERSAL,
        B.Type.OID,
        !1,
        B.oidToDer(ke.oids.keyBag).getBytes()
      ),
      // bagValue
      B.create(B.Class.CONTEXT_SPECIFIC, 0, !0, [
        // PrivateKeyInfo
        _
      ]),
      // bagAttributes (OPTIONAL)
      s
    ]) : D = B.create(B.Class.UNIVERSAL, B.Type.SEQUENCE, !0, [
      // bagId
      B.create(
        B.Class.UNIVERSAL,
        B.Type.OID,
        !1,
        B.oidToDer(ke.oids.pkcs8ShroudedKeyBag).getBytes()
      ),
      // bagValue
      B.create(B.Class.CONTEXT_SPECIFIC, 0, !0, [
        // EncryptedPrivateKeyInfo
        ke.encryptPrivateKeyInfo(_, n, r)
      ]),
      // bagAttributes (OPTIONAL)
      s
    ]);
    var M = B.create(B.Class.UNIVERSAL, B.Type.SEQUENCE, !0, [D]), K = (
      // PKCS#7 ContentInfo
      B.create(B.Class.UNIVERSAL, B.Type.SEQUENCE, !0, [
        // contentType
        B.create(
          B.Class.UNIVERSAL,
          B.Type.OID,
          !1,
          // OID for the content type is 'data'
          B.oidToDer(ke.oids.data).getBytes()
        ),
        // content
        B.create(B.Class.CONTEXT_SPECIFIC, 0, !0, [
          B.create(
            B.Class.UNIVERSAL,
            B.Type.OCTETSTRING,
            !1,
            B.toDer(M).getBytes()
          )
        ])
      ])
    );
    c.push(K);
  }
  var k = B.create(
    B.Class.UNIVERSAL,
    B.Type.SEQUENCE,
    !0,
    c
  ), J;
  if (r.useMac) {
    var o = et.md.sha1.create(), re = new et.util.ByteBuffer(
      et.random.getBytes(r.saltSize)
    ), G = r.count, e = Hn.generateKey(n, re, 3, G, 20), $ = et.hmac.create();
    $.start(o, e), $.update(B.toDer(k).getBytes());
    var ue = $.getMac();
    J = B.create(B.Class.UNIVERSAL, B.Type.SEQUENCE, !0, [
      // mac DigestInfo
      B.create(B.Class.UNIVERSAL, B.Type.SEQUENCE, !0, [
        // digestAlgorithm
        B.create(B.Class.UNIVERSAL, B.Type.SEQUENCE, !0, [
          // algorithm = SHA-1
          B.create(
            B.Class.UNIVERSAL,
            B.Type.OID,
            !1,
            B.oidToDer(ke.oids.sha1).getBytes()
          ),
          // parameters = Null
          B.create(B.Class.UNIVERSAL, B.Type.NULL, !1, "")
        ]),
        // digest
        B.create(
          B.Class.UNIVERSAL,
          B.Type.OCTETSTRING,
          !1,
          ue.getBytes()
        )
      ]),
      // macSalt OCTET STRING
      B.create(
        B.Class.UNIVERSAL,
        B.Type.OCTETSTRING,
        !1,
        re.getBytes()
      ),
      // iterations INTEGER (XXX: Only support count < 65536)
      B.create(
        B.Class.UNIVERSAL,
        B.Type.INTEGER,
        !1,
        B.integerToDer(G).getBytes()
      )
    ]);
  }
  return B.create(B.Class.UNIVERSAL, B.Type.SEQUENCE, !0, [
    // version (3)
    B.create(
      B.Class.UNIVERSAL,
      B.Type.INTEGER,
      !1,
      B.integerToDer(3).getBytes()
    ),
    // PKCS#7 ContentInfo
    B.create(B.Class.UNIVERSAL, B.Type.SEQUENCE, !0, [
      // contentType
      B.create(
        B.Class.UNIVERSAL,
        B.Type.OID,
        !1,
        // OID for the content type is 'data'
        B.oidToDer(ke.oids.data).getBytes()
      ),
      // content
      B.create(B.Class.CONTEXT_SPECIFIC, 0, !0, [
        B.create(
          B.Class.UNIVERSAL,
          B.Type.OCTETSTRING,
          !1,
          B.toDer(k).getBytes()
        )
      ])
    ]),
    J
  ]);
};
Hn.generateKey = et.pbe.generatePkcs12Key;
var Rr = De, Zi = Rr.asn1, En = Rr.pki = Rr.pki || {};
En.pemToDer = function(e) {
  var t = Rr.pem.decode(e)[0];
  if (t.procType && t.procType.type === "ENCRYPTED")
    throw new Error("Could not convert PEM to DER; PEM is encrypted.");
  return Rr.util.createBuffer(t.body);
};
En.privateKeyFromPem = function(e) {
  var t = Rr.pem.decode(e)[0];
  if (t.type !== "PRIVATE KEY" && t.type !== "RSA PRIVATE KEY") {
    var n = new Error('Could not convert private key from PEM; PEM header type is not "PRIVATE KEY" or "RSA PRIVATE KEY".');
    throw n.headerType = t.type, n;
  }
  if (t.procType && t.procType.type === "ENCRYPTED")
    throw new Error("Could not convert private key from PEM; PEM is encrypted.");
  var r = Zi.fromDer(t.body);
  return En.privateKeyFromAsn1(r);
};
En.privateKeyToPem = function(e, t) {
  var n = {
    type: "RSA PRIVATE KEY",
    body: Zi.toDer(En.privateKeyToAsn1(e)).getBytes()
  };
  return Rr.pem.encode(n, { maxline: t });
};
En.privateKeyInfoToPem = function(e, t) {
  var n = {
    type: "PRIVATE KEY",
    body: Zi.toDer(e).getBytes()
  };
  return Rr.pem.encode(n, { maxline: t });
};
var z = De, ka = function(e, t, n, r) {
  var a = z.util.createBuffer(), s = e.length >> 1, i = s + (e.length & 1), o = e.substr(0, i), u = e.substr(s, i), c = z.util.createBuffer(), l = z.hmac.create();
  n = t + n;
  var p = Math.ceil(r / 16), g = Math.ceil(r / 20);
  l.start("MD5", o);
  var C = z.util.createBuffer();
  c.putBytes(n);
  for (var d = 0; d < p; ++d)
    l.start(null, null), l.update(c.getBytes()), c.putBuffer(l.digest()), l.start(null, null), l.update(c.bytes() + n), C.putBuffer(l.digest());
  l.start("SHA1", u);
  var b = z.util.createBuffer();
  c.clear(), c.putBytes(n);
  for (var d = 0; d < g; ++d)
    l.start(null, null), l.update(c.getBytes()), c.putBuffer(l.digest()), l.start(null, null), l.update(c.bytes() + n), b.putBuffer(l.digest());
  return a.putBytes(z.util.xorBytes(
    C.getBytes(),
    b.getBytes(),
    r
  )), a;
}, ud = function(e, t, n) {
  var r = z.hmac.create();
  r.start("SHA1", e);
  var a = z.util.createBuffer();
  return a.putInt32(t[0]), a.putInt32(t[1]), a.putByte(n.type), a.putByte(n.version.major), a.putByte(n.version.minor), a.putInt16(n.length), a.putBytes(n.fragment.bytes()), r.update(a.getBytes()), r.digest().getBytes();
}, ld = function(e, t, n) {
  var r = !1;
  try {
    var a = e.deflate(t.fragment.getBytes());
    t.fragment = z.util.createBuffer(a), t.length = a.length, r = !0;
  } catch {
  }
  return r;
}, fd = function(e, t, n) {
  var r = !1;
  try {
    var a = e.inflate(t.fragment.getBytes());
    t.fragment = z.util.createBuffer(a), t.length = a.length, r = !0;
  } catch {
  }
  return r;
}, Rt = function(e, t) {
  var n = 0;
  switch (t) {
    case 1:
      n = e.getByte();
      break;
    case 2:
      n = e.getInt16();
      break;
    case 3:
      n = e.getInt24();
      break;
    case 4:
      n = e.getInt32();
      break;
  }
  return z.util.createBuffer(e.getBytes(n));
}, Pt = function(e, t, n) {
  e.putInt(n.length(), t << 3), e.putBuffer(n);
}, E = {};
E.Versions = {
  TLS_1_0: { major: 3, minor: 1 },
  TLS_1_1: { major: 3, minor: 2 },
  TLS_1_2: { major: 3, minor: 3 }
};
E.SupportedVersions = [
  E.Versions.TLS_1_1,
  E.Versions.TLS_1_0
];
E.Version = E.SupportedVersions[0];
E.MaxFragment = 16384 - 1024;
E.ConnectionEnd = {
  server: 0,
  client: 1
};
E.PRFAlgorithm = {
  tls_prf_sha256: 0
};
E.BulkCipherAlgorithm = {
  none: null,
  rc4: 0,
  des3: 1,
  aes: 2
};
E.CipherType = {
  stream: 0,
  block: 1,
  aead: 2
};
E.MACAlgorithm = {
  none: null,
  hmac_md5: 0,
  hmac_sha1: 1,
  hmac_sha256: 2,
  hmac_sha384: 3,
  hmac_sha512: 4
};
E.CompressionMethod = {
  none: 0,
  deflate: 1
};
E.ContentType = {
  change_cipher_spec: 20,
  alert: 21,
  handshake: 22,
  application_data: 23,
  heartbeat: 24
};
E.HandshakeType = {
  hello_request: 0,
  client_hello: 1,
  server_hello: 2,
  certificate: 11,
  server_key_exchange: 12,
  certificate_request: 13,
  server_hello_done: 14,
  certificate_verify: 15,
  client_key_exchange: 16,
  finished: 20
};
E.Alert = {};
E.Alert.Level = {
  warning: 1,
  fatal: 2
};
E.Alert.Description = {
  close_notify: 0,
  unexpected_message: 10,
  bad_record_mac: 20,
  decryption_failed: 21,
  record_overflow: 22,
  decompression_failure: 30,
  handshake_failure: 40,
  bad_certificate: 42,
  unsupported_certificate: 43,
  certificate_revoked: 44,
  certificate_expired: 45,
  certificate_unknown: 46,
  illegal_parameter: 47,
  unknown_ca: 48,
  access_denied: 49,
  decode_error: 50,
  decrypt_error: 51,
  export_restriction: 60,
  protocol_version: 70,
  insufficient_security: 71,
  internal_error: 80,
  user_canceled: 90,
  no_renegotiation: 100
};
E.HeartbeatMessageType = {
  heartbeat_request: 1,
  heartbeat_response: 2
};
E.CipherSuites = {};
E.getCipherSuite = function(e) {
  var t = null;
  for (var n in E.CipherSuites) {
    var r = E.CipherSuites[n];
    if (r.id[0] === e.charCodeAt(0) && r.id[1] === e.charCodeAt(1)) {
      t = r;
      break;
    }
  }
  return t;
};
E.handleUnexpected = function(e, t) {
  var n = !e.open && e.entity === E.ConnectionEnd.client;
  n || e.error(e, {
    message: "Unexpected message. Received TLS record out of order.",
    send: !0,
    alert: {
      level: E.Alert.Level.fatal,
      description: E.Alert.Description.unexpected_message
    }
  });
};
E.handleHelloRequest = function(e, t, n) {
  !e.handshaking && e.handshakes > 0 && (E.queue(e, E.createAlert(e, {
    level: E.Alert.Level.warning,
    description: E.Alert.Description.no_renegotiation
  })), E.flush(e)), e.process();
};
E.parseHelloMessage = function(e, t, n) {
  var r = null, a = e.entity === E.ConnectionEnd.client;
  if (n < 38)
    e.error(e, {
      message: a ? "Invalid ServerHello message. Message too short." : "Invalid ClientHello message. Message too short.",
      send: !0,
      alert: {
        level: E.Alert.Level.fatal,
        description: E.Alert.Description.illegal_parameter
      }
    });
  else {
    var s = t.fragment, i = s.length();
    if (r = {
      version: {
        major: s.getByte(),
        minor: s.getByte()
      },
      random: z.util.createBuffer(s.getBytes(32)),
      session_id: Rt(s, 1),
      extensions: []
    }, a ? (r.cipher_suite = s.getBytes(2), r.compression_method = s.getByte()) : (r.cipher_suites = Rt(s, 2), r.compression_methods = Rt(s, 1)), i = n - (i - s.length()), i > 0) {
      for (var o = Rt(s, 2); o.length() > 0; )
        r.extensions.push({
          type: [o.getByte(), o.getByte()],
          data: Rt(o, 2)
        });
      if (!a)
        for (var u = 0; u < r.extensions.length; ++u) {
          var c = r.extensions[u];
          if (c.type[0] === 0 && c.type[1] === 0)
            for (var l = Rt(c.data, 2); l.length() > 0; ) {
              var p = l.getByte();
              if (p !== 0)
                break;
              e.session.extensions.server_name.serverNameList.push(
                Rt(l, 2).getBytes()
              );
            }
        }
    }
    if (e.session.version && (r.version.major !== e.session.version.major || r.version.minor !== e.session.version.minor))
      return e.error(e, {
        message: "TLS version change is disallowed during renegotiation.",
        send: !0,
        alert: {
          level: E.Alert.Level.fatal,
          description: E.Alert.Description.protocol_version
        }
      });
    if (a)
      e.session.cipherSuite = E.getCipherSuite(r.cipher_suite);
    else
      for (var g = z.util.createBuffer(r.cipher_suites.bytes()); g.length() > 0 && (e.session.cipherSuite = E.getCipherSuite(g.getBytes(2)), e.session.cipherSuite === null); )
        ;
    if (e.session.cipherSuite === null)
      return e.error(e, {
        message: "No cipher suites in common.",
        send: !0,
        alert: {
          level: E.Alert.Level.fatal,
          description: E.Alert.Description.handshake_failure
        },
        cipherSuite: z.util.bytesToHex(r.cipher_suite)
      });
    a ? e.session.compressionMethod = r.compression_method : e.session.compressionMethod = E.CompressionMethod.none;
  }
  return r;
};
E.createSecurityParameters = function(e, t) {
  var n = e.entity === E.ConnectionEnd.client, r = t.random.bytes(), a = n ? e.session.sp.client_random : r, s = n ? r : E.createRandom().getBytes();
  e.session.sp = {
    entity: e.entity,
    prf_algorithm: E.PRFAlgorithm.tls_prf_sha256,
    bulk_cipher_algorithm: null,
    cipher_type: null,
    enc_key_length: null,
    block_length: null,
    fixed_iv_length: null,
    record_iv_length: null,
    mac_algorithm: null,
    mac_length: null,
    mac_key_length: null,
    compression_algorithm: e.session.compressionMethod,
    pre_master_secret: null,
    master_secret: null,
    client_random: a,
    server_random: s
  };
};
E.handleServerHello = function(e, t, n) {
  var r = E.parseHelloMessage(e, t, n);
  if (!e.fail) {
    if (r.version.minor <= e.version.minor)
      e.version.minor = r.version.minor;
    else
      return e.error(e, {
        message: "Incompatible TLS version.",
        send: !0,
        alert: {
          level: E.Alert.Level.fatal,
          description: E.Alert.Description.protocol_version
        }
      });
    e.session.version = e.version;
    var a = r.session_id.bytes();
    a.length > 0 && a === e.session.id ? (e.expect = Ac, e.session.resuming = !0, e.session.sp.server_random = r.random.bytes()) : (e.expect = hd, e.session.resuming = !1, E.createSecurityParameters(e, r)), e.session.id = a, e.process();
  }
};
E.handleClientHello = function(e, t, n) {
  var r = E.parseHelloMessage(e, t, n);
  if (!e.fail) {
    var a = r.session_id.bytes(), s = null;
    if (e.sessionCache && (s = e.sessionCache.getSession(a), s === null ? a = "" : (s.version.major !== r.version.major || s.version.minor > r.version.minor) && (s = null, a = "")), a.length === 0 && (a = z.random.getBytes(32)), e.session.id = a, e.session.clientHelloVersion = r.version, e.session.sp = {}, s)
      e.version = e.session.version = s.version, e.session.sp = s.sp;
    else {
      for (var i, o = 1; o < E.SupportedVersions.length && (i = E.SupportedVersions[o], !(i.minor <= r.version.minor)); ++o)
        ;
      e.version = { major: i.major, minor: i.minor }, e.session.version = e.version;
    }
    s !== null ? (e.expect = es, e.session.resuming = !0, e.session.sp.client_random = r.random.bytes()) : (e.expect = e.verifyClient !== !1 ? Cd : Ii, e.session.resuming = !1, E.createSecurityParameters(e, r)), e.open = !0, E.queue(e, E.createRecord(e, {
      type: E.ContentType.handshake,
      data: E.createServerHello(e)
    })), e.session.resuming ? (E.queue(e, E.createRecord(e, {
      type: E.ContentType.change_cipher_spec,
      data: E.createChangeCipherSpec()
    })), e.state.pending = E.createConnectionState(e), e.state.current.write = e.state.pending.write, E.queue(e, E.createRecord(e, {
      type: E.ContentType.handshake,
      data: E.createFinished(e)
    }))) : (E.queue(e, E.createRecord(e, {
      type: E.ContentType.handshake,
      data: E.createCertificate(e)
    })), e.fail || (E.queue(e, E.createRecord(e, {
      type: E.ContentType.handshake,
      data: E.createServerKeyExchange(e)
    })), e.verifyClient !== !1 && E.queue(e, E.createRecord(e, {
      type: E.ContentType.handshake,
      data: E.createCertificateRequest(e)
    })), E.queue(e, E.createRecord(e, {
      type: E.ContentType.handshake,
      data: E.createServerHelloDone(e)
    })))), E.flush(e), e.process();
  }
};
E.handleCertificate = function(e, t, n) {
  if (n < 3)
    return e.error(e, {
      message: "Invalid Certificate message. Message too short.",
      send: !0,
      alert: {
        level: E.Alert.Level.fatal,
        description: E.Alert.Description.illegal_parameter
      }
    });
  var r = t.fragment, a = {
    certificate_list: Rt(r, 3)
  }, s, i, o = [];
  try {
    for (; a.certificate_list.length() > 0; )
      s = Rt(a.certificate_list, 3), i = z.asn1.fromDer(s), s = z.pki.certificateFromAsn1(i, !0), o.push(s);
  } catch (c) {
    return e.error(e, {
      message: "Could not parse certificate list.",
      cause: c,
      send: !0,
      alert: {
        level: E.Alert.Level.fatal,
        description: E.Alert.Description.bad_certificate
      }
    });
  }
  var u = e.entity === E.ConnectionEnd.client;
  (u || e.verifyClient === !0) && o.length === 0 ? e.error(e, {
    message: u ? "No server certificate provided." : "No client certificate provided.",
    send: !0,
    alert: {
      level: E.Alert.Level.fatal,
      description: E.Alert.Description.illegal_parameter
    }
  }) : o.length === 0 ? e.expect = u ? ro : Ii : (u ? e.session.serverCertificate = o[0] : e.session.clientCertificate = o[0], E.verifyCertificateChain(e, o) && (e.expect = u ? ro : Ii)), e.process();
};
E.handleServerKeyExchange = function(e, t, n) {
  if (n > 0)
    return e.error(e, {
      message: "Invalid key parameters. Only RSA is supported.",
      send: !0,
      alert: {
        level: E.Alert.Level.fatal,
        description: E.Alert.Description.unsupported_certificate
      }
    });
  e.expect = dd, e.process();
};
E.handleClientKeyExchange = function(e, t, n) {
  if (n < 48)
    return e.error(e, {
      message: "Invalid key parameters. Only RSA is supported.",
      send: !0,
      alert: {
        level: E.Alert.Level.fatal,
        description: E.Alert.Description.unsupported_certificate
      }
    });
  var r = t.fragment, a = {
    enc_pre_master_secret: Rt(r, 2).getBytes()
  }, s = null;
  if (e.getPrivateKey)
    try {
      s = e.getPrivateKey(e, e.session.serverCertificate), s = z.pki.privateKeyFromPem(s);
    } catch (u) {
      e.error(e, {
        message: "Could not get private key.",
        cause: u,
        send: !0,
        alert: {
          level: E.Alert.Level.fatal,
          description: E.Alert.Description.internal_error
        }
      });
    }
  if (s === null)
    return e.error(e, {
      message: "No private key set.",
      send: !0,
      alert: {
        level: E.Alert.Level.fatal,
        description: E.Alert.Description.internal_error
      }
    });
  try {
    var i = e.session.sp;
    i.pre_master_secret = s.decrypt(a.enc_pre_master_secret);
    var o = e.session.clientHelloVersion;
    if (o.major !== i.pre_master_secret.charCodeAt(0) || o.minor !== i.pre_master_secret.charCodeAt(1))
      throw new Error("TLS version rollback attack detected.");
  } catch {
    i.pre_master_secret = z.random.getBytes(48);
  }
  e.expect = es, e.session.clientCertificate !== null && (e.expect = Sd), e.process();
};
E.handleCertificateRequest = function(e, t, n) {
  if (n < 3)
    return e.error(e, {
      message: "Invalid CertificateRequest. Message too short.",
      send: !0,
      alert: {
        level: E.Alert.Level.fatal,
        description: E.Alert.Description.illegal_parameter
      }
    });
  var r = t.fragment, a = {
    certificate_types: Rt(r, 1),
    certificate_authorities: Rt(r, 2)
  };
  e.session.certificateRequest = a, e.expect = yd, e.process();
};
E.handleCertificateVerify = function(e, t, n) {
  if (n < 2)
    return e.error(e, {
      message: "Invalid CertificateVerify. Message too short.",
      send: !0,
      alert: {
        level: E.Alert.Level.fatal,
        description: E.Alert.Description.illegal_parameter
      }
    });
  var r = t.fragment;
  r.read -= 4;
  var a = r.bytes();
  r.read += 4;
  var s = {
    signature: Rt(r, 2).getBytes()
  }, i = z.util.createBuffer();
  i.putBuffer(e.session.md5.digest()), i.putBuffer(e.session.sha1.digest()), i = i.getBytes();
  try {
    var o = e.session.clientCertificate;
    if (!o.publicKey.verify(i, s.signature, "NONE"))
      throw new Error("CertificateVerify signature does not match.");
    e.session.md5.update(a), e.session.sha1.update(a);
  } catch {
    return e.error(e, {
      message: "Bad signature in CertificateVerify.",
      send: !0,
      alert: {
        level: E.Alert.Level.fatal,
        description: E.Alert.Description.handshake_failure
      }
    });
  }
  e.expect = es, e.process();
};
E.handleServerHelloDone = function(e, t, n) {
  if (n > 0)
    return e.error(e, {
      message: "Invalid ServerHelloDone message. Invalid length.",
      send: !0,
      alert: {
        level: E.Alert.Level.fatal,
        description: E.Alert.Description.record_overflow
      }
    });
  if (e.serverCertificate === null) {
    var r = {
      message: "No server certificate provided. Not enough security.",
      send: !0,
      alert: {
        level: E.Alert.Level.fatal,
        description: E.Alert.Description.insufficient_security
      }
    }, a = 0, s = e.verify(e, r.alert.description, a, []);
    if (s !== !0)
      return (s || s === 0) && (typeof s == "object" && !z.util.isArray(s) ? (s.message && (r.message = s.message), s.alert && (r.alert.description = s.alert)) : typeof s == "number" && (r.alert.description = s)), e.error(e, r);
  }
  e.session.certificateRequest !== null && (t = E.createRecord(e, {
    type: E.ContentType.handshake,
    data: E.createCertificate(e)
  }), E.queue(e, t)), t = E.createRecord(e, {
    type: E.ContentType.handshake,
    data: E.createClientKeyExchange(e)
  }), E.queue(e, t), e.expect = md;
  var i = function(o, u) {
    o.session.certificateRequest !== null && o.session.clientCertificate !== null && E.queue(o, E.createRecord(o, {
      type: E.ContentType.handshake,
      data: E.createCertificateVerify(o, u)
    })), E.queue(o, E.createRecord(o, {
      type: E.ContentType.change_cipher_spec,
      data: E.createChangeCipherSpec()
    })), o.state.pending = E.createConnectionState(o), o.state.current.write = o.state.pending.write, E.queue(o, E.createRecord(o, {
      type: E.ContentType.handshake,
      data: E.createFinished(o)
    })), o.expect = Ac, E.flush(o), o.process();
  };
  if (e.session.certificateRequest === null || e.session.clientCertificate === null)
    return i(e, null);
  E.getClientSignature(e, i);
};
E.handleChangeCipherSpec = function(e, t) {
  if (t.fragment.getByte() !== 1)
    return e.error(e, {
      message: "Invalid ChangeCipherSpec message received.",
      send: !0,
      alert: {
        level: E.Alert.Level.fatal,
        description: E.Alert.Description.illegal_parameter
      }
    });
  var n = e.entity === E.ConnectionEnd.client;
  (e.session.resuming && n || !e.session.resuming && !n) && (e.state.pending = E.createConnectionState(e)), e.state.current.read = e.state.pending.read, (!e.session.resuming && n || e.session.resuming && !n) && (e.state.pending = null), e.expect = n ? gd : bd, e.process();
};
E.handleFinished = function(e, t, n) {
  var r = t.fragment;
  r.read -= 4;
  var a = r.bytes();
  r.read += 4;
  var s = t.fragment.getBytes();
  r = z.util.createBuffer(), r.putBuffer(e.session.md5.digest()), r.putBuffer(e.session.sha1.digest());
  var i = e.entity === E.ConnectionEnd.client, o = i ? "server finished" : "client finished", u = e.session.sp, c = 12, l = ka;
  if (r = l(u.master_secret, o, r.getBytes(), c), r.getBytes() !== s)
    return e.error(e, {
      message: "Invalid verify_data in Finished message.",
      send: !0,
      alert: {
        level: E.Alert.Level.fatal,
        description: E.Alert.Description.decrypt_error
      }
    });
  e.session.md5.update(a), e.session.sha1.update(a), (e.session.resuming && i || !e.session.resuming && !i) && (E.queue(e, E.createRecord(e, {
    type: E.ContentType.change_cipher_spec,
    data: E.createChangeCipherSpec()
  })), e.state.current.write = e.state.pending.write, e.state.pending = null, E.queue(e, E.createRecord(e, {
    type: E.ContentType.handshake,
    data: E.createFinished(e)
  }))), e.expect = i ? vd : xd, e.handshaking = !1, ++e.handshakes, e.peerCertificate = i ? e.session.serverCertificate : e.session.clientCertificate, E.flush(e), e.isConnected = !0, e.connected(e), e.process();
};
E.handleAlert = function(e, t) {
  var n = t.fragment, r = {
    level: n.getByte(),
    description: n.getByte()
  }, a;
  switch (r.description) {
    case E.Alert.Description.close_notify:
      a = "Connection closed.";
      break;
    case E.Alert.Description.unexpected_message:
      a = "Unexpected message.";
      break;
    case E.Alert.Description.bad_record_mac:
      a = "Bad record MAC.";
      break;
    case E.Alert.Description.decryption_failed:
      a = "Decryption failed.";
      break;
    case E.Alert.Description.record_overflow:
      a = "Record overflow.";
      break;
    case E.Alert.Description.decompression_failure:
      a = "Decompression failed.";
      break;
    case E.Alert.Description.handshake_failure:
      a = "Handshake failure.";
      break;
    case E.Alert.Description.bad_certificate:
      a = "Bad certificate.";
      break;
    case E.Alert.Description.unsupported_certificate:
      a = "Unsupported certificate.";
      break;
    case E.Alert.Description.certificate_revoked:
      a = "Certificate revoked.";
      break;
    case E.Alert.Description.certificate_expired:
      a = "Certificate expired.";
      break;
    case E.Alert.Description.certificate_unknown:
      a = "Certificate unknown.";
      break;
    case E.Alert.Description.illegal_parameter:
      a = "Illegal parameter.";
      break;
    case E.Alert.Description.unknown_ca:
      a = "Unknown certificate authority.";
      break;
    case E.Alert.Description.access_denied:
      a = "Access denied.";
      break;
    case E.Alert.Description.decode_error:
      a = "Decode error.";
      break;
    case E.Alert.Description.decrypt_error:
      a = "Decrypt error.";
      break;
    case E.Alert.Description.export_restriction:
      a = "Export restriction.";
      break;
    case E.Alert.Description.protocol_version:
      a = "Unsupported protocol version.";
      break;
    case E.Alert.Description.insufficient_security:
      a = "Insufficient security.";
      break;
    case E.Alert.Description.internal_error:
      a = "Internal error.";
      break;
    case E.Alert.Description.user_canceled:
      a = "User canceled.";
      break;
    case E.Alert.Description.no_renegotiation:
      a = "Renegotiation not supported.";
      break;
    default:
      a = "Unknown error.";
      break;
  }
  if (r.description === E.Alert.Description.close_notify)
    return e.close();
  e.error(e, {
    message: a,
    send: !1,
    // origin is the opposite end
    origin: e.entity === E.ConnectionEnd.client ? "server" : "client",
    alert: r
  }), e.process();
};
E.handleHandshake = function(e, t) {
  var n = t.fragment, r = n.getByte(), a = n.getInt24();
  if (a > n.length())
    return e.fragmented = t, t.fragment = z.util.createBuffer(), n.read -= 4, e.process();
  e.fragmented = null, n.read -= 4;
  var s = n.bytes(a + 4);
  n.read += 4, r in va[e.entity][e.expect] ? (e.entity === E.ConnectionEnd.server && !e.open && !e.fail && (e.handshaking = !0, e.session = {
    version: null,
    extensions: {
      server_name: {
        serverNameList: []
      }
    },
    cipherSuite: null,
    compressionMethod: null,
    serverCertificate: null,
    clientCertificate: null,
    md5: z.md.md5.create(),
    sha1: z.md.sha1.create()
  }), r !== E.HandshakeType.hello_request && r !== E.HandshakeType.certificate_verify && r !== E.HandshakeType.finished && (e.session.md5.update(s), e.session.sha1.update(s)), va[e.entity][e.expect][r](e, t, a)) : E.handleUnexpected(e, t);
};
E.handleApplicationData = function(e, t) {
  e.data.putBuffer(t.fragment), e.dataReady(e), e.process();
};
E.handleHeartbeat = function(e, t) {
  var n = t.fragment, r = n.getByte(), a = n.getInt16(), s = n.getBytes(a);
  if (r === E.HeartbeatMessageType.heartbeat_request) {
    if (e.handshaking || a > s.length)
      return e.process();
    E.queue(e, E.createRecord(e, {
      type: E.ContentType.heartbeat,
      data: E.createHeartbeat(
        E.HeartbeatMessageType.heartbeat_response,
        s
      )
    })), E.flush(e);
  } else if (r === E.HeartbeatMessageType.heartbeat_response) {
    if (s !== e.expectedHeartbeatPayload)
      return e.process();
    e.heartbeatReceived && e.heartbeatReceived(e, z.util.createBuffer(s));
  }
  e.process();
};
var pd = 0, hd = 1, ro = 2, dd = 3, yd = 4, Ac = 5, gd = 6, vd = 7, md = 8, Ed = 0, Cd = 1, Ii = 2, Sd = 3, es = 4, bd = 5, xd = 6, m = E.handleUnexpected, Ic = E.handleChangeCipherSpec, gt = E.handleAlert, Tt = E.handleHandshake, wc = E.handleApplicationData, vt = E.handleHeartbeat, ts = [];
ts[E.ConnectionEnd.client] = [
  //      CC,AL,HS,AD,HB
  /*SHE*/
  [m, gt, Tt, m, vt],
  /*SCE*/
  [m, gt, Tt, m, vt],
  /*SKE*/
  [m, gt, Tt, m, vt],
  /*SCR*/
  [m, gt, Tt, m, vt],
  /*SHD*/
  [m, gt, Tt, m, vt],
  /*SCC*/
  [Ic, gt, m, m, vt],
  /*SFI*/
  [m, gt, Tt, m, vt],
  /*SAD*/
  [m, gt, Tt, wc, vt],
  /*SER*/
  [m, gt, Tt, m, vt]
];
ts[E.ConnectionEnd.server] = [
  //      CC,AL,HS,AD
  /*CHE*/
  [m, gt, Tt, m, vt],
  /*CCE*/
  [m, gt, Tt, m, vt],
  /*CKE*/
  [m, gt, Tt, m, vt],
  /*CCV*/
  [m, gt, Tt, m, vt],
  /*CCC*/
  [Ic, gt, m, m, vt],
  /*CFI*/
  [m, gt, Tt, m, vt],
  /*CAD*/
  [m, gt, Tt, wc, vt],
  /*CER*/
  [m, gt, Tt, m, vt]
];
var Er = E.handleHelloRequest, Td = E.handleServerHello, Bc = E.handleCertificate, no = E.handleServerKeyExchange, ni = E.handleCertificateRequest, na = E.handleServerHelloDone, _c = E.handleFinished, va = [];
va[E.ConnectionEnd.client] = [
  //      HR,01,SH,03,04,05,06,07,08,09,10,SC,SK,CR,HD,15,CK,17,18,19,FI
  /*SHE*/
  [m, m, Td, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m],
  /*SCE*/
  [Er, m, m, m, m, m, m, m, m, m, m, Bc, no, ni, na, m, m, m, m, m, m],
  /*SKE*/
  [Er, m, m, m, m, m, m, m, m, m, m, m, no, ni, na, m, m, m, m, m, m],
  /*SCR*/
  [Er, m, m, m, m, m, m, m, m, m, m, m, m, ni, na, m, m, m, m, m, m],
  /*SHD*/
  [Er, m, m, m, m, m, m, m, m, m, m, m, m, m, na, m, m, m, m, m, m],
  /*SCC*/
  [Er, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m],
  /*SFI*/
  [Er, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, _c],
  /*SAD*/
  [Er, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m],
  /*SER*/
  [Er, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m]
];
var Ad = E.handleClientHello, Id = E.handleClientKeyExchange, wd = E.handleCertificateVerify;
va[E.ConnectionEnd.server] = [
  //      01,CH,02,03,04,05,06,07,08,09,10,CC,12,13,14,CV,CK,17,18,19,FI
  /*CHE*/
  [m, Ad, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m],
  /*CCE*/
  [m, m, m, m, m, m, m, m, m, m, m, Bc, m, m, m, m, m, m, m, m, m],
  /*CKE*/
  [m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, Id, m, m, m, m],
  /*CCV*/
  [m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, wd, m, m, m, m, m],
  /*CCC*/
  [m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m],
  /*CFI*/
  [m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, _c],
  /*CAD*/
  [m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m],
  /*CER*/
  [m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m, m]
];
E.generateKeys = function(e, t) {
  var n = ka, r = t.client_random + t.server_random;
  e.session.resuming || (t.master_secret = n(
    t.pre_master_secret,
    "master secret",
    r,
    48
  ).bytes(), t.pre_master_secret = null), r = t.server_random + t.client_random;
  var a = 2 * t.mac_key_length + 2 * t.enc_key_length, s = e.version.major === E.Versions.TLS_1_0.major && e.version.minor === E.Versions.TLS_1_0.minor;
  s && (a += 2 * t.fixed_iv_length);
  var i = n(t.master_secret, "key expansion", r, a), o = {
    client_write_MAC_key: i.getBytes(t.mac_key_length),
    server_write_MAC_key: i.getBytes(t.mac_key_length),
    client_write_key: i.getBytes(t.enc_key_length),
    server_write_key: i.getBytes(t.enc_key_length)
  };
  return s && (o.client_write_IV = i.getBytes(t.fixed_iv_length), o.server_write_IV = i.getBytes(t.fixed_iv_length)), o;
};
E.createConnectionState = function(e) {
  var t = e.entity === E.ConnectionEnd.client, n = function() {
    var s = {
      // two 32-bit numbers, first is most significant
      sequenceNumber: [0, 0],
      macKey: null,
      macLength: 0,
      macFunction: null,
      cipherState: null,
      cipherFunction: function(i) {
        return !0;
      },
      compressionState: null,
      compressFunction: function(i) {
        return !0;
      },
      updateSequenceNumber: function() {
        s.sequenceNumber[1] === 4294967295 ? (s.sequenceNumber[1] = 0, ++s.sequenceNumber[0]) : ++s.sequenceNumber[1];
      }
    };
    return s;
  }, r = {
    read: n(),
    write: n()
  };
  if (r.read.update = function(s, i) {
    return r.read.cipherFunction(i, r.read) ? r.read.compressFunction(s, i, r.read) || s.error(s, {
      message: "Could not decompress record.",
      send: !0,
      alert: {
        level: E.Alert.Level.fatal,
        description: E.Alert.Description.decompression_failure
      }
    }) : s.error(s, {
      message: "Could not decrypt record or bad MAC.",
      send: !0,
      alert: {
        level: E.Alert.Level.fatal,
        // doesn't matter if decryption failed or MAC was
        // invalid, return the same error so as not to reveal
        // which one occurred
        description: E.Alert.Description.bad_record_mac
      }
    }), !s.fail;
  }, r.write.update = function(s, i) {
    return r.write.compressFunction(s, i, r.write) ? r.write.cipherFunction(i, r.write) || s.error(s, {
      message: "Could not encrypt record.",
      send: !1,
      alert: {
        level: E.Alert.Level.fatal,
        description: E.Alert.Description.internal_error
      }
    }) : s.error(s, {
      message: "Could not compress record.",
      send: !1,
      alert: {
        level: E.Alert.Level.fatal,
        description: E.Alert.Description.internal_error
      }
    }), !s.fail;
  }, e.session) {
    var a = e.session.sp;
    switch (e.session.cipherSuite.initSecurityParameters(a), a.keys = E.generateKeys(e, a), r.read.macKey = t ? a.keys.server_write_MAC_key : a.keys.client_write_MAC_key, r.write.macKey = t ? a.keys.client_write_MAC_key : a.keys.server_write_MAC_key, e.session.cipherSuite.initConnectionState(r, e, a), a.compression_algorithm) {
      case E.CompressionMethod.none:
        break;
      case E.CompressionMethod.deflate:
        r.read.compressFunction = fd, r.write.compressFunction = ld;
        break;
      default:
        throw new Error("Unsupported compression algorithm.");
    }
  }
  return r;
};
E.createRandom = function() {
  var e = /* @__PURE__ */ new Date(), t = +e + e.getTimezoneOffset() * 6e4, n = z.util.createBuffer();
  return n.putInt32(t), n.putBytes(z.random.getBytes(28)), n;
};
E.createRecord = function(e, t) {
  if (!t.data)
    return null;
  var n = {
    type: t.type,
    version: {
      major: e.version.major,
      minor: e.version.minor
    },
    length: t.data.length(),
    fragment: t.data
  };
  return n;
};
E.createAlert = function(e, t) {
  var n = z.util.createBuffer();
  return n.putByte(t.level), n.putByte(t.description), E.createRecord(e, {
    type: E.ContentType.alert,
    data: n
  });
};
E.createClientHello = function(e) {
  e.session.clientHelloVersion = {
    major: e.version.major,
    minor: e.version.minor
  };
  for (var t = z.util.createBuffer(), n = 0; n < e.cipherSuites.length; ++n) {
    var r = e.cipherSuites[n];
    t.putByte(r.id[0]), t.putByte(r.id[1]);
  }
  var a = t.length(), s = z.util.createBuffer();
  s.putByte(E.CompressionMethod.none);
  var i = s.length(), o = z.util.createBuffer();
  if (e.virtualHost) {
    var u = z.util.createBuffer();
    u.putByte(0), u.putByte(0);
    var c = z.util.createBuffer();
    c.putByte(0), Pt(c, 2, z.util.createBuffer(e.virtualHost));
    var l = z.util.createBuffer();
    Pt(l, 2, c), Pt(u, 2, l), o.putBuffer(u);
  }
  var p = o.length();
  p > 0 && (p += 2);
  var g = e.session.id, C = g.length + 1 + // session ID vector
  2 + // version (major + minor)
  4 + 28 + // random time and random bytes
  2 + a + // cipher suites vector
  1 + i + // compression methods vector
  p, d = z.util.createBuffer();
  return d.putByte(E.HandshakeType.client_hello), d.putInt24(C), d.putByte(e.version.major), d.putByte(e.version.minor), d.putBytes(e.session.sp.client_random), Pt(d, 1, z.util.createBuffer(g)), Pt(d, 2, t), Pt(d, 1, s), p > 0 && Pt(d, 2, o), d;
};
E.createServerHello = function(e) {
  var t = e.session.id, n = t.length + 1 + // session ID vector
  2 + // version (major + minor)
  4 + 28 + // random time and random bytes
  2 + // chosen cipher suite
  1, r = z.util.createBuffer();
  return r.putByte(E.HandshakeType.server_hello), r.putInt24(n), r.putByte(e.version.major), r.putByte(e.version.minor), r.putBytes(e.session.sp.server_random), Pt(r, 1, z.util.createBuffer(t)), r.putByte(e.session.cipherSuite.id[0]), r.putByte(e.session.cipherSuite.id[1]), r.putByte(e.session.compressionMethod), r;
};
E.createCertificate = function(e) {
  var t = e.entity === E.ConnectionEnd.client, n = null;
  if (e.getCertificate) {
    var r;
    t ? r = e.session.certificateRequest : r = e.session.extensions.server_name.serverNameList, n = e.getCertificate(e, r);
  }
  var a = z.util.createBuffer();
  if (n !== null)
    try {
      z.util.isArray(n) || (n = [n]);
      for (var s = null, i = 0; i < n.length; ++i) {
        var o = z.pem.decode(n[i])[0];
        if (o.type !== "CERTIFICATE" && o.type !== "X509 CERTIFICATE" && o.type !== "TRUSTED CERTIFICATE") {
          var u = new Error('Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".');
          throw u.headerType = o.type, u;
        }
        if (o.procType && o.procType.type === "ENCRYPTED")
          throw new Error("Could not convert certificate from PEM; PEM is encrypted.");
        var c = z.util.createBuffer(o.body);
        s === null && (s = z.asn1.fromDer(c.bytes(), !1));
        var l = z.util.createBuffer();
        Pt(l, 3, c), a.putBuffer(l);
      }
      n = z.pki.certificateFromAsn1(s), t ? e.session.clientCertificate = n : e.session.serverCertificate = n;
    } catch (C) {
      return e.error(e, {
        message: "Could not send certificate list.",
        cause: C,
        send: !0,
        alert: {
          level: E.Alert.Level.fatal,
          description: E.Alert.Description.bad_certificate
        }
      });
    }
  var p = 3 + a.length(), g = z.util.createBuffer();
  return g.putByte(E.HandshakeType.certificate), g.putInt24(p), Pt(g, 3, a), g;
};
E.createClientKeyExchange = function(e) {
  var t = z.util.createBuffer();
  t.putByte(e.session.clientHelloVersion.major), t.putByte(e.session.clientHelloVersion.minor), t.putBytes(z.random.getBytes(46));
  var n = e.session.sp;
  n.pre_master_secret = t.getBytes();
  var r = e.session.serverCertificate.publicKey;
  t = r.encrypt(n.pre_master_secret);
  var a = t.length + 2, s = z.util.createBuffer();
  return s.putByte(E.HandshakeType.client_key_exchange), s.putInt24(a), s.putInt16(t.length), s.putBytes(t), s;
};
E.createServerKeyExchange = function(e) {
  var t = z.util.createBuffer();
  return t;
};
E.getClientSignature = function(e, t) {
  var n = z.util.createBuffer();
  n.putBuffer(e.session.md5.digest()), n.putBuffer(e.session.sha1.digest()), n = n.getBytes(), e.getSignature = e.getSignature || function(r, a, s) {
    var i = null;
    if (r.getPrivateKey)
      try {
        i = r.getPrivateKey(r, r.session.clientCertificate), i = z.pki.privateKeyFromPem(i);
      } catch (o) {
        r.error(r, {
          message: "Could not get private key.",
          cause: o,
          send: !0,
          alert: {
            level: E.Alert.Level.fatal,
            description: E.Alert.Description.internal_error
          }
        });
      }
    i === null ? r.error(r, {
      message: "No private key set.",
      send: !0,
      alert: {
        level: E.Alert.Level.fatal,
        description: E.Alert.Description.internal_error
      }
    }) : a = i.sign(a, null), s(r, a);
  }, e.getSignature(e, n, t);
};
E.createCertificateVerify = function(e, t) {
  var n = t.length + 2, r = z.util.createBuffer();
  return r.putByte(E.HandshakeType.certificate_verify), r.putInt24(n), r.putInt16(t.length), r.putBytes(t), r;
};
E.createCertificateRequest = function(e) {
  var t = z.util.createBuffer();
  t.putByte(1);
  var n = z.util.createBuffer();
  for (var r in e.caStore.certs) {
    var a = e.caStore.certs[r], s = z.pki.distinguishedNameToAsn1(a.subject), i = z.asn1.toDer(s);
    n.putInt16(i.length()), n.putBuffer(i);
  }
  var o = 1 + t.length() + 2 + n.length(), u = z.util.createBuffer();
  return u.putByte(E.HandshakeType.certificate_request), u.putInt24(o), Pt(u, 1, t), Pt(u, 2, n), u;
};
E.createServerHelloDone = function(e) {
  var t = z.util.createBuffer();
  return t.putByte(E.HandshakeType.server_hello_done), t.putInt24(0), t;
};
E.createChangeCipherSpec = function() {
  var e = z.util.createBuffer();
  return e.putByte(1), e;
};
E.createFinished = function(e) {
  var t = z.util.createBuffer();
  t.putBuffer(e.session.md5.digest()), t.putBuffer(e.session.sha1.digest());
  var n = e.entity === E.ConnectionEnd.client, r = e.session.sp, a = 12, s = ka, i = n ? "client finished" : "server finished";
  t = s(r.master_secret, i, t.getBytes(), a);
  var o = z.util.createBuffer();
  return o.putByte(E.HandshakeType.finished), o.putInt24(t.length()), o.putBuffer(t), o;
};
E.createHeartbeat = function(e, t, n) {
  typeof n > "u" && (n = t.length);
  var r = z.util.createBuffer();
  r.putByte(e), r.putInt16(n), r.putBytes(t);
  var a = r.length(), s = Math.max(16, a - n - 3);
  return r.putBytes(z.random.getBytes(s)), r;
};
E.queue = function(e, t) {
  if (t && !(t.fragment.length() === 0 && (t.type === E.ContentType.handshake || t.type === E.ContentType.alert || t.type === E.ContentType.change_cipher_spec))) {
    if (t.type === E.ContentType.handshake) {
      var n = t.fragment.bytes();
      e.session.md5.update(n), e.session.sha1.update(n), n = null;
    }
    var r;
    if (t.fragment.length() <= E.MaxFragment)
      r = [t];
    else {
      r = [];
      for (var a = t.fragment.bytes(); a.length > E.MaxFragment; )
        r.push(E.createRecord(e, {
          type: t.type,
          data: z.util.createBuffer(a.slice(0, E.MaxFragment))
        })), a = a.slice(E.MaxFragment);
      a.length > 0 && r.push(E.createRecord(e, {
        type: t.type,
        data: z.util.createBuffer(a)
      }));
    }
    for (var s = 0; s < r.length && !e.fail; ++s) {
      var i = r[s], o = e.state.current.write;
      o.update(e, i) && e.records.push(i);
    }
  }
};
E.flush = function(e) {
  for (var t = 0; t < e.records.length; ++t) {
    var n = e.records[t];
    e.tlsData.putByte(n.type), e.tlsData.putByte(n.version.major), e.tlsData.putByte(n.version.minor), e.tlsData.putInt16(n.fragment.length()), e.tlsData.putBuffer(e.records[t].fragment);
  }
  return e.records = [], e.tlsDataReady(e);
};
var ai = function(e) {
  switch (e) {
    case !0:
      return !0;
    case z.pki.certificateError.bad_certificate:
      return E.Alert.Description.bad_certificate;
    case z.pki.certificateError.unsupported_certificate:
      return E.Alert.Description.unsupported_certificate;
    case z.pki.certificateError.certificate_revoked:
      return E.Alert.Description.certificate_revoked;
    case z.pki.certificateError.certificate_expired:
      return E.Alert.Description.certificate_expired;
    case z.pki.certificateError.certificate_unknown:
      return E.Alert.Description.certificate_unknown;
    case z.pki.certificateError.unknown_ca:
      return E.Alert.Description.unknown_ca;
    default:
      return E.Alert.Description.bad_certificate;
  }
}, Bd = function(e) {
  switch (e) {
    case !0:
      return !0;
    case E.Alert.Description.bad_certificate:
      return z.pki.certificateError.bad_certificate;
    case E.Alert.Description.unsupported_certificate:
      return z.pki.certificateError.unsupported_certificate;
    case E.Alert.Description.certificate_revoked:
      return z.pki.certificateError.certificate_revoked;
    case E.Alert.Description.certificate_expired:
      return z.pki.certificateError.certificate_expired;
    case E.Alert.Description.certificate_unknown:
      return z.pki.certificateError.certificate_unknown;
    case E.Alert.Description.unknown_ca:
      return z.pki.certificateError.unknown_ca;
    default:
      return z.pki.certificateError.bad_certificate;
  }
};
E.verifyCertificateChain = function(e, t) {
  try {
    var n = {};
    for (var r in e.verifyOptions)
      n[r] = e.verifyOptions[r];
    n.verify = function(s, i, o) {
      var u = ai(s), c = e.verify(e, s, i, o);
      if (c !== !0) {
        if (typeof c == "object" && !z.util.isArray(c)) {
          var l = new Error("The application rejected the certificate.");
          throw l.send = !0, l.alert = {
            level: E.Alert.Level.fatal,
            description: E.Alert.Description.bad_certificate
          }, c.message && (l.message = c.message), c.alert && (l.alert.description = c.alert), l;
        }
        c !== s && (c = Bd(c));
      }
      return c;
    }, z.pki.verifyCertificateChain(e.caStore, t, n);
  } catch (s) {
    var a = s;
    (typeof a != "object" || z.util.isArray(a)) && (a = {
      send: !0,
      alert: {
        level: E.Alert.Level.fatal,
        description: ai(s)
      }
    }), "send" in a || (a.send = !0), "alert" in a || (a.alert = {
      level: E.Alert.Level.fatal,
      description: ai(a.error)
    }), e.error(e, a);
  }
  return !e.fail;
};
E.createSessionCache = function(e, t) {
  var n = null;
  if (e && e.getSession && e.setSession && e.order)
    n = e;
  else {
    n = {}, n.cache = e || {}, n.capacity = Math.max(t || 100, 1), n.order = [];
    for (var r in e)
      n.order.length <= t ? n.order.push(r) : delete e[r];
    n.getSession = function(a) {
      var s = null, i = null;
      if (a ? i = z.util.bytesToHex(a) : n.order.length > 0 && (i = n.order[0]), i !== null && i in n.cache) {
        s = n.cache[i], delete n.cache[i];
        for (var o in n.order)
          if (n.order[o] === i) {
            n.order.splice(o, 1);
            break;
          }
      }
      return s;
    }, n.setSession = function(a, s) {
      if (n.order.length === n.capacity) {
        var i = n.order.shift();
        delete n.cache[i];
      }
      var i = z.util.bytesToHex(a);
      n.order.push(i), n.cache[i] = s;
    };
  }
  return n;
};
E.createConnection = function(e) {
  var t = null;
  e.caStore ? z.util.isArray(e.caStore) ? t = z.pki.createCaStore(e.caStore) : t = e.caStore : t = z.pki.createCaStore();
  var n = e.cipherSuites || null;
  if (n === null) {
    n = [];
    for (var r in E.CipherSuites)
      n.push(E.CipherSuites[r]);
  }
  var a = e.server ? E.ConnectionEnd.server : E.ConnectionEnd.client, s = e.sessionCache ? E.createSessionCache(e.sessionCache) : null, i = {
    version: { major: E.Version.major, minor: E.Version.minor },
    entity: a,
    sessionId: e.sessionId,
    caStore: t,
    sessionCache: s,
    cipherSuites: n,
    connected: e.connected,
    virtualHost: e.virtualHost || null,
    verifyClient: e.verifyClient || !1,
    verify: e.verify || function(l, p, g, C) {
      return p;
    },
    verifyOptions: e.verifyOptions || {},
    getCertificate: e.getCertificate || null,
    getPrivateKey: e.getPrivateKey || null,
    getSignature: e.getSignature || null,
    input: z.util.createBuffer(),
    tlsData: z.util.createBuffer(),
    data: z.util.createBuffer(),
    tlsDataReady: e.tlsDataReady,
    dataReady: e.dataReady,
    heartbeatReceived: e.heartbeatReceived,
    closed: e.closed,
    error: function(l, p) {
      p.origin = p.origin || (l.entity === E.ConnectionEnd.client ? "client" : "server"), p.send && (E.queue(l, E.createAlert(l, p.alert)), E.flush(l));
      var g = p.fatal !== !1;
      g && (l.fail = !0), e.error(l, p), g && l.close(!1);
    },
    deflate: e.deflate || null,
    inflate: e.inflate || null
  };
  i.reset = function(l) {
    i.version = { major: E.Version.major, minor: E.Version.minor }, i.record = null, i.session = null, i.peerCertificate = null, i.state = {
      pending: null,
      current: null
    }, i.expect = i.entity === E.ConnectionEnd.client ? pd : Ed, i.fragmented = null, i.records = [], i.open = !1, i.handshakes = 0, i.handshaking = !1, i.isConnected = !1, i.fail = !(l || typeof l > "u"), i.input.clear(), i.tlsData.clear(), i.data.clear(), i.state.current = E.createConnectionState(i);
  }, i.reset();
  var o = function(l, p) {
    var g = p.type - E.ContentType.change_cipher_spec, C = ts[l.entity][l.expect];
    g in C ? C[g](l, p) : E.handleUnexpected(l, p);
  }, u = function(l) {
    var p = 0, g = l.input, C = g.length();
    if (C < 5)
      p = 5 - C;
    else {
      l.record = {
        type: g.getByte(),
        version: {
          major: g.getByte(),
          minor: g.getByte()
        },
        length: g.getInt16(),
        fragment: z.util.createBuffer(),
        ready: !1
      };
      var d = l.record.version.major === l.version.major;
      d && l.session && l.session.version && (d = l.record.version.minor === l.version.minor), d || l.error(l, {
        message: "Incompatible TLS version.",
        send: !0,
        alert: {
          level: E.Alert.Level.fatal,
          description: E.Alert.Description.protocol_version
        }
      });
    }
    return p;
  }, c = function(l) {
    var p = 0, g = l.input, C = g.length();
    if (C < l.record.length)
      p = l.record.length - C;
    else {
      l.record.fragment.putBytes(g.getBytes(l.record.length)), g.compact();
      var d = l.state.current.read;
      d.update(l, l.record) && (l.fragmented !== null && (l.fragmented.type === l.record.type ? (l.fragmented.fragment.putBuffer(l.record.fragment), l.record = l.fragmented) : l.error(l, {
        message: "Invalid fragmented record.",
        send: !0,
        alert: {
          level: E.Alert.Level.fatal,
          description: E.Alert.Description.unexpected_message
        }
      })), l.record.ready = !0);
    }
    return p;
  };
  return i.handshake = function(l) {
    if (i.entity !== E.ConnectionEnd.client)
      i.error(i, {
        message: "Cannot initiate handshake as a server.",
        fatal: !1
      });
    else if (i.handshaking)
      i.error(i, {
        message: "Handshake already in progress.",
        fatal: !1
      });
    else {
      i.fail && !i.open && i.handshakes === 0 && (i.fail = !1), i.handshaking = !0, l = l || "";
      var p = null;
      l.length > 0 && (i.sessionCache && (p = i.sessionCache.getSession(l)), p === null && (l = "")), l.length === 0 && i.sessionCache && (p = i.sessionCache.getSession(), p !== null && (l = p.id)), i.session = {
        id: l,
        version: null,
        cipherSuite: null,
        compressionMethod: null,
        serverCertificate: null,
        certificateRequest: null,
        clientCertificate: null,
        sp: {},
        md5: z.md.md5.create(),
        sha1: z.md.sha1.create()
      }, p && (i.version = p.version, i.session.sp = p.sp), i.session.sp.client_random = E.createRandom().getBytes(), i.open = !0, E.queue(i, E.createRecord(i, {
        type: E.ContentType.handshake,
        data: E.createClientHello(i)
      })), E.flush(i);
    }
  }, i.process = function(l) {
    var p = 0;
    return l && i.input.putBytes(l), i.fail || (i.record !== null && i.record.ready && i.record.fragment.isEmpty() && (i.record = null), i.record === null && (p = u(i)), !i.fail && i.record !== null && !i.record.ready && (p = c(i)), !i.fail && i.record !== null && i.record.ready && o(i, i.record)), p;
  }, i.prepare = function(l) {
    return E.queue(i, E.createRecord(i, {
      type: E.ContentType.application_data,
      data: z.util.createBuffer(l)
    })), E.flush(i);
  }, i.prepareHeartbeatRequest = function(l, p) {
    return l instanceof z.util.ByteBuffer && (l = l.bytes()), typeof p > "u" && (p = l.length), i.expectedHeartbeatPayload = l, E.queue(i, E.createRecord(i, {
      type: E.ContentType.heartbeat,
      data: E.createHeartbeat(
        E.HeartbeatMessageType.heartbeat_request,
        l,
        p
      )
    })), E.flush(i);
  }, i.close = function(l) {
    if (!i.fail && i.sessionCache && i.session) {
      var p = {
        id: i.session.id,
        version: i.session.version,
        sp: i.session.sp
      };
      p.sp.keys = null, i.sessionCache.setSession(p.id, p);
    }
    i.open && (i.open = !1, i.input.clear(), (i.isConnected || i.handshaking) && (i.isConnected = i.handshaking = !1, E.queue(i, E.createAlert(i, {
      level: E.Alert.Level.warning,
      description: E.Alert.Description.close_notify
    })), E.flush(i)), i.closed(i)), i.reset(l);
  }, i;
};
z.tls = z.tls || {};
for (var ii in E)
  typeof E[ii] != "function" && (z.tls[ii] = E[ii]);
z.tls.prf_tls1 = ka;
z.tls.hmac_sha1 = ud;
z.tls.createSessionCache = E.createSessionCache;
z.tls.createConnection = E.createConnection;
var _r = De, Mt = _r.tls;
Mt.CipherSuites.TLS_RSA_WITH_AES_128_CBC_SHA = {
  id: [0, 47],
  name: "TLS_RSA_WITH_AES_128_CBC_SHA",
  initSecurityParameters: function(e) {
    e.bulk_cipher_algorithm = Mt.BulkCipherAlgorithm.aes, e.cipher_type = Mt.CipherType.block, e.enc_key_length = 16, e.block_length = 16, e.fixed_iv_length = 16, e.record_iv_length = 16, e.mac_algorithm = Mt.MACAlgorithm.hmac_sha1, e.mac_length = 20, e.mac_key_length = 20;
  },
  initConnectionState: Nc
};
Mt.CipherSuites.TLS_RSA_WITH_AES_256_CBC_SHA = {
  id: [0, 53],
  name: "TLS_RSA_WITH_AES_256_CBC_SHA",
  initSecurityParameters: function(e) {
    e.bulk_cipher_algorithm = Mt.BulkCipherAlgorithm.aes, e.cipher_type = Mt.CipherType.block, e.enc_key_length = 32, e.block_length = 16, e.fixed_iv_length = 16, e.record_iv_length = 16, e.mac_algorithm = Mt.MACAlgorithm.hmac_sha1, e.mac_length = 20, e.mac_key_length = 20;
  },
  initConnectionState: Nc
};
function Nc(e, t, n) {
  var r = t.entity === _r.tls.ConnectionEnd.client;
  e.read.cipherState = {
    init: !1,
    cipher: _r.cipher.createDecipher("AES-CBC", r ? n.keys.server_write_key : n.keys.client_write_key),
    iv: r ? n.keys.server_write_IV : n.keys.client_write_IV
  }, e.write.cipherState = {
    init: !1,
    cipher: _r.cipher.createCipher("AES-CBC", r ? n.keys.client_write_key : n.keys.server_write_key),
    iv: r ? n.keys.client_write_IV : n.keys.server_write_IV
  }, e.read.cipherFunction = Ld, e.write.cipherFunction = _d, e.read.macLength = e.write.macLength = n.mac_length, e.read.macFunction = e.write.macFunction = Mt.hmac_sha1;
}
function _d(e, t) {
  var n = !1, r = t.macFunction(t.macKey, t.sequenceNumber, e);
  e.fragment.putBytes(r), t.updateSequenceNumber();
  var a;
  e.version.minor === Mt.Versions.TLS_1_0.minor ? a = t.cipherState.init ? null : t.cipherState.iv : a = _r.random.getBytesSync(16), t.cipherState.init = !0;
  var s = t.cipherState.cipher;
  return s.start({ iv: a }), e.version.minor >= Mt.Versions.TLS_1_1.minor && s.output.putBytes(a), s.update(e.fragment), s.finish(Nd) && (e.fragment = s.output, e.length = e.fragment.length(), n = !0), n;
}
function Nd(e, t, n) {
  if (!n) {
    var r = e - t.length() % e;
    t.fillWithByte(r - 1, r);
  }
  return !0;
}
function Rd(e, t, n) {
  var r = !0;
  if (n) {
    for (var a = t.length(), s = t.last(), i = a - 1 - s; i < a - 1; ++i)
      r = r && t.at(i) == s;
    r && t.truncate(s + 1);
  }
  return r;
}
function Ld(e, t) {
  var n = !1, r;
  e.version.minor === Mt.Versions.TLS_1_0.minor ? r = t.cipherState.init ? null : t.cipherState.iv : r = e.fragment.getBytes(16), t.cipherState.init = !0;
  var a = t.cipherState.cipher;
  a.start({ iv: r }), a.update(e.fragment), n = a.finish(Rd);
  var s = t.macLength, i = _r.random.getBytesSync(s), o = a.output.length();
  o >= s ? (e.fragment = a.output.getBytes(o - s), i = a.output.getBytes(s)) : e.fragment = a.output.getBytes(), e.fragment = _r.util.createBuffer(e.fragment), e.length = e.fragment.length();
  var u = t.macFunction(t.macKey, t.sequenceNumber, e);
  return t.updateSequenceNumber(), n = Dd(t.macKey, i, u) && n, n;
}
function Dd(e, t, n) {
  var r = _r.hmac.create();
  return r.start("SHA1", e), r.update(t), t = r.digest().getBytes(), r.start(null, null), r.update(n), n = r.digest().getBytes(), t === n;
}
var nt = De, $n = nt.sha512 = nt.sha512 || {};
nt.md.sha512 = nt.md.algorithms.sha512 = $n;
var Rc = nt.sha384 = nt.sha512.sha384 = nt.sha512.sha384 || {};
Rc.create = function() {
  return $n.create("SHA-384");
};
nt.md.sha384 = nt.md.algorithms.sha384 = Rc;
nt.sha512.sha256 = nt.sha512.sha256 || {
  create: function() {
    return $n.create("SHA-512/256");
  }
};
nt.md["sha512/256"] = nt.md.algorithms["sha512/256"] = nt.sha512.sha256;
nt.sha512.sha224 = nt.sha512.sha224 || {
  create: function() {
    return $n.create("SHA-512/224");
  }
};
nt.md["sha512/224"] = nt.md.algorithms["sha512/224"] = nt.sha512.sha224;
$n.create = function(e) {
  if (Lc || kd(), typeof e > "u" && (e = "SHA-512"), !(e in qr))
    throw new Error("Invalid SHA-512 algorithm: " + e);
  for (var t = qr[e], n = null, r = nt.util.createBuffer(), a = new Array(80), s = 0; s < 80; ++s)
    a[s] = new Array(2);
  var i = 64;
  switch (e) {
    case "SHA-384":
      i = 48;
      break;
    case "SHA-512/256":
      i = 32;
      break;
    case "SHA-512/224":
      i = 28;
      break;
  }
  var o = {
    // SHA-512 => sha512
    algorithm: e.replace("-", "").toLowerCase(),
    blockLength: 128,
    digestLength: i,
    // 56-bit length of message so far (does not including padding)
    messageLength: 0,
    // true message length
    fullMessageLength: null,
    // size of message length in bytes
    messageLengthSize: 16
  };
  return o.start = function() {
    o.messageLength = 0, o.fullMessageLength = o.messageLength128 = [];
    for (var u = o.messageLengthSize / 4, c = 0; c < u; ++c)
      o.fullMessageLength.push(0);
    r = nt.util.createBuffer(), n = new Array(t.length);
    for (var c = 0; c < t.length; ++c)
      n[c] = t[c].slice(0);
    return o;
  }, o.start(), o.update = function(u, c) {
    c === "utf8" && (u = nt.util.encodeUtf8(u));
    var l = u.length;
    o.messageLength += l, l = [l / 4294967296 >>> 0, l >>> 0];
    for (var p = o.fullMessageLength.length - 1; p >= 0; --p)
      o.fullMessageLength[p] += l[1], l[1] = l[0] + (o.fullMessageLength[p] / 4294967296 >>> 0), o.fullMessageLength[p] = o.fullMessageLength[p] >>> 0, l[0] = l[1] / 4294967296 >>> 0;
    return r.putBytes(u), ao(n, a, r), (r.read > 2048 || r.length() === 0) && r.compact(), o;
  }, o.digest = function() {
    var u = nt.util.createBuffer();
    u.putBytes(r.bytes());
    var c = o.fullMessageLength[o.fullMessageLength.length - 1] + o.messageLengthSize, l = c & o.blockLength - 1;
    u.putBytes(wi.substr(0, o.blockLength - l));
    for (var p, g, C = o.fullMessageLength[0] * 8, d = 0; d < o.fullMessageLength.length - 1; ++d)
      p = o.fullMessageLength[d + 1] * 8, g = p / 4294967296 >>> 0, C += g, u.putInt32(C >>> 0), C = p >>> 0;
    u.putInt32(C);
    for (var b = new Array(n.length), d = 0; d < n.length; ++d)
      b[d] = n[d].slice(0);
    ao(b, a, u);
    var S = nt.util.createBuffer(), A;
    e === "SHA-512" ? A = b.length : e === "SHA-384" ? A = b.length - 2 : A = b.length - 4;
    for (var d = 0; d < A; ++d)
      S.putInt32(b[d][0]), (d !== A - 1 || e !== "SHA-512/224") && S.putInt32(b[d][1]);
    return S;
  }, o;
};
var wi = null, Lc = !1, Bi = null, qr = null;
function kd() {
  wi = String.fromCharCode(128), wi += nt.util.fillString(String.fromCharCode(0), 128), Bi = [
    [1116352408, 3609767458],
    [1899447441, 602891725],
    [3049323471, 3964484399],
    [3921009573, 2173295548],
    [961987163, 4081628472],
    [1508970993, 3053834265],
    [2453635748, 2937671579],
    [2870763221, 3664609560],
    [3624381080, 2734883394],
    [310598401, 1164996542],
    [607225278, 1323610764],
    [1426881987, 3590304994],
    [1925078388, 4068182383],
    [2162078206, 991336113],
    [2614888103, 633803317],
    [3248222580, 3479774868],
    [3835390401, 2666613458],
    [4022224774, 944711139],
    [264347078, 2341262773],
    [604807628, 2007800933],
    [770255983, 1495990901],
    [1249150122, 1856431235],
    [1555081692, 3175218132],
    [1996064986, 2198950837],
    [2554220882, 3999719339],
    [2821834349, 766784016],
    [2952996808, 2566594879],
    [3210313671, 3203337956],
    [3336571891, 1034457026],
    [3584528711, 2466948901],
    [113926993, 3758326383],
    [338241895, 168717936],
    [666307205, 1188179964],
    [773529912, 1546045734],
    [1294757372, 1522805485],
    [1396182291, 2643833823],
    [1695183700, 2343527390],
    [1986661051, 1014477480],
    [2177026350, 1206759142],
    [2456956037, 344077627],
    [2730485921, 1290863460],
    [2820302411, 3158454273],
    [3259730800, 3505952657],
    [3345764771, 106217008],
    [3516065817, 3606008344],
    [3600352804, 1432725776],
    [4094571909, 1467031594],
    [275423344, 851169720],
    [430227734, 3100823752],
    [506948616, 1363258195],
    [659060556, 3750685593],
    [883997877, 3785050280],
    [958139571, 3318307427],
    [1322822218, 3812723403],
    [1537002063, 2003034995],
    [1747873779, 3602036899],
    [1955562222, 1575990012],
    [2024104815, 1125592928],
    [2227730452, 2716904306],
    [2361852424, 442776044],
    [2428436474, 593698344],
    [2756734187, 3733110249],
    [3204031479, 2999351573],
    [3329325298, 3815920427],
    [3391569614, 3928383900],
    [3515267271, 566280711],
    [3940187606, 3454069534],
    [4118630271, 4000239992],
    [116418474, 1914138554],
    [174292421, 2731055270],
    [289380356, 3203993006],
    [460393269, 320620315],
    [685471733, 587496836],
    [852142971, 1086792851],
    [1017036298, 365543100],
    [1126000580, 2618297676],
    [1288033470, 3409855158],
    [1501505948, 4234509866],
    [1607167915, 987167468],
    [1816402316, 1246189591]
  ], qr = {}, qr["SHA-512"] = [
    [1779033703, 4089235720],
    [3144134277, 2227873595],
    [1013904242, 4271175723],
    [2773480762, 1595750129],
    [1359893119, 2917565137],
    [2600822924, 725511199],
    [528734635, 4215389547],
    [1541459225, 327033209]
  ], qr["SHA-384"] = [
    [3418070365, 3238371032],
    [1654270250, 914150663],
    [2438529370, 812702999],
    [355462360, 4144912697],
    [1731405415, 4290775857],
    [2394180231, 1750603025],
    [3675008525, 1694076839],
    [1203062813, 3204075428]
  ], qr["SHA-512/256"] = [
    [573645204, 4230739756],
    [2673172387, 3360449730],
    [596883563, 1867755857],
    [2520282905, 1497426621],
    [2519219938, 2827943907],
    [3193839141, 1401305490],
    [721525244, 746961066],
    [246885852, 2177182882]
  ], qr["SHA-512/224"] = [
    [2352822216, 424955298],
    [1944164710, 2312950998],
    [502970286, 855612546],
    [1738396948, 1479516111],
    [258812777, 2077511080],
    [2011393907, 79989058],
    [1067287976, 1780299464],
    [286451373, 2446758561]
  ], Lc = !0;
}
function ao(e, t, n) {
  for (var r, a, s, i, o, u, c, l, p, g, C, d, b, S, A, D, _, M, K, k, J, re, G, $, ue, ge, de, ve, se, ie, Q, xe, Z, q, Y, le = n.length(); le >= 128; ) {
    for (se = 0; se < 16; ++se)
      t[se][0] = n.getInt32() >>> 0, t[se][1] = n.getInt32() >>> 0;
    for (; se < 80; ++se)
      xe = t[se - 2], ie = xe[0], Q = xe[1], r = ((ie >>> 19 | Q << 13) ^ // ROTR 19
      (Q >>> 29 | ie << 3) ^ // ROTR 61/(swap + ROTR 29)
      ie >>> 6) >>> 0, a = ((ie << 13 | Q >>> 19) ^ // ROTR 19
      (Q << 3 | ie >>> 29) ^ // ROTR 61/(swap + ROTR 29)
      (ie << 26 | Q >>> 6)) >>> 0, q = t[se - 15], ie = q[0], Q = q[1], s = ((ie >>> 1 | Q << 31) ^ // ROTR 1
      (ie >>> 8 | Q << 24) ^ // ROTR 8
      ie >>> 7) >>> 0, i = ((ie << 31 | Q >>> 1) ^ // ROTR 1
      (ie << 24 | Q >>> 8) ^ // ROTR 8
      (ie << 25 | Q >>> 7)) >>> 0, Z = t[se - 7], Y = t[se - 16], Q = a + Z[1] + i + Y[1], t[se][0] = r + Z[0] + s + Y[0] + (Q / 4294967296 >>> 0) >>> 0, t[se][1] = Q >>> 0;
    for (b = e[0][0], S = e[0][1], A = e[1][0], D = e[1][1], _ = e[2][0], M = e[2][1], K = e[3][0], k = e[3][1], J = e[4][0], re = e[4][1], G = e[5][0], $ = e[5][1], ue = e[6][0], ge = e[6][1], de = e[7][0], ve = e[7][1], se = 0; se < 80; ++se)
      c = ((J >>> 14 | re << 18) ^ // ROTR 14
      (J >>> 18 | re << 14) ^ // ROTR 18
      (re >>> 9 | J << 23)) >>> 0, l = ((J << 18 | re >>> 14) ^ // ROTR 14
      (J << 14 | re >>> 18) ^ // ROTR 18
      (re << 23 | J >>> 9)) >>> 0, p = (ue ^ J & (G ^ ue)) >>> 0, g = (ge ^ re & ($ ^ ge)) >>> 0, o = ((b >>> 28 | S << 4) ^ // ROTR 28
      (S >>> 2 | b << 30) ^ // ROTR 34/(swap + ROTR 2)
      (S >>> 7 | b << 25)) >>> 0, u = ((b << 4 | S >>> 28) ^ // ROTR 28
      (S << 30 | b >>> 2) ^ // ROTR 34/(swap + ROTR 2)
      (S << 25 | b >>> 7)) >>> 0, C = (b & A | _ & (b ^ A)) >>> 0, d = (S & D | M & (S ^ D)) >>> 0, Q = ve + l + g + Bi[se][1] + t[se][1], r = de + c + p + Bi[se][0] + t[se][0] + (Q / 4294967296 >>> 0) >>> 0, a = Q >>> 0, Q = u + d, s = o + C + (Q / 4294967296 >>> 0) >>> 0, i = Q >>> 0, de = ue, ve = ge, ue = G, ge = $, G = J, $ = re, Q = k + a, J = K + r + (Q / 4294967296 >>> 0) >>> 0, re = Q >>> 0, K = _, k = M, _ = A, M = D, A = b, D = S, Q = a + i, b = r + s + (Q / 4294967296 >>> 0) >>> 0, S = Q >>> 0;
    Q = e[0][1] + S, e[0][0] = e[0][0] + b + (Q / 4294967296 >>> 0) >>> 0, e[0][1] = Q >>> 0, Q = e[1][1] + D, e[1][0] = e[1][0] + A + (Q / 4294967296 >>> 0) >>> 0, e[1][1] = Q >>> 0, Q = e[2][1] + M, e[2][0] = e[2][0] + _ + (Q / 4294967296 >>> 0) >>> 0, e[2][1] = Q >>> 0, Q = e[3][1] + k, e[3][0] = e[3][0] + K + (Q / 4294967296 >>> 0) >>> 0, e[3][1] = Q >>> 0, Q = e[4][1] + re, e[4][0] = e[4][0] + J + (Q / 4294967296 >>> 0) >>> 0, e[4][1] = Q >>> 0, Q = e[5][1] + $, e[5][0] = e[5][0] + G + (Q / 4294967296 >>> 0) >>> 0, e[5][1] = Q >>> 0, Q = e[6][1] + ge, e[6][0] = e[6][0] + ue + (Q / 4294967296 >>> 0) >>> 0, e[6][1] = Q >>> 0, Q = e[7][1] + ve, e[7][0] = e[7][0] + de + (Q / 4294967296 >>> 0) >>> 0, e[7][1] = Q >>> 0, le -= 128;
  }
}
var rs = {}, Od = De, ht = Od.asn1;
rs.privateKeyValidator = {
  // PrivateKeyInfo
  name: "PrivateKeyInfo",
  tagClass: ht.Class.UNIVERSAL,
  type: ht.Type.SEQUENCE,
  constructed: !0,
  value: [{
    // Version (INTEGER)
    name: "PrivateKeyInfo.version",
    tagClass: ht.Class.UNIVERSAL,
    type: ht.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyVersion"
  }, {
    // privateKeyAlgorithm
    name: "PrivateKeyInfo.privateKeyAlgorithm",
    tagClass: ht.Class.UNIVERSAL,
    type: ht.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "AlgorithmIdentifier.algorithm",
      tagClass: ht.Class.UNIVERSAL,
      type: ht.Type.OID,
      constructed: !1,
      capture: "privateKeyOid"
    }]
  }, {
    // PrivateKey
    name: "PrivateKeyInfo",
    tagClass: ht.Class.UNIVERSAL,
    type: ht.Type.OCTETSTRING,
    constructed: !1,
    capture: "privateKey"
  }]
};
rs.publicKeyValidator = {
  name: "SubjectPublicKeyInfo",
  tagClass: ht.Class.UNIVERSAL,
  type: ht.Type.SEQUENCE,
  constructed: !0,
  captureAsn1: "subjectPublicKeyInfo",
  value: [
    {
      name: "SubjectPublicKeyInfo.AlgorithmIdentifier",
      tagClass: ht.Class.UNIVERSAL,
      type: ht.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "AlgorithmIdentifier.algorithm",
        tagClass: ht.Class.UNIVERSAL,
        type: ht.Type.OID,
        constructed: !1,
        capture: "publicKeyOid"
      }]
    },
    // capture group for ed25519PublicKey
    {
      tagClass: ht.Class.UNIVERSAL,
      type: ht.Type.BITSTRING,
      constructed: !1,
      composed: !0,
      captureBitStringValue: "ed25519PublicKey"
    }
    // FIXME: this is capture group for rsaPublicKey, use it in this API or
    // discard?
    /* {
      // subjectPublicKey
      name: 'SubjectPublicKeyInfo.subjectPublicKey',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.BITSTRING,
      constructed: false,
      value: [{
        // RSAPublicKey
        name: 'SubjectPublicKeyInfo.subjectPublicKey.RSAPublicKey',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.SEQUENCE,
        constructed: true,
        optional: true,
        captureAsn1: 'rsaPublicKey'
      }]
    } */
  ]
};
var mt = De, Dc = rs, Pd = Dc.publicKeyValidator, Ud = Dc.privateKeyValidator;
if (typeof Fd > "u")
  var Fd = mt.jsbn.BigInteger;
var _i = mt.util.ByteBuffer, Bt = typeof Buffer > "u" ? Uint8Array : Buffer;
mt.pki = mt.pki || {};
mt.pki.ed25519 = mt.ed25519 = mt.ed25519 || {};
var Oe = mt.ed25519;
Oe.constants = {};
Oe.constants.PUBLIC_KEY_BYTE_LENGTH = 32;
Oe.constants.PRIVATE_KEY_BYTE_LENGTH = 64;
Oe.constants.SEED_BYTE_LENGTH = 32;
Oe.constants.SIGN_BYTE_LENGTH = 64;
Oe.constants.HASH_BYTE_LENGTH = 64;
Oe.generateKeyPair = function(e) {
  e = e || {};
  var t = e.seed;
  if (t === void 0)
    t = mt.random.getBytesSync(Oe.constants.SEED_BYTE_LENGTH);
  else if (typeof t == "string") {
    if (t.length !== Oe.constants.SEED_BYTE_LENGTH)
      throw new TypeError(
        '"seed" must be ' + Oe.constants.SEED_BYTE_LENGTH + " bytes in length."
      );
  } else if (!(t instanceof Uint8Array))
    throw new TypeError(
      '"seed" must be a node.js Buffer, Uint8Array, or a binary string.'
    );
  t = hr({ message: t, encoding: "binary" });
  for (var n = new Bt(Oe.constants.PUBLIC_KEY_BYTE_LENGTH), r = new Bt(Oe.constants.PRIVATE_KEY_BYTE_LENGTH), a = 0; a < 32; ++a)
    r[a] = t[a];
  return jd(n, r), { publicKey: n, privateKey: r };
};
Oe.privateKeyFromAsn1 = function(e) {
  var t = {}, n = [], r = mt.asn1.validate(e, Ud, t, n);
  if (!r) {
    var a = new Error("Invalid Key.");
    throw a.errors = n, a;
  }
  var s = mt.asn1.derToOid(t.privateKeyOid), i = mt.oids.EdDSA25519;
  if (s !== i)
    throw new Error('Invalid OID "' + s + '"; OID must be "' + i + '".');
  var o = t.privateKey, u = hr({
    message: mt.asn1.fromDer(o).value,
    encoding: "binary"
  });
  return { privateKeyBytes: u };
};
Oe.publicKeyFromAsn1 = function(e) {
  var t = {}, n = [], r = mt.asn1.validate(e, Pd, t, n);
  if (!r) {
    var a = new Error("Invalid Key.");
    throw a.errors = n, a;
  }
  var s = mt.asn1.derToOid(t.publicKeyOid), i = mt.oids.EdDSA25519;
  if (s !== i)
    throw new Error('Invalid OID "' + s + '"; OID must be "' + i + '".');
  var o = t.ed25519PublicKey;
  if (o.length !== Oe.constants.PUBLIC_KEY_BYTE_LENGTH)
    throw new Error("Key length is invalid.");
  return hr({
    message: o,
    encoding: "binary"
  });
};
Oe.publicKeyFromPrivateKey = function(e) {
  e = e || {};
  var t = hr({
    message: e.privateKey,
    encoding: "binary"
  });
  if (t.length !== Oe.constants.PRIVATE_KEY_BYTE_LENGTH)
    throw new TypeError(
      '"options.privateKey" must have a byte length of ' + Oe.constants.PRIVATE_KEY_BYTE_LENGTH
    );
  for (var n = new Bt(Oe.constants.PUBLIC_KEY_BYTE_LENGTH), r = 0; r < n.length; ++r)
    n[r] = t[32 + r];
  return n;
};
Oe.sign = function(e) {
  e = e || {};
  var t = hr(e), n = hr({
    message: e.privateKey,
    encoding: "binary"
  });
  if (n.length === Oe.constants.SEED_BYTE_LENGTH) {
    var r = Oe.generateKeyPair({ seed: n });
    n = r.privateKey;
  } else if (n.length !== Oe.constants.PRIVATE_KEY_BYTE_LENGTH)
    throw new TypeError(
      '"options.privateKey" must have a byte length of ' + Oe.constants.SEED_BYTE_LENGTH + " or " + Oe.constants.PRIVATE_KEY_BYTE_LENGTH
    );
  var a = new Bt(
    Oe.constants.SIGN_BYTE_LENGTH + t.length
  );
  Hd(a, t, t.length, n);
  for (var s = new Bt(Oe.constants.SIGN_BYTE_LENGTH), i = 0; i < s.length; ++i)
    s[i] = a[i];
  return s;
};
Oe.verify = function(e) {
  e = e || {};
  var t = hr(e);
  if (e.signature === void 0)
    throw new TypeError(
      '"options.signature" must be a node.js Buffer, a Uint8Array, a forge ByteBuffer, or a binary string.'
    );
  var n = hr({
    message: e.signature,
    encoding: "binary"
  });
  if (n.length !== Oe.constants.SIGN_BYTE_LENGTH)
    throw new TypeError(
      '"options.signature" must have a byte length of ' + Oe.constants.SIGN_BYTE_LENGTH
    );
  var r = hr({
    message: e.publicKey,
    encoding: "binary"
  });
  if (r.length !== Oe.constants.PUBLIC_KEY_BYTE_LENGTH)
    throw new TypeError(
      '"options.publicKey" must have a byte length of ' + Oe.constants.PUBLIC_KEY_BYTE_LENGTH
    );
  var a = new Bt(Oe.constants.SIGN_BYTE_LENGTH + t.length), s = new Bt(Oe.constants.SIGN_BYTE_LENGTH + t.length), i;
  for (i = 0; i < Oe.constants.SIGN_BYTE_LENGTH; ++i)
    a[i] = n[i];
  for (i = 0; i < t.length; ++i)
    a[i + Oe.constants.SIGN_BYTE_LENGTH] = t[i];
  return qd(s, a, a.length, r) >= 0;
};
function hr(e) {
  var t = e.message;
  if (t instanceof Uint8Array || t instanceof Bt)
    return t;
  var n = e.encoding;
  if (t === void 0)
    if (e.md)
      t = e.md.digest().getBytes(), n = "binary";
    else
      throw new TypeError('"options.message" or "options.md" not specified.');
  if (typeof t == "string" && !n)
    throw new TypeError('"options.encoding" must be "binary" or "utf8".');
  if (typeof t == "string") {
    if (typeof Buffer < "u")
      return Buffer.from(t, n);
    t = new _i(t, n);
  } else if (!(t instanceof _i))
    throw new TypeError(
      '"options.message" must be a node.js Buffer, a Uint8Array, a forge ByteBuffer, or a string with "options.encoding" specifying its encoding.'
    );
  for (var r = new Bt(t.length()), a = 0; a < r.length; ++a)
    r[a] = t.at(a);
  return r;
}
var Ni = Ae(), ma = Ae([1]), Vd = Ae([
  30883,
  4953,
  19914,
  30187,
  55467,
  16705,
  2637,
  112,
  59544,
  30585,
  16505,
  36039,
  65139,
  11119,
  27886,
  20995
]), Md = Ae([
  61785,
  9906,
  39828,
  60374,
  45398,
  33411,
  5274,
  224,
  53552,
  61171,
  33010,
  6542,
  64743,
  22239,
  55772,
  9222
]), io = Ae([
  54554,
  36645,
  11616,
  51542,
  42930,
  38181,
  51040,
  26924,
  56412,
  64982,
  57905,
  49316,
  21502,
  52590,
  14035,
  8553
]), so = Ae([
  26200,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214
]), si = new Float64Array([
  237,
  211,
  245,
  92,
  26,
  99,
  18,
  88,
  214,
  156,
  247,
  162,
  222,
  249,
  222,
  20,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  16
]), Kd = Ae([
  41136,
  18958,
  6951,
  50414,
  58488,
  44335,
  6150,
  12099,
  55207,
  15867,
  153,
  11085,
  57099,
  20417,
  9344,
  11139
]);
function Un(e, t) {
  var n = mt.md.sha512.create(), r = new _i(e);
  n.update(r.getBytes(t), "binary");
  var a = n.digest().getBytes();
  if (typeof Buffer < "u")
    return Buffer.from(a, "binary");
  for (var s = new Bt(Oe.constants.HASH_BYTE_LENGTH), i = 0; i < 64; ++i)
    s[i] = a.charCodeAt(i);
  return s;
}
function jd(e, t) {
  var n = [Ae(), Ae(), Ae(), Ae()], r, a = Un(t, 32);
  for (a[0] &= 248, a[31] &= 127, a[31] |= 64, as(n, a), ns(e, n), r = 0; r < 32; ++r)
    t[r + 32] = e[r];
  return 0;
}
function Hd(e, t, n, r) {
  var a, s, i = new Float64Array(64), o = [Ae(), Ae(), Ae(), Ae()], u = Un(r, 32);
  u[0] &= 248, u[31] &= 127, u[31] |= 64;
  var c = n + 64;
  for (a = 0; a < n; ++a)
    e[64 + a] = t[a];
  for (a = 0; a < 32; ++a)
    e[32 + a] = u[32 + a];
  var l = Un(e.subarray(32), n + 32);
  for (Ri(l), as(o, l), ns(e, o), a = 32; a < 64; ++a)
    e[a] = r[a];
  var p = Un(e, n + 64);
  for (Ri(p), a = 32; a < 64; ++a)
    i[a] = 0;
  for (a = 0; a < 32; ++a)
    i[a] = l[a];
  for (a = 0; a < 32; ++a)
    for (s = 0; s < 32; s++)
      i[a + s] += p[a] * u[s];
  return kc(e.subarray(32), i), c;
}
function qd(e, t, n, r) {
  var a, s, i = new Bt(32), o = [Ae(), Ae(), Ae(), Ae()], u = [Ae(), Ae(), Ae(), Ae()];
  if (s = -1, n < 64 || Gd(u, r))
    return -1;
  for (a = 0; a < n; ++a)
    e[a] = t[a];
  for (a = 0; a < 32; ++a)
    e[a + 32] = r[a];
  var c = Un(e, n);
  if (Ri(c), Uc(o, u, c), as(u, t.subarray(32)), Li(o, u), ns(i, o), n -= 64, Oc(t, 0, i, 0)) {
    for (a = 0; a < n; ++a)
      e[a] = 0;
    return -1;
  }
  for (a = 0; a < n; ++a)
    e[a] = t[a + 64];
  return s = n, s;
}
function kc(e, t) {
  var n, r, a, s;
  for (r = 63; r >= 32; --r) {
    for (n = 0, a = r - 32, s = r - 12; a < s; ++a)
      t[a] += n - 16 * t[r] * si[a - (r - 32)], n = t[a] + 128 >> 8, t[a] -= n * 256;
    t[a] += n, t[r] = 0;
  }
  for (n = 0, a = 0; a < 32; ++a)
    t[a] += n - (t[31] >> 4) * si[a], n = t[a] >> 8, t[a] &= 255;
  for (a = 0; a < 32; ++a)
    t[a] -= n * si[a];
  for (r = 0; r < 32; ++r)
    t[r + 1] += t[r] >> 8, e[r] = t[r] & 255;
}
function Ri(e) {
  for (var t = new Float64Array(64), n = 0; n < 64; ++n)
    t[n] = e[n], e[n] = 0;
  kc(e, t);
}
function Li(e, t) {
  var n = Ae(), r = Ae(), a = Ae(), s = Ae(), i = Ae(), o = Ae(), u = Ae(), c = Ae(), l = Ae();
  dn(n, e[1], e[0]), dn(l, t[1], t[0]), Je(n, n, l), pn(r, e[0], e[1]), pn(l, t[0], t[1]), Je(r, r, l), Je(a, e[3], t[3]), Je(a, a, Md), Je(s, e[2], t[2]), pn(s, s, s), dn(i, r, n), dn(o, s, a), pn(u, s, a), pn(c, r, n), Je(e[0], i, o), Je(e[1], c, u), Je(e[2], u, o), Je(e[3], i, c);
}
function oo(e, t, n) {
  for (var r = 0; r < 4; ++r)
    Fc(e[r], t[r], n);
}
function ns(e, t) {
  var n = Ae(), r = Ae(), a = Ae();
  Qd(a, t[2]), Je(n, t[0], a), Je(r, t[1], a), Ea(e, r), e[31] ^= Pc(n) << 7;
}
function Ea(e, t) {
  var n, r, a, s = Ae(), i = Ae();
  for (n = 0; n < 16; ++n)
    i[n] = t[n];
  for (oi(i), oi(i), oi(i), r = 0; r < 2; ++r) {
    for (s[0] = i[0] - 65517, n = 1; n < 15; ++n)
      s[n] = i[n] - 65535 - (s[n - 1] >> 16 & 1), s[n - 1] &= 65535;
    s[15] = i[15] - 32767 - (s[14] >> 16 & 1), a = s[15] >> 16 & 1, s[14] &= 65535, Fc(i, s, 1 - a);
  }
  for (n = 0; n < 16; n++)
    e[2 * n] = i[n] & 255, e[2 * n + 1] = i[n] >> 8;
}
function Gd(e, t) {
  var n = Ae(), r = Ae(), a = Ae(), s = Ae(), i = Ae(), o = Ae(), u = Ae();
  return xr(e[2], ma), $d(e[1], t), Gr(a, e[1]), Je(s, a, Vd), dn(a, a, e[2]), pn(s, e[2], s), Gr(i, s), Gr(o, i), Je(u, o, i), Je(n, u, a), Je(n, n, s), zd(n, n), Je(n, n, a), Je(n, n, s), Je(n, n, s), Je(e[0], n, s), Gr(r, e[0]), Je(r, r, s), co(r, a) && Je(e[0], e[0], Kd), Gr(r, e[0]), Je(r, r, s), co(r, a) ? -1 : (Pc(e[0]) === t[31] >> 7 && dn(e[0], Ni, e[0]), Je(e[3], e[0], e[1]), 0);
}
function $d(e, t) {
  var n;
  for (n = 0; n < 16; ++n)
    e[n] = t[2 * n] + (t[2 * n + 1] << 8);
  e[15] &= 32767;
}
function zd(e, t) {
  var n = Ae(), r;
  for (r = 0; r < 16; ++r)
    n[r] = t[r];
  for (r = 250; r >= 0; --r)
    Gr(n, n), r !== 1 && Je(n, n, t);
  for (r = 0; r < 16; ++r)
    e[r] = n[r];
}
function co(e, t) {
  var n = new Bt(32), r = new Bt(32);
  return Ea(n, e), Ea(r, t), Oc(n, 0, r, 0);
}
function Oc(e, t, n, r) {
  return Wd(e, t, n, r, 32);
}
function Wd(e, t, n, r, a) {
  var s, i = 0;
  for (s = 0; s < a; ++s)
    i |= e[t + s] ^ n[r + s];
  return (1 & i - 1 >>> 8) - 1;
}
function Pc(e) {
  var t = new Bt(32);
  return Ea(t, e), t[0] & 1;
}
function Uc(e, t, n) {
  var r, a;
  for (xr(e[0], Ni), xr(e[1], ma), xr(e[2], ma), xr(e[3], Ni), a = 255; a >= 0; --a)
    r = n[a / 8 | 0] >> (a & 7) & 1, oo(e, t, r), Li(t, e), Li(e, e), oo(e, t, r);
}
function as(e, t) {
  var n = [Ae(), Ae(), Ae(), Ae()];
  xr(n[0], io), xr(n[1], so), xr(n[2], ma), Je(n[3], io, so), Uc(e, n, t);
}
function xr(e, t) {
  var n;
  for (n = 0; n < 16; n++)
    e[n] = t[n] | 0;
}
function Qd(e, t) {
  var n = Ae(), r;
  for (r = 0; r < 16; ++r)
    n[r] = t[r];
  for (r = 253; r >= 0; --r)
    Gr(n, n), r !== 2 && r !== 4 && Je(n, n, t);
  for (r = 0; r < 16; ++r)
    e[r] = n[r];
}
function oi(e) {
  var t, n, r = 1;
  for (t = 0; t < 16; ++t)
    n = e[t] + r + 65535, r = Math.floor(n / 65536), e[t] = n - r * 65536;
  e[0] += r - 1 + 37 * (r - 1);
}
function Fc(e, t, n) {
  for (var r, a = ~(n - 1), s = 0; s < 16; ++s)
    r = a & (e[s] ^ t[s]), e[s] ^= r, t[s] ^= r;
}
function Ae(e) {
  var t, n = new Float64Array(16);
  if (e)
    for (t = 0; t < e.length; ++t)
      n[t] = e[t];
  return n;
}
function pn(e, t, n) {
  for (var r = 0; r < 16; ++r)
    e[r] = t[r] + n[r];
}
function dn(e, t, n) {
  for (var r = 0; r < 16; ++r)
    e[r] = t[r] - n[r];
}
function Gr(e, t) {
  Je(e, t, t);
}
function Je(e, t, n) {
  var r, a, s = 0, i = 0, o = 0, u = 0, c = 0, l = 0, p = 0, g = 0, C = 0, d = 0, b = 0, S = 0, A = 0, D = 0, _ = 0, M = 0, K = 0, k = 0, J = 0, re = 0, G = 0, $ = 0, ue = 0, ge = 0, de = 0, ve = 0, se = 0, ie = 0, Q = 0, xe = 0, Z = 0, q = n[0], Y = n[1], le = n[2], Ce = n[3], O = n[4], we = n[5], Be = n[6], $e = n[7], Ee = n[8], Fe = n[9], qe = n[10], Ve = n[11], ze = n[12], Ge = n[13], Ne = n[14], Me = n[15];
  r = t[0], s += r * q, i += r * Y, o += r * le, u += r * Ce, c += r * O, l += r * we, p += r * Be, g += r * $e, C += r * Ee, d += r * Fe, b += r * qe, S += r * Ve, A += r * ze, D += r * Ge, _ += r * Ne, M += r * Me, r = t[1], i += r * q, o += r * Y, u += r * le, c += r * Ce, l += r * O, p += r * we, g += r * Be, C += r * $e, d += r * Ee, b += r * Fe, S += r * qe, A += r * Ve, D += r * ze, _ += r * Ge, M += r * Ne, K += r * Me, r = t[2], o += r * q, u += r * Y, c += r * le, l += r * Ce, p += r * O, g += r * we, C += r * Be, d += r * $e, b += r * Ee, S += r * Fe, A += r * qe, D += r * Ve, _ += r * ze, M += r * Ge, K += r * Ne, k += r * Me, r = t[3], u += r * q, c += r * Y, l += r * le, p += r * Ce, g += r * O, C += r * we, d += r * Be, b += r * $e, S += r * Ee, A += r * Fe, D += r * qe, _ += r * Ve, M += r * ze, K += r * Ge, k += r * Ne, J += r * Me, r = t[4], c += r * q, l += r * Y, p += r * le, g += r * Ce, C += r * O, d += r * we, b += r * Be, S += r * $e, A += r * Ee, D += r * Fe, _ += r * qe, M += r * Ve, K += r * ze, k += r * Ge, J += r * Ne, re += r * Me, r = t[5], l += r * q, p += r * Y, g += r * le, C += r * Ce, d += r * O, b += r * we, S += r * Be, A += r * $e, D += r * Ee, _ += r * Fe, M += r * qe, K += r * Ve, k += r * ze, J += r * Ge, re += r * Ne, G += r * Me, r = t[6], p += r * q, g += r * Y, C += r * le, d += r * Ce, b += r * O, S += r * we, A += r * Be, D += r * $e, _ += r * Ee, M += r * Fe, K += r * qe, k += r * Ve, J += r * ze, re += r * Ge, G += r * Ne, $ += r * Me, r = t[7], g += r * q, C += r * Y, d += r * le, b += r * Ce, S += r * O, A += r * we, D += r * Be, _ += r * $e, M += r * Ee, K += r * Fe, k += r * qe, J += r * Ve, re += r * ze, G += r * Ge, $ += r * Ne, ue += r * Me, r = t[8], C += r * q, d += r * Y, b += r * le, S += r * Ce, A += r * O, D += r * we, _ += r * Be, M += r * $e, K += r * Ee, k += r * Fe, J += r * qe, re += r * Ve, G += r * ze, $ += r * Ge, ue += r * Ne, ge += r * Me, r = t[9], d += r * q, b += r * Y, S += r * le, A += r * Ce, D += r * O, _ += r * we, M += r * Be, K += r * $e, k += r * Ee, J += r * Fe, re += r * qe, G += r * Ve, $ += r * ze, ue += r * Ge, ge += r * Ne, de += r * Me, r = t[10], b += r * q, S += r * Y, A += r * le, D += r * Ce, _ += r * O, M += r * we, K += r * Be, k += r * $e, J += r * Ee, re += r * Fe, G += r * qe, $ += r * Ve, ue += r * ze, ge += r * Ge, de += r * Ne, ve += r * Me, r = t[11], S += r * q, A += r * Y, D += r * le, _ += r * Ce, M += r * O, K += r * we, k += r * Be, J += r * $e, re += r * Ee, G += r * Fe, $ += r * qe, ue += r * Ve, ge += r * ze, de += r * Ge, ve += r * Ne, se += r * Me, r = t[12], A += r * q, D += r * Y, _ += r * le, M += r * Ce, K += r * O, k += r * we, J += r * Be, re += r * $e, G += r * Ee, $ += r * Fe, ue += r * qe, ge += r * Ve, de += r * ze, ve += r * Ge, se += r * Ne, ie += r * Me, r = t[13], D += r * q, _ += r * Y, M += r * le, K += r * Ce, k += r * O, J += r * we, re += r * Be, G += r * $e, $ += r * Ee, ue += r * Fe, ge += r * qe, de += r * Ve, ve += r * ze, se += r * Ge, ie += r * Ne, Q += r * Me, r = t[14], _ += r * q, M += r * Y, K += r * le, k += r * Ce, J += r * O, re += r * we, G += r * Be, $ += r * $e, ue += r * Ee, ge += r * Fe, de += r * qe, ve += r * Ve, se += r * ze, ie += r * Ge, Q += r * Ne, xe += r * Me, r = t[15], M += r * q, K += r * Y, k += r * le, J += r * Ce, re += r * O, G += r * we, $ += r * Be, ue += r * $e, ge += r * Ee, de += r * Fe, ve += r * qe, se += r * Ve, ie += r * ze, Q += r * Ge, xe += r * Ne, Z += r * Me, s += 38 * K, i += 38 * k, o += 38 * J, u += 38 * re, c += 38 * G, l += 38 * $, p += 38 * ue, g += 38 * ge, C += 38 * de, d += 38 * ve, b += 38 * se, S += 38 * ie, A += 38 * Q, D += 38 * xe, _ += 38 * Z, a = 1, r = s + a + 65535, a = Math.floor(r / 65536), s = r - a * 65536, r = i + a + 65535, a = Math.floor(r / 65536), i = r - a * 65536, r = o + a + 65535, a = Math.floor(r / 65536), o = r - a * 65536, r = u + a + 65535, a = Math.floor(r / 65536), u = r - a * 65536, r = c + a + 65535, a = Math.floor(r / 65536), c = r - a * 65536, r = l + a + 65535, a = Math.floor(r / 65536), l = r - a * 65536, r = p + a + 65535, a = Math.floor(r / 65536), p = r - a * 65536, r = g + a + 65535, a = Math.floor(r / 65536), g = r - a * 65536, r = C + a + 65535, a = Math.floor(r / 65536), C = r - a * 65536, r = d + a + 65535, a = Math.floor(r / 65536), d = r - a * 65536, r = b + a + 65535, a = Math.floor(r / 65536), b = r - a * 65536, r = S + a + 65535, a = Math.floor(r / 65536), S = r - a * 65536, r = A + a + 65535, a = Math.floor(r / 65536), A = r - a * 65536, r = D + a + 65535, a = Math.floor(r / 65536), D = r - a * 65536, r = _ + a + 65535, a = Math.floor(r / 65536), _ = r - a * 65536, r = M + a + 65535, a = Math.floor(r / 65536), M = r - a * 65536, s += a - 1 + 37 * (a - 1), a = 1, r = s + a + 65535, a = Math.floor(r / 65536), s = r - a * 65536, r = i + a + 65535, a = Math.floor(r / 65536), i = r - a * 65536, r = o + a + 65535, a = Math.floor(r / 65536), o = r - a * 65536, r = u + a + 65535, a = Math.floor(r / 65536), u = r - a * 65536, r = c + a + 65535, a = Math.floor(r / 65536), c = r - a * 65536, r = l + a + 65535, a = Math.floor(r / 65536), l = r - a * 65536, r = p + a + 65535, a = Math.floor(r / 65536), p = r - a * 65536, r = g + a + 65535, a = Math.floor(r / 65536), g = r - a * 65536, r = C + a + 65535, a = Math.floor(r / 65536), C = r - a * 65536, r = d + a + 65535, a = Math.floor(r / 65536), d = r - a * 65536, r = b + a + 65535, a = Math.floor(r / 65536), b = r - a * 65536, r = S + a + 65535, a = Math.floor(r / 65536), S = r - a * 65536, r = A + a + 65535, a = Math.floor(r / 65536), A = r - a * 65536, r = D + a + 65535, a = Math.floor(r / 65536), D = r - a * 65536, r = _ + a + 65535, a = Math.floor(r / 65536), _ = r - a * 65536, r = M + a + 65535, a = Math.floor(r / 65536), M = r - a * 65536, s += a - 1 + 37 * (a - 1), e[0] = s, e[1] = i, e[2] = o, e[3] = u, e[4] = c, e[5] = l, e[6] = p, e[7] = g, e[8] = C, e[9] = d, e[10] = b, e[11] = S, e[12] = A, e[13] = D, e[14] = _, e[15] = M;
}
var Lt = De;
Lt.kem = Lt.kem || {};
var uo = Lt.jsbn.BigInteger;
Lt.kem.rsa = {};
Lt.kem.rsa.create = function(e, t) {
  t = t || {};
  var n = t.prng || Lt.random, r = {};
  return r.encrypt = function(a, s) {
    var i = Math.ceil(a.n.bitLength() / 8), o;
    do
      o = new uo(
        Lt.util.bytesToHex(n.getBytesSync(i)),
        16
      ).mod(a.n);
    while (o.compareTo(uo.ONE) <= 0);
    o = Lt.util.hexToBytes(o.toString(16));
    var u = i - o.length;
    u > 0 && (o = Lt.util.fillString(String.fromCharCode(0), u) + o);
    var c = a.encrypt(o, "NONE"), l = e.generate(o, s);
    return { encapsulation: c, key: l };
  }, r.decrypt = function(a, s, i) {
    var o = a.decrypt(s, "NONE");
    return e.generate(o, i);
  }, r;
};
Lt.kem.kdf1 = function(e, t) {
  Vc(this, e, 0, t || e.digestLength);
};
Lt.kem.kdf2 = function(e, t) {
  Vc(this, e, 1, t || e.digestLength);
};
function Vc(e, t, n, r) {
  e.generate = function(a, s) {
    for (var i = new Lt.util.ByteBuffer(), o = Math.ceil(s / r) + n, u = new Lt.util.ByteBuffer(), c = n; c < o; ++c) {
      u.putInt32(c), t.start(), t.update(a + u.getBytes());
      var l = t.digest();
      i.putBytes(l.getBytes(r));
    }
    return i.truncate(i.length() - s), i.getBytes();
  };
}
var Ue = De;
Ue.log = Ue.log || {};
Ue.log.levels = [
  "none",
  "error",
  "warning",
  "info",
  "debug",
  "verbose",
  "max"
];
var Ca = {}, Di = [], Fn = null;
Ue.log.LEVEL_LOCKED = 2;
Ue.log.NO_LEVEL_CHECK = 4;
Ue.log.INTERPOLATE = 8;
for (var Tr = 0; Tr < Ue.log.levels.length; ++Tr) {
  var lo = Ue.log.levels[Tr];
  Ca[lo] = {
    index: Tr,
    name: lo.toUpperCase()
  };
}
Ue.log.logMessage = function(e) {
  for (var t = Ca[e.level].index, n = 0; n < Di.length; ++n) {
    var r = Di[n];
    if (r.flags & Ue.log.NO_LEVEL_CHECK)
      r.f(e);
    else {
      var a = Ca[r.level].index;
      t <= a && r.f(r, e);
    }
  }
};
Ue.log.prepareStandard = function(e) {
  "standard" in e || (e.standard = Ca[e.level].name + //' ' + +message.timestamp +
  " [" + e.category + "] " + e.message);
};
Ue.log.prepareFull = function(e) {
  if (!("full" in e)) {
    var t = [e.message];
    t = t.concat([]), e.full = Ue.util.format.apply(this, t);
  }
};
Ue.log.prepareStandardFull = function(e) {
  "standardFull" in e || (Ue.log.prepareStandard(e), e.standardFull = e.standard);
};
for (var fo = ["error", "warning", "info", "debug", "verbose"], Tr = 0; Tr < fo.length; ++Tr)
  (function(t) {
    Ue.log[t] = function(n, r) {
      var a = Array.prototype.slice.call(arguments).slice(2), s = {
        timestamp: /* @__PURE__ */ new Date(),
        level: t,
        category: n,
        message: r,
        arguments: a
        /*standard*/
        /*full*/
        /*fullMessage*/
      };
      Ue.log.logMessage(s);
    };
  })(fo[Tr]);
Ue.log.makeLogger = function(e) {
  var t = {
    flags: 0,
    f: e
  };
  return Ue.log.setLevel(t, "none"), t;
};
Ue.log.setLevel = function(e, t) {
  var n = !1;
  if (e && !(e.flags & Ue.log.LEVEL_LOCKED))
    for (var r = 0; r < Ue.log.levels.length; ++r) {
      var a = Ue.log.levels[r];
      if (t == a) {
        e.level = t, n = !0;
        break;
      }
    }
  return n;
};
Ue.log.lock = function(e, t) {
  typeof t > "u" || t ? e.flags |= Ue.log.LEVEL_LOCKED : e.flags &= ~Ue.log.LEVEL_LOCKED;
};
Ue.log.addLogger = function(e) {
  Di.push(e);
};
if (typeof console < "u" && "log" in console) {
  var Dn;
  if (console.error && console.warn && console.info && console.debug) {
    var Yd = {
      error: console.error,
      warning: console.warn,
      info: console.info,
      debug: console.debug,
      verbose: console.debug
    }, is = function(e, t) {
      Ue.log.prepareStandard(t);
      var n = Yd[t.level], r = [t.standard];
      r = r.concat(t.arguments.slice()), n.apply(console, r);
    };
    Dn = Ue.log.makeLogger(is);
  } else {
    var is = function(t, n) {
      Ue.log.prepareStandardFull(n), console.log(n.standardFull);
    };
    Dn = Ue.log.makeLogger(is);
  }
  Ue.log.setLevel(Dn, "debug"), Ue.log.addLogger(Dn), Fn = Dn;
} else
  console = {
    log: function() {
    }
  };
if (Fn !== null && typeof window < "u" && window.location) {
  var aa = new URL(window.location.href).searchParams;
  if (aa.has("console.level") && Ue.log.setLevel(
    Fn,
    aa.get("console.level").slice(-1)[0]
  ), aa.has("console.lock")) {
    var Xd = aa.get("console.lock").slice(-1)[0];
    Xd == "true" && Ue.log.lock(Fn);
  }
}
Ue.log.consoleLogger = Fn;
var oe = De, N = oe.asn1, At = oe.pkcs7 = oe.pkcs7 || {};
At.messageFromPem = function(e) {
  var t = oe.pem.decode(e)[0];
  if (t.type !== "PKCS7") {
    var n = new Error('Could not convert PKCS#7 message from PEM; PEM header type is not "PKCS#7".');
    throw n.headerType = t.type, n;
  }
  if (t.procType && t.procType.type === "ENCRYPTED")
    throw new Error("Could not convert PKCS#7 message from PEM; PEM is encrypted.");
  var r = N.fromDer(t.body);
  return At.messageFromAsn1(r);
};
At.messageToPem = function(e, t) {
  var n = {
    type: "PKCS7",
    body: N.toDer(e.toAsn1()).getBytes()
  };
  return oe.pem.encode(n, { maxline: t });
};
At.messageFromAsn1 = function(e) {
  var t = {}, n = [];
  if (!N.validate(e, At.asn1.contentInfoValidator, t, n)) {
    var r = new Error("Cannot read PKCS#7 message. ASN.1 object is not an PKCS#7 ContentInfo.");
    throw r.errors = n, r;
  }
  var a = N.derToOid(t.contentType), s;
  switch (a) {
    case oe.pki.oids.envelopedData:
      s = At.createEnvelopedData();
      break;
    case oe.pki.oids.encryptedData:
      s = At.createEncryptedData();
      break;
    case oe.pki.oids.signedData:
      s = At.createSignedData();
      break;
    default:
      throw new Error("Cannot read PKCS#7 message. ContentType with OID " + a + " is not (yet) supported.");
  }
  return s.fromAsn1(t.content.value[0]), s;
};
At.createSignedData = function() {
  var e = null;
  return e = {
    type: oe.pki.oids.signedData,
    version: 1,
    certificates: [],
    crls: [],
    // TODO: add json-formatted signer stuff here?
    signers: [],
    // populated during sign()
    digestAlgorithmIdentifiers: [],
    contentInfo: null,
    signerInfos: [],
    fromAsn1: function(r) {
      if (ss(e, r, At.asn1.signedDataValidator), e.certificates = [], e.crls = [], e.digestAlgorithmIdentifiers = [], e.contentInfo = null, e.signerInfos = [], e.rawCapture.certificates)
        for (var a = e.rawCapture.certificates.value, s = 0; s < a.length; ++s)
          e.certificates.push(oe.pki.certificateFromAsn1(a[s]));
    },
    toAsn1: function() {
      e.contentInfo || e.sign();
      for (var r = [], a = 0; a < e.certificates.length; ++a)
        r.push(oe.pki.certificateToAsn1(e.certificates[a]));
      var s = [], i = N.create(N.Class.CONTEXT_SPECIFIC, 0, !0, [
        N.create(N.Class.UNIVERSAL, N.Type.SEQUENCE, !0, [
          // Version
          N.create(
            N.Class.UNIVERSAL,
            N.Type.INTEGER,
            !1,
            N.integerToDer(e.version).getBytes()
          ),
          // DigestAlgorithmIdentifiers
          N.create(
            N.Class.UNIVERSAL,
            N.Type.SET,
            !0,
            e.digestAlgorithmIdentifiers
          ),
          // ContentInfo
          e.contentInfo
        ])
      ]);
      return r.length > 0 && i.value[0].value.push(
        N.create(N.Class.CONTEXT_SPECIFIC, 0, !0, r)
      ), s.length > 0 && i.value[0].value.push(
        N.create(N.Class.CONTEXT_SPECIFIC, 1, !0, s)
      ), i.value[0].value.push(
        N.create(
          N.Class.UNIVERSAL,
          N.Type.SET,
          !0,
          e.signerInfos
        )
      ), N.create(
        N.Class.UNIVERSAL,
        N.Type.SEQUENCE,
        !0,
        [
          // ContentType
          N.create(
            N.Class.UNIVERSAL,
            N.Type.OID,
            !1,
            N.oidToDer(e.type).getBytes()
          ),
          // [0] SignedData
          i
        ]
      );
    },
    /**
     * Add (another) entity to list of signers.
     *
     * Note: If authenticatedAttributes are provided, then, per RFC 2315,
     * they must include at least two attributes: content type and
     * message digest. The message digest attribute value will be
     * auto-calculated during signing and will be ignored if provided.
     *
     * Here's an example of providing these two attributes:
     *
     * forge.pkcs7.createSignedData();
     * p7.addSigner({
     *   issuer: cert.issuer.attributes,
     *   serialNumber: cert.serialNumber,
     *   key: privateKey,
     *   digestAlgorithm: forge.pki.oids.sha1,
     *   authenticatedAttributes: [{
     *     type: forge.pki.oids.contentType,
     *     value: forge.pki.oids.data
     *   }, {
     *     type: forge.pki.oids.messageDigest
     *   }]
     * });
     *
     * TODO: Support [subjectKeyIdentifier] as signer's ID.
     *
     * @param signer the signer information:
     *          key the signer's private key.
     *          [certificate] a certificate containing the public key
     *            associated with the signer's private key; use this option as
     *            an alternative to specifying signer.issuer and
     *            signer.serialNumber.
     *          [issuer] the issuer attributes (eg: cert.issuer.attributes).
     *          [serialNumber] the signer's certificate's serial number in
     *           hexadecimal (eg: cert.serialNumber).
     *          [digestAlgorithm] the message digest OID, as a string, to use
     *            (eg: forge.pki.oids.sha1).
     *          [authenticatedAttributes] an optional array of attributes
     *            to also sign along with the content.
     */
    addSigner: function(r) {
      var a = r.issuer, s = r.serialNumber;
      if (r.certificate) {
        var i = r.certificate;
        typeof i == "string" && (i = oe.pki.certificateFromPem(i)), a = i.issuer.attributes, s = i.serialNumber;
      }
      var o = r.key;
      if (!o)
        throw new Error(
          "Could not add PKCS#7 signer; no private key specified."
        );
      typeof o == "string" && (o = oe.pki.privateKeyFromPem(o));
      var u = r.digestAlgorithm || oe.pki.oids.sha1;
      switch (u) {
        case oe.pki.oids.sha1:
        case oe.pki.oids.sha256:
        case oe.pki.oids.sha384:
        case oe.pki.oids.sha512:
        case oe.pki.oids.md5:
          break;
        default:
          throw new Error(
            "Could not add PKCS#7 signer; unknown message digest algorithm: " + u
          );
      }
      var c = r.authenticatedAttributes || [];
      if (c.length > 0) {
        for (var l = !1, p = !1, g = 0; g < c.length; ++g) {
          var C = c[g];
          if (!l && C.type === oe.pki.oids.contentType) {
            if (l = !0, p)
              break;
            continue;
          }
          if (!p && C.type === oe.pki.oids.messageDigest) {
            if (p = !0, l)
              break;
            continue;
          }
        }
        if (!l || !p)
          throw new Error("Invalid signer.authenticatedAttributes. If signer.authenticatedAttributes is specified, then it must contain at least two attributes, PKCS #9 content-type and PKCS #9 message-digest.");
      }
      e.signers.push({
        key: o,
        version: 1,
        issuer: a,
        serialNumber: s,
        digestAlgorithm: u,
        signatureAlgorithm: oe.pki.oids.rsaEncryption,
        signature: null,
        authenticatedAttributes: c,
        unauthenticatedAttributes: []
      });
    },
    /**
     * Signs the content.
     * @param options Options to apply when signing:
     *    [detached] boolean. If signing should be done in detached mode. Defaults to false.
     */
    sign: function(r) {
      if (r = r || {}, (typeof e.content != "object" || e.contentInfo === null) && (e.contentInfo = N.create(
        N.Class.UNIVERSAL,
        N.Type.SEQUENCE,
        !0,
        [
          // ContentType
          N.create(
            N.Class.UNIVERSAL,
            N.Type.OID,
            !1,
            N.oidToDer(oe.pki.oids.data).getBytes()
          )
        ]
      ), "content" in e)) {
        var a;
        e.content instanceof oe.util.ByteBuffer ? a = e.content.bytes() : typeof e.content == "string" && (a = oe.util.encodeUtf8(e.content)), r.detached ? e.detachedContent = N.create(N.Class.UNIVERSAL, N.Type.OCTETSTRING, !1, a) : e.contentInfo.value.push(
          // [0] EXPLICIT content
          N.create(N.Class.CONTEXT_SPECIFIC, 0, !0, [
            N.create(
              N.Class.UNIVERSAL,
              N.Type.OCTETSTRING,
              !1,
              a
            )
          ])
        );
      }
      if (e.signers.length !== 0) {
        var s = t();
        n(s);
      }
    },
    verify: function() {
      throw new Error("PKCS#7 signature verification not yet implemented.");
    },
    /**
     * Add a certificate.
     *
     * @param cert the certificate to add.
     */
    addCertificate: function(r) {
      typeof r == "string" && (r = oe.pki.certificateFromPem(r)), e.certificates.push(r);
    },
    /**
     * Add a certificate revokation list.
     *
     * @param crl the certificate revokation list to add.
     */
    addCertificateRevokationList: function(r) {
      throw new Error("PKCS#7 CRL support not yet implemented.");
    }
  }, e;
  function t() {
    for (var r = {}, a = 0; a < e.signers.length; ++a) {
      var s = e.signers[a], i = s.digestAlgorithm;
      i in r || (r[i] = oe.md[oe.pki.oids[i]].create()), s.authenticatedAttributes.length === 0 ? s.md = r[i] : s.md = oe.md[oe.pki.oids[i]].create();
    }
    e.digestAlgorithmIdentifiers = [];
    for (var i in r)
      e.digestAlgorithmIdentifiers.push(
        // AlgorithmIdentifier
        N.create(N.Class.UNIVERSAL, N.Type.SEQUENCE, !0, [
          // algorithm
          N.create(
            N.Class.UNIVERSAL,
            N.Type.OID,
            !1,
            N.oidToDer(i).getBytes()
          ),
          // parameters (null)
          N.create(N.Class.UNIVERSAL, N.Type.NULL, !1, "")
        ])
      );
    return r;
  }
  function n(r) {
    var a;
    if (e.detachedContent ? a = e.detachedContent : (a = e.contentInfo.value[1], a = a.value[0]), !a)
      throw new Error(
        "Could not sign PKCS#7 message; there is no content to sign."
      );
    var s = N.derToOid(e.contentInfo.value[0].value), i = N.toDer(a);
    i.getByte(), N.getBerValueLength(i), i = i.getBytes();
    for (var o in r)
      r[o].start().update(i);
    for (var u = /* @__PURE__ */ new Date(), c = 0; c < e.signers.length; ++c) {
      var l = e.signers[c];
      if (l.authenticatedAttributes.length === 0) {
        if (s !== oe.pki.oids.data)
          throw new Error(
            "Invalid signer; authenticatedAttributes must be present when the ContentInfo content type is not PKCS#7 Data."
          );
      } else {
        l.authenticatedAttributesAsn1 = N.create(
          N.Class.CONTEXT_SPECIFIC,
          0,
          !0,
          []
        );
        for (var p = N.create(
          N.Class.UNIVERSAL,
          N.Type.SET,
          !0,
          []
        ), g = 0; g < l.authenticatedAttributes.length; ++g) {
          var C = l.authenticatedAttributes[g];
          C.type === oe.pki.oids.messageDigest ? C.value = r[l.digestAlgorithm].digest() : C.type === oe.pki.oids.signingTime && (C.value || (C.value = u)), p.value.push(ki(C)), l.authenticatedAttributesAsn1.value.push(ki(C));
        }
        i = N.toDer(p).getBytes(), l.md.start().update(i);
      }
      l.signature = l.key.sign(l.md, "RSASSA-PKCS1-V1_5");
    }
    e.signerInfos = ny(e.signers);
  }
};
At.createEncryptedData = function() {
  var e = null;
  return e = {
    type: oe.pki.oids.encryptedData,
    version: 0,
    encryptedContent: {
      algorithm: oe.pki.oids["aes256-CBC"]
    },
    /**
     * Reads an EncryptedData content block (in ASN.1 format)
     *
     * @param obj The ASN.1 representation of the EncryptedData content block
     */
    fromAsn1: function(t) {
      ss(e, t, At.asn1.encryptedDataValidator);
    },
    /**
     * Decrypt encrypted content
     *
     * @param key The (symmetric) key as a byte buffer
     */
    decrypt: function(t) {
      t !== void 0 && (e.encryptedContent.key = t), Mc(e);
    }
  }, e;
};
At.createEnvelopedData = function() {
  var e = null;
  return e = {
    type: oe.pki.oids.envelopedData,
    version: 0,
    recipients: [],
    encryptedContent: {
      algorithm: oe.pki.oids["aes256-CBC"]
    },
    /**
     * Reads an EnvelopedData content block (in ASN.1 format)
     *
     * @param obj the ASN.1 representation of the EnvelopedData content block.
     */
    fromAsn1: function(t) {
      var n = ss(e, t, At.asn1.envelopedDataValidator);
      e.recipients = ey(n.recipientInfos.value);
    },
    toAsn1: function() {
      return N.create(N.Class.UNIVERSAL, N.Type.SEQUENCE, !0, [
        // ContentType
        N.create(
          N.Class.UNIVERSAL,
          N.Type.OID,
          !1,
          N.oidToDer(e.type).getBytes()
        ),
        // [0] EnvelopedData
        N.create(N.Class.CONTEXT_SPECIFIC, 0, !0, [
          N.create(N.Class.UNIVERSAL, N.Type.SEQUENCE, !0, [
            // Version
            N.create(
              N.Class.UNIVERSAL,
              N.Type.INTEGER,
              !1,
              N.integerToDer(e.version).getBytes()
            ),
            // RecipientInfos
            N.create(
              N.Class.UNIVERSAL,
              N.Type.SET,
              !0,
              ty(e.recipients)
            ),
            // EncryptedContentInfo
            N.create(
              N.Class.UNIVERSAL,
              N.Type.SEQUENCE,
              !0,
              ay(e.encryptedContent)
            )
          ])
        ])
      ]);
    },
    /**
     * Find recipient by X.509 certificate's issuer.
     *
     * @param cert the certificate with the issuer to look for.
     *
     * @return the recipient object.
     */
    findRecipient: function(t) {
      for (var n = t.issuer.attributes, r = 0; r < e.recipients.length; ++r) {
        var a = e.recipients[r], s = a.issuer;
        if (a.serialNumber === t.serialNumber && s.length === n.length) {
          for (var i = !0, o = 0; o < n.length; ++o)
            if (s[o].type !== n[o].type || s[o].value !== n[o].value) {
              i = !1;
              break;
            }
          if (i)
            return a;
        }
      }
      return null;
    },
    /**
     * Decrypt enveloped content
     *
     * @param recipient The recipient object related to the private key
     * @param privKey The (RSA) private key object
     */
    decrypt: function(t, n) {
      if (e.encryptedContent.key === void 0 && t !== void 0 && n !== void 0)
        switch (t.encryptedContent.algorithm) {
          case oe.pki.oids.rsaEncryption:
          case oe.pki.oids.desCBC:
            var r = n.decrypt(t.encryptedContent.content);
            e.encryptedContent.key = oe.util.createBuffer(r);
            break;
          default:
            throw new Error("Unsupported asymmetric cipher, OID " + t.encryptedContent.algorithm);
        }
      Mc(e);
    },
    /**
     * Add (another) entity to list of recipients.
     *
     * @param cert The certificate of the entity to add.
     */
    addRecipient: function(t) {
      e.recipients.push({
        version: 0,
        issuer: t.issuer.attributes,
        serialNumber: t.serialNumber,
        encryptedContent: {
          // We simply assume rsaEncryption here, since forge.pki only
          // supports RSA so far.  If the PKI module supports other
          // ciphers one day, we need to modify this one as well.
          algorithm: oe.pki.oids.rsaEncryption,
          key: t.publicKey
        }
      });
    },
    /**
     * Encrypt enveloped content.
     *
     * This function supports two optional arguments, cipher and key, which
     * can be used to influence symmetric encryption.  Unless cipher is
     * provided, the cipher specified in encryptedContent.algorithm is used
     * (defaults to AES-256-CBC).  If no key is provided, encryptedContent.key
     * is (re-)used.  If that one's not set, a random key will be generated
     * automatically.
     *
     * @param [key] The key to be used for symmetric encryption.
     * @param [cipher] The OID of the symmetric cipher to use.
     */
    encrypt: function(t, n) {
      if (e.encryptedContent.content === void 0) {
        n = n || e.encryptedContent.algorithm, t = t || e.encryptedContent.key;
        var r, a, s;
        switch (n) {
          case oe.pki.oids["aes128-CBC"]:
            r = 16, a = 16, s = oe.aes.createEncryptionCipher;
            break;
          case oe.pki.oids["aes192-CBC"]:
            r = 24, a = 16, s = oe.aes.createEncryptionCipher;
            break;
          case oe.pki.oids["aes256-CBC"]:
            r = 32, a = 16, s = oe.aes.createEncryptionCipher;
            break;
          case oe.pki.oids["des-EDE3-CBC"]:
            r = 24, a = 8, s = oe.des.createEncryptionCipher;
            break;
          default:
            throw new Error("Unsupported symmetric cipher, OID " + n);
        }
        if (t === void 0)
          t = oe.util.createBuffer(oe.random.getBytes(r));
        else if (t.length() != r)
          throw new Error("Symmetric key has wrong length; got " + t.length() + " bytes, expected " + r + ".");
        e.encryptedContent.algorithm = n, e.encryptedContent.key = t, e.encryptedContent.parameter = oe.util.createBuffer(
          oe.random.getBytes(a)
        );
        var i = s(t);
        if (i.start(e.encryptedContent.parameter.copy()), i.update(e.content), !i.finish())
          throw new Error("Symmetric encryption failed.");
        e.encryptedContent.content = i.output;
      }
      for (var o = 0; o < e.recipients.length; ++o) {
        var u = e.recipients[o];
        if (u.encryptedContent.content === void 0)
          switch (u.encryptedContent.algorithm) {
            case oe.pki.oids.rsaEncryption:
              u.encryptedContent.content = u.encryptedContent.key.encrypt(
                e.encryptedContent.key.data
              );
              break;
            default:
              throw new Error("Unsupported asymmetric cipher, OID " + u.encryptedContent.algorithm);
          }
      }
    }
  }, e;
};
function Jd(e) {
  var t = {}, n = [];
  if (!N.validate(e, At.asn1.recipientInfoValidator, t, n)) {
    var r = new Error("Cannot read PKCS#7 RecipientInfo. ASN.1 object is not an PKCS#7 RecipientInfo.");
    throw r.errors = n, r;
  }
  return {
    version: t.version.charCodeAt(0),
    issuer: oe.pki.RDNAttributesAsArray(t.issuer),
    serialNumber: oe.util.createBuffer(t.serial).toHex(),
    encryptedContent: {
      algorithm: N.derToOid(t.encAlgorithm),
      parameter: t.encParameter ? t.encParameter.value : void 0,
      content: t.encKey
    }
  };
}
function Zd(e) {
  return N.create(N.Class.UNIVERSAL, N.Type.SEQUENCE, !0, [
    // Version
    N.create(
      N.Class.UNIVERSAL,
      N.Type.INTEGER,
      !1,
      N.integerToDer(e.version).getBytes()
    ),
    // IssuerAndSerialNumber
    N.create(N.Class.UNIVERSAL, N.Type.SEQUENCE, !0, [
      // Name
      oe.pki.distinguishedNameToAsn1({ attributes: e.issuer }),
      // Serial
      N.create(
        N.Class.UNIVERSAL,
        N.Type.INTEGER,
        !1,
        oe.util.hexToBytes(e.serialNumber)
      )
    ]),
    // KeyEncryptionAlgorithmIdentifier
    N.create(N.Class.UNIVERSAL, N.Type.SEQUENCE, !0, [
      // Algorithm
      N.create(
        N.Class.UNIVERSAL,
        N.Type.OID,
        !1,
        N.oidToDer(e.encryptedContent.algorithm).getBytes()
      ),
      // Parameter, force NULL, only RSA supported for now.
      N.create(N.Class.UNIVERSAL, N.Type.NULL, !1, "")
    ]),
    // EncryptedKey
    N.create(
      N.Class.UNIVERSAL,
      N.Type.OCTETSTRING,
      !1,
      e.encryptedContent.content
    )
  ]);
}
function ey(e) {
  for (var t = [], n = 0; n < e.length; ++n)
    t.push(Jd(e[n]));
  return t;
}
function ty(e) {
  for (var t = [], n = 0; n < e.length; ++n)
    t.push(Zd(e[n]));
  return t;
}
function ry(e) {
  var t = N.create(N.Class.UNIVERSAL, N.Type.SEQUENCE, !0, [
    // version
    N.create(
      N.Class.UNIVERSAL,
      N.Type.INTEGER,
      !1,
      N.integerToDer(e.version).getBytes()
    ),
    // issuerAndSerialNumber
    N.create(N.Class.UNIVERSAL, N.Type.SEQUENCE, !0, [
      // name
      oe.pki.distinguishedNameToAsn1({ attributes: e.issuer }),
      // serial
      N.create(
        N.Class.UNIVERSAL,
        N.Type.INTEGER,
        !1,
        oe.util.hexToBytes(e.serialNumber)
      )
    ]),
    // digestAlgorithm
    N.create(N.Class.UNIVERSAL, N.Type.SEQUENCE, !0, [
      // algorithm
      N.create(
        N.Class.UNIVERSAL,
        N.Type.OID,
        !1,
        N.oidToDer(e.digestAlgorithm).getBytes()
      ),
      // parameters (null)
      N.create(N.Class.UNIVERSAL, N.Type.NULL, !1, "")
    ])
  ]);
  if (e.authenticatedAttributesAsn1 && t.value.push(e.authenticatedAttributesAsn1), t.value.push(N.create(N.Class.UNIVERSAL, N.Type.SEQUENCE, !0, [
    // algorithm
    N.create(
      N.Class.UNIVERSAL,
      N.Type.OID,
      !1,
      N.oidToDer(e.signatureAlgorithm).getBytes()
    ),
    // parameters (null)
    N.create(N.Class.UNIVERSAL, N.Type.NULL, !1, "")
  ])), t.value.push(N.create(
    N.Class.UNIVERSAL,
    N.Type.OCTETSTRING,
    !1,
    e.signature
  )), e.unauthenticatedAttributes.length > 0) {
    for (var n = N.create(N.Class.CONTEXT_SPECIFIC, 1, !0, []), r = 0; r < e.unauthenticatedAttributes.length; ++r) {
      var a = e.unauthenticatedAttributes[r];
      n.values.push(ki(a));
    }
    t.value.push(n);
  }
  return t;
}
function ny(e) {
  for (var t = [], n = 0; n < e.length; ++n)
    t.push(ry(e[n]));
  return t;
}
function ki(e) {
  var t;
  if (e.type === oe.pki.oids.contentType)
    t = N.create(
      N.Class.UNIVERSAL,
      N.Type.OID,
      !1,
      N.oidToDer(e.value).getBytes()
    );
  else if (e.type === oe.pki.oids.messageDigest)
    t = N.create(
      N.Class.UNIVERSAL,
      N.Type.OCTETSTRING,
      !1,
      e.value.bytes()
    );
  else if (e.type === oe.pki.oids.signingTime) {
    var n = /* @__PURE__ */ new Date("1950-01-01T00:00:00Z"), r = /* @__PURE__ */ new Date("2050-01-01T00:00:00Z"), a = e.value;
    if (typeof a == "string") {
      var s = Date.parse(a);
      isNaN(s) ? a.length === 13 ? a = N.utcTimeToDate(a) : a = N.generalizedTimeToDate(a) : a = new Date(s);
    }
    a >= n && a < r ? t = N.create(
      N.Class.UNIVERSAL,
      N.Type.UTCTIME,
      !1,
      N.dateToUtcTime(a)
    ) : t = N.create(
      N.Class.UNIVERSAL,
      N.Type.GENERALIZEDTIME,
      !1,
      N.dateToGeneralizedTime(a)
    );
  }
  return N.create(N.Class.UNIVERSAL, N.Type.SEQUENCE, !0, [
    // AttributeType
    N.create(
      N.Class.UNIVERSAL,
      N.Type.OID,
      !1,
      N.oidToDer(e.type).getBytes()
    ),
    N.create(N.Class.UNIVERSAL, N.Type.SET, !0, [
      // AttributeValue
      t
    ])
  ]);
}
function ay(e) {
  return [
    // ContentType, always Data for the moment
    N.create(
      N.Class.UNIVERSAL,
      N.Type.OID,
      !1,
      N.oidToDer(oe.pki.oids.data).getBytes()
    ),
    // ContentEncryptionAlgorithmIdentifier
    N.create(N.Class.UNIVERSAL, N.Type.SEQUENCE, !0, [
      // Algorithm
      N.create(
        N.Class.UNIVERSAL,
        N.Type.OID,
        !1,
        N.oidToDer(e.algorithm).getBytes()
      ),
      // Parameters (IV)
      e.parameter ? N.create(
        N.Class.UNIVERSAL,
        N.Type.OCTETSTRING,
        !1,
        e.parameter.getBytes()
      ) : void 0
    ]),
    // [0] EncryptedContent
    N.create(N.Class.CONTEXT_SPECIFIC, 0, !0, [
      N.create(
        N.Class.UNIVERSAL,
        N.Type.OCTETSTRING,
        !1,
        e.content.getBytes()
      )
    ])
  ];
}
function ss(e, t, n) {
  var r = {}, a = [];
  if (!N.validate(t, n, r, a)) {
    var s = new Error("Cannot read PKCS#7 message. ASN.1 object is not a supported PKCS#7 message.");
    throw s.errors = s, s;
  }
  var i = N.derToOid(r.contentType);
  if (i !== oe.pki.oids.data)
    throw new Error("Unsupported PKCS#7 message. Only wrapped ContentType Data supported.");
  if (r.encryptedContent) {
    var o = "";
    if (oe.util.isArray(r.encryptedContent))
      for (var u = 0; u < r.encryptedContent.length; ++u) {
        if (r.encryptedContent[u].type !== N.Type.OCTETSTRING)
          throw new Error("Malformed PKCS#7 message, expecting encrypted content constructed of only OCTET STRING objects.");
        o += r.encryptedContent[u].value;
      }
    else
      o = r.encryptedContent;
    e.encryptedContent = {
      algorithm: N.derToOid(r.encAlgorithm),
      parameter: oe.util.createBuffer(r.encParameter.value),
      content: oe.util.createBuffer(o)
    };
  }
  if (r.content) {
    var o = "";
    if (oe.util.isArray(r.content))
      for (var u = 0; u < r.content.length; ++u) {
        if (r.content[u].type !== N.Type.OCTETSTRING)
          throw new Error("Malformed PKCS#7 message, expecting content constructed of only OCTET STRING objects.");
        o += r.content[u].value;
      }
    else
      o = r.content;
    e.content = oe.util.createBuffer(o);
  }
  return e.version = r.version.charCodeAt(0), e.rawCapture = r, r;
}
function Mc(e) {
  if (e.encryptedContent.key === void 0)
    throw new Error("Symmetric key not available.");
  if (e.content === void 0) {
    var t;
    switch (e.encryptedContent.algorithm) {
      case oe.pki.oids["aes128-CBC"]:
      case oe.pki.oids["aes192-CBC"]:
      case oe.pki.oids["aes256-CBC"]:
        t = oe.aes.createDecryptionCipher(e.encryptedContent.key);
        break;
      case oe.pki.oids.desCBC:
      case oe.pki.oids["des-EDE3-CBC"]:
        t = oe.des.createDecryptionCipher(e.encryptedContent.key);
        break;
      default:
        throw new Error("Unsupported symmetric cipher, OID " + e.encryptedContent.algorithm);
    }
    if (t.start(e.encryptedContent.parameter), t.update(e.encryptedContent.content), !t.finish())
      throw new Error("Symmetric decryption failed.");
    e.content = t.output;
  }
}
var ft = De, Oa = ft.ssh = ft.ssh || {};
Oa.privateKeyToPutty = function(e, t, n) {
  n = n || "", t = t || "";
  var r = "ssh-rsa", a = t === "" ? "none" : "aes256-cbc", s = "PuTTY-User-Key-File-2: " + r + `\r
`;
  s += "Encryption: " + a + `\r
`, s += "Comment: " + n + `\r
`;
  var i = ft.util.createBuffer();
  yn(i, r), er(i, e.e), er(i, e.n);
  var o = ft.util.encode64(i.bytes(), 64), u = Math.floor(o.length / 66) + 1;
  s += "Public-Lines: " + u + `\r
`, s += o;
  var c = ft.util.createBuffer();
  er(c, e.d), er(c, e.p), er(c, e.q), er(c, e.qInv);
  var l;
  if (!t)
    l = ft.util.encode64(c.bytes(), 64);
  else {
    var p = c.length() + 16 - 1;
    p -= p % 16;
    var g = ia(c.bytes());
    g.truncate(g.length() - p + c.length()), c.putBuffer(g);
    var C = ft.util.createBuffer();
    C.putBuffer(ia("\0\0\0\0", t)), C.putBuffer(ia("\0\0\0", t));
    var d = ft.aes.createEncryptionCipher(C.truncate(8), "CBC");
    d.start(ft.util.createBuffer().fillWithByte(0, 16)), d.update(c.copy()), d.finish();
    var b = d.output;
    b.truncate(16), l = ft.util.encode64(b.bytes(), 64);
  }
  u = Math.floor(l.length / 66) + 1, s += `\r
Private-Lines: ` + u + `\r
`, s += l;
  var S = ia("putty-private-key-file-mac-key", t), A = ft.util.createBuffer();
  yn(A, r), yn(A, a), yn(A, n), A.putInt32(i.length()), A.putBuffer(i), A.putInt32(c.length()), A.putBuffer(c);
  var D = ft.hmac.create();
  return D.start("sha1", S), D.update(A.bytes()), s += `\r
Private-MAC: ` + D.digest().toHex() + `\r
`, s;
};
Oa.publicKeyToOpenSSH = function(e, t) {
  var n = "ssh-rsa";
  t = t || "";
  var r = ft.util.createBuffer();
  return yn(r, n), er(r, e.e), er(r, e.n), n + " " + ft.util.encode64(r.bytes()) + " " + t;
};
Oa.privateKeyToOpenSSH = function(e, t) {
  return t ? ft.pki.encryptRsaPrivateKey(
    e,
    t,
    { legacy: !0, algorithm: "aes128" }
  ) : ft.pki.privateKeyToPem(e);
};
Oa.getPublicKeyFingerprint = function(e, t) {
  t = t || {};
  var n = t.md || ft.md.md5.create(), r = "ssh-rsa", a = ft.util.createBuffer();
  yn(a, r), er(a, e.e), er(a, e.n), n.start(), n.update(a.getBytes());
  var s = n.digest();
  if (t.encoding === "hex") {
    var i = s.toHex();
    return t.delimiter ? i.match(/.{2}/g).join(t.delimiter) : i;
  } else {
    if (t.encoding === "binary")
      return s.getBytes();
    if (t.encoding)
      throw new Error('Unknown encoding "' + t.encoding + '".');
  }
  return s;
};
function er(e, t) {
  var n = t.toString(16);
  n[0] >= "8" && (n = "00" + n);
  var r = ft.util.hexToBytes(n);
  e.putInt32(r.length), e.putBytes(r);
}
function yn(e, t) {
  e.putInt32(t.length), e.putString(t);
}
function ia() {
  for (var e = ft.md.sha1.create(), t = arguments.length, n = 0; n < t; ++n)
    e.update(arguments[n]);
  return e.digest();
}
var Vn = De;
globalThis && globalThis.__awaiter;
function Kc(e) {
  const t = yo(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return jc(() => {
    t.current = e;
  }, [e]), Mn((...n) => t.current(...n), [t]);
}
function Sa(e, t, n, r) {
  const a = yo(t);
  jc(() => {
    a.current = t;
  }, [t]), ba(() => {
    var s;
    const i = (s = n == null ? void 0 : n.current) !== null && s !== void 0 ? s : window;
    if (!(i && i.addEventListener))
      return;
    const o = (u) => a.current(u);
    return i.addEventListener(e, o, r), () => {
      i.removeEventListener(e, o, r);
    };
  }, [e, n, r]);
}
globalThis && globalThis.__awaiter;
const jc = typeof window < "u" ? yu : ba, ur = "at", po = "session-storage", py = (e) => {
  const t = Mn(() => {
    if (typeof window > "u")
      return e;
    try {
      const i = window.sessionStorage.getItem(ur);
      return i ? Hc(i) : e;
    } catch (i) {
      return console.warn(`Error reading account data “${ur}”:`, i), e;
    }
  }, [e, ur]), [n, r] = go(t), a = Kc((i) => {
    typeof window > "u" && console.warn(
      `Tried setting account data “${ur}” even though environment is not a client`
    );
    try {
      const o = i instanceof Function ? i(n) : i;
      window.sessionStorage.setItem(ur, JSON.stringify(o)), r(o), window.dispatchEvent(new Event(po));
    } catch (o) {
      console.warn(`Error setting account data key “${ur}”:`, o);
    }
  });
  ba(() => {
    r(t());
  }, []);
  const s = Mn(
    (i) => {
      i != null && i.key && i.key !== ur || r(t());
    },
    [ur, t]
  );
  return Sa("storage", s), Sa(po, s), [n, a];
}, hy = () => {
}, dy = (e) => (e.indexOf("/") === 0 && (e = e.substring(1)), `${window.location.origin}/${e}`), yy = (e, t) => !!(e && t && (e.profileId || e.userId) && t.authorization && t.token);
function Hc(e) {
  try {
    return e === "undefined" ? void 0 : JSON.parse(e ?? "");
  } catch {
    console.log("parsing error on", { value: e });
    return;
  }
}
const gy = () => {
  const e = ur, t = lr;
  {
    const n = JSON.parse(sessionStorage.getItem(e) || ""), r = JSON.parse(sessionStorage.getItem(t) || "");
    return {
      token: n.token || "",
      authorization: n.authorization || "",
      userId: r && r.userId ? r.userId : "",
      profileId: r && r.profileId ? r.profileId : ""
    };
  }
}, vy = ({ method: e = "GET", httpPath: t = "/", token: n }, r) => {
  const a = Vn.hmac.create();
  return a.start("sha512", r), a.update(`${e}_${t}_${n}`), a.digest().toHex();
}, my = (e) => {
  var r, a;
  if (!e)
    return;
  let t;
  try {
    t = new URL(e ?? "");
  } catch {
    t = new URL(`${window.location.href}${e}`);
  }
  return (a = (r = /\/(sqa|uat|dev|prodgreen|prod)?(?<path>.*)/.exec(t.pathname)) == null ? void 0 : r.groups) == null ? void 0 : a.path;
}, Ey = (e) => {
  const t = Vn.md.sha256.create();
  return t.update(e.toString()), t.digest().toHex();
}, Cy = (e, t, n = 128, { iterations: r, keySize: a, hasher: s } = {
  iterations: 1e4,
  keySize: 64,
  hasher: Vn.md.algorithms.sha512.create()
}) => {
  const i = Vn.pkcs5.pbkdf2(e, t, r, a, s);
  return Vn.util.bytesToHex(i).slice(0, n);
}, Sy = (e) => `${vu().toLowerCase()}-${e.toLowerCase()}`;
async function iy(e) {
  let t;
  if (!e || Object.keys(e).length === 0)
    return;
  Bs().length === 0 ? t = Io(e) : t = Bs()[0];
  const n = Yf(t);
  return n.settings.minimumFetchIntervalMillis = 6e4, await g0(n), n;
}
const by = async (e, t) => {
  if (!e || Object.keys(e).length === 0)
    return;
  const n = await iy(e);
  return n ? Yo(n, t).asString() : void 0;
}, xy = (e) => {
  var t, n, r, a, s;
  if ((n = (t = e == null ? void 0 : e.toString()) == null ? void 0 : t.toLowerCase()) != null && n.includes("by"))
    return e;
  {
    (a = (r = e == null ? void 0 : e.toString()) == null ? void 0 : r.toUpperCase()) != null && a.endsWith("H") && (e = (s = e == null ? void 0 : e.toString()) == null ? void 0 : s.slice(0, -1));
    const i = e >= 12 ? "pm" : "am";
    let o = e > 12 ? e - 12 : e;
    return o = o == "00" ? 12 : o, `By ${o}${i}`;
  }
}, Ty = () => {
  console.log("%c @MGPD/myasurion-shared v2.15.4  ", "background: #9747DD; color: #FFF");
}, Ay = () => mu() === "repair" ? "/portal" : "/";
var qc = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(self, function() {
    return function() {
      var n = { 737: function(i, o, u) {
        var c = u(750), l = u(573), p = l(c("String.prototype.indexOf"));
        i.exports = function(g, C) {
          var d = c(g, !!C);
          return typeof d == "function" && p(g, ".prototype.") > -1 ? l(d) : d;
        };
      }, 573: function(i, o, u) {
        var c = u(132), l = u(750), p = u(504), g = l("%TypeError%"), C = l("%Function.prototype.apply%"), d = l("%Function.prototype.call%"), b = l("%Reflect.apply%", !0) || c.call(d, C), S = l("%Object.defineProperty%", !0), A = l("%Math.max%");
        if (S)
          try {
            S({}, "a", { value: 1 });
          } catch {
            S = null;
          }
        i.exports = function(_) {
          if (typeof _ != "function")
            throw new g("a function is required");
          var M = b(c, d, arguments);
          return p(M, 1 + A(0, _.length - (arguments.length - 1)), !0);
        };
        var D = function() {
          return b(c, C, arguments);
        };
        S ? S(i.exports, "apply", { value: D }) : i.exports.apply = D;
      }, 137: function(i) {
        var o = String.prototype.replace, u = /%20/g, c = "RFC3986";
        i.exports = { default: c, formatters: { RFC1738: function(l) {
          return o.call(l, u, "+");
        }, RFC3986: function(l) {
          return String(l);
        } }, RFC1738: "RFC1738", RFC3986: c };
      }, 122: function(i, o, u) {
        var c = u(892), l = u(15), p = u(137);
        i.exports = { formats: p, parse: l, stringify: c };
      }, 15: function(i, o, u) {
        var c = u(634), l = Object.prototype.hasOwnProperty, p = Array.isArray, g = { allowDots: !1, allowPrototypes: !1, allowSparse: !1, arrayLimit: 20, charset: "utf-8", charsetSentinel: !1, comma: !1, decoder: c.decode, delimiter: "&", depth: 5, ignoreQueryPrefix: !1, interpretNumericEntities: !1, parameterLimit: 1e3, parseArrays: !0, plainObjects: !1, strictNullHandling: !1 }, C = function(S) {
          return S.replace(/&#(\d+);/g, function(A, D) {
            return String.fromCharCode(parseInt(D, 10));
          });
        }, d = function(S, A) {
          return S && typeof S == "string" && A.comma && S.indexOf(",") > -1 ? S.split(",") : S;
        }, b = function(S, A, D, _) {
          if (S) {
            var M = D.allowDots ? S.replace(/\.([^.[]+)/g, "[$1]") : S, K = /(\[[^[\]]*])/g, k = D.depth > 0 && /(\[[^[\]]*])/.exec(M), J = k ? M.slice(0, k.index) : M, re = [];
            if (J) {
              if (!D.plainObjects && l.call(Object.prototype, J) && !D.allowPrototypes)
                return;
              re.push(J);
            }
            for (var G = 0; D.depth > 0 && (k = K.exec(M)) !== null && G < D.depth; ) {
              if (G += 1, !D.plainObjects && l.call(Object.prototype, k[1].slice(1, -1)) && !D.allowPrototypes)
                return;
              re.push(k[1]);
            }
            return k && re.push("[" + M.slice(k.index) + "]"), function($, ue, ge, de) {
              for (var ve = de ? ue : d(ue, ge), se = $.length - 1; se >= 0; --se) {
                var ie, Q = $[se];
                if (Q === "[]" && ge.parseArrays)
                  ie = [].concat(ve);
                else {
                  ie = ge.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
                  var xe = Q.charAt(0) === "[" && Q.charAt(Q.length - 1) === "]" ? Q.slice(1, -1) : Q, Z = parseInt(xe, 10);
                  ge.parseArrays || xe !== "" ? !isNaN(Z) && Q !== xe && String(Z) === xe && Z >= 0 && ge.parseArrays && Z <= ge.arrayLimit ? (ie = [])[Z] = ve : xe !== "__proto__" && (ie[xe] = ve) : ie = { 0: ve };
                }
                ve = ie;
              }
              return ve;
            }(re, A, D, _);
          }
        };
        i.exports = function(S, A) {
          var D = function(G) {
            if (!G)
              return g;
            if (G.decoder !== null && G.decoder !== void 0 && typeof G.decoder != "function")
              throw new TypeError("Decoder has to be a function.");
            if (G.charset !== void 0 && G.charset !== "utf-8" && G.charset !== "iso-8859-1")
              throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
            var $ = G.charset === void 0 ? g.charset : G.charset;
            return { allowDots: G.allowDots === void 0 ? g.allowDots : !!G.allowDots, allowPrototypes: typeof G.allowPrototypes == "boolean" ? G.allowPrototypes : g.allowPrototypes, allowSparse: typeof G.allowSparse == "boolean" ? G.allowSparse : g.allowSparse, arrayLimit: typeof G.arrayLimit == "number" ? G.arrayLimit : g.arrayLimit, charset: $, charsetSentinel: typeof G.charsetSentinel == "boolean" ? G.charsetSentinel : g.charsetSentinel, comma: typeof G.comma == "boolean" ? G.comma : g.comma, decoder: typeof G.decoder == "function" ? G.decoder : g.decoder, delimiter: typeof G.delimiter == "string" || c.isRegExp(G.delimiter) ? G.delimiter : g.delimiter, depth: typeof G.depth == "number" || G.depth === !1 ? +G.depth : g.depth, ignoreQueryPrefix: G.ignoreQueryPrefix === !0, interpretNumericEntities: typeof G.interpretNumericEntities == "boolean" ? G.interpretNumericEntities : g.interpretNumericEntities, parameterLimit: typeof G.parameterLimit == "number" ? G.parameterLimit : g.parameterLimit, parseArrays: G.parseArrays !== !1, plainObjects: typeof G.plainObjects == "boolean" ? G.plainObjects : g.plainObjects, strictNullHandling: typeof G.strictNullHandling == "boolean" ? G.strictNullHandling : g.strictNullHandling };
          }(A);
          if (S === "" || S == null)
            return D.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
          for (var _ = typeof S == "string" ? function(G, $) {
            var ue, ge = { __proto__: null }, de = $.ignoreQueryPrefix ? G.replace(/^\?/, "") : G, ve = $.parameterLimit === 1 / 0 ? void 0 : $.parameterLimit, se = de.split($.delimiter, ve), ie = -1, Q = $.charset;
            if ($.charsetSentinel)
              for (ue = 0; ue < se.length; ++ue)
                se[ue].indexOf("utf8=") === 0 && (se[ue] === "utf8=%E2%9C%93" ? Q = "utf-8" : se[ue] === "utf8=%26%2310003%3B" && (Q = "iso-8859-1"), ie = ue, ue = se.length);
            for (ue = 0; ue < se.length; ++ue)
              if (ue !== ie) {
                var xe, Z, q = se[ue], Y = q.indexOf("]="), le = Y === -1 ? q.indexOf("=") : Y + 1;
                le === -1 ? (xe = $.decoder(q, g.decoder, Q, "key"), Z = $.strictNullHandling ? null : "") : (xe = $.decoder(q.slice(0, le), g.decoder, Q, "key"), Z = c.maybeMap(d(q.slice(le + 1), $), function(Ce) {
                  return $.decoder(Ce, g.decoder, Q, "value");
                })), Z && $.interpretNumericEntities && Q === "iso-8859-1" && (Z = C(Z)), q.indexOf("[]=") > -1 && (Z = p(Z) ? [Z] : Z), l.call(ge, xe) ? ge[xe] = c.combine(ge[xe], Z) : ge[xe] = Z;
              }
            return ge;
          }(S, D) : S, M = D.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, K = Object.keys(_), k = 0; k < K.length; ++k) {
            var J = K[k], re = b(J, _[J], D, typeof S == "string");
            M = c.merge(M, re, D);
          }
          return D.allowSparse === !0 ? M : c.compact(M);
        };
      }, 892: function(i, o, u) {
        var c = u(337), l = u(634), p = u(137), g = Object.prototype.hasOwnProperty, C = { brackets: function(k) {
          return k + "[]";
        }, comma: "comma", indices: function(k, J) {
          return k + "[" + J + "]";
        }, repeat: function(k) {
          return k;
        } }, d = Array.isArray, b = Array.prototype.push, S = function(k, J) {
          b.apply(k, d(J) ? J : [J]);
        }, A = Date.prototype.toISOString, D = p.default, _ = { addQueryPrefix: !1, allowDots: !1, charset: "utf-8", charsetSentinel: !1, delimiter: "&", encode: !0, encoder: l.encode, encodeValuesOnly: !1, format: D, formatter: p.formatters[D], indices: !1, serializeDate: function(k) {
          return A.call(k);
        }, skipNulls: !1, strictNullHandling: !1 }, M = {}, K = function k(J, re, G, $, ue, ge, de, ve, se, ie, Q, xe, Z, q, Y, le) {
          for (var Ce, O = J, we = le, Be = 0, $e = !1; (we = we.get(M)) !== void 0 && !$e; ) {
            var Ee = we.get(J);
            if (Be += 1, Ee !== void 0) {
              if (Ee === Be)
                throw new RangeError("Cyclic object value");
              $e = !0;
            }
            we.get(M) === void 0 && (Be = 0);
          }
          if (typeof ve == "function" ? O = ve(re, O) : O instanceof Date ? O = Q(O) : G === "comma" && d(O) && (O = l.maybeMap(O, function(jt) {
            return jt instanceof Date ? Q(jt) : jt;
          })), O === null) {
            if (ue)
              return de && !q ? de(re, _.encoder, Y, "key", xe) : re;
            O = "";
          }
          if (typeof (Ce = O) == "string" || typeof Ce == "number" || typeof Ce == "boolean" || typeof Ce == "symbol" || typeof Ce == "bigint" || l.isBuffer(O))
            return de ? [Z(q ? re : de(re, _.encoder, Y, "key", xe)) + "=" + Z(de(O, _.encoder, Y, "value", xe))] : [Z(re) + "=" + Z(String(O))];
          var Fe, qe = [];
          if (O === void 0)
            return qe;
          if (G === "comma" && d(O))
            q && de && (O = l.maybeMap(O, de)), Fe = [{ value: O.length > 0 ? O.join(",") || null : void 0 }];
          else if (d(ve))
            Fe = ve;
          else {
            var Ve = Object.keys(O);
            Fe = se ? Ve.sort(se) : Ve;
          }
          for (var ze = $ && d(O) && O.length === 1 ? re + "[]" : re, Ge = 0; Ge < Fe.length; ++Ge) {
            var Ne = Fe[Ge], Me = typeof Ne == "object" && Ne.value !== void 0 ? Ne.value : O[Ne];
            if (!ge || Me !== null) {
              var zt = d(O) ? typeof G == "function" ? G(ze, Ne) : ze : ze + (ie ? "." + Ne : "[" + Ne + "]");
              le.set(J, Be);
              var Kt = c();
              Kt.set(M, le), S(qe, k(Me, zt, G, $, ue, ge, G === "comma" && q && d(O) ? null : de, ve, se, ie, Q, xe, Z, q, Y, Kt));
            }
          }
          return qe;
        };
        i.exports = function(k, J) {
          var re, G = k, $ = function(q) {
            if (!q)
              return _;
            if (q.encoder !== null && q.encoder !== void 0 && typeof q.encoder != "function")
              throw new TypeError("Encoder has to be a function.");
            var Y = q.charset || _.charset;
            if (q.charset !== void 0 && q.charset !== "utf-8" && q.charset !== "iso-8859-1")
              throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
            var le = p.default;
            if (q.format !== void 0) {
              if (!g.call(p.formatters, q.format))
                throw new TypeError("Unknown format option provided.");
              le = q.format;
            }
            var Ce = p.formatters[le], O = _.filter;
            return (typeof q.filter == "function" || d(q.filter)) && (O = q.filter), { addQueryPrefix: typeof q.addQueryPrefix == "boolean" ? q.addQueryPrefix : _.addQueryPrefix, allowDots: q.allowDots === void 0 ? _.allowDots : !!q.allowDots, charset: Y, charsetSentinel: typeof q.charsetSentinel == "boolean" ? q.charsetSentinel : _.charsetSentinel, delimiter: q.delimiter === void 0 ? _.delimiter : q.delimiter, encode: typeof q.encode == "boolean" ? q.encode : _.encode, encoder: typeof q.encoder == "function" ? q.encoder : _.encoder, encodeValuesOnly: typeof q.encodeValuesOnly == "boolean" ? q.encodeValuesOnly : _.encodeValuesOnly, filter: O, format: le, formatter: Ce, serializeDate: typeof q.serializeDate == "function" ? q.serializeDate : _.serializeDate, skipNulls: typeof q.skipNulls == "boolean" ? q.skipNulls : _.skipNulls, sort: typeof q.sort == "function" ? q.sort : null, strictNullHandling: typeof q.strictNullHandling == "boolean" ? q.strictNullHandling : _.strictNullHandling };
          }(J);
          typeof $.filter == "function" ? G = (0, $.filter)("", G) : d($.filter) && (re = $.filter);
          var ue, ge = [];
          if (typeof G != "object" || G === null)
            return "";
          ue = J && J.arrayFormat in C ? J.arrayFormat : J && "indices" in J ? J.indices ? "indices" : "repeat" : "indices";
          var de = C[ue];
          if (J && "commaRoundTrip" in J && typeof J.commaRoundTrip != "boolean")
            throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
          var ve = de === "comma" && J && J.commaRoundTrip;
          re || (re = Object.keys(G)), $.sort && re.sort($.sort);
          for (var se = c(), ie = 0; ie < re.length; ++ie) {
            var Q = re[ie];
            $.skipNulls && G[Q] === null || S(ge, K(G[Q], Q, de, ve, $.strictNullHandling, $.skipNulls, $.encode ? $.encoder : null, $.filter, $.sort, $.allowDots, $.serializeDate, $.format, $.formatter, $.encodeValuesOnly, $.charset, se));
          }
          var xe = ge.join($.delimiter), Z = $.addQueryPrefix === !0 ? "?" : "";
          return $.charsetSentinel && ($.charset === "iso-8859-1" ? Z += "utf8=%26%2310003%3B&" : Z += "utf8=%E2%9C%93&"), xe.length > 0 ? Z + xe : "";
        };
      }, 634: function(i, o, u) {
        var c = u(137), l = Object.prototype.hasOwnProperty, p = Array.isArray, g = function() {
          for (var d = [], b = 0; b < 256; ++b)
            d.push("%" + ((b < 16 ? "0" : "") + b.toString(16)).toUpperCase());
          return d;
        }(), C = function(d, b) {
          for (var S = b && b.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, A = 0; A < d.length; ++A)
            d[A] !== void 0 && (S[A] = d[A]);
          return S;
        };
        i.exports = { arrayToObject: C, assign: function(d, b) {
          return Object.keys(b).reduce(function(S, A) {
            return S[A] = b[A], S;
          }, d);
        }, combine: function(d, b) {
          return [].concat(d, b);
        }, compact: function(d) {
          for (var b = [{ obj: { o: d }, prop: "o" }], S = [], A = 0; A < b.length; ++A)
            for (var D = b[A], _ = D.obj[D.prop], M = Object.keys(_), K = 0; K < M.length; ++K) {
              var k = M[K], J = _[k];
              typeof J == "object" && J !== null && S.indexOf(J) === -1 && (b.push({ obj: _, prop: k }), S.push(J));
            }
          return function(re) {
            for (; re.length > 1; ) {
              var G = re.pop(), $ = G.obj[G.prop];
              if (p($)) {
                for (var ue = [], ge = 0; ge < $.length; ++ge)
                  $[ge] !== void 0 && ue.push($[ge]);
                G.obj[G.prop] = ue;
              }
            }
          }(b), d;
        }, decode: function(d, b, S) {
          var A = d.replace(/\+/g, " ");
          if (S === "iso-8859-1")
            return A.replace(/%[0-9a-f]{2}/gi, unescape);
          try {
            return decodeURIComponent(A);
          } catch {
            return A;
          }
        }, encode: function(d, b, S, A, D) {
          if (d.length === 0)
            return d;
          var _ = d;
          if (typeof d == "symbol" ? _ = Symbol.prototype.toString.call(d) : typeof d != "string" && (_ = String(d)), S === "iso-8859-1")
            return escape(_).replace(/%u[0-9a-f]{4}/gi, function(J) {
              return "%26%23" + parseInt(J.slice(2), 16) + "%3B";
            });
          for (var M = "", K = 0; K < _.length; ++K) {
            var k = _.charCodeAt(K);
            k === 45 || k === 46 || k === 95 || k === 126 || k >= 48 && k <= 57 || k >= 65 && k <= 90 || k >= 97 && k <= 122 || D === c.RFC1738 && (k === 40 || k === 41) ? M += _.charAt(K) : k < 128 ? M += g[k] : k < 2048 ? M += g[192 | k >> 6] + g[128 | 63 & k] : k < 55296 || k >= 57344 ? M += g[224 | k >> 12] + g[128 | k >> 6 & 63] + g[128 | 63 & k] : (K += 1, k = 65536 + ((1023 & k) << 10 | 1023 & _.charCodeAt(K)), M += g[240 | k >> 18] + g[128 | k >> 12 & 63] + g[128 | k >> 6 & 63] + g[128 | 63 & k]);
          }
          return M;
        }, isBuffer: function(d) {
          return !(!d || typeof d != "object" || !(d.constructor && d.constructor.isBuffer && d.constructor.isBuffer(d)));
        }, isRegExp: function(d) {
          return Object.prototype.toString.call(d) === "[object RegExp]";
        }, maybeMap: function(d, b) {
          if (p(d)) {
            for (var S = [], A = 0; A < d.length; A += 1)
              S.push(b(d[A]));
            return S;
          }
          return b(d);
        }, merge: function d(b, S, A) {
          if (!S)
            return b;
          if (typeof S != "object") {
            if (p(b))
              b.push(S);
            else {
              if (!b || typeof b != "object")
                return [b, S];
              (A && (A.plainObjects || A.allowPrototypes) || !l.call(Object.prototype, S)) && (b[S] = !0);
            }
            return b;
          }
          if (!b || typeof b != "object")
            return [b].concat(S);
          var D = b;
          return p(b) && !p(S) && (D = C(b, A)), p(b) && p(S) ? (S.forEach(function(_, M) {
            if (l.call(b, M)) {
              var K = b[M];
              K && typeof K == "object" && _ && typeof _ == "object" ? b[M] = d(K, _, A) : b.push(_);
            } else
              b[M] = _;
          }), b) : Object.keys(S).reduce(function(_, M) {
            var K = S[M];
            return l.call(_, M) ? _[M] = d(_[M], K, A) : _[M] = K, _;
          }, D);
        } };
      }, 300: function(i, o, u) {
        var c = u(365)(), l = u(750), p = c && l("%Object.defineProperty%", !0);
        if (p)
          try {
            p({}, "a", { value: 1 });
          } catch {
            p = !1;
          }
        var g = l("%SyntaxError%"), C = l("%TypeError%"), d = u(502);
        i.exports = function(b, S, A) {
          if (!b || typeof b != "object" && typeof b != "function")
            throw new C("`obj` must be an object or a function`");
          if (typeof S != "string" && typeof S != "symbol")
            throw new C("`property` must be a string or a symbol`");
          if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
            throw new C("`nonEnumerable`, if provided, must be a boolean or null");
          if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
            throw new C("`nonWritable`, if provided, must be a boolean or null");
          if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
            throw new C("`nonConfigurable`, if provided, must be a boolean or null");
          if (arguments.length > 6 && typeof arguments[6] != "boolean")
            throw new C("`loose`, if provided, must be a boolean");
          var D = arguments.length > 3 ? arguments[3] : null, _ = arguments.length > 4 ? arguments[4] : null, M = arguments.length > 5 ? arguments[5] : null, K = arguments.length > 6 && arguments[6], k = !!d && d(b, S);
          if (p)
            p(b, S, { configurable: M === null && k ? k.configurable : !M, enumerable: D === null && k ? k.enumerable : !D, value: A, writable: _ === null && k ? k.writable : !_ });
          else {
            if (!K && (D || _ || M))
              throw new g("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
            b[S] = A;
          }
        };
      }, 581: function(i, o, u) {
        i.exports = function() {
          var c = Function.prototype.toString, l = Object.create, p = Object.defineProperty, g = Object.getOwnPropertyDescriptor, C = Object.getOwnPropertyNames, d = Object.getOwnPropertySymbols, b = Object.getPrototypeOf, S = Object.prototype, A = S.hasOwnProperty, D = S.propertyIsEnumerable, _ = typeof d == "function", M = typeof WeakMap == "function", K = function() {
            if (M)
              return function() {
                return /* @__PURE__ */ new WeakMap();
              };
            var de = function() {
              function ve() {
                this._keys = [], this._values = [];
              }
              return ve.prototype.has = function(se) {
                return !!~this._keys.indexOf(se);
              }, ve.prototype.get = function(se) {
                return this._values[this._keys.indexOf(se)];
              }, ve.prototype.set = function(se, ie) {
                this._keys.push(se), this._values.push(ie);
              }, ve;
            }();
            return function() {
              return new de();
            };
          }(), k = function(de, ve) {
            var se = de.__proto__ || b(de);
            if (!se)
              return l(null);
            var ie = se.constructor;
            if (ie === ve.Object)
              return se === ve.Object.prototype ? {} : l(se);
            if (~c.call(ie).indexOf("[native code]"))
              try {
                return new ie();
              } catch {
              }
            return l(se);
          }, J = function(de, ve, se, ie) {
            var Q = k(de, ve);
            for (var xe in ie.set(de, Q), de)
              A.call(de, xe) && (Q[xe] = se(de[xe], ie));
            if (_)
              for (var Z = d(de), q = 0, Y = Z.length, le = void 0; q < Y; ++q)
                le = Z[q], D.call(de, le) && (Q[le] = se(de[le], ie));
            return Q;
          }, re = function(de, ve, se, ie) {
            var Q = k(de, ve);
            ie.set(de, Q);
            for (var xe = _ ? C(de).concat(d(de)) : C(de), Z = 0, q = xe.length, Y = void 0, le = void 0; Z < q; ++Z)
              if ((Y = xe[Z]) !== "callee" && Y !== "caller")
                if (le = g(de, Y)) {
                  le.get || le.set || (le.value = se(de[Y], ie));
                  try {
                    p(Q, Y, le);
                  } catch {
                    Q[Y] = le.value;
                  }
                } else
                  Q[Y] = se(de[Y], ie);
            return Q;
          }, G = Array.isArray, $ = Object.getPrototypeOf, ue = function() {
            return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : u.g !== void 0 ? u.g : (console && console.error && console.error('Unable to locate global object, returning "this".'), this);
          }();
          function ge(de, ve) {
            var se = !(!ve || !ve.isStrict), ie = ve && ve.realm || ue, Q = se ? re : J, xe = function(Z, q) {
              if (!Z || typeof Z != "object")
                return Z;
              if (q.has(Z))
                return q.get(Z);
              var Y, le, Ce, O = Z.__proto__ || $(Z), we = O && O.constructor;
              if (!we || we === ie.Object)
                return Q(Z, ie, xe, q);
              if (G(Z)) {
                if (se)
                  return re(Z, ie, xe, q);
                Y = new we(), q.set(Z, Y);
                for (var Be = 0, $e = Z.length; Be < $e; ++Be)
                  Y[Be] = xe(Z[Be], q);
                return Y;
              }
              if (Z instanceof ie.Date)
                return new we(Z.getTime());
              if (Z instanceof ie.RegExp)
                return (Y = new we(Z.source, Z.flags || (le = Z, Ce = "", le.global && (Ce += "g"), le.ignoreCase && (Ce += "i"), le.multiline && (Ce += "m"), le.unicode && (Ce += "u"), le.sticky && (Ce += "y"), Ce))).lastIndex = Z.lastIndex, Y;
              if (ie.Map && Z instanceof ie.Map)
                return Y = new we(), q.set(Z, Y), Z.forEach(function(Ee, Fe) {
                  Y.set(Fe, xe(Ee, q));
                }), Y;
              if (ie.Set && Z instanceof ie.Set)
                return Y = new we(), q.set(Z, Y), Z.forEach(function(Ee) {
                  Y.add(xe(Ee, q));
                }), Y;
              if (ie.Blob && Z instanceof ie.Blob)
                return Z.slice(0, Z.size, Z.type);
              if (ie.Buffer && ie.Buffer.isBuffer(Z))
                return Y = ie.Buffer.allocUnsafe ? ie.Buffer.allocUnsafe(Z.length) : new we(Z.length), q.set(Z, Y), Z.copy(Y), Y;
              if (ie.ArrayBuffer) {
                if (ie.ArrayBuffer.isView(Z))
                  return Y = new we(Z.buffer.slice(0)), q.set(Z, Y), Y;
                if (Z instanceof ie.ArrayBuffer)
                  return Y = Z.slice(0), q.set(Z, Y), Y;
              }
              return typeof Z.then == "function" || Z instanceof Error || ie.WeakMap && Z instanceof ie.WeakMap || ie.WeakSet && Z instanceof ie.WeakSet ? Z : Q(Z, ie, xe, q);
            };
            return xe(de, K());
          }
          return ge.default = ge, ge.strict = function(de, ve) {
            return ge(de, { isStrict: !0, realm: ve ? ve.realm : void 0 });
          }, ge;
        }();
      }, 458: function(i) {
        var o = Object.prototype.toString, u = Math.max, c = function(l, p) {
          for (var g = [], C = 0; C < l.length; C += 1)
            g[C] = l[C];
          for (var d = 0; d < p.length; d += 1)
            g[d + l.length] = p[d];
          return g;
        };
        i.exports = function(l) {
          var p = this;
          if (typeof p != "function" || o.apply(p) !== "[object Function]")
            throw new TypeError("Function.prototype.bind called on incompatible " + p);
          for (var g, C = function(D, _) {
            for (var M = [], K = 1, k = 0; K < D.length; K += 1, k += 1)
              M[k] = D[K];
            return M;
          }(arguments), d = u(0, p.length - C.length), b = [], S = 0; S < d; S++)
            b[S] = "$" + S;
          if (g = Function("binder", "return function (" + function(D, _) {
            for (var M = "", K = 0; K < D.length; K += 1)
              M += D[K], K + 1 < D.length && (M += ",");
            return M;
          }(b) + "){ return binder.apply(this,arguments); }")(function() {
            if (this instanceof g) {
              var D = p.apply(this, c(C, arguments));
              return Object(D) === D ? D : this;
            }
            return p.apply(l, c(C, arguments));
          }), p.prototype) {
            var A = function() {
            };
            A.prototype = p.prototype, g.prototype = new A(), A.prototype = null;
          }
          return g;
        };
      }, 132: function(i, o, u) {
        var c = u(458);
        i.exports = Function.prototype.bind || c;
      }, 750: function(i, o, u) {
        var c, l = SyntaxError, p = Function, g = TypeError, C = function(q) {
          try {
            return p('"use strict"; return (' + q + ").constructor;")();
          } catch {
          }
        }, d = Object.getOwnPropertyDescriptor;
        if (d)
          try {
            d({}, "");
          } catch {
            d = null;
          }
        var b = function() {
          throw new g();
        }, S = d ? function() {
          try {
            return b;
          } catch {
            try {
              return d(arguments, "callee").get;
            } catch {
              return b;
            }
          }
        }() : b, A = u(679)(), D = u(574)(), _ = Object.getPrototypeOf || (D ? function(q) {
          return q.__proto__;
        } : null), M = {}, K = typeof Uint8Array < "u" && _ ? _(Uint8Array) : c, k = { "%AggregateError%": typeof AggregateError > "u" ? c : AggregateError, "%Array%": Array, "%ArrayBuffer%": typeof ArrayBuffer > "u" ? c : ArrayBuffer, "%ArrayIteratorPrototype%": A && _ ? _([][Symbol.iterator]()) : c, "%AsyncFromSyncIteratorPrototype%": c, "%AsyncFunction%": M, "%AsyncGenerator%": M, "%AsyncGeneratorFunction%": M, "%AsyncIteratorPrototype%": M, "%Atomics%": typeof Atomics > "u" ? c : Atomics, "%BigInt%": typeof BigInt > "u" ? c : BigInt, "%BigInt64Array%": typeof BigInt64Array > "u" ? c : BigInt64Array, "%BigUint64Array%": typeof BigUint64Array > "u" ? c : BigUint64Array, "%Boolean%": Boolean, "%DataView%": typeof DataView > "u" ? c : DataView, "%Date%": Date, "%decodeURI%": decodeURI, "%decodeURIComponent%": decodeURIComponent, "%encodeURI%": encodeURI, "%encodeURIComponent%": encodeURIComponent, "%Error%": Error, "%eval%": eval, "%EvalError%": EvalError, "%Float32Array%": typeof Float32Array > "u" ? c : Float32Array, "%Float64Array%": typeof Float64Array > "u" ? c : Float64Array, "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? c : FinalizationRegistry, "%Function%": p, "%GeneratorFunction%": M, "%Int8Array%": typeof Int8Array > "u" ? c : Int8Array, "%Int16Array%": typeof Int16Array > "u" ? c : Int16Array, "%Int32Array%": typeof Int32Array > "u" ? c : Int32Array, "%isFinite%": isFinite, "%isNaN%": isNaN, "%IteratorPrototype%": A && _ ? _(_([][Symbol.iterator]())) : c, "%JSON%": typeof JSON == "object" ? JSON : c, "%Map%": typeof Map > "u" ? c : Map, "%MapIteratorPrototype%": typeof Map < "u" && A && _ ? _((/* @__PURE__ */ new Map())[Symbol.iterator]()) : c, "%Math%": Math, "%Number%": Number, "%Object%": Object, "%parseFloat%": parseFloat, "%parseInt%": parseInt, "%Promise%": typeof Promise > "u" ? c : Promise, "%Proxy%": typeof Proxy > "u" ? c : Proxy, "%RangeError%": RangeError, "%ReferenceError%": ReferenceError, "%Reflect%": typeof Reflect > "u" ? c : Reflect, "%RegExp%": RegExp, "%Set%": typeof Set > "u" ? c : Set, "%SetIteratorPrototype%": typeof Set < "u" && A && _ ? _((/* @__PURE__ */ new Set())[Symbol.iterator]()) : c, "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? c : SharedArrayBuffer, "%String%": String, "%StringIteratorPrototype%": A && _ ? _(""[Symbol.iterator]()) : c, "%Symbol%": A ? Symbol : c, "%SyntaxError%": l, "%ThrowTypeError%": S, "%TypedArray%": K, "%TypeError%": g, "%Uint8Array%": typeof Uint8Array > "u" ? c : Uint8Array, "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? c : Uint8ClampedArray, "%Uint16Array%": typeof Uint16Array > "u" ? c : Uint16Array, "%Uint32Array%": typeof Uint32Array > "u" ? c : Uint32Array, "%URIError%": URIError, "%WeakMap%": typeof WeakMap > "u" ? c : WeakMap, "%WeakRef%": typeof WeakRef > "u" ? c : WeakRef, "%WeakSet%": typeof WeakSet > "u" ? c : WeakSet };
        if (_)
          try {
            null.error;
          } catch (q) {
            var J = _(_(q));
            k["%Error.prototype%"] = J;
          }
        var re = function q(Y) {
          var le;
          if (Y === "%AsyncFunction%")
            le = C("async function () {}");
          else if (Y === "%GeneratorFunction%")
            le = C("function* () {}");
          else if (Y === "%AsyncGeneratorFunction%")
            le = C("async function* () {}");
          else if (Y === "%AsyncGenerator%") {
            var Ce = q("%AsyncGeneratorFunction%");
            Ce && (le = Ce.prototype);
          } else if (Y === "%AsyncIteratorPrototype%") {
            var O = q("%AsyncGenerator%");
            O && _ && (le = _(O.prototype));
          }
          return k[Y] = le, le;
        }, G = { "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"], "%ArrayPrototype%": ["Array", "prototype"], "%ArrayProto_entries%": ["Array", "prototype", "entries"], "%ArrayProto_forEach%": ["Array", "prototype", "forEach"], "%ArrayProto_keys%": ["Array", "prototype", "keys"], "%ArrayProto_values%": ["Array", "prototype", "values"], "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"], "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"], "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"], "%BooleanPrototype%": ["Boolean", "prototype"], "%DataViewPrototype%": ["DataView", "prototype"], "%DatePrototype%": ["Date", "prototype"], "%ErrorPrototype%": ["Error", "prototype"], "%EvalErrorPrototype%": ["EvalError", "prototype"], "%Float32ArrayPrototype%": ["Float32Array", "prototype"], "%Float64ArrayPrototype%": ["Float64Array", "prototype"], "%FunctionPrototype%": ["Function", "prototype"], "%Generator%": ["GeneratorFunction", "prototype"], "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"], "%Int8ArrayPrototype%": ["Int8Array", "prototype"], "%Int16ArrayPrototype%": ["Int16Array", "prototype"], "%Int32ArrayPrototype%": ["Int32Array", "prototype"], "%JSONParse%": ["JSON", "parse"], "%JSONStringify%": ["JSON", "stringify"], "%MapPrototype%": ["Map", "prototype"], "%NumberPrototype%": ["Number", "prototype"], "%ObjectPrototype%": ["Object", "prototype"], "%ObjProto_toString%": ["Object", "prototype", "toString"], "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"], "%PromisePrototype%": ["Promise", "prototype"], "%PromiseProto_then%": ["Promise", "prototype", "then"], "%Promise_all%": ["Promise", "all"], "%Promise_reject%": ["Promise", "reject"], "%Promise_resolve%": ["Promise", "resolve"], "%RangeErrorPrototype%": ["RangeError", "prototype"], "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"], "%RegExpPrototype%": ["RegExp", "prototype"], "%SetPrototype%": ["Set", "prototype"], "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"], "%StringPrototype%": ["String", "prototype"], "%SymbolPrototype%": ["Symbol", "prototype"], "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"], "%TypedArrayPrototype%": ["TypedArray", "prototype"], "%TypeErrorPrototype%": ["TypeError", "prototype"], "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"], "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"], "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"], "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"], "%URIErrorPrototype%": ["URIError", "prototype"], "%WeakMapPrototype%": ["WeakMap", "prototype"], "%WeakSetPrototype%": ["WeakSet", "prototype"] }, $ = u(132), ue = u(712), ge = $.call(Function.call, Array.prototype.concat), de = $.call(Function.apply, Array.prototype.splice), ve = $.call(Function.call, String.prototype.replace), se = $.call(Function.call, String.prototype.slice), ie = $.call(Function.call, RegExp.prototype.exec), Q = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, xe = /\\(\\)?/g, Z = function(q, Y) {
          var le, Ce = q;
          if (ue(G, Ce) && (Ce = "%" + (le = G[Ce])[0] + "%"), ue(k, Ce)) {
            var O = k[Ce];
            if (O === M && (O = re(Ce)), O === void 0 && !Y)
              throw new g("intrinsic " + q + " exists, but is not available. Please file an issue!");
            return { alias: le, name: Ce, value: O };
          }
          throw new l("intrinsic " + q + " does not exist!");
        };
        i.exports = function(q, Y) {
          if (typeof q != "string" || q.length === 0)
            throw new g("intrinsic name must be a non-empty string");
          if (arguments.length > 1 && typeof Y != "boolean")
            throw new g('"allowMissing" argument must be a boolean');
          if (ie(/^%?[^%]*%?$/, q) === null)
            throw new l("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
          var le = function(Me) {
            var zt = se(Me, 0, 1), Kt = se(Me, -1);
            if (zt === "%" && Kt !== "%")
              throw new l("invalid intrinsic syntax, expected closing `%`");
            if (Kt === "%" && zt !== "%")
              throw new l("invalid intrinsic syntax, expected opening `%`");
            var jt = [];
            return ve(Me, Q, function(Wt, dr, Dr, Et) {
              jt[jt.length] = Dr ? ve(Et, xe, "$1") : dr || Wt;
            }), jt;
          }(q), Ce = le.length > 0 ? le[0] : "", O = Z("%" + Ce + "%", Y), we = O.name, Be = O.value, $e = !1, Ee = O.alias;
          Ee && (Ce = Ee[0], de(le, ge([0, 1], Ee)));
          for (var Fe = 1, qe = !0; Fe < le.length; Fe += 1) {
            var Ve = le[Fe], ze = se(Ve, 0, 1), Ge = se(Ve, -1);
            if ((ze === '"' || ze === "'" || ze === "`" || Ge === '"' || Ge === "'" || Ge === "`") && ze !== Ge)
              throw new l("property names with quotes must have matching quotes");
            if (Ve !== "constructor" && qe || ($e = !0), ue(k, we = "%" + (Ce += "." + Ve) + "%"))
              Be = k[we];
            else if (Be != null) {
              if (!(Ve in Be)) {
                if (!Y)
                  throw new g("base intrinsic for " + q + " exists, but the property is not available.");
                return;
              }
              if (d && Fe + 1 >= le.length) {
                var Ne = d(Be, Ve);
                Be = (qe = !!Ne) && "get" in Ne && !("originalValue" in Ne.get) ? Ne.get : Be[Ve];
              } else
                qe = ue(Be, Ve), Be = Be[Ve];
              qe && !$e && (k[we] = Be);
            }
          }
          return Be;
        };
      }, 502: function(i, o, u) {
        var c = u(750)("%Object.getOwnPropertyDescriptor%", !0);
        if (c)
          try {
            c([], "length");
          } catch {
            c = null;
          }
        i.exports = c;
      }, 365: function(i, o, u) {
        var c = u(750)("%Object.defineProperty%", !0), l = function() {
          if (c)
            try {
              return c({}, "a", { value: 1 }), !0;
            } catch {
              return !1;
            }
          return !1;
        };
        l.hasArrayLengthDefineBug = function() {
          if (!l())
            return null;
          try {
            return c([], "length", { value: 1 }).length !== 1;
          } catch {
            return !0;
          }
        }, i.exports = l;
      }, 574: function(i) {
        var o = { foo: {} }, u = Object;
        i.exports = function() {
          return { __proto__: o }.foo === o.foo && !({ __proto__: null } instanceof u);
        };
      }, 679: function(i, o, u) {
        var c = typeof Symbol < "u" && Symbol, l = u(186);
        i.exports = function() {
          return typeof c == "function" && typeof Symbol == "function" && typeof c("foo") == "symbol" && typeof Symbol("bar") == "symbol" && l();
        };
      }, 186: function(i) {
        i.exports = function() {
          if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
            return !1;
          if (typeof Symbol.iterator == "symbol")
            return !0;
          var o = {}, u = Symbol("test"), c = Object(u);
          if (typeof u == "string" || Object.prototype.toString.call(u) !== "[object Symbol]" || Object.prototype.toString.call(c) !== "[object Symbol]")
            return !1;
          for (u in o[u] = 42, o)
            return !1;
          if (typeof Object.keys == "function" && Object.keys(o).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(o).length !== 0)
            return !1;
          var l = Object.getOwnPropertySymbols(o);
          if (l.length !== 1 || l[0] !== u || !Object.prototype.propertyIsEnumerable.call(o, u))
            return !1;
          if (typeof Object.getOwnPropertyDescriptor == "function") {
            var p = Object.getOwnPropertyDescriptor(o, u);
            if (p.value !== 42 || p.enumerable !== !0)
              return !1;
          }
          return !0;
        };
      }, 712: function(i, o, u) {
        var c = Function.prototype.call, l = Object.prototype.hasOwnProperty, p = u(132);
        i.exports = p.call(c, l);
      }, 784: function(i, o) {
        function u(c, l) {
          var p = [], g = [];
          return l == null && (l = function(C, d) {
            return p[0] === d ? "[Circular ~]" : "[Circular ~." + g.slice(0, p.indexOf(d)).join(".") + "]";
          }), function(C, d) {
            if (p.length > 0) {
              var b = p.indexOf(this);
              ~b ? p.splice(b + 1) : p.push(this), ~b ? g.splice(b, 1 / 0, C) : g.push(C), ~p.indexOf(d) && (d = l.call(this, C, d));
            } else
              p.push(d);
            return c == null ? d : c.call(this, C, d);
          };
        }
        (i.exports = function(c, l, p, g) {
          return JSON.stringify(c, u(l, g), p);
        }).getSerialize = u;
      }, 261: function(i) {
        var o, u, c = Function.prototype, l = Object.prototype, p = c.toString, g = l.hasOwnProperty, C = p.call(Object), d = l.toString, b = (o = Object.getPrototypeOf, u = Object, function(S) {
          return o(u(S));
        });
        i.exports = function(S) {
          if (!function(_) {
            return !!_ && typeof _ == "object";
          }(S) || d.call(S) != "[object Object]" || function(_) {
            var M = !1;
            if (_ != null && typeof _.toString != "function")
              try {
                M = !!(_ + "");
              } catch {
              }
            return M;
          }(S))
            return !1;
          var A = b(S);
          if (A === null)
            return !0;
          var D = g.call(A, "constructor") && A.constructor;
          return typeof D == "function" && D instanceof D && p.call(D) == C;
        };
      }, 451: function(i) {
        var o = Object.prototype.toString, u = Array.isArray;
        i.exports = function(c) {
          return typeof c == "string" || !u(c) && function(l) {
            return !!l && typeof l == "object";
          }(c) && o.call(c) == "[object String]";
        };
      }, 524: function(i, o, u) {
        var c = typeof Map == "function" && Map.prototype, l = Object.getOwnPropertyDescriptor && c ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, p = c && l && typeof l.get == "function" ? l.get : null, g = c && Map.prototype.forEach, C = typeof Set == "function" && Set.prototype, d = Object.getOwnPropertyDescriptor && C ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, b = C && d && typeof d.get == "function" ? d.get : null, S = C && Set.prototype.forEach, A = typeof WeakMap == "function" && WeakMap.prototype ? WeakMap.prototype.has : null, D = typeof WeakSet == "function" && WeakSet.prototype ? WeakSet.prototype.has : null, _ = typeof WeakRef == "function" && WeakRef.prototype ? WeakRef.prototype.deref : null, M = Boolean.prototype.valueOf, K = Object.prototype.toString, k = Function.prototype.toString, J = String.prototype.match, re = String.prototype.slice, G = String.prototype.replace, $ = String.prototype.toUpperCase, ue = String.prototype.toLowerCase, ge = RegExp.prototype.test, de = Array.prototype.concat, ve = Array.prototype.join, se = Array.prototype.slice, ie = Math.floor, Q = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, xe = Object.getOwnPropertySymbols, Z = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, q = typeof Symbol == "function" && typeof Symbol.iterator == "object", Y = typeof Symbol == "function" && Symbol.toStringTag ? Symbol.toStringTag : null, le = Object.prototype.propertyIsEnumerable, Ce = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(ne) {
          return ne.__proto__;
        } : null);
        function O(ne, H) {
          if (ne === 1 / 0 || ne === -1 / 0 || ne != ne || ne && ne > -1e3 && ne < 1e3 || ge.call(/e/, H))
            return H;
          var Ye = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
          if (typeof ne == "number") {
            var We = ne < 0 ? -ie(-ne) : ie(ne);
            if (We !== ne) {
              var ct = String(We), Le = re.call(H, ct.length + 1);
              return G.call(ct, Ye, "$&_") + "." + G.call(G.call(Le, /([0-9]{3})/g, "$&_"), /_$/, "");
            }
          }
          return G.call(H, Ye, "$&_");
        }
        var we = u(553), Be = we.custom, $e = ze(Be) ? Be : null;
        function Ee(ne, H, Ye) {
          var We = (Ye.quoteStyle || H) === "double" ? '"' : "'";
          return We + ne + We;
        }
        function Fe(ne) {
          return G.call(String(ne), /"/g, "&quot;");
        }
        function qe(ne) {
          return !(Me(ne) !== "[object Array]" || Y && typeof ne == "object" && Y in ne);
        }
        function Ve(ne) {
          return !(Me(ne) !== "[object RegExp]" || Y && typeof ne == "object" && Y in ne);
        }
        function ze(ne) {
          if (q)
            return ne && typeof ne == "object" && ne instanceof Symbol;
          if (typeof ne == "symbol")
            return !0;
          if (!ne || typeof ne != "object" || !Z)
            return !1;
          try {
            return Z.call(ne), !0;
          } catch {
          }
          return !1;
        }
        i.exports = function ne(H, Ye, We, ct) {
          var Le = Ye || {};
          if (Ne(Le, "quoteStyle") && Le.quoteStyle !== "single" && Le.quoteStyle !== "double")
            throw new TypeError('option "quoteStyle" must be "single" or "double"');
          if (Ne(Le, "maxStringLength") && (typeof Le.maxStringLength == "number" ? Le.maxStringLength < 0 && Le.maxStringLength !== 1 / 0 : Le.maxStringLength !== null))
            throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
          var Ct = !Ne(Le, "customInspect") || Le.customInspect;
          if (typeof Ct != "boolean" && Ct !== "symbol")
            throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
          if (Ne(Le, "indent") && Le.indent !== null && Le.indent !== "	" && !(parseInt(Le.indent, 10) === Le.indent && Le.indent > 0))
            throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
          if (Ne(Le, "numericSeparator") && typeof Le.numericSeparator != "boolean")
            throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
          var Dt = Le.numericSeparator;
          if (H === void 0)
            return "undefined";
          if (H === null)
            return "null";
          if (typeof H == "boolean")
            return H ? "true" : "false";
          if (typeof H == "string")
            return Kt(H, Le);
          if (typeof H == "number") {
            if (H === 0)
              return 1 / 0 / H > 0 ? "0" : "-0";
            var st = String(H);
            return Dt ? O(H, st) : st;
          }
          if (typeof H == "bigint") {
            var kt = String(H) + "n";
            return Dt ? O(H, kt) : kt;
          }
          var rn = Le.depth === void 0 ? 5 : Le.depth;
          if (We === void 0 && (We = 0), We >= rn && rn > 0 && typeof H == "object")
            return qe(H) ? "[Array]" : "[Object]";
          var yr, Ht = function(ce, Xe) {
            var Yt;
            if (ce.indent === "	")
              Yt = "	";
            else {
              if (!(typeof ce.indent == "number" && ce.indent > 0))
                return null;
              Yt = ve.call(Array(ce.indent + 1), " ");
            }
            return { base: Yt, prev: ve.call(Array(Xe + 1), Yt) };
          }(Le, We);
          if (ct === void 0)
            ct = [];
          else if (zt(ct, H) >= 0)
            return "[Circular]";
          function _t(ce, Xe, Yt) {
            if (Xe && (ct = se.call(ct)).push(Xe), Yt) {
              var Wn = { depth: Le.depth };
              return Ne(Le, "quoteStyle") && (Wn.quoteStyle = Le.quoteStyle), ne(ce, Wn, We + 1, ct);
            }
            return ne(ce, Le, We + 1, ct);
          }
          if (typeof H == "function" && !Ve(H)) {
            var Tn = function(ce) {
              if (ce.name)
                return ce.name;
              var Xe = J.call(k.call(ce), /^function\s*([\w$]+)/);
              return Xe ? Xe[1] : null;
            }(H), zn = kr(H, _t);
            return "[Function" + (Tn ? ": " + Tn : " (anonymous)") + "]" + (zn.length > 0 ? " { " + ve.call(zn, ", ") + " }" : "");
          }
          if (ze(H)) {
            var An = q ? G.call(String(H), /^(Symbol\(.*\))_[^)]*$/, "$1") : Z.call(H);
            return typeof H != "object" || q ? An : Wt(An);
          }
          if ((yr = H) && typeof yr == "object" && (typeof HTMLElement < "u" && yr instanceof HTMLElement || typeof yr.nodeName == "string" && typeof yr.getAttribute == "function")) {
            for (var gr = "<" + ue.call(String(H.nodeName)), nn = H.attributes || [], an = 0; an < nn.length; an++)
              gr += " " + nn[an].name + "=" + Ee(Fe(nn[an].value), "double", Le);
            return gr += ">", H.childNodes && H.childNodes.length && (gr += "..."), gr + "</" + ue.call(String(H.nodeName)) + ">";
          }
          if (qe(H)) {
            if (H.length === 0)
              return "[]";
            var sn = kr(H, _t);
            return Ht && !function(ce) {
              for (var Xe = 0; Xe < ce.length; Xe++)
                if (zt(ce[Xe], `
`) >= 0)
                  return !1;
              return !0;
            }(sn) ? "[" + Et(sn, Ht) + "]" : "[ " + ve.call(sn, ", ") + " ]";
          }
          if (function(ce) {
            return !(Me(ce) !== "[object Error]" || Y && typeof ce == "object" && Y in ce);
          }(H)) {
            var Or = kr(H, _t);
            return "cause" in Error.prototype || !("cause" in H) || le.call(H, "cause") ? Or.length === 0 ? "[" + String(H) + "]" : "{ [" + String(H) + "] " + ve.call(Or, ", ") + " }" : "{ [" + String(H) + "] " + ve.call(de.call("[cause]: " + _t(H.cause), Or), ", ") + " }";
          }
          if (typeof H == "object" && Ct) {
            if ($e && typeof H[$e] == "function" && we)
              return we(H, { depth: rn - We });
            if (Ct !== "symbol" && typeof H.inspect == "function")
              return H.inspect();
          }
          if (function(ce) {
            if (!p || !ce || typeof ce != "object")
              return !1;
            try {
              p.call(ce);
              try {
                b.call(ce);
              } catch {
                return !0;
              }
              return ce instanceof Map;
            } catch {
            }
            return !1;
          }(H)) {
            var In = [];
            return g && g.call(H, function(ce, Xe) {
              In.push(_t(Xe, H, !0) + " => " + _t(ce, H));
            }), Dr("Map", p.call(H), In, Ht);
          }
          if (function(ce) {
            if (!b || !ce || typeof ce != "object")
              return !1;
            try {
              b.call(ce);
              try {
                p.call(ce);
              } catch {
                return !0;
              }
              return ce instanceof Set;
            } catch {
            }
            return !1;
          }(H)) {
            var wn = [];
            return S && S.call(H, function(ce) {
              wn.push(_t(ce, H));
            }), Dr("Set", b.call(H), wn, Ht);
          }
          if (function(ce) {
            if (!A || !ce || typeof ce != "object")
              return !1;
            try {
              A.call(ce, A);
              try {
                D.call(ce, D);
              } catch {
                return !0;
              }
              return ce instanceof WeakMap;
            } catch {
            }
            return !1;
          }(H))
            return dr("WeakMap");
          if (function(ce) {
            if (!D || !ce || typeof ce != "object")
              return !1;
            try {
              D.call(ce, D);
              try {
                A.call(ce, A);
              } catch {
                return !0;
              }
              return ce instanceof WeakSet;
            } catch {
            }
            return !1;
          }(H))
            return dr("WeakSet");
          if (function(ce) {
            if (!_ || !ce || typeof ce != "object")
              return !1;
            try {
              return _.call(ce), !0;
            } catch {
            }
            return !1;
          }(H))
            return dr("WeakRef");
          if (function(ce) {
            return !(Me(ce) !== "[object Number]" || Y && typeof ce == "object" && Y in ce);
          }(H))
            return Wt(_t(Number(H)));
          if (function(ce) {
            if (!ce || typeof ce != "object" || !Q)
              return !1;
            try {
              return Q.call(ce), !0;
            } catch {
            }
            return !1;
          }(H))
            return Wt(_t(Q.call(H)));
          if (function(ce) {
            return !(Me(ce) !== "[object Boolean]" || Y && typeof ce == "object" && Y in ce);
          }(H))
            return Wt(M.call(H));
          if (function(ce) {
            return !(Me(ce) !== "[object String]" || Y && typeof ce == "object" && Y in ce);
          }(H))
            return Wt(_t(String(H)));
          if (typeof window < "u" && H === window)
            return "{ [object Window] }";
          if (H === u.g)
            return "{ [object globalThis] }";
          if (!function(ce) {
            return !(Me(ce) !== "[object Date]" || Y && typeof ce == "object" && Y in ce);
          }(H) && !Ve(H)) {
            var Qt = kr(H, _t), on = Ce ? Ce(H) === Object.prototype : H instanceof Object || H.constructor === Object, cn = H instanceof Object ? "" : "null prototype", un = !on && Y && Object(H) === H && Y in H ? re.call(Me(H), 8, -1) : cn ? "Object" : "", Ot = (on || typeof H.constructor != "function" ? "" : H.constructor.name ? H.constructor.name + " " : "") + (un || cn ? "[" + ve.call(de.call([], un || [], cn || []), ": ") + "] " : "");
            return Qt.length === 0 ? Ot + "{}" : Ht ? Ot + "{" + Et(Qt, Ht) + "}" : Ot + "{ " + ve.call(Qt, ", ") + " }";
          }
          return String(H);
        };
        var Ge = Object.prototype.hasOwnProperty || function(ne) {
          return ne in this;
        };
        function Ne(ne, H) {
          return Ge.call(ne, H);
        }
        function Me(ne) {
          return K.call(ne);
        }
        function zt(ne, H) {
          if (ne.indexOf)
            return ne.indexOf(H);
          for (var Ye = 0, We = ne.length; Ye < We; Ye++)
            if (ne[Ye] === H)
              return Ye;
          return -1;
        }
        function Kt(ne, H) {
          if (ne.length > H.maxStringLength) {
            var Ye = ne.length - H.maxStringLength, We = "... " + Ye + " more character" + (Ye > 1 ? "s" : "");
            return Kt(re.call(ne, 0, H.maxStringLength), H) + We;
          }
          return Ee(G.call(G.call(ne, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, jt), "single", H);
        }
        function jt(ne) {
          var H = ne.charCodeAt(0), Ye = { 8: "b", 9: "t", 10: "n", 12: "f", 13: "r" }[H];
          return Ye ? "\\" + Ye : "\\x" + (H < 16 ? "0" : "") + $.call(H.toString(16));
        }
        function Wt(ne) {
          return "Object(" + ne + ")";
        }
        function dr(ne) {
          return ne + " { ? }";
        }
        function Dr(ne, H, Ye, We) {
          return ne + " (" + H + ") {" + (We ? Et(Ye, We) : ve.call(Ye, ", ")) + "}";
        }
        function Et(ne, H) {
          if (ne.length === 0)
            return "";
          var Ye = `
` + H.prev + H.base;
          return Ye + ve.call(ne, "," + Ye) + `
` + H.prev;
        }
        function kr(ne, H) {
          var Ye = qe(ne), We = [];
          if (Ye) {
            We.length = ne.length;
            for (var ct = 0; ct < ne.length; ct++)
              We[ct] = Ne(ne, ct) ? H(ne[ct], ne) : "";
          }
          var Le, Ct = typeof xe == "function" ? xe(ne) : [];
          if (q) {
            Le = {};
            for (var Dt = 0; Dt < Ct.length; Dt++)
              Le["$" + Ct[Dt]] = Ct[Dt];
          }
          for (var st in ne)
            Ne(ne, st) && (Ye && String(Number(st)) === st && st < ne.length || q && Le["$" + st] instanceof Symbol || (ge.call(/[^\w$]/, st) ? We.push(H(st, ne) + ": " + H(ne[st], ne)) : We.push(st + ": " + H(ne[st], ne))));
          if (typeof xe == "function")
            for (var kt = 0; kt < Ct.length; kt++)
              le.call(ne, Ct[kt]) && We.push("[" + H(Ct[kt]) + "]: " + H(ne[Ct[kt]], ne));
          return We;
        }
      }, 930: function(i) {
        class o extends Error {
          constructor() {
            super("Throttled function aborted"), this.name = "AbortError";
          }
        }
        i.exports = ({ limit: u, interval: c, strict: l }) => {
          if (!Number.isFinite(u))
            throw new TypeError("Expected `limit` to be a finite number");
          if (!Number.isFinite(c))
            throw new TypeError("Expected `interval` to be a finite number");
          const p = /* @__PURE__ */ new Map();
          let g = 0, C = 0;
          const d = [], b = l ? function() {
            const S = Date.now();
            if (d.length < u)
              return d.push(S), 0;
            const A = d.shift() + c;
            return S >= A ? (d.push(S), 0) : (d.push(A), A - S);
          } : function() {
            const S = Date.now();
            return S - g > c ? (C = 1, g = S, 0) : (C < u ? C++ : (g += c, C = 1), g - S);
          };
          return (S) => {
            const A = function(...D) {
              if (!A.isEnabled)
                return (async () => S.apply(this, D))();
              let _;
              return new Promise((M, K) => {
                _ = setTimeout(() => {
                  M(S.apply(this, D)), p.delete(_);
                }, b()), p.set(_, K);
              });
            };
            return A.abort = () => {
              for (const D of p.keys())
                clearTimeout(D), p.get(D)(new o());
              p.clear(), d.splice(0, d.length);
            }, A.isEnabled = !0, A;
          };
        }, i.exports.AbortError = o;
      }, 504: function(i, o, u) {
        var c = u(750), l = u(300), p = u(365)(), g = u(502), C = c("%TypeError%"), d = c("%Math.floor%");
        i.exports = function(b, S) {
          if (typeof b != "function")
            throw new C("`fn` is not a function");
          if (typeof S != "number" || S < 0 || S > 4294967295 || d(S) !== S)
            throw new C("`length` must be a positive 32-bit integer");
          var A = arguments.length > 2 && !!arguments[2], D = !0, _ = !0;
          if ("length" in b && g) {
            var M = g(b, "length");
            M && !M.configurable && (D = !1), M && !M.writable && (_ = !1);
          }
          return (D || _ || !A) && (p ? l(b, "length", S, !0, !0) : l(b, "length", S)), b;
        };
      }, 337: function(i, o, u) {
        var c = u(750), l = u(737), p = u(524), g = c("%TypeError%"), C = c("%WeakMap%", !0), d = c("%Map%", !0), b = l("WeakMap.prototype.get", !0), S = l("WeakMap.prototype.set", !0), A = l("WeakMap.prototype.has", !0), D = l("Map.prototype.get", !0), _ = l("Map.prototype.set", !0), M = l("Map.prototype.has", !0), K = function(k, J) {
          for (var re, G = k; (re = G.next) !== null; G = re)
            if (re.key === J)
              return G.next = re.next, re.next = k.next, k.next = re, re;
        };
        i.exports = function() {
          var k, J, re, G = { assert: function($) {
            if (!G.has($))
              throw new g("Side channel does not contain " + p($));
          }, get: function($) {
            if (C && $ && (typeof $ == "object" || typeof $ == "function")) {
              if (k)
                return b(k, $);
            } else if (d) {
              if (J)
                return D(J, $);
            } else if (re)
              return function(ue, ge) {
                var de = K(ue, ge);
                return de && de.value;
              }(re, $);
          }, has: function($) {
            if (C && $ && (typeof $ == "object" || typeof $ == "function")) {
              if (k)
                return A(k, $);
            } else if (d) {
              if (J)
                return M(J, $);
            } else if (re)
              return function(ue, ge) {
                return !!K(ue, ge);
              }(re, $);
            return !1;
          }, set: function($, ue) {
            C && $ && (typeof $ == "object" || typeof $ == "function") ? (k || (k = new C()), S(k, $, ue)) : d ? (J || (J = new d()), _(J, $, ue)) : (re || (re = { key: {}, next: null }), function(ge, de, ve) {
              var se = K(ge, de);
              se ? se.value = ve : ge.next = { key: de, next: ge.next, value: ve };
            }(re, $, ue));
          } };
          return G;
        };
      }, 553: function() {
      } }, r = {};
      function a(i) {
        var o = r[i];
        if (o !== void 0)
          return o.exports;
        var u = r[i] = { exports: {} };
        return n[i].call(u.exports, u, u.exports, a), u.exports;
      }
      a.n = function(i) {
        var o = i && i.__esModule ? function() {
          return i.default;
        } : function() {
          return i;
        };
        return a.d(o, { a: o }), o;
      }, a.d = function(i, o) {
        for (var u in o)
          a.o(o, u) && !a.o(i, u) && Object.defineProperty(i, u, { enumerable: !0, get: o[u] });
      }, a.g = function() {
        if (typeof globalThis == "object")
          return globalThis;
        try {
          return this || new Function("return this")();
        } catch {
          if (typeof window == "object")
            return window;
        }
      }(), a.o = function(i, o) {
        return Object.prototype.hasOwnProperty.call(i, o);
      }, a.r = function(i) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
      };
      var s = {};
      return function() {
        function i(f, h) {
          return function() {
            return f.apply(h, arguments);
          };
        }
        a.r(s), a.d(s, { createClient: function() {
          return pu;
        }, createGlobalOptions: function() {
          return gs;
        } });
        const { toString: o } = Object.prototype, { getPrototypeOf: u } = Object, c = (l = /* @__PURE__ */ Object.create(null), (f) => {
          const h = o.call(f);
          return l[h] || (l[h] = h.slice(8, -1).toLowerCase());
        });
        var l;
        const p = (f) => (f = f.toLowerCase(), (h) => c(h) === f), g = (f) => (h) => typeof h === f, { isArray: C } = Array, d = g("undefined"), b = p("ArrayBuffer"), S = g("string"), A = g("function"), D = g("number"), _ = (f) => f !== null && typeof f == "object", M = (f) => {
          if (c(f) !== "object")
            return !1;
          const h = u(f);
          return !(h !== null && h !== Object.prototype && Object.getPrototypeOf(h) !== null || Symbol.toStringTag in f || Symbol.iterator in f);
        }, K = p("Date"), k = p("File"), J = p("Blob"), re = p("FileList"), G = p("URLSearchParams");
        function $(f, h, { allOwnKeys: y = !1 } = {}) {
          if (f == null)
            return;
          let x, T;
          if (typeof f != "object" && (f = [f]), C(f))
            for (x = 0, T = f.length; x < T; x++)
              h.call(null, f[x], x, f);
          else {
            const w = y ? Object.getOwnPropertyNames(f) : Object.keys(f), I = w.length;
            let F;
            for (x = 0; x < I; x++)
              F = w[x], h.call(null, f[F], F, f);
          }
        }
        function ue(f, h) {
          h = h.toLowerCase();
          const y = Object.keys(f);
          let x, T = y.length;
          for (; T-- > 0; )
            if (x = y[T], h === x.toLowerCase())
              return x;
          return null;
        }
        const ge = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : vo, de = (f) => !d(f) && f !== ge, ve = (se = typeof Uint8Array < "u" && u(Uint8Array), (f) => se && f instanceof se);
        var se;
        const ie = p("HTMLFormElement"), Q = (({ hasOwnProperty: f }) => (h, y) => f.call(h, y))(Object.prototype), xe = p("RegExp"), Z = (f, h) => {
          const y = Object.getOwnPropertyDescriptors(f), x = {};
          $(y, (T, w) => {
            let I;
            (I = h(T, w, f)) !== !1 && (x[w] = I || T);
          }), Object.defineProperties(f, x);
        }, q = "abcdefghijklmnopqrstuvwxyz", Y = "0123456789", le = { DIGIT: Y, ALPHA: q, ALPHA_DIGIT: q + q.toUpperCase() + Y }, Ce = p("AsyncFunction");
        var O = { isArray: C, isArrayBuffer: b, isBuffer: function(f) {
          return f !== null && !d(f) && f.constructor !== null && !d(f.constructor) && A(f.constructor.isBuffer) && f.constructor.isBuffer(f);
        }, isFormData: (f) => {
          let h;
          return f && (typeof FormData == "function" && f instanceof FormData || A(f.append) && ((h = c(f)) === "formdata" || h === "object" && A(f.toString) && f.toString() === "[object FormData]"));
        }, isArrayBufferView: function(f) {
          let h;
          return h = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(f) : f && f.buffer && b(f.buffer), h;
        }, isString: S, isNumber: D, isBoolean: (f) => f === !0 || f === !1, isObject: _, isPlainObject: M, isUndefined: d, isDate: K, isFile: k, isBlob: J, isRegExp: xe, isFunction: A, isStream: (f) => _(f) && A(f.pipe), isURLSearchParams: G, isTypedArray: ve, isFileList: re, forEach: $, merge: function f() {
          const { caseless: h } = de(this) && this || {}, y = {}, x = (T, w) => {
            const I = h && ue(y, w) || w;
            M(y[I]) && M(T) ? y[I] = f(y[I], T) : M(T) ? y[I] = f({}, T) : C(T) ? y[I] = T.slice() : y[I] = T;
          };
          for (let T = 0, w = arguments.length; T < w; T++)
            arguments[T] && $(arguments[T], x);
          return y;
        }, extend: (f, h, y, { allOwnKeys: x } = {}) => ($(h, (T, w) => {
          y && A(T) ? f[w] = i(T, y) : f[w] = T;
        }, { allOwnKeys: x }), f), trim: (f) => f.trim ? f.trim() : f.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), stripBOM: (f) => (f.charCodeAt(0) === 65279 && (f = f.slice(1)), f), inherits: (f, h, y, x) => {
          f.prototype = Object.create(h.prototype, x), f.prototype.constructor = f, Object.defineProperty(f, "super", { value: h.prototype }), y && Object.assign(f.prototype, y);
        }, toFlatObject: (f, h, y, x) => {
          let T, w, I;
          const F = {};
          if (h = h || {}, f == null)
            return h;
          do {
            for (T = Object.getOwnPropertyNames(f), w = T.length; w-- > 0; )
              I = T[w], x && !x(I, f, h) || F[I] || (h[I] = f[I], F[I] = !0);
            f = y !== !1 && u(f);
          } while (f && (!y || y(f, h)) && f !== Object.prototype);
          return h;
        }, kindOf: c, kindOfTest: p, endsWith: (f, h, y) => {
          f = String(f), (y === void 0 || y > f.length) && (y = f.length), y -= h.length;
          const x = f.indexOf(h, y);
          return x !== -1 && x === y;
        }, toArray: (f) => {
          if (!f)
            return null;
          if (C(f))
            return f;
          let h = f.length;
          if (!D(h))
            return null;
          const y = new Array(h);
          for (; h-- > 0; )
            y[h] = f[h];
          return y;
        }, forEachEntry: (f, h) => {
          const y = (f && f[Symbol.iterator]).call(f);
          let x;
          for (; (x = y.next()) && !x.done; ) {
            const T = x.value;
            h.call(f, T[0], T[1]);
          }
        }, matchAll: (f, h) => {
          let y;
          const x = [];
          for (; (y = f.exec(h)) !== null; )
            x.push(y);
          return x;
        }, isHTMLForm: ie, hasOwnProperty: Q, hasOwnProp: Q, reduceDescriptors: Z, freezeMethods: (f) => {
          Z(f, (h, y) => {
            if (A(f) && ["arguments", "caller", "callee"].indexOf(y) !== -1)
              return !1;
            const x = f[y];
            A(x) && (h.enumerable = !1, "writable" in h ? h.writable = !1 : h.set || (h.set = () => {
              throw Error("Can not rewrite read-only method '" + y + "'");
            }));
          });
        }, toObjectSet: (f, h) => {
          const y = {}, x = (T) => {
            T.forEach((w) => {
              y[w] = !0;
            });
          };
          return C(f) ? x(f) : x(String(f).split(h)), y;
        }, toCamelCase: (f) => f.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(h, y, x) {
          return y.toUpperCase() + x;
        }), noop: () => {
        }, toFiniteNumber: (f, h) => (f = +f, Number.isFinite(f) ? f : h), findKey: ue, global: ge, isContextDefined: de, ALPHABET: le, generateString: (f = 16, h = le.ALPHA_DIGIT) => {
          let y = "";
          const { length: x } = h;
          for (; f--; )
            y += h[Math.random() * x | 0];
          return y;
        }, isSpecCompliantForm: function(f) {
          return !!(f && A(f.append) && f[Symbol.toStringTag] === "FormData" && f[Symbol.iterator]);
        }, toJSONObject: (f) => {
          const h = new Array(10), y = (x, T) => {
            if (_(x)) {
              if (h.indexOf(x) >= 0)
                return;
              if (!("toJSON" in x)) {
                h[T] = x;
                const w = C(x) ? [] : {};
                return $(x, (I, F) => {
                  const U = y(I, T + 1);
                  !d(U) && (w[F] = U);
                }), h[T] = void 0, w;
              }
            }
            return x;
          };
          return y(f, 0);
        }, isAsyncFn: Ce, isThenable: (f) => f && (_(f) || A(f)) && A(f.then) && A(f.catch) };
        function we(f, h, y, x, T) {
          Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = f, this.name = "AxiosError", h && (this.code = h), y && (this.config = y), x && (this.request = x), T && (this.response = T);
        }
        O.inherits(we, Error, { toJSON: function() {
          return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: O.toJSONObject(this.config), code: this.code, status: this.response && this.response.status ? this.response.status : null };
        } });
        const Be = we.prototype, $e = {};
        ["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((f) => {
          $e[f] = { value: f };
        }), Object.defineProperties(we, $e), Object.defineProperty(Be, "isAxiosError", { value: !0 }), we.from = (f, h, y, x, T, w) => {
          const I = Object.create(Be);
          return O.toFlatObject(f, I, function(F) {
            return F !== Error.prototype;
          }, (F) => F !== "isAxiosError"), we.call(I, f.message, h, y, x, T), I.cause = f, I.name = f.name, w && Object.assign(I, w), I;
        };
        var Ee = we;
        function Fe(f) {
          return O.isPlainObject(f) || O.isArray(f);
        }
        function qe(f) {
          return O.endsWith(f, "[]") ? f.slice(0, -2) : f;
        }
        function Ve(f, h, y) {
          return f ? f.concat(h).map(function(x, T) {
            return x = qe(x), !y && T ? "[" + x + "]" : x;
          }).join(y ? "." : "") : h;
        }
        const ze = O.toFlatObject(O, {}, null, function(f) {
          return /^is[A-Z]/.test(f);
        });
        var Ge = function(f, h, y) {
          if (!O.isObject(f))
            throw new TypeError("target must be an object");
          h = h || new FormData();
          const x = (y = O.toFlatObject(y, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(X, pe) {
            return !O.isUndefined(pe[X]);
          })).metaTokens, T = y.visitor || R, w = y.dots, I = y.indexes, F = (y.Blob || typeof Blob < "u" && Blob) && O.isSpecCompliantForm(h);
          if (!O.isFunction(T))
            throw new TypeError("visitor must be a function");
          function U(X) {
            if (X === null)
              return "";
            if (O.isDate(X))
              return X.toISOString();
            if (!F && O.isBlob(X))
              throw new Ee("Blob is not supported. Use a Buffer instead.");
            return O.isArrayBuffer(X) || O.isTypedArray(X) ? F && typeof Blob == "function" ? new Blob([X]) : Buffer.from(X) : X;
          }
          function R(X, pe, me) {
            let Ie = X;
            if (X && !me && typeof X == "object") {
              if (O.endsWith(pe, "{}"))
                pe = x ? pe : pe.slice(0, -2), X = JSON.stringify(X);
              else if (O.isArray(X) && function(Te) {
                return O.isArray(Te) && !Te.some(Fe);
              }(X) || (O.isFileList(X) || O.endsWith(pe, "[]")) && (Ie = O.toArray(X)))
                return pe = qe(pe), Ie.forEach(function(Te, ot) {
                  !O.isUndefined(Te) && Te !== null && h.append(I === !0 ? Ve([pe], ot, w) : I === null ? pe : pe + "[]", U(Te));
                }), !1;
            }
            return !!Fe(X) || (h.append(Ve(me, pe, w), U(X)), !1);
          }
          const V = [], te = Object.assign(ze, { defaultVisitor: R, convertValue: U, isVisitable: Fe });
          if (!O.isObject(f))
            throw new TypeError("data must be an object");
          return function X(pe, me) {
            if (!O.isUndefined(pe)) {
              if (V.indexOf(pe) !== -1)
                throw Error("Circular reference detected in " + me.join("."));
              V.push(pe), O.forEach(pe, function(Ie, Te) {
                (!(O.isUndefined(Ie) || Ie === null) && T.call(h, Ie, O.isString(Te) ? Te.trim() : Te, me, te)) === !0 && X(Ie, me ? me.concat(Te) : [Te]);
              }), V.pop();
            }
          }(f), h;
        };
        function Ne(f) {
          const h = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
          return encodeURIComponent(f).replace(/[!'()~]|%20|%00/g, function(y) {
            return h[y];
          });
        }
        function Me(f, h) {
          this._pairs = [], f && Ge(f, this, h);
        }
        const zt = Me.prototype;
        zt.append = function(f, h) {
          this._pairs.push([f, h]);
        }, zt.toString = function(f) {
          const h = f ? function(y) {
            return f.call(this, y, Ne);
          } : Ne;
          return this._pairs.map(function(y) {
            return h(y[0]) + "=" + h(y[1]);
          }, "").join("&");
        };
        var Kt = Me;
        function jt(f) {
          return encodeURIComponent(f).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
        }
        function Wt(f, h, y) {
          if (!h)
            return f;
          const x = y && y.encode || jt, T = y && y.serialize;
          let w;
          if (w = T ? T(h, y) : O.isURLSearchParams(h) ? h.toString() : new Kt(h, y).toString(x), w) {
            const I = f.indexOf("#");
            I !== -1 && (f = f.slice(0, I)), f += (f.indexOf("?") === -1 ? "?" : "&") + w;
          }
          return f;
        }
        var dr = class {
          constructor() {
            this.handlers = [];
          }
          use(f, h, y) {
            return this.handlers.push({ fulfilled: f, rejected: h, synchronous: !!y && y.synchronous, runWhen: y ? y.runWhen : null }), this.handlers.length - 1;
          }
          eject(f) {
            this.handlers[f] && (this.handlers[f] = null);
          }
          clear() {
            this.handlers && (this.handlers = []);
          }
          forEach(f) {
            O.forEach(this.handlers, function(h) {
              h !== null && f(h);
            });
          }
        }, Dr = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, Et = { isBrowser: !0, classes: { URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : Kt, FormData: typeof FormData < "u" ? FormData : null, Blob: typeof Blob < "u" ? Blob : null }, isStandardBrowserEnv: (() => {
          let f;
          return (typeof navigator > "u" || (f = navigator.product) !== "ReactNative" && f !== "NativeScript" && f !== "NS") && typeof window < "u" && typeof document < "u";
        })(), isStandardBrowserWebWorkerEnv: typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", protocols: ["http", "https", "file", "blob", "url", "data"] }, kr = function(f) {
          function h(y, x, T, w) {
            let I = y[w++];
            const F = Number.isFinite(+I), U = w >= y.length;
            return I = !I && O.isArray(T) ? T.length : I, U ? (O.hasOwnProp(T, I) ? T[I] = [T[I], x] : T[I] = x, !F) : (T[I] && O.isObject(T[I]) || (T[I] = []), h(y, x, T[I], w) && O.isArray(T[I]) && (T[I] = function(R) {
              const V = {}, te = Object.keys(R);
              let X;
              const pe = te.length;
              let me;
              for (X = 0; X < pe; X++)
                me = te[X], V[me] = R[me];
              return V;
            }(T[I])), !F);
          }
          if (O.isFormData(f) && O.isFunction(f.entries)) {
            const y = {};
            return O.forEachEntry(f, (x, T) => {
              h(function(w) {
                return O.matchAll(/\w+|\[(\w*)]/g, w).map((I) => I[0] === "[]" ? "" : I[1] || I[0]);
              }(x), T, y, 0);
            }), y;
          }
          return null;
        };
        const ne = { transitional: Dr, adapter: ["xhr", "http"], transformRequest: [function(f, h) {
          const y = h.getContentType() || "", x = y.indexOf("application/json") > -1, T = O.isObject(f);
          if (T && O.isHTMLForm(f) && (f = new FormData(f)), O.isFormData(f))
            return x && x ? JSON.stringify(kr(f)) : f;
          if (O.isArrayBuffer(f) || O.isBuffer(f) || O.isStream(f) || O.isFile(f) || O.isBlob(f))
            return f;
          if (O.isArrayBufferView(f))
            return f.buffer;
          if (O.isURLSearchParams(f))
            return h.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), f.toString();
          let w;
          if (T) {
            if (y.indexOf("application/x-www-form-urlencoded") > -1)
              return function(I, F) {
                return Ge(I, new Et.classes.URLSearchParams(), Object.assign({ visitor: function(U, R, V, te) {
                  return Et.isNode && O.isBuffer(U) ? (this.append(R, U.toString("base64")), !1) : te.defaultVisitor.apply(this, arguments);
                } }, F));
              }(f, this.formSerializer).toString();
            if ((w = O.isFileList(f)) || y.indexOf("multipart/form-data") > -1) {
              const I = this.env && this.env.FormData;
              return Ge(w ? { "files[]": f } : f, I && new I(), this.formSerializer);
            }
          }
          return T || x ? (h.setContentType("application/json", !1), function(I, F, U) {
            if (O.isString(I))
              try {
                return (0, JSON.parse)(I), O.trim(I);
              } catch (R) {
                if (R.name !== "SyntaxError")
                  throw R;
              }
            return (0, JSON.stringify)(I);
          }(f)) : f;
        }], transformResponse: [function(f) {
          const h = this.transitional || ne.transitional, y = h && h.forcedJSONParsing, x = this.responseType === "json";
          if (f && O.isString(f) && (y && !this.responseType || x)) {
            const T = !(h && h.silentJSONParsing) && x;
            try {
              return JSON.parse(f);
            } catch (w) {
              if (T)
                throw w.name === "SyntaxError" ? Ee.from(w, Ee.ERR_BAD_RESPONSE, this, null, this.response) : w;
            }
          }
          return f;
        }], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: Et.classes.FormData, Blob: Et.classes.Blob }, validateStatus: function(f) {
          return f >= 200 && f < 300;
        }, headers: { common: { Accept: "application/json, text/plain, */*", "Content-Type": void 0 } } };
        O.forEach(["delete", "get", "head", "post", "put", "patch"], (f) => {
          ne.headers[f] = {};
        });
        var H = ne;
        const Ye = O.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), We = Symbol("internals");
        function ct(f) {
          return f && String(f).trim().toLowerCase();
        }
        function Le(f) {
          return f === !1 || f == null ? f : O.isArray(f) ? f.map(Le) : String(f);
        }
        function Ct(f, h, y, x, T) {
          return O.isFunction(x) ? x.call(this, h, y) : (T && (h = y), O.isString(h) ? O.isString(x) ? h.indexOf(x) !== -1 : O.isRegExp(x) ? x.test(h) : void 0 : void 0);
        }
        class Dt {
          constructor(h) {
            h && this.set(h);
          }
          set(h, y, x) {
            const T = this;
            function w(F, U, R) {
              const V = ct(U);
              if (!V)
                throw new Error("header name must be a non-empty string");
              const te = O.findKey(T, V);
              (!te || T[te] === void 0 || R === !0 || R === void 0 && T[te] !== !1) && (T[te || U] = Le(F));
            }
            const I = (F, U) => O.forEach(F, (R, V) => w(R, V, U));
            return O.isPlainObject(h) || h instanceof this.constructor ? I(h, y) : O.isString(h) && (h = h.trim()) && !/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(h.trim()) ? I(((F) => {
              const U = {};
              let R, V, te;
              return F && F.split(`
`).forEach(function(X) {
                te = X.indexOf(":"), R = X.substring(0, te).trim().toLowerCase(), V = X.substring(te + 1).trim(), !R || U[R] && Ye[R] || (R === "set-cookie" ? U[R] ? U[R].push(V) : U[R] = [V] : U[R] = U[R] ? U[R] + ", " + V : V);
              }), U;
            })(h), y) : h != null && w(y, h, x), this;
          }
          get(h, y) {
            if (h = ct(h)) {
              const x = O.findKey(this, h);
              if (x) {
                const T = this[x];
                if (!y)
                  return T;
                if (y === !0)
                  return function(w) {
                    const I = /* @__PURE__ */ Object.create(null), F = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
                    let U;
                    for (; U = F.exec(w); )
                      I[U[1]] = U[2];
                    return I;
                  }(T);
                if (O.isFunction(y))
                  return y.call(this, T, x);
                if (O.isRegExp(y))
                  return y.exec(T);
                throw new TypeError("parser must be boolean|regexp|function");
              }
            }
          }
          has(h, y) {
            if (h = ct(h)) {
              const x = O.findKey(this, h);
              return !(!x || this[x] === void 0 || y && !Ct(0, this[x], x, y));
            }
            return !1;
          }
          delete(h, y) {
            const x = this;
            let T = !1;
            function w(I) {
              if (I = ct(I)) {
                const F = O.findKey(x, I);
                !F || y && !Ct(0, x[F], F, y) || (delete x[F], T = !0);
              }
            }
            return O.isArray(h) ? h.forEach(w) : w(h), T;
          }
          clear(h) {
            const y = Object.keys(this);
            let x = y.length, T = !1;
            for (; x--; ) {
              const w = y[x];
              h && !Ct(0, this[w], w, h, !0) || (delete this[w], T = !0);
            }
            return T;
          }
          normalize(h) {
            const y = this, x = {};
            return O.forEach(this, (T, w) => {
              const I = O.findKey(x, w);
              if (I)
                return y[I] = Le(T), void delete y[w];
              const F = h ? function(U) {
                return U.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (R, V, te) => V.toUpperCase() + te);
              }(w) : String(w).trim();
              F !== w && delete y[w], y[F] = Le(T), x[F] = !0;
            }), this;
          }
          concat(...h) {
            return this.constructor.concat(this, ...h);
          }
          toJSON(h) {
            const y = /* @__PURE__ */ Object.create(null);
            return O.forEach(this, (x, T) => {
              x != null && x !== !1 && (y[T] = h && O.isArray(x) ? x.join(", ") : x);
            }), y;
          }
          [Symbol.iterator]() {
            return Object.entries(this.toJSON())[Symbol.iterator]();
          }
          toString() {
            return Object.entries(this.toJSON()).map(([h, y]) => h + ": " + y).join(`
`);
          }
          get [Symbol.toStringTag]() {
            return "AxiosHeaders";
          }
          static from(h) {
            return h instanceof this ? h : new this(h);
          }
          static concat(h, ...y) {
            const x = new this(h);
            return y.forEach((T) => x.set(T)), x;
          }
          static accessor(h) {
            const y = (this[We] = this[We] = { accessors: {} }).accessors, x = this.prototype;
            function T(w) {
              const I = ct(w);
              y[I] || (function(F, U) {
                const R = O.toCamelCase(" " + U);
                ["get", "set", "has"].forEach((V) => {
                  Object.defineProperty(F, V + R, { value: function(te, X, pe) {
                    return this[V].call(this, U, te, X, pe);
                  }, configurable: !0 });
                });
              }(x, w), y[I] = !0);
            }
            return O.isArray(h) ? h.forEach(T) : T(h), this;
          }
        }
        Dt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]), O.reduceDescriptors(Dt.prototype, ({ value: f }, h) => {
          let y = h[0].toUpperCase() + h.slice(1);
          return { get: () => f, set(x) {
            this[y] = x;
          } };
        }), O.freezeMethods(Dt);
        var st = Dt;
        function kt(f, h) {
          const y = this || H, x = h || y, T = st.from(x.headers);
          let w = x.data;
          return O.forEach(f, function(I) {
            w = I.call(y, w, T.normalize(), h ? h.status : void 0);
          }), T.normalize(), w;
        }
        function rn(f) {
          return !(!f || !f.__CANCEL__);
        }
        function yr(f, h, y) {
          Ee.call(this, f ?? "canceled", Ee.ERR_CANCELED, h, y), this.name = "CanceledError";
        }
        O.inherits(yr, Ee, { __CANCEL__: !0 });
        var Ht = yr, _t = Et.isStandardBrowserEnv ? { write: function(f, h, y, x, T, w) {
          const I = [];
          I.push(f + "=" + encodeURIComponent(h)), O.isNumber(y) && I.push("expires=" + new Date(y).toGMTString()), O.isString(x) && I.push("path=" + x), O.isString(T) && I.push("domain=" + T), w === !0 && I.push("secure"), document.cookie = I.join("; ");
        }, read: function(f) {
          const h = document.cookie.match(new RegExp("(^|;\\s*)(" + f + ")=([^;]*)"));
          return h ? decodeURIComponent(h[3]) : null;
        }, remove: function(f) {
          this.write(f, "", Date.now() - 864e5);
        } } : { write: function() {
        }, read: function() {
          return null;
        }, remove: function() {
        } };
        function Tn(f, h) {
          return f && !/^([a-z][a-z\d+\-.]*:)?\/\//i.test(h) ? function(y, x) {
            return x ? y.replace(/\/+$/, "") + "/" + x.replace(/^\/+/, "") : y;
          }(f, h) : h;
        }
        var zn = Et.isStandardBrowserEnv ? function() {
          const f = /(msie|trident)/i.test(navigator.userAgent), h = document.createElement("a");
          let y;
          function x(T) {
            let w = T;
            return f && (h.setAttribute("href", w), w = h.href), h.setAttribute("href", w), { href: h.href, protocol: h.protocol ? h.protocol.replace(/:$/, "") : "", host: h.host, search: h.search ? h.search.replace(/^\?/, "") : "", hash: h.hash ? h.hash.replace(/^#/, "") : "", hostname: h.hostname, port: h.port, pathname: h.pathname.charAt(0) === "/" ? h.pathname : "/" + h.pathname };
          }
          return y = x(window.location.href), function(T) {
            const w = O.isString(T) ? x(T) : T;
            return w.protocol === y.protocol && w.host === y.host;
          };
        }() : function() {
          return !0;
        };
        function An(f, h) {
          let y = 0;
          const x = function(T, w) {
            T = T || 10;
            const I = new Array(T), F = new Array(T);
            let U, R = 0, V = 0;
            return w = w !== void 0 ? w : 1e3, function(te) {
              const X = Date.now(), pe = F[V];
              U || (U = X), I[R] = te, F[R] = X;
              let me = V, Ie = 0;
              for (; me !== R; )
                Ie += I[me++], me %= T;
              if (R = (R + 1) % T, R === V && (V = (V + 1) % T), X - U < w)
                return;
              const Te = pe && X - pe;
              return Te ? Math.round(1e3 * Ie / Te) : void 0;
            };
          }(50, 250);
          return (T) => {
            const w = T.loaded, I = T.lengthComputable ? T.total : void 0, F = w - y, U = x(F);
            y = w;
            const R = { loaded: w, total: I, progress: I ? w / I : void 0, bytes: F, rate: U || void 0, estimated: U && I && w <= I ? (I - w) / U : void 0, event: T };
            R[h ? "download" : "upload"] = !0, f(R);
          };
        }
        const gr = { http: null, xhr: typeof XMLHttpRequest < "u" && function(f) {
          return new Promise(function(h, y) {
            let x = f.data;
            const T = st.from(f.headers).normalize(), w = f.responseType;
            let I, F;
            function U() {
              f.cancelToken && f.cancelToken.unsubscribe(I), f.signal && f.signal.removeEventListener("abort", I);
            }
            O.isFormData(x) && (Et.isStandardBrowserEnv || Et.isStandardBrowserWebWorkerEnv ? T.setContentType(!1) : T.getContentType(/^\s*multipart\/form-data/) ? O.isString(F = T.getContentType()) && T.setContentType(F.replace(/^\s*(multipart\/form-data);+/, "$1")) : T.setContentType("multipart/form-data"));
            let R = new XMLHttpRequest();
            if (f.auth) {
              const pe = f.auth.username || "", me = f.auth.password ? unescape(encodeURIComponent(f.auth.password)) : "";
              T.set("Authorization", "Basic " + btoa(pe + ":" + me));
            }
            const V = Tn(f.baseURL, f.url);
            function te() {
              if (!R)
                return;
              const pe = st.from("getAllResponseHeaders" in R && R.getAllResponseHeaders());
              (function(me, Ie, Te) {
                const ot = Te.config.validateStatus;
                Te.status && ot && !ot(Te.status) ? Ie(new Ee("Request failed with status code " + Te.status, [Ee.ERR_BAD_REQUEST, Ee.ERR_BAD_RESPONSE][Math.floor(Te.status / 100) - 4], Te.config, Te.request, Te)) : me(Te);
              })(function(me) {
                h(me), U();
              }, function(me) {
                y(me), U();
              }, { data: w && w !== "text" && w !== "json" ? R.response : R.responseText, status: R.status, statusText: R.statusText, headers: pe, config: f, request: R }), R = null;
            }
            if (R.open(f.method.toUpperCase(), Wt(V, f.params, f.paramsSerializer), !0), R.timeout = f.timeout, "onloadend" in R ? R.onloadend = te : R.onreadystatechange = function() {
              R && R.readyState === 4 && (R.status !== 0 || R.responseURL && R.responseURL.indexOf("file:") === 0) && setTimeout(te);
            }, R.onabort = function() {
              R && (y(new Ee("Request aborted", Ee.ECONNABORTED, f, R)), R = null);
            }, R.onerror = function() {
              y(new Ee("Network Error", Ee.ERR_NETWORK, f, R)), R = null;
            }, R.ontimeout = function() {
              let pe = f.timeout ? "timeout of " + f.timeout + "ms exceeded" : "timeout exceeded";
              const me = f.transitional || Dr;
              f.timeoutErrorMessage && (pe = f.timeoutErrorMessage), y(new Ee(pe, me.clarifyTimeoutError ? Ee.ETIMEDOUT : Ee.ECONNABORTED, f, R)), R = null;
            }, Et.isStandardBrowserEnv) {
              const pe = zn(V) && f.xsrfCookieName && _t.read(f.xsrfCookieName);
              pe && T.set(f.xsrfHeaderName, pe);
            }
            x === void 0 && T.setContentType(null), "setRequestHeader" in R && O.forEach(T.toJSON(), function(pe, me) {
              R.setRequestHeader(me, pe);
            }), O.isUndefined(f.withCredentials) || (R.withCredentials = !!f.withCredentials), w && w !== "json" && (R.responseType = f.responseType), typeof f.onDownloadProgress == "function" && R.addEventListener("progress", An(f.onDownloadProgress, !0)), typeof f.onUploadProgress == "function" && R.upload && R.upload.addEventListener("progress", An(f.onUploadProgress)), (f.cancelToken || f.signal) && (I = (pe) => {
              R && (y(!pe || pe.type ? new Ht(null, f, R) : pe), R.abort(), R = null);
            }, f.cancelToken && f.cancelToken.subscribe(I), f.signal && (f.signal.aborted ? I() : f.signal.addEventListener("abort", I)));
            const X = function(pe) {
              const me = /^([-+\w]{1,25})(:?\/\/|:)/.exec(pe);
              return me && me[1] || "";
            }(V);
            X && Et.protocols.indexOf(X) === -1 ? y(new Ee("Unsupported protocol " + X + ":", Ee.ERR_BAD_REQUEST, f)) : R.send(x || null);
          });
        } };
        O.forEach(gr, (f, h) => {
          if (f) {
            try {
              Object.defineProperty(f, "name", { value: h });
            } catch {
            }
            Object.defineProperty(f, "adapterName", { value: h });
          }
        });
        const nn = (f) => `- ${f}`, an = (f) => O.isFunction(f) || f === null || f === !1;
        var sn = { getAdapter: (f) => {
          f = O.isArray(f) ? f : [f];
          const { length: h } = f;
          let y, x;
          const T = {};
          for (let w = 0; w < h; w++) {
            let I;
            if (y = f[w], x = y, !an(y) && (x = gr[(I = String(y)).toLowerCase()], x === void 0))
              throw new Ee(`Unknown adapter '${I}'`);
            if (x)
              break;
            T[I || "#" + w] = x;
          }
          if (!x) {
            const w = Object.entries(T).map(([F, U]) => `adapter ${F} ` + (U === !1 ? "is not supported by the environment" : "is not available in the build"));
            let I = h ? w.length > 1 ? `since :
` + w.map(nn).join(`
`) : " " + nn(w[0]) : "as no adapter specified";
            throw new Ee("There is no suitable adapter to dispatch the request " + I, "ERR_NOT_SUPPORT");
          }
          return x;
        }, adapters: gr };
        function Or(f) {
          if (f.cancelToken && f.cancelToken.throwIfRequested(), f.signal && f.signal.aborted)
            throw new Ht(null, f);
        }
        function In(f) {
          return Or(f), f.headers = st.from(f.headers), f.data = kt.call(f, f.transformRequest), ["post", "put", "patch"].indexOf(f.method) !== -1 && f.headers.setContentType("application/x-www-form-urlencoded", !1), sn.getAdapter(f.adapter || H.adapter)(f).then(function(h) {
            return Or(f), h.data = kt.call(f, f.transformResponse, h), h.headers = st.from(h.headers), h;
          }, function(h) {
            return rn(h) || (Or(f), h && h.response && (h.response.data = kt.call(f, f.transformResponse, h.response), h.response.headers = st.from(h.response.headers))), Promise.reject(h);
          });
        }
        const wn = (f) => f instanceof st ? f.toJSON() : f;
        function Qt(f, h) {
          h = h || {};
          const y = {};
          function x(R, V, te) {
            return O.isPlainObject(R) && O.isPlainObject(V) ? O.merge.call({ caseless: te }, R, V) : O.isPlainObject(V) ? O.merge({}, V) : O.isArray(V) ? V.slice() : V;
          }
          function T(R, V, te) {
            return O.isUndefined(V) ? O.isUndefined(R) ? void 0 : x(void 0, R, te) : x(R, V, te);
          }
          function w(R, V) {
            if (!O.isUndefined(V))
              return x(void 0, V);
          }
          function I(R, V) {
            return O.isUndefined(V) ? O.isUndefined(R) ? void 0 : x(void 0, R) : x(void 0, V);
          }
          function F(R, V, te) {
            return te in h ? x(R, V) : te in f ? x(void 0, R) : void 0;
          }
          const U = { url: w, method: w, data: w, baseURL: I, transformRequest: I, transformResponse: I, paramsSerializer: I, timeout: I, timeoutMessage: I, withCredentials: I, adapter: I, responseType: I, xsrfCookieName: I, xsrfHeaderName: I, onUploadProgress: I, onDownloadProgress: I, decompress: I, maxContentLength: I, maxBodyLength: I, beforeRedirect: I, transport: I, httpAgent: I, httpsAgent: I, cancelToken: I, socketPath: I, responseEncoding: I, validateStatus: F, headers: (R, V) => T(wn(R), wn(V), !0) };
          return O.forEach(Object.keys(Object.assign({}, f, h)), function(R) {
            const V = U[R] || T, te = V(f[R], h[R], R);
            O.isUndefined(te) && V !== F || (y[R] = te);
          }), y;
        }
        const on = {};
        ["object", "boolean", "number", "function", "string", "symbol"].forEach((f, h) => {
          on[f] = function(y) {
            return typeof y === f || "a" + (h < 1 ? "n " : " ") + f;
          };
        });
        const cn = {};
        on.transitional = function(f, h, y) {
          function x(T, w) {
            return "[Axios v1.6.0] Transitional option '" + T + "'" + w + (y ? ". " + y : "");
          }
          return (T, w, I) => {
            if (f === !1)
              throw new Ee(x(w, " has been removed" + (h ? " in " + h : "")), Ee.ERR_DEPRECATED);
            return h && !cn[w] && (cn[w] = !0, console.warn(x(w, " has been deprecated since v" + h + " and will be removed in the near future"))), !f || f(T, w, I);
          };
        };
        var un = { assertOptions: function(f, h, y) {
          if (typeof f != "object")
            throw new Ee("options must be an object", Ee.ERR_BAD_OPTION_VALUE);
          const x = Object.keys(f);
          let T = x.length;
          for (; T-- > 0; ) {
            const w = x[T], I = h[w];
            if (I) {
              const F = f[w], U = F === void 0 || I(F, w, f);
              if (U !== !0)
                throw new Ee("option " + w + " must be " + U, Ee.ERR_BAD_OPTION_VALUE);
            } else if (y !== !0)
              throw new Ee("Unknown option " + w, Ee.ERR_BAD_OPTION);
          }
        }, validators: on };
        const Ot = un.validators;
        class ce {
          constructor(h) {
            this.defaults = h, this.interceptors = { request: new dr(), response: new dr() };
          }
          request(h, y) {
            typeof h == "string" ? (y = y || {}).url = h : y = h || {}, y = Qt(this.defaults, y);
            const { transitional: x, paramsSerializer: T, headers: w } = y;
            x !== void 0 && un.assertOptions(x, { silentJSONParsing: Ot.transitional(Ot.boolean), forcedJSONParsing: Ot.transitional(Ot.boolean), clarifyTimeoutError: Ot.transitional(Ot.boolean) }, !1), T != null && (O.isFunction(T) ? y.paramsSerializer = { serialize: T } : un.assertOptions(T, { encode: Ot.function, serialize: Ot.function }, !0)), y.method = (y.method || this.defaults.method || "get").toLowerCase();
            let I = w && O.merge(w.common, w[y.method]);
            w && O.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (me) => {
              delete w[me];
            }), y.headers = st.concat(I, w);
            const F = [];
            let U = !0;
            this.interceptors.request.forEach(function(me) {
              typeof me.runWhen == "function" && me.runWhen(y) === !1 || (U = U && me.synchronous, F.unshift(me.fulfilled, me.rejected));
            });
            const R = [];
            let V;
            this.interceptors.response.forEach(function(me) {
              R.push(me.fulfilled, me.rejected);
            });
            let te, X = 0;
            if (!U) {
              const me = [In.bind(this), void 0];
              for (me.unshift.apply(me, F), me.push.apply(me, R), te = me.length, V = Promise.resolve(y); X < te; )
                V = V.then(me[X++], me[X++]);
              return V;
            }
            te = F.length;
            let pe = y;
            for (X = 0; X < te; ) {
              const me = F[X++], Ie = F[X++];
              try {
                pe = me(pe);
              } catch (Te) {
                Ie.call(this, Te);
                break;
              }
            }
            try {
              V = In.call(this, pe);
            } catch (me) {
              return Promise.reject(me);
            }
            for (X = 0, te = R.length; X < te; )
              V = V.then(R[X++], R[X++]);
            return V;
          }
          getUri(h) {
            return Wt(Tn((h = Qt(this.defaults, h)).baseURL, h.url), h.params, h.paramsSerializer);
          }
        }
        O.forEach(["delete", "get", "head", "options"], function(f) {
          ce.prototype[f] = function(h, y) {
            return this.request(Qt(y || {}, { method: f, url: h, data: (y || {}).data }));
          };
        }), O.forEach(["post", "put", "patch"], function(f) {
          function h(y) {
            return function(x, T, w) {
              return this.request(Qt(w || {}, { method: f, headers: y ? { "Content-Type": "multipart/form-data" } : {}, url: x, data: T }));
            };
          }
          ce.prototype[f] = h(), ce.prototype[f + "Form"] = h(!0);
        });
        var Xe = ce;
        class Yt {
          constructor(h) {
            if (typeof h != "function")
              throw new TypeError("executor must be a function.");
            let y;
            this.promise = new Promise(function(T) {
              y = T;
            });
            const x = this;
            this.promise.then((T) => {
              if (!x._listeners)
                return;
              let w = x._listeners.length;
              for (; w-- > 0; )
                x._listeners[w](T);
              x._listeners = null;
            }), this.promise.then = (T) => {
              let w;
              const I = new Promise((F) => {
                x.subscribe(F), w = F;
              }).then(T);
              return I.cancel = function() {
                x.unsubscribe(w);
              }, I;
            }, h(function(T, w, I) {
              x.reason || (x.reason = new Ht(T, w, I), y(x.reason));
            });
          }
          throwIfRequested() {
            if (this.reason)
              throw this.reason;
          }
          subscribe(h) {
            this.reason ? h(this.reason) : this._listeners ? this._listeners.push(h) : this._listeners = [h];
          }
          unsubscribe(h) {
            if (!this._listeners)
              return;
            const y = this._listeners.indexOf(h);
            y !== -1 && this._listeners.splice(y, 1);
          }
          static source() {
            let h;
            return { token: new Yt(function(y) {
              h = y;
            }), cancel: h };
          }
        }
        var Wn = Yt;
        const Pa = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511 };
        Object.entries(Pa).forEach(([f, h]) => {
          Pa[h] = f;
        });
        var Gc = Pa;
        const lt = function f(h) {
          const y = new Xe(h), x = i(Xe.prototype.request, y);
          return O.extend(x, Xe.prototype, y, { allOwnKeys: !0 }), O.extend(x, y, null, { allOwnKeys: !0 }), x.create = function(T) {
            return f(Qt(h, T));
          }, x;
        }(H);
        lt.Axios = Xe, lt.CanceledError = Ht, lt.CancelToken = Wn, lt.isCancel = rn, lt.VERSION = "1.6.0", lt.toFormData = Ge, lt.AxiosError = Ee, lt.Cancel = lt.CanceledError, lt.all = function(f) {
          return Promise.all(f);
        }, lt.spread = function(f) {
          return function(h) {
            return f.apply(null, h);
          };
        }, lt.isAxiosError = function(f) {
          return O.isObject(f) && f.isAxiosError === !0;
        }, lt.mergeConfig = Qt, lt.AxiosHeaders = st, lt.formToJSON = (f) => kr(O.isHTMLForm(f) ? new FormData(f) : f), lt.getAdapter = sn.getAdapter, lt.HttpStatusCode = Gc, lt.default = lt;
        var $c = lt, zc = a(581), Qn = a.n(zc), Wc = a(122), Qc = a.n(Wc), Yc = a(451), os = a.n(Yc), Xc = a(930), Jc = a.n(Xc), Zc = a(261), Ua = a.n(Zc);
        function cs(f, h) {
          var y = Object.keys(f);
          if (Object.getOwnPropertySymbols) {
            var x = Object.getOwnPropertySymbols(f);
            h && (x = x.filter(function(T) {
              return Object.getOwnPropertyDescriptor(f, T).enumerable;
            })), y.push.apply(y, x);
          }
          return y;
        }
        function Yn(f) {
          for (var h = 1; h < arguments.length; h++) {
            var y = arguments[h] != null ? arguments[h] : {};
            h % 2 ? cs(Object(y), !0).forEach(function(x) {
              var T, w, I;
              T = f, w = x, I = y[x], (w = function(F) {
                var U = function(R, V) {
                  if (typeof R != "object" || R === null)
                    return R;
                  var te = R[Symbol.toPrimitive];
                  if (te !== void 0) {
                    var X = te.call(R, "string");
                    if (typeof X != "object")
                      return X;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                  }
                  return String(R);
                }(F);
                return typeof U == "symbol" ? U : String(U);
              }(w)) in T ? Object.defineProperty(T, w, { value: I, enumerable: !0, configurable: !0, writable: !0 }) : T[w] = I;
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(f, Object.getOwnPropertyDescriptors(y)) : cs(Object(y)).forEach(function(x) {
              Object.defineProperty(f, x, Object.getOwnPropertyDescriptor(y, x));
            });
          }
          return f;
        }
        function Xn(f) {
          return Xn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(h) {
            return typeof h;
          } : function(h) {
            return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : typeof h;
          }, Xn(f);
        }
        function Fa() {
          Fa = function(T, w) {
            return new y(T, void 0, w);
          };
          var f = RegExp.prototype, h = /* @__PURE__ */ new WeakMap();
          function y(T, w, I) {
            var F = new RegExp(T, w);
            return h.set(F, I || h.get(T)), Jn(F, y.prototype);
          }
          function x(T, w) {
            var I = h.get(w);
            return Object.keys(I).reduce(function(F, U) {
              var R = I[U];
              if (typeof R == "number")
                F[U] = T[R];
              else {
                for (var V = 0; T[R[V]] === void 0 && V + 1 < R.length; )
                  V++;
                F[U] = T[R[V]];
              }
              return F;
            }, /* @__PURE__ */ Object.create(null));
          }
          return function(T, w) {
            if (typeof w != "function" && w !== null)
              throw new TypeError("Super expression must either be null or a function");
            T.prototype = Object.create(w && w.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), Object.defineProperty(T, "prototype", { writable: !1 }), w && Jn(T, w);
          }(y, RegExp), y.prototype.exec = function(T) {
            var w = f.exec.call(this, T);
            if (w) {
              w.groups = x(w, this);
              var I = w.indices;
              I && (I.groups = x(I, this));
            }
            return w;
          }, y.prototype[Symbol.replace] = function(T, w) {
            if (typeof w == "string") {
              var I = h.get(this);
              return f[Symbol.replace].call(this, T, w.replace(/\$<([^>]+)>/g, function(U, R) {
                var V = I[R];
                return "$" + (Array.isArray(V) ? V.join("$") : V);
              }));
            }
            if (typeof w == "function") {
              var F = this;
              return f[Symbol.replace].call(this, T, function() {
                var U = arguments;
                return typeof U[U.length - 1] != "object" && (U = [].slice.call(U)).push(x(U, F)), w.apply(this, U);
              });
            }
            return f[Symbol.replace].call(this, T, w);
          }, Fa.apply(this, arguments);
        }
        function Jn(f, h) {
          return Jn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(y, x) {
            return y.__proto__ = x, y;
          }, Jn(f, h);
        }
        function us(f, h) {
          if (f) {
            if (typeof f == "string")
              return ls(f, h);
            var y = Object.prototype.toString.call(f).slice(8, -1);
            return y === "Object" && f.constructor && (y = f.constructor.name), y === "Map" || y === "Set" ? Array.from(f) : y === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(y) ? ls(f, h) : void 0;
          }
        }
        function ls(f, h) {
          (h == null || h > f.length) && (h = f.length);
          for (var y = 0, x = new Array(h); y < h; y++)
            x[y] = f[y];
          return x;
        }
        function Va() {
        }
        var eu = function(f) {
          return new Promise(function(h) {
            setTimeout(h, f);
          });
        }, tu = function(f) {
          return Math.pow(Math.SQRT2, f);
        }, Ma = Fa(/(\d+)(%)/, { value: 1 });
        function Ka(f) {
          var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 7, y = h;
          if (Ma.test(f)) {
            var x, T = (x = f.match(Ma)) === null || x === void 0 ? void 0 : x.groups;
            if (T && T.value) {
              var w = parseInt(T.value) / 100;
              y = Math.round(h * w);
            }
          }
          return Math.min(30, Math.max(1, y));
        }
        function fs(f, h) {
          return h("info", "Throttle request to ".concat(f, "/s")), Jc()({ limit: f, interval: 1e3, strict: !1 });
        }
        var ru = function(f) {
          var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "auto", y = f.defaults.logHandler, x = y === void 0 ? Va : y, T = os()(h) ? Ka(h) : Ka("auto", h), w = fs(T, x), I = !1, F = f.interceptors.request.use(function(R) {
            return w(function() {
              return R;
            })();
          }, function(R) {
            return Promise.reject(R);
          }), U = f.interceptors.response.use(function(R) {
            if (!I && os()(h) && (h === "auto" || Ma.test(h)) && R.headers && R.headers["x-contentful-ratelimit-second-limit"]) {
              var V = parseInt(R.headers["x-contentful-ratelimit-second-limit"]), te = Ka(h, V);
              te !== T && (F && f.interceptors.request.eject(F), T = te, w = fs(te, x), F = f.interceptors.request.use(function(X) {
                return w(function() {
                  return X;
                })();
              }, function(X) {
                return Promise.reject(X);
              })), I = !0;
            }
            return R;
          }, function(R) {
            return Promise.reject(R);
          });
          return function() {
            f.interceptors.request.eject(F), f.interceptors.response.eject(U);
          };
        }, nu = /^(?!\w+:\/\/)([^\s:]+\.?[^\s:]+)(?::(\d+))?(?!:)$/;
        function ps(f, h) {
          var y = Yn(Yn({}, { insecure: !1, retryOnError: !0, logHandler: function(Ie, Te) {
            if (Ie === "error" && Te) {
              var ot = [Te.name, Te.message].filter(function(qt) {
                return qt;
              }).join(" - ");
              return console.error("[error] ".concat(ot)), void console.error(Te);
            }
            console.log("[".concat(Ie, "] ").concat(Te));
          }, headers: {}, httpAgent: !1, httpsAgent: !1, timeout: 3e4, throttle: 0, basePath: "", adapter: void 0, maxContentLength: 1073741824, maxBodyLength: 1073741824 }), h);
          if (!y.accessToken) {
            var x = new TypeError("Expected parameter accessToken");
            throw y.logHandler("error", x), x;
          }
          var T, w, I = y.insecure ? "http" : "https", F = y.space ? "".concat(y.space, "/") : "", U = y.defaultHostname, R = y.insecure ? 80 : 443;
          if (y.host && nu.test(y.host)) {
            var V = y.host.split(":");
            if (V.length === 2) {
              var te = (w = 2, function(Ie) {
                if (Array.isArray(Ie))
                  return Ie;
              }(T = V) || function(Ie, Te) {
                var ot = Ie == null ? null : typeof Symbol < "u" && Ie[Symbol.iterator] || Ie["@@iterator"];
                if (ot != null) {
                  var qt, vr, sr, Xt, at = [], St = !0, Nt = !1;
                  try {
                    if (sr = (ot = ot.call(Ie)).next, Te === 0) {
                      if (Object(ot) !== ot)
                        return;
                      St = !1;
                    } else
                      for (; !(St = (qt = sr.call(ot)).done) && (at.push(qt.value), at.length !== Te); St = !0)
                        ;
                  } catch (or) {
                    Nt = !0, vr = or;
                  } finally {
                    try {
                      if (!St && ot.return != null && (Xt = ot.return(), Object(Xt) !== Xt))
                        return;
                    } finally {
                      if (Nt)
                        throw vr;
                    }
                  }
                  return at;
                }
              }(T, w) || us(T, w) || function() {
                throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }());
              U = te[0], R = te[1];
            } else
              U = V[0];
          }
          y.basePath && (y.basePath = "/".concat(y.basePath.split("/").filter(Boolean).join("/")));
          var X = h.baseURL || "".concat(I, "://").concat(U, ":").concat(R).concat(y.basePath, "/spaces/").concat(F);
          y.headers.Authorization || typeof y.accessToken == "function" || (y.headers.Authorization = "Bearer " + y.accessToken);
          var pe = { baseURL: X, headers: y.headers, httpAgent: y.httpAgent, httpsAgent: y.httpsAgent, proxy: y.proxy, timeout: y.timeout, adapter: y.adapter, maxContentLength: y.maxContentLength, maxBodyLength: y.maxBodyLength, paramsSerializer: { serialize: function(Ie) {
            return Qc().stringify(Ie);
          } }, logHandler: y.logHandler, responseLogger: y.responseLogger, requestLogger: y.requestLogger, retryOnError: y.retryOnError }, me = f.create(pe);
          return me.httpClientParams = h, me.cloneWithNewParams = function(Ie) {
            return ps(f, Yn(Yn({}, Qn()(h)), Ie));
          }, y.onBeforeRequest && me.interceptors.request.use(y.onBeforeRequest), typeof y.accessToken == "function" && function(Ie, Te) {
            Ie.interceptors.request.use(function(ot) {
              return Te().then(function(qt) {
                return ot.headers.set("Authorization", "Bearer ".concat(qt)), ot;
              });
            });
          }(me, y.accessToken), y.throttle && ru(me, y.throttle), function(Ie) {
            var Te = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5, ot = Ie.defaults, qt = ot.responseLogger, vr = qt === void 0 ? Va : qt, sr = ot.requestLogger, Xt = sr === void 0 ? Va : sr;
            Ie.interceptors.request.use(function(at) {
              return Xt(at), at;
            }, function(at) {
              return Xt(at), Promise.reject(at);
            }), Ie.interceptors.response.use(function(at) {
              return vr(at), at;
            }, function(at) {
              var St = at.response, Nt = at.config;
              if (vr(at), !Nt || !Ie.defaults.retryOnError)
                return Promise.reject(at);
              var or = Nt.attempts || 1;
              if (or > Te)
                return at.attempts = Nt.attempts, Promise.reject(at);
              var Vr = null, Rn = tu(or);
              return St ? St.status >= 500 && St.status < 600 ? Vr = "Server ".concat(St.status) : St.status === 429 && (Vr = "Rate limit", St.headers && at.response.headers["x-contentful-ratelimit-reset"] && (Rn = St.headers["x-contentful-ratelimit-reset"])) : Vr = "Connection", Vr ? (Rn = Math.floor(1e3 * Rn + 200 * Math.random() + 500), Ie.defaults.logHandler("warning", "".concat(Vr, " error occurred. Waiting for ").concat(Rn, " ms before retrying...")), Nt.attempts = or + 1, delete Nt.httpAgent, delete Nt.httpsAgent, eu(Rn).then(function() {
                return Ie(Nt);
              })) : Promise.reject(at);
            });
          }(me, y.retryLimit), y.onError && me.interceptors.response.use(function(Ie) {
            return Ie;
          }, y.onError), me;
        }
        function Pr(f) {
          var h = f.query, y = {};
          return delete h.resolveLinks, y.params = Qn()(h), y;
        }
        function hs(f) {
          var h, y = function(T, w) {
            var I = typeof Symbol < "u" && T[Symbol.iterator] || T["@@iterator"];
            if (!I) {
              if (Array.isArray(T) || (I = us(T))) {
                I && (T = I);
                var F = 0, U = function() {
                };
                return { s: U, n: function() {
                  return F >= T.length ? { done: !0 } : { done: !1, value: T[F++] };
                }, e: function(X) {
                  throw X;
                }, f: U };
              }
              throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            var R, V = !0, te = !1;
            return { s: function() {
              I = I.call(T);
            }, n: function() {
              var X = I.next();
              return V = X.done, X;
            }, e: function(X) {
              te = !0, R = X;
            }, f: function() {
              try {
                V || I.return == null || I.return();
              } finally {
                if (te)
                  throw R;
              }
            } };
          }(Object.getOwnPropertyNames(f));
          try {
            for (y.s(); !(h = y.n()).done; ) {
              var x = f[h.value];
              x && Xn(x) === "object" && hs(x);
            }
          } catch (T) {
            y.e(T);
          } finally {
            y.f();
          }
          return Object.freeze(f);
        }
        function ds() {
          var f = window;
          if (!f)
            return null;
          var h = f.navigator.userAgent, y = f.navigator.platform;
          return ["Macintosh", "MacIntel", "MacPPC", "Mac68K"].indexOf(y) !== -1 ? "macOS" : ["iPhone", "iPad", "iPod"].indexOf(y) !== -1 ? "iOS" : ["Win32", "Win64", "Windows", "WinCE"].indexOf(y) !== -1 ? "Windows" : /Android/.test(h) ? "Android" : /Linux/.test(y) ? "Linux" : null;
        }
        function ys(f) {
          return Object.defineProperty(f, "toPlainObject", { enumerable: !1, configurable: !1, writable: !1, value: function() {
            return Qn()(this);
          } });
        }
        function Ur(f) {
          var h, y = f.config, x = f.response;
          if (y && y.headers && y.headers.Authorization) {
            var T = "...".concat(y.headers.Authorization.toString().substr(-5));
            y.headers.Authorization = "Bearer ".concat(T);
          }
          if (!Ua()(x) || !Ua()(y))
            throw f;
          var w, I = x == null ? void 0 : x.data, F = { status: x == null ? void 0 : x.status, statusText: x == null ? void 0 : x.statusText, message: "", details: {} };
          y && Ua()(y) && (F.request = { url: y.url, headers: y.headers, method: y.method, payloadData: y.data }), I && Xn(I) === "object" && ("requestId" in I && (F.requestId = I.requestId || "UNKNOWN"), "message" in I && (F.message = I.message || ""), "details" in I && (F.details = I.details || {}), h = (w = I.sys) === null || w === void 0 ? void 0 : w.id);
          var U = new Error();
          U.name = h && h !== "Unknown" ? h : "".concat(x == null ? void 0 : x.status, " ").concat(x == null ? void 0 : x.statusText);
          try {
            U.message = JSON.stringify(F, null, "  ");
          } catch {
            var R;
            U.message = (R = F == null ? void 0 : F.message) !== null && R !== void 0 ? R : "";
          }
          throw U;
        }
        function gs(f) {
          return function(h) {
            return Object.assign({}, f, h);
          };
        }
        var au = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(f) {
          return typeof f;
        } : function(f) {
          return f && typeof Symbol == "function" && f.constructor === Symbol && f !== Symbol.prototype ? "symbol" : typeof f;
        };
        function Bn(f) {
          if (Array.isArray(f)) {
            for (var h = 0, y = Array(f.length); h < f.length; h++)
              y[h] = f[h];
            return y;
          }
          return Array.from(f);
        }
        var _n = {}, vs = function(f, h) {
          var y = h.entryId, x = h.linkType, T = h.spaceId, w = h.environmentId;
          return T && w ? f.get(T + "!" + w + "!" + x + "!" + y) : f.get(x + "!" + y);
        }, iu = function(f, h) {
          var y = h.sys, x = y.type, T = y.linkType;
          if (x === "ResourceLink") {
            var w = function(te) {
              var X = /.*:spaces\/([^/]+)(?:\/environments\/([^/]+))?\/entries\/([^/]+)$/;
              if (X.test(te)) {
                var pe = function(Te, ot) {
                  if (Array.isArray(Te))
                    return Te;
                  if (Symbol.iterator in Object(Te))
                    return function(qt, vr) {
                      var sr = [], Xt = !0, at = !1, St = void 0;
                      try {
                        for (var Nt, or = qt[Symbol.iterator](); !(Xt = (Nt = or.next()).done) && (sr.push(Nt.value), !vr || sr.length !== vr); Xt = !0)
                          ;
                      } catch (Vr) {
                        at = !0, St = Vr;
                      } finally {
                        try {
                          !Xt && or.return && or.return();
                        } finally {
                          if (at)
                            throw St;
                        }
                      }
                      return sr;
                    }(Te, ot);
                  throw new TypeError("Invalid attempt to destructure non-iterable instance");
                }(te.match(X), 4), me = (pe[0], pe[1]), Ie = pe[2];
                return { spaceId: me, environmentId: Ie === void 0 ? "master" : Ie, entryId: pe[3] };
              }
            }(h.sys.urn), I = w.spaceId, F = w.environmentId, U = w.entryId, R = T.split(":")[1];
            return vs(f, { linkType: R, entryId: U, spaceId: I, environmentId: F }) || _n;
          }
          var V = h.sys.id;
          return vs(f, { linkType: T, entryId: V }) || _n;
        }, su = function f(h, y, x, T) {
          if (y(h))
            return x(h);
          if (h && (h === void 0 ? "undefined" : au(h)) === "object") {
            for (var w in h)
              h.hasOwnProperty(w) && (h[w] = f(h[w], y, x, T));
            T && (h = function(I) {
              if (Array.isArray(I))
                return I.filter(function(U) {
                  return U !== _n;
                });
              for (var F in I)
                I[F] === _n && delete I[F];
              return I;
            }(h));
          }
          return h;
        }, ms = function(f, h) {
          if (h = h || {}, !f.items)
            return [];
          var y = Qn()(f), x = Object.keys(y.includes || {}).reduce(function(I, F) {
            return [].concat(Bn(I), Bn(f.includes[F]));
          }, []), T = [].concat(Bn(y.items), Bn(x)).filter(function(I) {
            return !!I.sys;
          }), w = new Map(T.reduce(function(I, F) {
            var U, R = (U = F.sys, U.space && U.environment ? [U.type + "!" + U.id, U.space.sys.id + "!" + U.environment.sys.id + "!" + U.type + "!" + U.id] : [U.type + "!" + U.id]).map(function(V) {
              return [V, F];
            });
            return I.push.apply(I, Bn(R)), I;
          }, []));
          return T.forEach(function(I) {
            var F = function(U, R) {
              return Array.isArray(R) ? Object.keys(U).filter(function(V) {
                return R.indexOf(V) !== -1;
              }).reduce(function(V, te) {
                return V[te] = U[te], V;
              }, {}) : U;
            }(I, h.itemEntryPoints);
            Object.assign(I, su(F, function(U) {
              return (R = U) && R.sys && R.sys.type === "Link" || function(V) {
                return V && V.sys && V.sys.type === "ResourceLink";
              }(U);
              var R;
            }, function(U) {
              return function(R, V, te) {
                var X = iu(R, V);
                return X === _n ? te ? X : V : X;
              }(w, U, h.removeUnresolved);
            }, h.removeUnresolved));
          }), y.items;
        }, ou = a(784), cu = a.n(ou);
        function Es(f) {
          return Object.defineProperty(f, "stringifySafe", { enumerable: !1, configurable: !1, writable: !1, value: function(h = null, y = "") {
            return cu()(this, h, y, (x, T) => ({ sys: { type: "Link", linkType: "Entry", id: T.sys.id, circular: !0 } }));
          } });
        }
        async function uu(f, h, y) {
          if (!h || !h.initial && !h.nextSyncToken && !h.nextPageToken)
            throw new Error("Please provide one of `initial`, `nextSyncToken` or `nextPageToken` parameters for syncing");
          if (h.content_type && !h.type)
            h.type = "Entry";
          else if (h.content_type && h.type && h.type !== "Entry")
            throw new Error("When using the `content_type` filter your `type` parameter cannot be different from `Entry`.");
          const { withoutLinkResolution: x, withoutUnresolvableLinks: T, paginate: w } = { withoutLinkResolution: !1, withoutUnresolvableLinks: !1, paginate: !0, ...y }, I = await Cs(f, [], h, { paginate: w });
          x || (I.items = ms(I, { removeUnresolved: T, itemEntryPoints: ["fields"] }));
          const F = function(R) {
            const V = (te) => (X, pe) => (pe.sys.type === te && X.push(ys(pe)), X);
            return { entries: R.reduce(V("Entry"), []), assets: R.reduce(V("Asset"), []), deletedEntries: R.reduce(V("DeletedEntry"), []), deletedAssets: R.reduce(V("DeletedAsset"), []) };
          }(I.items);
          return I.nextSyncToken && (F.nextSyncToken = I.nextSyncToken), I.nextPageToken && (F.nextPageToken = I.nextPageToken), hs((U = Es(ys(F))).sys || {}), U;
          var U;
        }
        async function Cs(f, h, y, { paginate: x }) {
          const T = (w = y).nextPageToken ? { sync_token: w.nextPageToken } : w.nextSyncToken ? { sync_token: w.nextSyncToken } : w.sync_token ? { sync_token: w.sync_token } : w;
          var w;
          const I = (await f.get("sync", Pr({ query: T }))).data || {};
          return h = h.concat(I.items || []), I.nextPageUrl ? x ? (delete T.initial, T.sync_token = ja(I.nextPageUrl), Cs(f, h, T, { paginate: x })) : { items: h, nextPageToken: ja(I.nextPageUrl) } : I.nextSyncUrl ? { items: h, nextSyncToken: ja(I.nextSyncUrl) } : { items: [] };
        }
        function ja(f) {
          const h = f.split("?");
          return h.length > 0 ? h[1].replace("sync_token=", "") : "";
        }
        function Ha(f) {
          const h = {};
          let y = !1;
          for (const x in f)
            Array.isArray(f[x]) && (h[x] = f[x].join(","), y = !0);
          return y ? { ...f, ...h } : f;
        }
        function Nn(f) {
          if (!f.select)
            return f;
          const h = Array.isArray(f.select) ? f.select : f.select.split(",").map((x) => x.trim()), y = new Set(h);
          return y.has("sys") ? f : (y.add("sys.id"), y.add("sys.type"), { ...f, select: [...y].join(",") });
        }
        function Ss(f, { resolveLinks: h, removeUnresolved: y }) {
          const x = Es(f);
          return h && (x.items = ms(x, { removeUnresolved: y, itemEntryPoints: ["fields"] })), x;
        }
        class Fr extends Error {
          constructor(h, y) {
            super(`Invalid "${h}" provided, ` + y), this.name = "ValidationError";
          }
        }
        function Zn(f, h) {
          h ? function(y) {
            if (y.locale)
              throw new Fr("locale", "The `locale` parameter is not allowed");
          }(f) : function(y) {
            if (y.locale === "*")
              throw new Fr("locale", `The use of locale='*' is no longer supported.To fetch an entry in all existing locales, 
      use client.withAllLocales instead of the locale='*' parameter.`);
          }(f);
        }
        function ea(f) {
          if ("resolveLinks" in f)
            throw new Fr("resolveLinks", `The use of the 'resolveLinks' parameter is no longer supported. By default, links are resolved. 
      If you do not want to resolve links, use client.withoutLinkResolution.`);
        }
        function ta(f) {
          if ("removeUnresolved" in f)
            throw new Fr("removeUnresolved", `The use of the 'removeUnresolved' parameter is no longer supported. By default, unresolved links are kept as link objects.
      If you do not want to include unresolved links, use client.withoutUnresolvableLinks.`);
        }
        function ln(f) {
          for (const h in f) {
            const y = f[h];
            if (typeof y == "object" && y !== null && !Array.isArray(y))
              throw new Error(`Objects are not supported as value for the "${h}" query parameter.`);
          }
        }
        class lu extends Error {
          constructor(y, x, T) {
            super("The resource could not be found.");
            qa(this, "sys");
            qa(this, "details");
            this.sys = { type: "Error", id: "NotFound" }, this.details = { type: "Entry", id: y, environment: x, space: T };
          }
        }
        function bs({ http: f, getGlobalOptions: h }, y) {
          const x = (F = "unknown") => new lu(F, h().environment, h().space), T = (F) => {
            let U = F === "space" ? h().spaceBaseUrl : h().environmentBaseUrl;
            if (!U)
              throw new Error("Please define baseUrl for " + F);
            return U.endsWith("/") || (U += "/"), U;
          };
          async function w({ context: F, path: U, config: R }) {
            const V = T(F);
            try {
              return (await f.get(V + U, R)).data;
            } catch (te) {
              Ur(te);
            }
          }
          async function I(F, U) {
            const { withoutLinkResolution: R, withoutUnresolvableLinks: V } = U;
            try {
              return Ss(await w({ context: "environment", path: "entries", config: Pr({ query: Ha(Nn(F)) }) }), { resolveLinks: !R, removeUnresolved: V ?? !1 });
            } catch (te) {
              Ur(te);
            }
          }
          return { version: "10.6.14", getSpace: async function() {
            return w({ context: "space", path: "" });
          }, getContentType: async function(F) {
            return w({ context: "environment", path: `content_types/${F}` });
          }, getContentTypes: async function(F = {}) {
            return w({ context: "environment", path: "content_types", config: Pr({ query: F }) });
          }, getAsset: async function(F, U = {}) {
            return async function(R, V, te = { withAllLocales: !1, withoutLinkResolution: !1, withoutUnresolvableLinks: !1 }) {
              const { withAllLocales: X } = te;
              return Zn(V, X), ln(V), async function(pe, me) {
                try {
                  return w({ context: "environment", path: `assets/${pe}`, config: Pr({ query: Nn(me) }) });
                } catch (Ie) {
                  Ur(Ie);
                }
              }(R, X ? { ...V, locale: "*" } : V);
            }(F, U, y);
          }, getAssets: async function(F = {}) {
            return async function(U, R = { withAllLocales: !1, withoutLinkResolution: !1, withoutUnresolvableLinks: !1 }) {
              const { withAllLocales: V } = R;
              return Zn(U, V), ln(U), async function(te) {
                try {
                  return w({ context: "environment", path: "assets", config: Pr({ query: Ha(Nn(te)) }) });
                } catch (X) {
                  Ur(X);
                }
              }(V ? { ...U, locale: "*" } : U);
            }(F, y);
          }, getTag: async function(F) {
            return w({ context: "environment", path: `tags/${F}` });
          }, getTags: async function(F = {}) {
            return ln(F), w({ context: "environment", path: "tags", config: Pr({ query: Ha(Nn(F)) }) });
          }, getLocales: async function(F = {}) {
            return ln(F), w({ context: "environment", path: "locales", config: Pr({ query: Nn(F) }) });
          }, parseEntries: function(F) {
            return function(U, R = { withAllLocales: !1, withoutLinkResolution: !1, withoutUnresolvableLinks: !1 }) {
              return function(V, te) {
                const { withoutLinkResolution: X, withoutUnresolvableLinks: pe } = te;
                return Ss(V, { resolveLinks: !X, removeUnresolved: pe ?? !1 });
              }(U, R);
            }(F, y);
          }, sync: async function(F, U = { paginate: !0 }) {
            return async function(R, V, te = { withAllLocales: !1, withoutLinkResolution: !1, withoutUnresolvableLinks: !1 }) {
              ea(R), ta(R);
              const X = { ...V, ...te };
              return function(pe) {
                pe.defaults.baseURL = h().environmentBaseUrl;
              }(f), uu(f, R, X);
            }(F, U, y);
          }, getEntry: async function(F, U = {}) {
            return async function(R, V, te = { withAllLocales: !1, withoutLinkResolution: !1, withoutUnresolvableLinks: !1 }) {
              const { withAllLocales: X } = te;
              return Zn(V, X), ea(V), ta(V), ln(V), async function(pe, me, Ie) {
                if (!pe)
                  throw x(pe);
                try {
                  const Te = await I({ "sys.id": pe, ...me }, Ie);
                  if (Te.items.length > 0)
                    return Te.items[0];
                  throw x(pe);
                } catch (Te) {
                  Ur(Te);
                }
              }(R, X ? { ...V, locale: "*" } : V, te);
            }(F, U, y);
          }, getEntries: async function(F = {}) {
            return async function(U, R = { withAllLocales: !1, withoutLinkResolution: !1, withoutUnresolvableLinks: !1 }) {
              const { withAllLocales: V } = R;
              return Zn(U, V), ea(U), ta(U), ln(U), I(V ? { ...U, locale: "*" } : U, R);
            }(F, y);
          }, createAssetKey: async function(F) {
            try {
              const U = Math.floor(Date.now() / 1e3);
              (function(R, V, te) {
                if (te = te || {}, typeof V != "number")
                  throw new Fr(R, `only numeric values are allowed for timestamps, provided type was "${typeof V}"`);
                if (te.maximum && V > te.maximum)
                  throw new Fr(R, `value (${V}) cannot be further in the future than expected maximum (${te.maximum})`);
                if (te.now && V < te.now)
                  throw new Fr(R, `value (${V}) cannot be in the past, current time was ${te.now}`);
              })("expiresAt", F, { maximum: U + 172800, now: U });
            } catch (U) {
              Ur(U);
            }
            return async function({ context: U, path: R, data: V, config: te }) {
              const X = T(U);
              try {
                return (await f.post(X + R, V, te)).data;
              } catch (pe) {
                Ur(pe);
              }
            }({ context: "environment", path: "asset_keys", data: { expiresAt: F } });
          } };
        }
        const fu = ({ http: f, getGlobalOptions: h }) => {
          function y(x) {
            return function({ http: T, getGlobalOptions: w }, I, F) {
              const U = bs({ http: T, getGlobalOptions: w }, I);
              return Object.defineProperty(U, "withAllLocales", { get: () => F({ ...I, withAllLocales: !0 }) }), Object.defineProperty(U, "withoutLinkResolution", { get: () => F({ ...I, withoutLinkResolution: !0 }) }), Object.defineProperty(U, "withoutUnresolvableLinks", { get: () => F({ ...I, withoutUnresolvableLinks: !0 }) }), Object.create(U);
            }({ http: f, getGlobalOptions: h }, x, y);
          }
          return { ...bs({ http: f, getGlobalOptions: h }, { withoutLinkResolution: !1, withAllLocales: !1, withoutUnresolvableLinks: !1 }), get withAllLocales() {
            return y({ withAllLocales: !0, withoutLinkResolution: !1, withoutUnresolvableLinks: !1 });
          }, get withoutLinkResolution() {
            return y({ withAllLocales: !1, withoutLinkResolution: !0, withoutUnresolvableLinks: !1 });
          }, get withoutUnresolvableLinks() {
            return y({ withAllLocales: !1, withoutLinkResolution: !1, withoutUnresolvableLinks: !0 });
          } };
        };
        function pu(f) {
          if (!f.accessToken)
            throw new TypeError("Expected parameter accessToken");
          if (!f.space)
            throw new TypeError("Expected parameter space");
          ea(f), ta(f);
          const h = { resolveLinks: !0, removeUnresolved: !1, defaultHostname: "cdn.contentful.com", environment: "master", ...f }, y = function(w, I, F, U) {
            var R = [];
            I && R.push("app ".concat(I)), F && R.push("integration ".concat(F)), U && R.push("feature " + U), R.push("sdk ".concat(w));
            var V = null;
            try {
              typeof window < "u" && "navigator" in window && "product" in window.navigator && window.navigator.product === "ReactNative" ? (V = ds(), R.push("platform ReactNative")) : typeof process > "u" || process.browser ? (V = ds(), R.push("platform browser")) : (V = function() {
                var te = process.platform || "linux", X = process.version || "0.0.0", pe = { android: "Android", aix: "Linux", darwin: "macOS", freebsd: "Linux", linux: "Linux", openbsd: "Linux", sunos: "Linux", win32: "Windows" };
                return te in pe ? "".concat(pe[te] || "Linux", "/").concat(X) : null;
              }(), R.push("platform node.js/".concat(process.versions && process.versions.node ? "v".concat(process.versions.node) : process.version)));
            } catch {
              V = null;
            }
            return V && R.push("os ".concat(V)), "".concat(R.filter(function(te) {
              return te !== "";
            }).join("; "), ";");
          }("contentful.js/10.6.14", h.application, h.integration);
          h.headers = { ...h.headers, "Content-Type": "application/vnd.contentful.delivery.v1+json", "X-Contentful-User-Agent": y };
          const x = ps($c, h);
          if (!x.defaults.baseURL)
            throw new Error("Please define a baseURL");
          const T = gs({ space: h.space, environment: h.environment, spaceBaseUrl: x.defaults.baseURL, environmentBaseUrl: `${x.defaults.baseURL}environments/${h.environment}` });
          return x.defaults.baseURL = T({}).environmentBaseUrl, fu({ http: x, getGlobalOptions: T });
        }
      }(), s;
    }();
  });
})(qc);
var Iy = qc.exports;
const lr = "account", ho = "session-storage", wy = (e) => {
  const t = Mn(() => {
    if (typeof window > "u")
      return e;
    try {
      const i = window.sessionStorage.getItem(lr);
      return i ? Hc(i) : e;
    } catch (i) {
      return console.warn(`Error reading account data “${lr}”:`, i), e;
    }
  }, [e, lr]), [n, r] = go(t), a = Kc((i) => {
    typeof window > "u" && console.warn(
      `Tried setting account data “${lr}” even though environment is not a client`
    );
    try {
      const o = i instanceof Function ? i(n) : i;
      window.sessionStorage.setItem(lr, JSON.stringify(o)), r(o), window.dispatchEvent(new Event(ho));
    } catch (o) {
      console.warn(`Error setting account data key “${lr}”:`, o);
    }
  });
  ba(() => {
    r(t());
  }, []);
  const s = Mn(
    (i) => {
      i != null && i.key && i.key !== lr || r(t());
    },
    [lr, t]
  );
  return Sa("storage", s), Sa(ho, s), [n, a];
};
export {
  fy as A,
  gy as a,
  vy as b,
  my as c,
  Ey as d,
  Sy as e,
  iy as f,
  dy as g,
  Cy as h,
  yy as i,
  by as j,
  Ty as k,
  Ay as l,
  Yo as m,
  hy as n,
  Iy as o,
  Hc as p,
  wy as q,
  Kc as r,
  Sa as s,
  xy as t,
  py as u,
  Wi as v,
  jc as w,
  Yf as x,
  g0 as y,
  Io as z
};
